
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("79vw2", function(module, exports) {

var $99WQy = parcelRequire("99WQy");
const $e4034aced29ead60$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};


var $dsdUb = parcelRequire("dsdUb");

var $l6lJr = parcelRequire("l6lJr");

var $9WUug = parcelRequire("9WUug");

var $4sK6R = parcelRequire("4sK6R");

var $ccQw1 = parcelRequire("ccQw1");

var $hUifo = parcelRequire("hUifo");


var $9JHBV = parcelRequire("9JHBV");


var $lyclm = parcelRequire("lyclm");

const $56d3cb5a2f4b0466$export$3eda18658b66108 = (response, removeTextHighlightingFromTitle)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.displayName;
    return (0, $hUifo.extractTitle)(response?.data, removeTextHighlightingFromTitle);
};
const $56d3cb5a2f4b0466$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.url;
    return (0, $l6lJr.extractLink)(response?.data);
};
const $56d3cb5a2f4b0466$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.ari || (0, $lyclm.extractEntity)(response)?.thirdPartyAri;
    const data = response?.data;
    return (0, $99WQy.extractAri)(data);
};
const $56d3cb5a2f4b0466$export$864b719baf5d744d = (response, iframeUrlType)=>{
    if ((0, $lyclm.isEntityPresent)(response)) {
        // TODO: Missing iframeUrlType
        const embedUrl = (0, $lyclm.extractEntityEmbedUrl)(response);
        return embedUrl ? {
            src: embedUrl
        } : undefined;
    }
    return (0, $9JHBV.extractPreview)(response?.data, 'web', iframeUrlType);
};
const $56d3cb5a2f4b0466$export$ff753ed519e96e9e = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntityProvider)(response);
    return response?.data && (0, $ccQw1.extractProvider)(response?.data);
};
const $56d3cb5a2f4b0466$export$7a685df468cbf38f = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.createdAt;
    return response?.data && (0, $e4034aced29ead60$export$e1226a5e0bbbf862)(response.data);
};
const $56d3cb5a2f4b0466$export$75047940e157fd1f = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.lastUpdatedAt;
    return response?.data && (0, $dsdUb.extractDateUpdated)(response.data);
};
const $56d3cb5a2f4b0466$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.createdBy?.displayName;
    const persons = (0, $9WUug.extractPersonCreatedBy)(response.data);
    return !!persons?.length ? persons[0].name : undefined;
};
const $56d3cb5a2f4b0466$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        const owners = entity?.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $9WUug.extractPersonCreatedBy)(response.data);
};
const $56d3cb5a2f4b0466$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $lyclm.isEntityPresent)(response)) return (0, $lyclm.extractEntity)(response)?.lastUpdatedBy?.displayName;
    const person = (0, $4sK6R.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};
const $56d3cb5a2f4b0466$export$96ed4c1b14ac210a = (response)=>{
    if ((0, $lyclm.isEntityPresent)(response)) {
        const entity = (0, $lyclm.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity?.exportLinks?.[0].url : undefined;
    }
    return response?.data?.['atlassian:downloadUrl'];
};
module.exports["extractSmartLinkTitle"] = $56d3cb5a2f4b0466$export$3eda18658b66108;
module.exports["extractSmartLinkUrl"] = $56d3cb5a2f4b0466$export$7ba9b12c6a1b73de;
module.exports["extractSmartLinkAri"] = $56d3cb5a2f4b0466$export$16b02be3e2bb31ad;
module.exports["extractSmartLinkEmbed"] = $56d3cb5a2f4b0466$export$864b719baf5d744d;
module.exports["extractSmartLinkProvider"] = $56d3cb5a2f4b0466$export$ff753ed519e96e9e;
module.exports["extractSmartLinkCreatedOn"] = $56d3cb5a2f4b0466$export$7a685df468cbf38f;
module.exports["extractSmartLinkModifiedOn"] = $56d3cb5a2f4b0466$export$75047940e157fd1f;
module.exports["extractSmartLinkCreatedBy"] = $56d3cb5a2f4b0466$export$242875b46118beb2;
module.exports["extractSmartLinkAuthorGroup"] = $56d3cb5a2f4b0466$export$41fc716e1bc2dc90;
module.exports["extractSmartLinkModifiedBy"] = $56d3cb5a2f4b0466$export$7f099a839071a190;
module.exports["extractSmartLinkDownloadUrl"] = $56d3cb5a2f4b0466$export$96ed4c1b14ac210a;

});

parcelRegister("99WQy", function(module, exports) {
const $7b9cf113c389991e$export$be18a6294fd426ec = (jsonLd)=>{
    if (jsonLd['atlassian:ari']) return jsonLd['atlassian:ari'];
    return undefined;
};
module.exports["extractAri"] = $7b9cf113c389991e$export$be18a6294fd426ec;

});

parcelRegister("dsdUb", function(module, exports) {
const $d35ebe54446110dc$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd.updated) return jsonLd.updated;
    return undefined;
};
module.exports["extractDateUpdated"] = $d35ebe54446110dc$export$7fc2f5e6f9d22ae7;

});

parcelRegister("l6lJr", function(module, exports) {

var $kzBLz = parcelRequire("kzBLz");

const $d3adf1d8ff29df55$export$63f54cf4c5883620 = (jsonLd)=>{
    const url = jsonLd?.url;
    if (url) {
        if (typeof url === 'string') return url;
        else return (0, $kzBLz.extractUrlFromLinkJsonLd)(url);
    }
    return undefined;
};
module.exports["extractLink"] = $d3adf1d8ff29df55$export$63f54cf4c5883620;

});

parcelRegister("kzBLz", function(module, exports) {
const $8554b737f5c5cb14$export$396ba4ef2e37dc65 = (link)=>{
    if (typeof link === 'string') return link;
    else if (Array.isArray(link)) {
        if (link.length > 0) return $8554b737f5c5cb14$export$396ba4ef2e37dc65(link[0]);
    } else return link.href;
    return undefined;
};
module.exports["extractUrlFromLinkJsonLd"] = $8554b737f5c5cb14$export$396ba4ef2e37dc65;

});

parcelRegister("9WUug", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $7710b1270e0d3189$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $kzSaQ.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $kzSaQ.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};
module.exports["extractPersonCreatedBy"] = $7710b1270e0d3189$export$a66235cba0c9d11a;

});

parcelRegister("kzSaQ", function(module, exports) {

var $8hlRK = parcelRequire("8hlRK");

const $141d786062a33a3a$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};
module.exports["extractPersonFromJsonLd"] = $141d786062a33a3a$export$c471ae5fddcf1392;

});

parcelRegister("8hlRK", function(module, exports) {

var $kzBLz = parcelRequire("kzBLz");

const $15c3e8c19f3e9f93$export$67f3d92c824fd850 = (icon)=>{
    if (typeof icon === 'string') return icon;
    else if (icon['@type'] === 'Link') return (0, $kzBLz.extractUrlFromLinkJsonLd)(icon);
    else {
        if (icon.url) return (0, $kzBLz.extractUrlFromLinkJsonLd)(icon.url);
    }
    return undefined;
};
module.exports["extractUrlFromIconJsonLd"] = $15c3e8c19f3e9f93$export$67f3d92c824fd850;

});

parcelRegister("4sK6R", function(module, exports) {

var $kzSaQ = parcelRequire("kzSaQ");

const $120900a6e202ebd4$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $kzSaQ.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};
module.exports["extractPersonUpdatedBy"] = $120900a6e202ebd4$export$8a2d1ed7e6f336f0;

});

parcelRegister("ccQw1", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4sZvs = parcelRequire("4sZvs");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $3fvfu = parcelRequire("3fvfu");


var $8hlRK = parcelRequire("8hlRK");

var $kzBLz = parcelRequire("kzBLz");

const $56eab8749893649b$export$a832871718466647 = (jsonLd)=>{
    const generator = jsonLd.generator;
    if (generator) {
        if (typeof generator === 'string') throw Error('Link.generator requires a name and icon.');
        else if (generator['@type'] === 'Link') {
            if (generator.name) return {
                text: generator.name
            };
        } else if (generator.name) {
            const id = generator['@id'];
            return {
                text: generator.name,
                icon: $56eab8749893649b$export$6fb636a2ac885215(generator.icon, id),
                id: id,
                image: $56eab8749893649b$var$extractProviderImage(generator.image)
            };
        }
    }
    return undefined;
};
const $56eab8749893649b$export$6fb636a2ac885215 = (icon, id)=>{
    if (id) {
        if (id === (0, $3fvfu.CONFLUENCE_GENERATOR_ID)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $4sZvs.ConfluenceIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
        else if (id === (0, $3fvfu.JIRA_GENERATOR_ID)) return /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
            appearance: "brand",
            size: "xxsmall",
            ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                shouldUseNewLogoDesign: true
            } : undefined
        });
    }
    if (icon) return (0, $8hlRK.extractUrlFromIconJsonLd)(icon);
    return undefined;
};
const $56eab8749893649b$var$extractProviderImage = (image)=>{
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $kzBLz.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $kzBLz.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};
const $56eab8749893649b$export$38df542ff03a4183 = (id)=>{
    return id === (0, $3fvfu.CONFLUENCE_GENERATOR_ID);
};
module.exports["extractProvider"] = $56eab8749893649b$export$a832871718466647;
module.exports["extractProviderIcon"] = $56eab8749893649b$export$6fb636a2ac885215;
module.exports["isConfluenceGenerator"] = $56eab8749893649b$export$38df542ff03a4183;

});

parcelRegister("4sZvs", function(module, exports) {

var $ldZvW = parcelRequire("ldZvW");


var $2i2Hp = parcelRequire("2i2Hp");


var $jTnRu = parcelRequire("jTnRu");

const $8bfb06df0501dc58$export$68f3db7f6af48bcb = (0, $jTnRu.createFeatureFlaggedComponent)((0, $2i2Hp.ConfluenceIcon), (0, $ldZvW.ConfluenceIcon));
module.exports["ConfluenceIcon"] = $8bfb06df0501dc58$export$68f3db7f6af48bcb;

});

parcelRegister("hUifo", function(module, exports) {

var $aliCf = parcelRequire("aliCf");


var $8hlRK = parcelRequire("8hlRK");

const $1aa29b094fdafad8$export$efdbd45f3e77a161 = (jsonLd)=>{
    const context = jsonLd.context;
    if (context) {
        if (typeof context === 'string') return {
            name: context
        };
        else if (context['@type'] === 'Link') {
            if (context.name) return {
                name: context.name
            };
        } else {
            if (context.name) return {
                name: context.name,
                icon: context.icon && (0, $8hlRK.extractUrlFromIconJsonLd)(context.icon),
                type: (0, $aliCf.extractType)(context)
            };
        }
    }
    return undefined;
};





const $ca558e6955be7d7f$export$b05803156e5015b6 = (jsonLd, removeTextHighlightingFromTitle)=>{
    if (!jsonLd) return undefined;
    const name = jsonLd.name?.replace(/[\r\n]+/g, '');
    const id = jsonLd['@id'] || '';
    // Check if this is a reference to something _inside_ a Repository.
    // We format these titles to represent more metadata.
    const context = (0, $1aa29b094fdafad8$export$efdbd45f3e77a161)(jsonLd);
    const type = (0, $aliCf.extractType)(jsonLd);
    const hasContextType = context && context.type;
    const hasContextRepo = hasContextType && context.type.includes('atlassian:SourceCodeRepository');
    if (hasContextRepo && type) {
        const contextName = context.name && `${context.name}: ` || '';
        // COMMIT: `repo-name: abf137c title of commit message`
        if (type.includes('atlassian:SourceCodeCommit')) {
            const [, hashContent] = id.split(':');
            const hash = hashContent && `${hashContent.substring(0, 8)} `;
            return contextName + (hash || '') + name;
        }
        // PR: `repo-name: #42 title of pull request`
        if (type.includes('atlassian:SourceCodePullRequest')) {
            const pullRequest = jsonLd;
            const internalId = pullRequest['atlassian:internalId'];
            const internalIdRef = internalId && `#${internalId} `;
            return contextName + (internalIdRef || '') + name;
        }
        // BRANCH: `repo-name/branch-name`
        if (type.includes('atlassian:SourceCodeReference')) return contextName + name;
        // FILE: `repo-name: filepath`
        if (type.includes('schema:DigitalDocument')) return contextName + name;
    }
    if (removeTextHighlightingFromTitle) {
        const textFragmentRegex = new RegExp(' \\| :~:text=.*', 'g');
        const truncated = name?.replace(textFragmentRegex, '');
        return truncated;
    }
    return name;
};
module.exports["extractTitle"] = $ca558e6955be7d7f$export$b05803156e5015b6;

});

parcelRegister("aliCf", function(module, exports) {
const $b71c91ab48ca7fcb$export$2e9ae379995d99e3 = (jsonLd)=>{
    const type = jsonLd['@type'];
    if (type) {
        if (Array.isArray(jsonLd['@type'])) return type;
        else return [
            type
        ];
    }
    return undefined;
};
module.exports["extractType"] = $b71c91ab48ca7fcb$export$2e9ae379995d99e3;

});

parcelRegister("9JHBV", function(module, exports) {
const $0d1a0b98f1eafbac$export$3e8ad908070b68b2 = (preview, platform)=>{
    if (preview) {
        // By default, we support previews everywhere.
        if (typeof preview === 'string') return true;
        else {
            const supportedPlatforms = preview['atlassian:supportedPlatforms'];
            if (supportedPlatforms) {
                const isWeb = platform === 'web';
                return isWeb && supportedPlatforms.includes('web') || !isWeb && supportedPlatforms.includes('mobile');
            }
            // No supported platforms - assume they are all supported.
            return true;
        }
    }
    // No preview, don't try and render it on any platforms.
    return false;
};



var $kzBLz = parcelRequire("kzBLz");

const $619c28d037f806e9$export$4b0d98b1b7f6d115 = (jsonLd, platform, iframeUrlType)=>{
    const preview = jsonLd?.preview;
    const isSupported = (0, $0d1a0b98f1eafbac$export$3e8ad908070b68b2)(preview, platform);
    if (preview && isSupported) {
        if (typeof preview === 'string') return {
            src: preview
        };
        else if (preview['@type'] === 'Link' && iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
            src: preview.interactiveHref,
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else if (preview['@type'] === 'Link') return {
            src: (0, $kzBLz.extractUrlFromLinkJsonLd)(preview),
            aspectRatio: preview['atlassian:aspectRatio']
        };
        else {
            // TODO, EDM-565: Remove this once the typings for Dropbox and Jira have been patched up.
            if (preview.url || preview.href) {
                if (iframeUrlType === 'interactiveHref' && preview.interactiveHref) return {
                    src: preview.interactiveHref,
                    aspectRatio: preview['atlassian:aspectRatio']
                };
                return {
                    src: (0, $kzBLz.extractUrlFromLinkJsonLd)(preview.url || preview.href),
                    aspectRatio: preview['atlassian:aspectRatio']
                };
            } else if (preview.content) return {
                content: preview.content
            };
        }
    }
    return undefined;
};
module.exports["extractPreview"] = $619c28d037f806e9$export$4b0d98b1b7f6d115;

});

parcelRegister("lyclm", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $4sZvs = parcelRequire("4sZvs");


var $lAFHW = parcelRequire("lAFHW");


var $dh538 = parcelRequire("dh538");


var $3fvfu = parcelRequire("3fvfu");

const $fe608b0eca8c0821$export$8beff7405d020ddf = (response)=>response?.entityData;
const $fe608b0eca8c0821$export$c7168210b81d9383 = (response)=>Boolean($fe608b0eca8c0821$export$8beff7405d020ddf(response));
const $fe608b0eca8c0821$export$f97663ee76ac5b24 = (response)=>{
    const entity = $fe608b0eca8c0821$export$8beff7405d020ddf(response);
    return entity && 'liveEmbedUrl' in entity && typeof entity?.liveEmbedUrl === 'string' ? entity?.liveEmbedUrl : undefined;
};
const $fe608b0eca8c0821$export$ad879f2c9d5100a0 = (response)=>{
    if (!response?.meta?.generator) return undefined;
    const { icon: icon, id: id, image: image, name: name } = response.meta.generator;
    if (!name || !icon) throw Error('Link.generator requires a name and icon.');
    let providerIcon;
    switch(id){
        case 0, $3fvfu.CONFLUENCE_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $4sZvs.ConfluenceIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        case 0, $3fvfu.JIRA_GENERATOR_ID:
            providerIcon = /*#__PURE__*/ (0, $l998X.jsx)((0, $lAFHW.JiraIcon), {
                appearance: "brand",
                ...(0, $dh538.fg)('navx-1895-new-logo-design') ? {
                    shouldUseNewLogoDesign: true
                } : undefined,
                size: "xxsmall"
            });
            break;
        default:
            providerIcon = icon.url;
    }
    return {
        text: name,
        icon: providerIcon,
        id: id,
        image: image ? image : icon.url
    };
};
const $fe608b0eca8c0821$export$19346520e937a99f = (response)=>{
    const entity = $fe608b0eca8c0821$export$8beff7405d020ddf(response);
    let url;
    if (entity) url = 'iconUrl' in entity && typeof entity?.iconUrl === 'string' ? entity.iconUrl : response?.meta.generator?.icon?.url;
    return {
        url: url,
        label: entity?.displayName
    };
};
module.exports["extractEntity"] = $fe608b0eca8c0821$export$8beff7405d020ddf;
module.exports["isEntityPresent"] = $fe608b0eca8c0821$export$c7168210b81d9383;
module.exports["extractEntityEmbedUrl"] = $fe608b0eca8c0821$export$f97663ee76ac5b24;
module.exports["extractEntityProvider"] = $fe608b0eca8c0821$export$ad879f2c9d5100a0;
module.exports["extractEntityIcon"] = $fe608b0eca8c0821$export$19346520e937a99f;

});

parcelRegister("btw9C", function(module, exports) {
const $2b201a7ae9d0ebd0$var$getStatusForNotFoundVisibility = (meta)=>{
    const accessType = meta.requestAccess?.accessType;
    if (!accessType || accessType === 'ACCESS_EXISTS') return 'not_found';
    // for the rest of the accessTypes we will return forbidden,see https://product-fabric.atlassian.net/browse/EDM-7125
    return 'forbidden';
};
const $2b201a7ae9d0ebd0$export$b70265791d2079d4 = ({ meta: meta })=>{
    const { access: access, visibility: visibility } = meta;
    switch(access){
        case 'forbidden':
            if (visibility === 'not_found') return $2b201a7ae9d0ebd0$var$getStatusForNotFoundVisibility(meta);
            else return 'forbidden';
        case 'unauthorized':
            return 'unauthorized';
        default:
            return 'resolved';
    }
};
module.exports["getStatus"] = $2b201a7ae9d0ebd0$export$b70265791d2079d4;

});

parcelRegister("jHnts", function(module, exports) {
class $65b10cace4bd92e7$export$3e5b797e39668f84 extends Error {
    constructor(kind, hostname, message, type, extensionKey){
        super(`${kind}: ${message}`), this.kind = kind, this.hostname = hostname, this.message = message, this.type = type, this.extensionKey = extensionKey;
        this.name = 'APIError';
        // The error type received from the server.
        this.type = type;
        // The kind mapped to on the client.
        this.kind = kind;
        // The message received from the server.
        this.message = message;
        // The hostname of the URL which failed - do NOT log this (contains PII/UGC).
        this.hostname = hostname;
        // The extensionKey passed from the error response from ORS
        this.extensionKey = extensionKey;
    }
}
class $65b10cace4bd92e7$export$19fa02dd69bd4efd extends Error {
    constructor(error){
        super(error);
        this.name = 'InvalidUrlError';
    }
}
module.exports["APIError"] = $65b10cace4bd92e7$export$3e5b797e39668f84;
module.exports["InvalidUrlError"] = $65b10cace4bd92e7$export$19fa02dd69bd4efd;

});

parcelRegister("d925B", function(module, exports) {
var $09866f7fbcdd08d4$export$76a2e4c433c23bb9 = /*#__PURE__*/ function(EVENT_TYPE) {
    EVENT_TYPE["OPERATIONAL"] = "operational";
    EVENT_TYPE["SCREEN"] = "screen";
    EVENT_TYPE["TRACK"] = "track";
    EVENT_TYPE["UI"] = "ui";
    return EVENT_TYPE;
}({});
var $09866f7fbcdd08d4$export$9523889e0a5da4ba = /*#__PURE__*/ function(ACTION) {
    ACTION["ACTIONED"] = "actioned";
    ACTION["ACTIVATED"] = "activated";
    ACTION["ADDED"] = "added";
    ACTION["API_ERROR"] = "apiError";
    ACTION["API_RECEIVED"] = "apiReceived";
    ACTION["API_PURGED"] = "apiPurged";
    ACTION["BROWSER_FREEZE"] = "browserFreeze";
    ACTION["CANCELLED"] = "cancelled";
    ACTION["CAUGHT_DOM_ERROR"] = "caughtDomError";
    ACTION["CHANGED_BACKGROUND_COLOR"] = "changedBackgroundColor";
    ACTION["CHANGED_ICON"] = "changedIcon";
    ACTION["CHANGED_FULL_WIDTH_MODE"] = "changedFullWidthMode";
    ACTION["CHANGED_LAYOUT"] = "changedLayout";
    ACTION["CHANGED_BREAKOUT_MODE"] = "changedBreakoutMode";
    ACTION["CHANGED_REPLACEMENT_TEXT"] = "changedReplacementText";
    ACTION["CHANGED_TYPE"] = "changedType";
    ACTION["CHANGED_URL"] = "changedUrl";
    ACTION["CLEARED"] = "cleared";
    ACTION["CLICK"] = "click";
    ACTION["CLICKED"] = "clicked";
    ACTION["CLOSED"] = "closed";
    ACTION["COMMITTED"] = "committed";
    /** used in @atlassian/editor-referentiality */ ACTION["CONNECTED_NODES"] = "connectedNodes";
    ACTION["CONVERTED"] = "converted";
    ACTION["COPIED"] = "copied";
    ACTION["COPY_FAILED"] = "copyFailed";
    ACTION["CUT"] = "cut";
    ACTION["DEACTIVATED"] = "deactivated";
    ACTION["DECREMENTED"] = "decremented";
    ACTION["DELETED"] = "deleted";
    ACTION["DISCARDED_INVALID_STEPS_FROM_TRANSACTION"] = "discardedInvalidStepsFromTransaction";
    ACTION["DISCARDED"] = "discarded";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_SOURCE"] = "disconnectedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["DISCONNECTED_TARGET"] = "disconnectedTarget";
    ACTION["DISMISSED"] = "dismissed";
    ACTION["DISPATCHED_INVALID_TRANSACTION"] = "dispatchedInvalidTransaction";
    ACTION["DISPATCHED_VALID_TRANSACTION"] = "dispatchedValidTransaction";
    ACTION["DOUBLE_CLICKED"] = "doubleClicked";
    ACTION["DRAGGED"] = "dragged";
    ACTION["EDITED"] = "edited";
    ACTION["EDITOR_CRASHED"] = "unhandledErrorCaught";
    ACTION["EDITOR_CRASHED_ADDITIONAL_INFORMATION"] = "unhandledErrorCaughtAdditionalInfov2";
    ACTION["EDITOR_MOUNTED"] = "mounted";
    ACTION["EDITOR_CONTENT_RETRIEVAL_PERFORMED"] = "contentRetrievalPerformed";
    ACTION["RE_RENDERED"] = "reRendered";
    ACTION["ENDED"] = "ended";
    ACTION["ENTERED"] = "entered";
    ACTION["ERROR"] = "error";
    ACTION["ERRORED"] = "errored";
    ACTION["EXPERIENCE_MEASURED"] = "experienceMeasured";
    ACTION["EXPERIENCE_SAMPLED"] = "experienceSampled";
    ACTION["EXPOSED"] = "exposed";
    ACTION["FETCHED"] = "fetched";
    ACTION["FAILED_TO_UNMOUNT"] = "failedToUnmount";
    ACTION["FAILED_TO_INSERT"] = "failedToInsert";
    ACTION["FIND_NEXT_PERFORMED"] = "findNextPerformed";
    ACTION["FIND_PERFORMED"] = "findPerformed";
    ACTION["FIND_PREV_PERFORMED"] = "findPrevPerformed";
    ACTION["UNDO_PERFORMED"] = "undo";
    ACTION["REDO_PERFORMED"] = "redo";
    ACTION["FORMATTED"] = "formatted";
    ACTION["HELP_OPENED"] = "helpOpened";
    ACTION["HIGHLIGHTED"] = "highlighted";
    ACTION["INCREMENTED"] = "incremented";
    ACTION["INDENTED"] = "indented";
    ACTION["INITIALISED"] = "initialised";
    ACTION["INITIATED"] = "initiated";
    /** used in @atlassian/editor-referentiality */ ACTION["INITIALISED_FRAGMENT_MARK"] = "initialisedFragmentMark";
    ACTION["INPUT_PERF_SAMPLING"] = "inputPerfSampling";
    ACTION["INPUT_PERF_SAMPLING_AVG"] = "inputPerfSamplingAvg";
    ACTION["INSERTED"] = "inserted";
    ACTION["INVALID_DOCUMENT_ENCOUNTERED"] = "invalidDocumentEncountered";
    ACTION["INVOKED"] = "invoked";
    /** used in @atlassian/editor-referentiality */ ACTION["GOT_CONNECTIONS"] = "gotConnections";
    ACTION["LANGUAGE_SELECTED"] = "languageSelected";
    ACTION["LIST_ITEM_JOINED"] = "listItemJoined";
    ACTION["MATCHED"] = "matched";
    ACTION["MEDIA_LINK_TRANSFORMED"] = "mediaLinkTransformed";
    ACTION["NODE_CONTENT_SANITIZED"] = "nodeContentSanitized";
    ACTION["OFFLINE_STORAGE_TOO_MANY_RETRIES_ERROR"] = "offlineStorageTooManyRetriesError";
    ACTION["OFFLINE_STORAGE_FAILED_STEPS"] = "offlineStorageFailedSteps";
    ACTION["OFFLINE_STORAGE_STEPS_DATABASE_ERROR"] = "offlineStorageStepsDatabaseError";
    ACTION["OFFLINE_STORAGE_RESYNC_ONLINE"] = "offlineStorageResyncOnline";
    ACTION["OFFLINE_STORAGE_BROADCAST_CHANNEL_FIRST_UPDATE"] = "offlineStorageBroadcastChannelFirstUpdate";
    ACTION["OFFLINE_STORAGE_RESTORE_STEPS_INITIATED"] = "offlineStorageRestoreStepsInitiated";
    ACTION["OPENED"] = "opened";
    ACTION["OUTDENTED"] = "outdented";
    ACTION["PASTED"] = "pasted";
    ACTION["PASTED_AS_PLAIN"] = "pastedAsPlain";
    ACTION["PASTED_TIMED"] = "pastedTimed";
    ACTION["PRESSED"] = "pressed";
    ACTION["PROSEMIRROR_RENDERED"] = "proseMirrorRendered";
    ACTION["REACT_NODEVIEW_RENDERED"] = "reactNodeViewRendered";
    ACTION["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION["REFERENCE_SYNCED_BLOCK_UNSYNC"] = "referenceSyncedBlockUnsync";
    ACTION["REFERENCE_SYNCED_BLOCK_COPY"] = "referenceSyncedBlockCopy";
    ACTION["REPLACED_ALL"] = "replacedAll";
    ACTION["REPLACED_ONE"] = "replacedOne";
    ACTION["RESOLVED"] = "resolved";
    ACTION["REQUEST_TO_EDIT"] = "requestToEdit";
    ACTION["SELECTED"] = "selected";
    ACTION["SHOWN"] = "shown";
    ACTION["SLOW_INPUT"] = "slowInput";
    ACTION["STARTED"] = "started";
    ACTION["STOPPED"] = "stopped";
    ACTION["SUBMITTED"] = "submitted";
    ACTION["SUBSTITUTED"] = "autoSubstituted";
    ACTION["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION["SYNCED_BLOCK_UNSYNC"] = "syncedBlockUnsync";
    ACTION["SYNCED_BLOCK_EDIT_SOURCE"] = "syncedBlockEditSource";
    ACTION["SYNCED_BLOCK_VIEW_SYNCED_LOCATIONS"] = "syncedBlockViewSyncedLocations";
    ACTION["SYNCHRONY_DISCONNECTED"] = "synchronyDisconnected";
    ACTION["SYNCHRONY_ENTITY_ERROR"] = "synchronyEntityError";
    ACTION["SYNCHRONY_ERROR"] = "synchronyError";
    ACTION["TEXT_LINK_MARK_TRANSFORMED"] = "textLinkMarkTransformed";
    ACTION["TOGGLED"] = "toggled";
    ACTION["DEDUPE_MARKS_TRANSFORMED_V2"] = "dedupeMarksTransformedV2";
    ACTION["NODES_MISSING_CONTENT_TRANSFORMED"] = "nodesMissingContentTransformed";
    ACTION["INDENTATION_MARKS_TRANSFORMED"] = "indentationMarksTransformed";
    ACTION["INVALID_MEDIA_CONTENT_TRANSFORMED"] = "invalidMediaContentTransformed";
    ACTION["TOGGLE_EXPAND"] = "toggleExpand";
    ACTION["TRANSACTION_MUTATED_AFTER_DISPATCH"] = "transactionMutatedAfterDispatched";
    ACTION["TYPING_FINISHED"] = "typingFinished";
    ACTION["TYPING_STARTED"] = "typingStarted";
    ACTION["UNHANDLED_ERROR_CAUGHT"] = "unhandledErrorCaught";
    ACTION["UNLINK"] = "unlinked";
    ACTION["UNSUPPORTED_CONTENT_ENCOUNTERED"] = "unsupportedContentEncounteredV2";
    ACTION["UPDATED"] = "updated";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_FRAGMENT_MARK_NAME"] = "updatedFragmentMarkName";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_SOURCE"] = "updatedSource";
    /** used in @atlassian/editor-referentiality */ ACTION["UPDATED_TARGET"] = "updatedTarget";
    ACTION["UPLOAD_EXTERNAL_FAIL"] = "uploadExternalFailed";
    ACTION["VIEWED"] = "viewed";
    ACTION["VISITED"] = "visited";
    ACTION["WITH_PLUGIN_STATE_CALLED"] = "withPluginStateCalled";
    ACTION["RENDERED"] = "rendered";
    ACTION["RENDERED_SAMPLED"] = "renderedSampled";
    ACTION["ON_EDITOR_READY_CALLBACK"] = "onEditorReadyCallback";
    /**
	 * @private
	 * @deprecated
	 *
	 * This is no longer used and can be removed at a later date
	 */ ACTION["ON_CHANGE_CALLBACK"] = "onChangeCalled";
    ACTION["NESTED_TABLE_TRANSFORMED"] = "nestedTableTransformed";
    ACTION["NATIVE_EMBEDS_TRANSFORMED"] = "nativeEmbedsTransformed";
    ACTION["NEW_COLLAB_SYNC_UP_ERROR_NO_STEPS"] = "newCollabSyncUpErrorNoSteps";
    ACTION["REMOVE_ICON"] = "removedIcon";
    ACTION["INVALID_PROSEMIRROR_DOCUMENT"] = "invalidProsemirrorDocument";
    ACTION["DOCUMENT_PROCESSING_ERROR"] = "documentProcessingErrorV2";
    ACTION["CRASHED"] = "unhandledErrorCaughtV2";
    ACTION["SELECT_ALL_CAUGHT"] = "selectAllCaught";
    ACTION["SELECT_ALL_ESCAPED"] = "selectAllEscaped";
    ACTION["SORT_COLUMN"] = "sortedColumn";
    ACTION["SORT_COLUMN_NOT_ALLOWED"] = "sortColumnNotAllowed";
    ACTION["NCS_SESSION_STEP_METRICS"] = "ncsSessionStepMetrics";
    ACTION["STEPS_TRACKED"] = "stepsTracked";
    ACTION["ORGANIC_CHANGES_TRACKED"] = "organicChangesTracked";
    ACTION["STEPS_FILTERED"] = "stepsFiltered";
    ACTION["CREATE_NOT_ALLOWED"] = "createNotAllowed";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_SUCCEEDED"] = "unsupportedContentLevelsTrackingSucceeded";
    ACTION["UNSUPPORTED_CONTENT_LEVELS_TRACKING_ERRORED"] = "unsupportedContentLevelsTrackingErrored";
    ACTION["UNSUPPORTED_TOOLTIP_VIEWED"] = "viewed";
    ACTION["RECORD_VIDEO"] = "recordVideo";
    ACTION["INSERT_VIDEO"] = "insertVideo";
    ACTION["RECORD_VIDEO_FAILED"] = "recordVideoFailed";
    ACTION["ADD_CHILD"] = "addChild";
    ACTION["CHANGE_ACTIVE"] = "changeActive";
    ACTION["REMOVE_CHILD"] = "removeChild";
    ACTION["UPDATE_PARAMETERS"] = "updateParameters";
    ACTION["GET_CHILDREN"] = "getChildren";
    ACTION["GET_CHILDREN_CONTAINER"] = "getChildrenContainer";
    ACTION["MOVED"] = "moved";
    ACTION["UPLOAD_COMMENCED"] = "uploadCommenced";
    ACTION["UPLOAD_SUCCEEDED"] = "uploadSucceeded";
    ACTION["UPLOAD_FAILED"] = "uploadFailed";
    ACTION["TOGGLE_CODE_BLOCK_WRAP"] = "toggleCodeBlockWrap";
    ACTION["TRANSFORMED"] = "transformed";
    ACTION["RESIZED"] = "resized";
    ACTION["RESIZED_PERF_SAMPLING"] = "resizedPerfSampling";
    ACTION["BLOCKS_DRAG_INIT"] = "blocksDragInit";
    ACTION["SINGLE_COL_LAYOUT_DETECTED"] = "singleColumLayoutDetected";
    ACTION["VIEW_MORE"] = "viewMore";
    ACTION["LOCAL_ID_NOT_FOUND"] = "localIdNotFound";
    ACTION["NO_DOC_CHANGE_FOUND"] = "noDocChangeFound";
    ACTION["INVALID_COMMAND_FOUND"] = "invalidCommandFound";
    ACTION["MEDIA_SINGLE_WIDTH_TRANSFORMED"] = "mediaSingleWidthTransformed";
    /**
	 * used in Editor AI inline suggestion for a track event when a suggestion is inserted
	 * previously tracked events being used by Editor AI proactive suggestion
	 *
	 */ ACTION["SUGGESTION_INSERTED"] = "suggestionInserted";
    ACTION["SUGGESTION_DISMISSED"] = "suggestionDismissed";
    ACTION["SUGGESTION_VIEWED"] = "suggestionViewed";
    ACTION["TABLE_WIDTH_INFO"] = "tableWidthInformation";
    ACTION["SUPPRESSED"] = "suppressed";
    return ACTION;
}({});
var $09866f7fbcdd08d4$export$85f107b1fcc9d96f = /*#__PURE__*/ function(INPUT_METHOD) {
    INPUT_METHOD["ASCII"] = "ascii";
    INPUT_METHOD["AUTO"] = "auto";
    INPUT_METHOD["AUTO_DETECT"] = "autoDetect";
    INPUT_METHOD["BUTTON"] = "button";
    INPUT_METHOD["BLUR"] = "blur";
    INPUT_METHOD["CARD"] = "card";
    INPUT_METHOD["CLIPBOARD"] = "clipboard";
    INPUT_METHOD["CONFIG_PANEL"] = "configPanel";
    INPUT_METHOD["CONTEXT_MENU"] = "contextMenu";
    INPUT_METHOD["DRAG_AND_DROP"] = "dragAndDrop";
    INPUT_METHOD["DRAG"] = "drag";
    INPUT_METHOD["EXTERNAL"] = "external";
    INPUT_METHOD["EXTENSION_API"] = "extensionApi";
    INPUT_METHOD["FLOATING_TB"] = "floatingToolbar";
    INPUT_METHOD["FORMATTING"] = "autoformatting";
    INPUT_METHOD["INSERT_MENU"] = "insertMenu";
    INPUT_METHOD["INSERT_MENU_RIGHT_RAIL"] = "insertMenuRightRail";
    INPUT_METHOD["KEYBOARD"] = "keyboard";
    INPUT_METHOD["MEDIA_PICKER"] = "mediaPicker";
    INPUT_METHOD["MACRO_BROWSER"] = "macroBrowser";
    INPUT_METHOD["MANUAL"] = "manual";
    INPUT_METHOD["PICKER"] = "picker";
    INPUT_METHOD["PICKER_CLOUD"] = "cloudPicker";
    INPUT_METHOD["PREFILL"] = "prefill";
    INPUT_METHOD["QUICK_INSERT"] = "quickInsert";
    INPUT_METHOD["SHORTCUT"] = "shortcut";
    INPUT_METHOD["TOOLBAR"] = "toolbar";
    INPUT_METHOD["TYPEAHEAD"] = "typeAhead";
    INPUT_METHOD["DATASOURCE"] = "datasource_config";
    INPUT_METHOD["TABLE_CONTEXT_MENU"] = "tableContextMenu";
    INPUT_METHOD["MOUSE"] = "mouse";
    INPUT_METHOD["BROWSER"] = "browser";
    INPUT_METHOD["DOUBLE_CLICK"] = "doubleClick";
    INPUT_METHOD["META_CLICK"] = "metaClick";
    INPUT_METHOD["INLINE_SUGGESTION_FLOATING_TB"] = "inlineSuggestionFloatingToolbar";
    INPUT_METHOD["SYNCED_BLOCK_TB"] = "syncedBlockToolbar";
    INPUT_METHOD["BLOCK_MENU"] = "blockMenu";
    INPUT_METHOD["SMART_LINK"] = "smartLink";
    INPUT_METHOD["ELEMENT_BROWSER"] = "elementBrowser";
    return INPUT_METHOD;
}({});
var $09866f7fbcdd08d4$export$9b31fa32ae3f8051 = /*#__PURE__*/ function(INSERT_MEDIA_VIA) {
    INSERT_MEDIA_VIA["LOCAL_UPLOAD"] = "localUpload";
    INSERT_MEDIA_VIA["EXTERNAL_URL"] = "externalUrl";
    INSERT_MEDIA_VIA["EXTERNAL_UPLOAD"] = "externalUpload";
    return INSERT_MEDIA_VIA;
}({});
var $09866f7fbcdd08d4$export$81a8b7dba1aa8f75 = /*#__PURE__*/ function(TRIGGER_METHOD) {
    TRIGGER_METHOD["BUTTON"] = "button";
    TRIGGER_METHOD["KEYBOARD"] = "keyboard";
    TRIGGER_METHOD["SHORTCUT"] = "shortcut";
    TRIGGER_METHOD["TOOLBAR"] = "toolbar";
    TRIGGER_METHOD["EXTERNAL"] = "external";
    return TRIGGER_METHOD;
}({});
var $09866f7fbcdd08d4$export$7525482b5931e326 = /*#__PURE__*/ function(ACTION_SUBJECT) {
    ACTION_SUBJECT["AI_INTERACTION"] = "aiInteraction";
    ACTION_SUBJECT["AI_RESULT"] = "aiResult";
    ACTION_SUBJECT["AI_FEEDBACK"] = "aiFeedback";
    ACTION_SUBJECT["AI_STREAMING"] = "aiStreaming";
    ACTION_SUBJECT["COLLAB"] = "collab";
    ACTION_SUBJECT["TOOLBAR_BUTTON"] = "toolbarButton";
    ACTION_SUBJECT["BUTTON"] = "button";
    ACTION_SUBJECT["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT["CONFIG_PANEL"] = "configPanel";
    ACTION_SUBJECT["CONTENT_COMPONENT"] = "contentComponent";
    ACTION_SUBJECT["DATE"] = "date";
    ACTION_SUBJECT["DATE_SEGMENT"] = "dateSegment";
    ACTION_SUBJECT["DOCUMENT"] = "document";
    ACTION_SUBJECT["EDITOR"] = "editor";
    ACTION_SUBJECT["ACTIVITY_SESSION"] = "activitySession";
    ACTION_SUBJECT["ELEMENT_BROWSER"] = "elementBrowser";
    ACTION_SUBJECT["EMBEDS"] = "embeds";
    ACTION_SUBJECT["EXPAND"] = "expand";
    ACTION_SUBJECT["EXTENSION"] = "extension";
    ACTION_SUBJECT["FEATURE"] = "feature";
    ACTION_SUBJECT["FEEDBACK_DIALOG"] = "feedbackDialog";
    ACTION_SUBJECT["FIND_REPLACE_DIALOG"] = "findReplaceDialog";
    ACTION_SUBJECT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    ACTION_SUBJECT["FLOATING_TOOLBAR_PLUGIN"] = "floatingToolbarPlugin";
    ACTION_SUBJECT["HELP"] = "help";
    ACTION_SUBJECT["INVITE_ITEM"] = "inviteItem";
    ACTION_SUBJECT["LAYOUT"] = "layout";
    ACTION_SUBJECT["LIST"] = "list";
    ACTION_SUBJECT["MEDIA"] = "media";
    ACTION_SUBJECT["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT["MENTION"] = "mention";
    ACTION_SUBJECT["MENTION_TYPEAHEAD"] = "mentionTypeahead";
    ACTION_SUBJECT["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT["PANEL"] = "panel";
    ACTION_SUBJECT["PICKER"] = "picker";
    ACTION_SUBJECT["PLUS_MENU"] = "plusMenu";
    ACTION_SUBJECT["PLUGIN_SLOT"] = "pluginSlot";
    ACTION_SUBJECT["REQUEST_TO_EDIT_POP_UP"] = "requestToEditPopUp";
    ACTION_SUBJECT["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT["SELECTION"] = "selection";
    ACTION_SUBJECT["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT["TABLE"] = "table";
    ACTION_SUBJECT["TABLES_PLUGIN"] = "tablesPlugin";
    ACTION_SUBJECT["TEAM_MENTION_TYPEAHEAD"] = "teamMentionTypeahead";
    ACTION_SUBJECT["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT["TEXT"] = "text";
    ACTION_SUBJECT["TOOLBAR"] = "toolbar";
    ACTION_SUBJECT["TYPEAHEAD"] = "typeAhead";
    ACTION_SUBJECT["TYPEAHEAD_ITEM"] = "typeAheadItem";
    ACTION_SUBJECT["ANNOTATION"] = "annotation";
    ACTION_SUBJECT["SEARCH_RESULT"] = "searchResult";
    ACTION_SUBJECT["CREATE_LINK_INLINE_DIALOG"] = "createLinkInlineDialog";
    ACTION_SUBJECT["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT["REACT_EDITOR_VIEW"] = "reactEditorView";
    ACTION_SUBJECT["RENDERER"] = "renderer";
    ACTION_SUBJECT["ANCHOR_LINK"] = "anchorLink";
    ACTION_SUBJECT["LINK"] = "link";
    ACTION_SUBJECT["TOOLTIP"] = "tooltip";
    ACTION_SUBJECT["LOOM"] = "loom";
    ACTION_SUBJECT["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT["BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT["DROP_TARGET"] = "dropTarget";
    ACTION_SUBJECT["DRAG"] = "drag";
    ACTION_SUBJECT["ELEMENT"] = "element";
    ACTION_SUBJECT["INLINE_DIALOG"] = "inlineDialog";
    ACTION_SUBJECT["ENGAGEMENT_PLATFORM"] = "engagementPlatform";
    ACTION_SUBJECT["MEDIA_VIEWER"] = "mediaViewer";
    ACTION_SUBJECT["DECORATION"] = "decoration";
    ACTION_SUBJECT["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT["EDITOR_PLUGIN_SELECTION_EXTENSION"] = "editorPluginSelectionExtension";
    ACTION_SUBJECT["AI_DEFINITIONS"] = "aiDefinitions";
    ACTION_SUBJECT["USER_PREFERENCES"] = "userPreferences";
    ACTION_SUBJECT["ALIGNMENT"] = "alignment";
    ACTION_SUBJECT["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU"] = "toolbarDropdownMenu";
    ACTION_SUBJECT["TOOLBAR_DROPDOWN_MENU_ITEM"] = "toolbarDropdownMenuItem";
    ACTION_SUBJECT["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT["BLOCK_MENU_ITEM"] = "blockMenuItem";
    ACTION_SUBJECT["SYNCED_BLOCK"] = "syncedBlock";
    return ACTION_SUBJECT;
}({});
var $09866f7fbcdd08d4$export$9957974f8b4d8f74 = /*#__PURE__*/ function(ACTION_SUBJECT_ID) {
    ACTION_SUBJECT_ID["ACTION"] = "action";
    ACTION_SUBJECT_ID["ACTIVITY"] = "activity";
    ACTION_SUBJECT_ID["AI_CHANGES_ACCEPT_BUTTON"] = "aiChangesAcceptButton";
    ACTION_SUBJECT_ID["AI_CHANGES_REJECT_BUTTON"] = "aiChangesRejectButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_DEFINE_BUTTON"] = "aiDefinitionsDefineButton";
    ACTION_SUBJECT_ID["AI_DEFINITIONS_AUTO_HIGHLIGHT"] = "aiDefinitionsAutoHighlight";
    ACTION_SUBJECT_ID["AI_INLINE_SUGGESTION"] = "aiInlineSuggestion";
    ACTION_SUBJECT_ID["AI_PANELS_BODIED_EXTENSION"] = "aiPanelsBodiedExtension";
    ACTION_SUBJECT_ID["AI_PROMPT_LINK_PICKER_BUTTON"] = "aiPromptLinkPickerButton";
    ACTION_SUBJECT_ID["AI_PROMPT_MENTION_BUTTON"] = "aiPromptMentionButton";
    ACTION_SUBJECT_ID["AI_PROACTIVE_FEEDBACK_DIALOG"] = "aiProactiveFeedbackDialog";
    ACTION_SUBJECT_ID["AI_ASK_ROVO_BUTTON"] = "aiAskRovoButton";
    ACTION_SUBJECT_ID["AI_HERO_PROMPT_BUTTON"] = "aiHeroPromptButton";
    ACTION_SUBJECT_ID["AI_MORE_ROVO_OPTIONS"] = "aiMoreRovoOptions";
    ACTION_SUBJECT_ID["AI_TRANSLATE"] = "aiTranslate";
    ACTION_SUBJECT_ID["AI_CHANGE_TONE"] = "aiChangeTone";
    ACTION_SUBJECT_ID["ALL"] = "all";
    ACTION_SUBJECT_ID["ALT_TEXT"] = "altText";
    ACTION_SUBJECT_ID["ANNOTATE_BUTTON"] = "annotateButton";
    ACTION_SUBJECT_ID["AVATAR_GROUP_PLUGIN"] = "AvatarGroupInPlugin";
    ACTION_SUBJECT_ID["BLOCK_MENU"] = "blockMenu";
    ACTION_SUBJECT_ID["BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["BORDER"] = "border";
    ACTION_SUBJECT_ID["BUTTON_CATEGORY"] = "categoryButton";
    ACTION_SUBJECT_ID["BUTTON_FEEDBACK"] = "feedbackButton";
    ACTION_SUBJECT_ID["BUTTON_HELP"] = "helpButton";
    ACTION_SUBJECT_ID["CANCEL"] = "cancel";
    ACTION_SUBJECT_ID["CAPTION"] = "caption";
    ACTION_SUBJECT_ID["CARD_BLOCK"] = "blockCard";
    ACTION_SUBJECT_ID["CARD_INLINE"] = "inlineCard";
    ACTION_SUBJECT_ID["CELL"] = "cell";
    ACTION_SUBJECT_ID["CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["CODEBLOCK_COPY"] = "codeBlockCopy";
    ACTION_SUBJECT_ID["CODEBLOCK_WRAP"] = "codeBlockWrap";
    ACTION_SUBJECT_ID["COPY_BUTTON"] = "copyButton";
    ACTION_SUBJECT_ID["COPY_LINK_TO_ANCHOR"] = "copyLinkToAnchor";
    ACTION_SUBJECT_ID["COPY_BLOCK"] = "copyBlock";
    ACTION_SUBJECT_ID["COPY_LINK_TO_BLOCK"] = "copyLinkToBlock";
    ACTION_SUBJECT_ID["DELETE_BLOCK"] = "deleteBlock";
    ACTION_SUBJECT_ID["MOVE_UP_BLOCK"] = "moveUpBlock";
    ACTION_SUBJECT_ID["MOVE_DOWN_BLOCK"] = "moveDownBlock";
    ACTION_SUBJECT_ID["TRANSFORM_BLOCK"] = "transformBlock";
    ACTION_SUBJECT_ID["FORMAT_MENU"] = "formatMenu";
    ACTION_SUBJECT_ID["CREATE_INLINE_COMMENT_FROM_HIGHLIGHT_ACTIONS_MENU"] = "createInlineCommentFromHighlightActionsMenu";
    ACTION_SUBJECT_ID["DATE"] = "date";
    ACTION_SUBJECT_ID["DATE_DAY"] = "day";
    ACTION_SUBJECT_ID["DATE_MONTH"] = "month";
    ACTION_SUBJECT_ID["DATE_YEAR"] = "year";
    ACTION_SUBJECT_ID["DECISION"] = "decision";
    ACTION_SUBJECT_ID["DISCARD_STREAM"] = "discardStream";
    ACTION_SUBJECT_ID["DIVIDER"] = "divider";
    ACTION_SUBJECT_ID["EDIT_LINK"] = "editLink";
    ACTION_SUBJECT_ID["EDIT_DATASOURCE"] = "editDatasource";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_AI"] = "editorPluginAI";
    ACTION_SUBJECT_ID["ELEMENT_DRAG_HANDLE"] = "elementDragHandle";
    ACTION_SUBJECT_ID["ELEMENT_DROP_TARGET"] = "elementDropTarget";
    ACTION_SUBJECT_ID["EMBEDS"] = "embeds";
    ACTION_SUBJECT_ID["EMOJI"] = "emoji";
    ACTION_SUBJECT_ID["EXPAND"] = "expand";
    ACTION_SUBJECT_ID["EXPERIENCE_APPLICATION"] = "experienceApplication";
    ACTION_SUBJECT_ID["EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_API"] = "extensionApi";
    ACTION_SUBJECT_ID["EXTENSION_BLOCK"] = "extension";
    ACTION_SUBJECT_ID["EXTENSION_BODIED"] = "bodiedExtension";
    ACTION_SUBJECT_ID["EXTENSION_INLINE"] = "inlineExtension";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR_OVERFLOW"] = "floatingToolbarOverflow";
    ACTION_SUBJECT_ID["FLOATING_TOOLBAR"] = "floatingToolbar";
    ACTION_SUBJECT_ID["FORMAT_BACKGROUND_COLOR"] = "backgroundColor";
    ACTION_SUBJECT_ID["FORMAT_BLOCK_QUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["FORMAT_CLEAR"] = "clearFormatting";
    ACTION_SUBJECT_ID["FORMAT_CODE"] = "code";
    ACTION_SUBJECT_ID["FORMAT_COLOR"] = "color";
    ACTION_SUBJECT_ID["FORMAT_HEADING"] = "heading";
    ACTION_SUBJECT_ID["FORMAT_INDENT"] = "indentation";
    ACTION_SUBJECT_ID["FORMAT_ITALIC"] = "italic";
    ACTION_SUBJECT_ID["FORMAT_LIST_BULLET"] = "bulletedList";
    ACTION_SUBJECT_ID["FORMAT_LIST_NUMBER"] = "numberedList";
    ACTION_SUBJECT_ID["FORMAT_STRIKE"] = "strike";
    ACTION_SUBJECT_ID["FORMAT_STRONG"] = "strong";
    ACTION_SUBJECT_ID["FORMAT_SUB"] = "subscript";
    ACTION_SUBJECT_ID["FORMAT_SUPER"] = "superscript";
    ACTION_SUBJECT_ID["FORMAT_UNDERLINE"] = "underline";
    ACTION_SUBJECT_ID["FRAGMENT_MARK"] = "fragmentMark";
    ACTION_SUBJECT_ID["GOTO_SMART_LINK_SETTINGS"] = "goToSmartLinkSettings";
    ACTION_SUBJECT_ID["HELP_QUICK_INSERT"] = "helpQuickInsert";
    ACTION_SUBJECT_ID["HOVER_LABEL"] = "hoverLabel";
    ACTION_SUBJECT_ID["HYPERLINK"] = "hyperlink";
    ACTION_SUBJECT_ID["INLINE_COMMENT"] = "inlineComment";
    ACTION_SUBJECT_ID["LAYOUT"] = "layout";
    ACTION_SUBJECT_ID["LINE_BREAK"] = "lineBreak";
    ACTION_SUBJECT_ID["LINK"] = "link";
    ACTION_SUBJECT_ID["LINK_PREVIEW"] = "linkPreview";
    ACTION_SUBJECT_ID["LINK_SEARCH_INPUT"] = "linkSearchInput";
    ACTION_SUBJECT_ID["MEDIA"] = "media";
    ACTION_SUBJECT_ID["MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["MEDIA_INLINE"] = "mediaInline";
    ACTION_SUBJECT_ID["MEDIA_INLINE_IMAGE"] = "mediaInlineImage";
    ACTION_SUBJECT_ID["MEDIA_LINK"] = "mediaLink";
    ACTION_SUBJECT_ID["MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["MENTION"] = "mention";
    ACTION_SUBJECT_ID["MENTION_PROVIDER"] = "mentionProvider";
    ACTION_SUBJECT_ID["NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["NODE"] = "node";
    ACTION_SUBJECT_ID["OPEN_LINK"] = "openLink";
    ACTION_SUBJECT_ID["OFFLINE_EDITING"] = "offlineEditing";
    ACTION_SUBJECT_ID["PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_BLOCK_CARD"] = "blockCard";
    ACTION_SUBJECT_ID["PASTE_BLOCKQUOTE"] = "blockQuote";
    ACTION_SUBJECT_ID["PASTE_BODIED_EXTENSION"] = "bodiedExtension";
    ACTION_SUBJECT_ID["PASTE_BULLET_LIST"] = "bulletList";
    ACTION_SUBJECT_ID["PASTE_CODE_BLOCK"] = "codeBlock";
    ACTION_SUBJECT_ID["PASTE_DECISION_LIST"] = "decisionList";
    ACTION_SUBJECT_ID["PASTE_EXPAND"] = "expand";
    ACTION_SUBJECT_ID["PASTE_EXTENSION"] = "extension";
    ACTION_SUBJECT_ID["PASTE_HEADING"] = "heading";
    ACTION_SUBJECT_ID["PASTE_MEDIA_GROUP"] = "mediaGroup";
    ACTION_SUBJECT_ID["PASTE_MEDIA_SINGLE"] = "mediaSingle";
    ACTION_SUBJECT_ID["PASTE_NESTED_EXPAND"] = "nestedExpand";
    ACTION_SUBJECT_ID["PASTE_ORDERED_LIST"] = "orderedList";
    ACTION_SUBJECT_ID["PASTE_PANEL"] = "panel";
    ACTION_SUBJECT_ID["PASTE_PARAGRAPH"] = "paragraph";
    ACTION_SUBJECT_ID["PASTE_RULE"] = "rule";
    ACTION_SUBJECT_ID["PASTE_TABLE"] = "table";
    ACTION_SUBJECT_ID["PASTE_TABLE_CELL"] = "tableCell";
    ACTION_SUBJECT_ID["PASTE_TABLE_HEADER"] = "tableHeader";
    ACTION_SUBJECT_ID["PASTE_TABLE_ROW"] = "tableRow";
    ACTION_SUBJECT_ID["PASTE_TASK_LIST"] = "taskList";
    ACTION_SUBJECT_ID["PICKER_CLOUD"] = "cloudPicker";
    ACTION_SUBJECT_ID["PICKER_MEDIA"] = "mediaPicker";
    ACTION_SUBJECT_ID["PICKER_COLOR"] = "colorPicker";
    ACTION_SUBJECT_ID["PICKER_EMOJI"] = "emojiPicker";
    ACTION_SUBJECT_ID["PICKER_TABLE_SIZE"] = "tableSizePicker";
    ACTION_SUBJECT_ID["DOCKED_PRIMARY_TOOLBAR"] = "dockedPrimaryToolbar";
    ACTION_SUBJECT_ID["PLACEHOLDER_TEXT"] = "placeholderText";
    ACTION_SUBJECT_ID["POST_QUERY_SEARCH_RESULTS"] = "postQuerySearchResults";
    ACTION_SUBJECT_ID["PRE_QUERY_SEARCH_RESULTS"] = "preQuerySearchResults";
    ACTION_SUBJECT_ID["PRIMARY_TOOLBAR"] = "primaryToolbar";
    ACTION_SUBJECT_ID["PROACTIVE_SUGGESTION"] = "proactiveSuggestion";
    ACTION_SUBJECT_ID["PRODUCT_NAME"] = "productName";
    ACTION_SUBJECT_ID["PUNC"] = "punctuation";
    ACTION_SUBJECT_ID["QUICK_SEARCH"] = "quickSearch";
    ACTION_SUBJECT_ID["QUICK_INSERT"] = "quickInsert";
    ACTION_SUBJECT_ID["RANGE"] = "range";
    ACTION_SUBJECT_ID["REACT_NODE_VIEW"] = "reactNodeView";
    ACTION_SUBJECT_ID["RECENT_ACTIVITIES"] = "recentActivities";
    ACTION_SUBJECT_ID["RESIZED"] = "resized";
    ACTION_SUBJECT_ID["RESPONSE_FEEDBACK_BUTTON"] = "responseFeedbackButton";
    ACTION_SUBJECT_ID["RICH_MEDIA_LAYOUT"] = "richMediaLayout";
    ACTION_SUBJECT_ID["SAVE"] = "save";
    ACTION_SUBJECT_ID["SECTION"] = "section";
    ACTION_SUBJECT_ID["SMART_LINK"] = "smartLink";
    ACTION_SUBJECT_ID["SMART_LINK_TOOLBAR"] = "smartLinkToolbar";
    ACTION_SUBJECT_ID["STATUS"] = "status";
    ACTION_SUBJECT_ID["SYMBOL"] = "symbol";
    ACTION_SUBJECT_ID["TABLE"] = "table";
    ACTION_SUBJECT_ID["TELEPOINTER"] = "telepointer";
    ACTION_SUBJECT_ID["TEXT"] = "text";
    ACTION_SUBJECT_ID["TYPEAHEAD_EMOJI"] = "emojiTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_LINK"] = "linkTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_MENTION"] = "mentionTypeAhead";
    ACTION_SUBJECT_ID["TYPEAHEAD_QUICK_INSERT"] = "quickInsertTypeAhead";
    ACTION_SUBJECT_ID["TOOLBAR_PREVIEW"] = "previewFromToolbar";
    ACTION_SUBJECT_ID["UNKNOWN_NODE"] = "unknownNode";
    ACTION_SUBJECT_ID["UNLINK"] = "unlink";
    ACTION_SUBJECT_ID["HEADING_ANCHOR_LINK"] = "headingAnchorLink";
    ACTION_SUBJECT_ID["UNSUPPORTED_ERROR"] = "unsupportedUnhandled";
    ACTION_SUBJECT_ID["UNSUPPORTED_NODE_ATTRIBUTE"] = "unsupportedNodeAttribute";
    ACTION_SUBJECT_ID["UNSUPPORTED_BLOCK"] = "unsupportedBlock";
    ACTION_SUBJECT_ID["UNSUPPORTED_INLINE"] = "unsupportedInline";
    ACTION_SUBJECT_ID["UNSUPPORTED_MARK"] = "unsupportedMark";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_INLINE"] = "onUnsupportedInline";
    ACTION_SUBJECT_ID["ON_UNSUPPORTED_BLOCK"] = "onUnsupportedBlock";
    ACTION_SUBJECT_ID["MULTI_BODIED_EXTENSION"] = "multiBodiedExtension";
    ACTION_SUBJECT_ID["UPDATE_STREAM"] = "updateStream";
    ACTION_SUBJECT_ID["UPLOAD_MEDIA"] = "uploadMedia";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR_PREFERENCES"] = "selectionToolbarPreferences";
    ACTION_SUBJECT_ID["SELECTION_TOOLBAR"] = "selectionToolbar";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_DROPDOWN"] = "editorPluginSelectionExtensionDropdown";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_ITEM"] = "editorPluginSelectionExtensionItem";
    ACTION_SUBJECT_ID["EDITOR_PLUGIN_SELECTION_EXTENSION_COMPONENT"] = "editorPluginSelectionExtensionComponent";
    ACTION_SUBJECT_ID["TRANSFORM"] = "transform";
    ACTION_SUBJECT_ID["BODIED_SYNCED_BLOCK"] = "bodiedSyncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK"] = "syncBlock";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_TOOLBAR"] = "syncedBlockToolbar";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_COPY"] = "syncedBlockCopy";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SOURCE_URL"] = "syncedBlockSourceUrl";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE_CACHE"] = "syncedBlockUpdateCache";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_UPDATE"] = "syncedBlockUpdate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_UPDATE"] = "referenceSyncedBlockUpdate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CREATE"] = "syncedBlockCreate";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_CREATE"] = "referenceSyncedBlockCreate";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_DELETE"] = "syncedBlockDelete";
    ACTION_SUBJECT_ID["REFERENCE_SYNCED_BLOCK_DELETE"] = "referenceSyncedBlockDelete";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_GET_SOURCE_INFO"] = "syncedBlockGetSourceInfo";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH"] = "syncedBlockFetch";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_FETCH_REFERENCES"] = "syncedBlockFetchReferences";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_CLICK_SYNCED_LOCATION"] = "syncedBlockClickSyncedLocation";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_LABEL"] = "syncedBlockLabel";
    ACTION_SUBJECT_ID["SYNCED_BLOCK_SSR_ERROR"] = "syncedBlockSSRError";
    ACTION_SUBJECT_ID["TABLE_STICKY_HEADER"] = "tableStickyHeader";
    return ACTION_SUBJECT_ID;
}({});
var $09866f7fbcdd08d4$export$75ef928acd21e35b = /*#__PURE__*/ function(FLOATING_CONTROLS_TITLE) {
    FLOATING_CONTROLS_TITLE["CODE_BLOCK"] = "codeBlockFloatingControls";
    FLOATING_CONTROLS_TITLE["EXTENSION"] = "extensionFloatingControls";
    FLOATING_CONTROLS_TITLE["HYPERLINK"] = "hyperlinkFloatingControls";
    FLOATING_CONTROLS_TITLE["MEDIA"] = "mediaFloatingControls";
    FLOATING_CONTROLS_TITLE["PANEL"] = "panelFloatingControls";
    FLOATING_CONTROLS_TITLE["TABLE"] = "tableFloatingControls";
    FLOATING_CONTROLS_TITLE["EXPAND"] = "expandToolbar";
    return FLOATING_CONTROLS_TITLE;
}({});
var $09866f7fbcdd08d4$export$9f0b2adf3cfd71b7 = /*#__PURE__*/ function(CONTENT_COMPONENT) {
    CONTENT_COMPONENT["INLINE_COMMENT"] = "inlineComment";
    CONTENT_COMPONENT["FLOATING_CONTEXTUAL_BUTTON"] = "floatingContextualButton";
    CONTENT_COMPONENT["FLOATING_INSERT_BUTTON"] = "floatingInsertButton";
    CONTENT_COMPONENT["FLOATING_TOOLBAR"] = "floatingToolbar";
    CONTENT_COMPONENT["SELECTION_TOOLBAR"] = "selectionToolbar";
    return CONTENT_COMPONENT;
}({});
module.exports["EVENT_TYPE"] = $09866f7fbcdd08d4$export$76a2e4c433c23bb9;
module.exports["ACTION"] = $09866f7fbcdd08d4$export$9523889e0a5da4ba;
module.exports["INPUT_METHOD"] = $09866f7fbcdd08d4$export$85f107b1fcc9d96f;
module.exports["INSERT_MEDIA_VIA"] = $09866f7fbcdd08d4$export$9b31fa32ae3f8051;
module.exports["TRIGGER_METHOD"] = $09866f7fbcdd08d4$export$81a8b7dba1aa8f75;
module.exports["ACTION_SUBJECT"] = $09866f7fbcdd08d4$export$7525482b5931e326;
module.exports["ACTION_SUBJECT_ID"] = $09866f7fbcdd08d4$export$9957974f8b4d8f74;
module.exports["CONTENT_COMPONENT"] = $09866f7fbcdd08d4$export$9f0b2adf3cfd71b7;

});

parcelRegister("h9yJL", function(module, exports) {
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $a4TK8 = parcelRequire("a4TK8");


var $4HD7y = parcelRequire("4HD7y");

var $4dOgb = parcelRequire("4dOgb");

var $4r9Pq = parcelRequire("4r9Pq");

var $jTb2k = parcelRequire("jTb2k");

var $gQUY7 = parcelRequire("gQUY7");

var $jblCI = parcelRequire("jblCI");

var $kZ3vg = parcelRequire("kZ3vg");

var $CmplZ = parcelRequire("CmplZ");

var $63Ztt = parcelRequire("63Ztt");


var $iyDxB = parcelRequire("iyDxB");

const $08eccc3aac6e9e51$var$defaultAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return true;
    }
};
const $08eccc3aac6e9e51$var$defaultDoNotAllowOverrideBehaviour = {
    canOverrideUnsupportedMark: ()=>{
        return false;
    }
};
const $08eccc3aac6e9e51$export$28e4e3c024cce988 = (type)=>{
    switch(type){
        case 'link':
        case 'em':
        case 'strong':
        case 'strike':
        case 'subsup':
        case 'underline':
        case 'code':
        case 'textColor':
        case 'backgroundColor':
        case 'confluenceInlineComment':
        case 'breakout':
        case 'alignment':
        case 'indentation':
        case 'border':
            return $08eccc3aac6e9e51$var$defaultAllowOverrideBehaviour;
        default:
            return $08eccc3aac6e9e51$var$defaultDoNotAllowOverrideBehaviour;
    }
};



var $dDZcC = parcelRequire("dDZcC");


var $6jPem = parcelRequire("6jPem");

function $36b0fc3bb7ba2bf8$export$9bf001d8ef76e497(node) {
    const newNode = {
        ...node
    };
    delete newNode.marks;
    return newNode;
}
function $36b0fc3bb7ba2bf8$export$8cae9126fc577085(node) {
    const newNode = {
        ...node
    };
    if (node.marks) newNode.marks = node.marks.filter((mark)=>mark.type === 'annotation');
    return newNode;
}


const $f8993b2ce626873e$var$hasNestedTable = (tableCellNode)=>tableCellNode.content?.some((node)=>node?.type === 'table');
function $f8993b2ce626873e$export$48b382180baf8e88(json, options = {}) {
    const { keepNestedTables: keepNestedTables = false } = options;
    const sanitizedJSON = (0, $6jPem.traverse)(json, {
        text: (node)=>{
            if (!node || !Array.isArray(node.marks)) return node;
            return {
                ...node,
                marks: node.marks.filter((mark)=>mark.type !== 'typeAheadQuery')
            };
        },
        status: (node)=>{
            if (node.attrs && !!node.attrs.text) return (0, $36b0fc3bb7ba2bf8$export$8cae9126fc577085)(node);
            return false; // empty status
        },
        caption: (node)=>{
            if (node.content) return node;
            return false; // empty caption
        },
        tableCell: (node)=>{
            if ($f8993b2ce626873e$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        tableHeader: (node)=>{
            if ($f8993b2ce626873e$var$hasNestedTable(node)) return keepNestedTables ? node : (0, $dDZcC.transformNestedTableNodeOutgoingDocument)(node);
            return;
        },
        emoji: (0, $36b0fc3bb7ba2bf8$export$8cae9126fc577085),
        mention: (0, $36b0fc3bb7ba2bf8$export$8cae9126fc577085),
        date: (0, $36b0fc3bb7ba2bf8$export$8cae9126fc577085),
        hardBreak: (0, $36b0fc3bb7ba2bf8$export$9bf001d8ef76e497),
        inlineCard: (0, $36b0fc3bb7ba2bf8$export$8cae9126fc577085)
    });
    return sanitizedJSON;
}


var $f8f7a748914a9c23$export$933e6445c497ffd5 = /*#__PURE__*/ function(SchemaStage) {
    SchemaStage["FINAL"] = "final";
    SchemaStage["STAGE_0"] = "stage0";
    return SchemaStage;
}({});
const $f8f7a748914a9c23$var$isType = (type)=>(node)=>node.type.name === type;
// Create a Set of node types that should have empty attrs removed
const $f8f7a748914a9c23$var$NODES_WITH_EMPTY_ATTRS_REMOVAL = new Set([
    'paragraph',
    'layoutSection',
    'blockquote',
    'nestedExpand',
    'bulletList',
    'listItem',
    'orderedList',
    'rule',
    'caption',
    'tableRow',
    'media',
    'mediaSingle',
    'mediaInline'
]);
const $f8f7a748914a9c23$var$isCodeBlock = $f8f7a748914a9c23$var$isType('codeBlock');
const $f8f7a748914a9c23$var$isMediaNode = $f8f7a748914a9c23$var$isType('media');
const $f8f7a748914a9c23$var$isMediaInline = $f8f7a748914a9c23$var$isType('mediaInline');
const $f8f7a748914a9c23$var$isMediaSingleNode = $f8f7a748914a9c23$var$isType('mediaSingle');
const $f8f7a748914a9c23$var$isMentionNode = $f8f7a748914a9c23$var$isType('mention');
const $f8f7a748914a9c23$var$isParagraph = $f8f7a748914a9c23$var$isType('paragraph');
const $f8f7a748914a9c23$var$isHeading = $f8f7a748914a9c23$var$isType('heading');
const $f8f7a748914a9c23$var$isTable = $f8f7a748914a9c23$var$isType('table');
const $f8f7a748914a9c23$var$isTableCell = $f8f7a748914a9c23$var$isType('tableCell');
const $f8f7a748914a9c23$var$isTableHeader = $f8f7a748914a9c23$var$isType('tableHeader');
const $f8f7a748914a9c23$var$isLinkMark = $f8f7a748914a9c23$var$isType('link');
const $f8f7a748914a9c23$var$isUnsupportedMark = $f8f7a748914a9c23$var$isType('unsupportedMark');
const $f8f7a748914a9c23$var$isUnsupportedNodeAttributeMark = $f8f7a748914a9c23$var$isType('unsupportedNodeAttribute');
const $f8f7a748914a9c23$var$isExpand = $f8f7a748914a9c23$var$isType('expand');
const $f8f7a748914a9c23$var$isNestedExpand = $f8f7a748914a9c23$var$isType('nestedExpand');
const $f8f7a748914a9c23$var$isUnsupportedNode = (node)=>$f8f7a748914a9c23$var$isType('unsupportedBlock')(node) || $f8f7a748914a9c23$var$isType('unsupportedInline')(node);
const $f8f7a748914a9c23$var$isDataConsumer = $f8f7a748914a9c23$var$isType('dataConsumer');
const $f8f7a748914a9c23$var$isFragmentMark = $f8f7a748914a9c23$var$isType('fragment');
const $f8f7a748914a9c23$var$isHardBreak = $f8f7a748914a9c23$var$isType('hardBreak');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $f8f7a748914a9c23$var$filterNull = (subject)=>{
    let output = {
        ...subject
    };
    // eslint-disable-next-line guard-for-in
    for(const key in output){
        const current = output[key];
        if (current === null) {
            const { [key]: unusedKey, ...filteredObj } = output;
            output = filteredObj;
        } else if (typeof current === 'object' && !Array.isArray(current)) output[key] = $f8f7a748914a9c23$var$filterNull(current);
    }
    return output;
};
const $f8f7a748914a9c23$var$createDocFromContent = (content)=>{
    return {
        version: 1,
        type: 'doc',
        content: content || []
    };
};
const $f8f7a748914a9c23$var$emptyDoc = $f8f7a748914a9c23$var$createDocFromContent([
    {
        type: 'paragraph',
        content: []
    }
]);
/**
 * Transforms a Prosemirror node into a JSON representation. Compared with
 * native Prosemirror JSON, this representation ensures we have valid ADF attrs.
 *
 * @param node The Prosemirror node to transform.
 * @param mentionMap A map of mention IDs to their display names.
 * @returns The JSON representation of the node.
 */ const $f8f7a748914a9c23$export$3a858d3babd60825 = (node, mentionMap)=>{
    const obj = {
        type: node.type.name
    };
    if ($f8f7a748914a9c23$var$isUnsupportedNode(node)) return node.attrs.originalValue;
    else if ($f8f7a748914a9c23$var$isMediaNode(node)) obj.attrs = (0, $kZ3vg.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isMediaSingleNode(node)) obj.attrs = (0, $jblCI.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isMediaInline(node)) obj.attrs = (0, $kZ3vg.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isMentionNode(node)) obj.attrs = (0, $CmplZ.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isCodeBlock(node)) obj.attrs = (0, $4HD7y.toJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isTable(node)) obj.attrs = (0, $63Ztt.tableToJSON)(node).attrs;
    else if ($f8f7a748914a9c23$var$isTableCell(node)) obj.attrs = (0, $63Ztt.toJSONTableCell)(node).attrs;
    else if ($f8f7a748914a9c23$var$isTableHeader(node)) obj.attrs = (0, $63Ztt.toJSONTableHeader)(node).attrs;
    else if ($f8f7a748914a9c23$var$isExpand(node) || $f8f7a748914a9c23$var$isNestedExpand(node)) obj.attrs = (0, $4r9Pq.toJSON)(node).attrs;
    else if (node.attrs && Object.keys(node.attrs).length) obj.attrs = node.attrs;
    if (obj.attrs) obj.attrs = $f8f7a748914a9c23$var$filterNull(obj.attrs);
    if ($f8f7a748914a9c23$var$isMentionNode(node) && mentionMap) {
        // If the mentionMap exists and has a name defined then we should use it and prepend @ to the begining of it.
        const name = !!mentionMap?.[node.attrs.id] ? `@${mentionMap[node.attrs.id]}` : '';
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const text = obj.attrs?.text ?? '';
        obj.attrs = {
            ...obj.attrs,
            // If an explicit text value is set on the mention then that should take priority over the mentionMap value.
            text: !!text ? text : name
        };
    }
    if ($f8f7a748914a9c23$var$NODES_WITH_EMPTY_ATTRS_REMOVAL.has(node.type.name) && obj.attrs && !Object.keys(obj.attrs).length || $f8f7a748914a9c23$var$isHardBreak(node)) delete obj.attrs;
    if (node.isText) obj.text = node.textContent;
    else node.content.forEach((child)=>{
        obj.content = obj.content || [];
        obj.content.push($f8f7a748914a9c23$export$3a858d3babd60825(child, mentionMap));
    });
    if ($f8f7a748914a9c23$var$isParagraph(node) || $f8f7a748914a9c23$var$isHeading(node)) obj.content = obj.content || [];
    if (node.marks.length) {
        // Run any custom mark serialisers
        const parsedMarks = node.marks.map((mark)=>{
            if ($f8f7a748914a9c23$var$isUnsupportedMark(mark)) return $f8f7a748914a9c23$var$canOverrideMark(mark, node.marks) ? null : mark.attrs.originalValue;
            else if ($f8f7a748914a9c23$var$isUnsupportedNodeAttributeMark(mark)) return null;
            else if ($f8f7a748914a9c23$var$isLinkMark(mark)) return (0, $gQUY7.toJSON)(mark);
            else if ($f8f7a748914a9c23$var$isDataConsumer(mark)) {
                const serialised = (0, $4dOgb.toJSON)(mark);
                return !serialised.attrs.sources || serialised.attrs.sources?.length === 0 ? null : serialised;
            } else if ($f8f7a748914a9c23$var$isFragmentMark(mark)) {
                const fragmentMark = (0, $jTb2k.toJSON)(mark);
                if (!fragmentMark.attrs.localId) return null;
                return fragmentMark;
            } else return mark.toJSON();
        }).filter((maybeMark)=>maybeMark !== null);
        // Only set if we have a non-empty array, otherwise explicitly undefine it (as we only run this path if `node.marks.length`)
        obj.marks = parsedMarks?.length > 0 ? parsedMarks : undefined;
        const nodeAttributeMark = node.marks.find($f8f7a748914a9c23$var$isUnsupportedNodeAttributeMark);
        if (nodeAttributeMark && nodeAttributeMark.attrs.type.nodeType === obj.type) obj.attrs = {
            ...$f8f7a748914a9c23$var$getUnwrappedNodeAttributes(node, nodeAttributeMark, obj)
        };
    }
    return obj;
};
const $f8f7a748914a9c23$var$canOverrideMark = (mark, existingMarks)=>{
    if (existingMarks.some((e)=>mark.attrs.originalValue.type === e.type.name)) return (0, $08eccc3aac6e9e51$export$28e4e3c024cce988)(mark.attrs.originalValue.type).canOverrideUnsupportedMark();
    return false;
};
const $f8f7a748914a9c23$var$getUnwrappedNodeAttributes = (node, mark, obj)=>{
    const nodeAttributes = node.type.spec.attrs;
    const attributes = {
        ...mark.attrs.unsupported,
        ...obj.attrs
    };
    // Ignored via go/ees005
    // eslint-disable-next-line no-var
    for(var key in obj.attrs)if (obj.attrs.hasOwnProperty(key)) {
        const attribute = nodeAttributes ? nodeAttributes[key] : null;
        if (attribute) {
            if (attribute.default === node.attrs[key] && mark.attrs.unsupported[key]) return {
                ...attributes,
                [key]: mark.attrs.unsupported[key]
            };
        }
    }
    return attributes;
};
class $f8f7a748914a9c23$export$98cb1d9308d0944d {
    encode(node, options = {}) {
        const content = [];
        node.content.forEach((child)=>{
            content.push((0, $f8993b2ce626873e$export$48b382180baf8e88)($f8f7a748914a9c23$export$3a858d3babd60825(child, this.mentionMap), options));
        });
        if (!content || (0, (/*@__PURE__*/$parcel$interopDefault($a4TK8)))(content, $f8f7a748914a9c23$var$emptyDoc.content)) return $f8f7a748914a9c23$var$createDocFromContent([]);
        return $f8f7a748914a9c23$var$createDocFromContent(content);
    }
    internalParse(content, schema) {
        const doc = schema.nodeFromJSON(content);
        doc.check();
        return doc;
    }
    parse(content, stage) {
        if (content.type !== 'doc') throw new Error('Expected content format to be ADF');
        const schema = !!stage ? (0, $iyDxB.getSchemaBasedOnStage)(stage) : this.schema;
        if (!content.content || content.content.length === 0) return this.internalParse($f8f7a748914a9c23$var$emptyDoc, schema);
        return this.internalParse(content, schema);
    }
    /**
   * This method is used to encode a single node
   */ encodeNode(node) {
        return (0, $f8993b2ce626873e$export$48b382180baf8e88)($f8f7a748914a9c23$export$3a858d3babd60825(node, this.mentionMap));
    }
    /**
   * @param schema The current editor schema
   * @param mentionMap An optional mapping of user IDs to mention names. This is used by the encoder to substitute empty
   * mention node.attr.text values with mapped names.
   */ constructor(schema = (0, $iyDxB.defaultSchema), mentionMap){
        this.schema = void 0;
        this.mentionMap = void 0;
        this.schema = schema;
        this.mentionMap = mentionMap;
    }
}
function $f8f7a748914a9c23$export$1c4065b3a9f04cf2(value) {
    if (!value || typeof value !== 'object') return false;
    const doc = value;
    // Check required properties
    if (doc.type !== 'doc') return false;
    if (!Array.isArray(doc.content)) return false;
    // Version is optional but if present should be a number
    if (doc.version !== undefined && typeof doc.version !== 'number') return false;
    return true;
}
module.exports["nodeToJSON"] = $f8f7a748914a9c23$export$3a858d3babd60825;
module.exports["JSONTransformer"] = $f8f7a748914a9c23$export$98cb1d9308d0944d;
module.exports["isJSONDocNode"] = $f8f7a748914a9c23$export$1c4065b3a9f04cf2;

});

parcelRegister("4HD7y", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $6c7d0cc1110d98ce$var$getLanguageFromEditorStyle = (dom)=>{
    return dom.getAttribute('data-language') || undefined;
};
// example of BB style:
// <div class="codehilite language-javascript"><pre><span>hello world</span><span>\n</span></pre></div>
const $6c7d0cc1110d98ce$var$getLanguageFromBitbucketStyle = (dom)=>{
    if (dom && dom.classList.contains('codehilite')) // code block html from Bitbucket always contains an extra new line
    return $6c7d0cc1110d98ce$var$extractLanguageFromClass(dom.className);
    return;
};
// If there is a child code element, check that for data-language
const $6c7d0cc1110d98ce$var$getLanguageFromCode = (dom)=>{
    const firstChild = dom.firstElementChild;
    if (firstChild && firstChild.nodeName === 'CODE') return firstChild.getAttribute('data-language') || undefined;
};
const $6c7d0cc1110d98ce$var$extractLanguageFromClass = (className)=>{
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const languageRegex = /(?:^|\s)language-([^\s]+)/u;
    const result = languageRegex.exec(className);
    if (result && result[1]) return result[1];
    return;
};
const $6c7d0cc1110d98ce$var$removeLastNewLine = (dom)=>{
    const parent = dom && dom.parentElement;
    if (parent && parent.classList.contains('codehilite')) // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    dom.textContent = dom.textContent.replace(/\n$/u, '');
    return dom;
};
function $6c7d0cc1110d98ce$var$parseCodeFromHtml(node) {
    let code = '';
    node.childNodes.forEach((child)=>{
        if (child.nodeType === Node.TEXT_NODE) // append text
        code += child.nodeValue;
        else if (child.nodeType === Node.ELEMENT_NODE && child instanceof Element) {
            const tagName = child.tagName.toLowerCase();
            if (tagName === 'div' || tagName === 'p') // add a newline before its content, unless it's the first child to avoid leading newlines
            {
                if (child.previousElementSibling !== null) code += '\n';
            }
            if (tagName === 'br') code += '\n';
            else code += $6c7d0cc1110d98ce$var$parseCodeFromHtml(child);
        }
    });
    return code;
}
const $6c7d0cc1110d98ce$export$7bb0d5c671655cc4 = (0, $17CG5.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $6c7d0cc1110d98ce$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $6c7d0cc1110d98ce$var$getLanguageFromEditorStyle(dom.parentElement) || $6c7d0cc1110d98ce$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $6c7d0cc1110d98ce$var$removeLastNewLine(dom);
                return {
                    language: language
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $6c7d0cc1110d98ce$var$parseCodeFromHtml(domNode);
                return code ? (0, $5SAOw.Fragment).from(schema.text(code)) : (0, $5SAOw.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        return [
            'pre',
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
const $6c7d0cc1110d98ce$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((memo, key)=>{
            if (key === 'uniqueId') return memo;
            if (key === 'language' && node.attrs.language === null) return memo;
            memo[key] = node.attrs[key];
            return memo;
        }, {})
    });
const $6c7d0cc1110d98ce$export$3f75de798a0b5356 = (0, $17CG5.codeBlock)({
    parseDOM: [
        {
            tag: 'pre',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                let dom = domNode;
                const language = // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $6c7d0cc1110d98ce$var$getLanguageFromBitbucketStyle(dom.parentElement) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $6c7d0cc1110d98ce$var$getLanguageFromEditorStyle(dom.parentElement) || $6c7d0cc1110d98ce$var$getLanguageFromCode(dom) || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-language');
                dom = $6c7d0cc1110d98ce$var$removeLastNewLine(dom);
                return {
                    language: language,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        },
        // Handle VSCode, Android Studio paste
        // Checking `white-space: pre-wrap` is too aggressive @see ED-2627
        {
            tag: 'div[style]',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre' || dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') > -1) return {};
                return false;
            },
            getContent: (domNode, schema)=>{
                const code = $6c7d0cc1110d98ce$var$parseCodeFromHtml(domNode);
                return code ? (0, $5SAOw.Fragment).from(schema.text(code)) : (0, $5SAOw.Fragment).empty;
            }
        },
        // Handle GitHub/Gist paste
        {
            tag: 'table[style]',
            preserveWhitespace: 'full',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                if (dom.querySelector('td[class*="blob-code"]')) return {};
                return false;
            }
        },
        {
            tag: 'div.code-block',
            preserveWhitespace: 'full',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // TODO: ED-5604 - Fix it inside `react-syntax-highlighter`
                // Remove line numbers
                const lineNumber = dom.querySelectorAll('.react-syntax-highlighter-line-number');
                if (lineNumber.length > 0) // It's possible to copy without the line numbers too hence this
                // `react-syntax-highlighter-line-number` check, so that we don't remove real code
                lineNumber.forEach((line)=>line.remove());
                return {};
            }
        }
    ],
    toDOM (node) {
        const attrs = {};
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'pre',
            attrs,
            [
                'code',
                {
                    'data-language': node.attrs.language
                },
                0
            ]
        ];
    }
});
module.exports["codeBlock"] = $6c7d0cc1110d98ce$export$7bb0d5c671655cc4;
module.exports["toJSON"] = $6c7d0cc1110d98ce$export$54fd2c36b5cc6731;
module.exports["codeBlockWithLocalId"] = $6c7d0cc1110d98ce$export$3f75de798a0b5356;

});

parcelRegister("5SAOw", function(module, exports) {
// ::- Persistent data structure representing an ordered mapping from
// strings to values, with some convenient update methods.
function $9ac5e8463c86a39c$var$OrderedMap(content) {
    this.content = content;
}
$9ac5e8463c86a39c$var$OrderedMap.prototype = {
    constructor: $9ac5e8463c86a39c$var$OrderedMap,
    find: function(key) {
        for(var i = 0; i < this.content.length; i += 2)if (this.content[i] === key) return i;
        return -1;
    },
    // :: (string) → ?any
    // Retrieve the value stored under `key`, or return undefined when
    // no such key exists.
    get: function(key) {
        var found = this.find(key);
        return found == -1 ? undefined : this.content[found + 1];
    },
    // :: (string, any, ?string) → OrderedMap
    // Create a new map by replacing the value of `key` with a new
    // value, or adding a binding to the end of the map. If `newKey` is
    // given, the key of the binding will be replaced with that key.
    update: function(key, value, newKey) {
        var self = newKey && newKey != key ? this.remove(newKey) : this;
        var found = self.find(key), content = self.content.slice();
        if (found == -1) content.push(newKey || key, value);
        else {
            content[found + 1] = value;
            if (newKey) content[found] = newKey;
        }
        return new $9ac5e8463c86a39c$var$OrderedMap(content);
    },
    // :: (string) → OrderedMap
    // Return a map with the given key removed, if it existed.
    remove: function(key) {
        var found = this.find(key);
        if (found == -1) return this;
        var content = this.content.slice();
        content.splice(found, 2);
        return new $9ac5e8463c86a39c$var$OrderedMap(content);
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the start of the map.
    addToStart: function(key, value) {
        return new $9ac5e8463c86a39c$var$OrderedMap([
            key,
            value
        ].concat(this.remove(key).content));
    },
    // :: (string, any) → OrderedMap
    // Add a new key to the end of the map.
    addToEnd: function(key, value) {
        var content = this.remove(key).content.slice();
        content.push(key, value);
        return new $9ac5e8463c86a39c$var$OrderedMap(content);
    },
    // :: (string, string, any) → OrderedMap
    // Add a key after the given key. If `place` is not found, the new
    // key is added to the end.
    addBefore: function(place, key, value) {
        var without = this.remove(key), content = without.content.slice();
        var found = without.find(place);
        content.splice(found == -1 ? content.length : found, 0, key, value);
        return new $9ac5e8463c86a39c$var$OrderedMap(content);
    },
    // :: ((key: string, value: any))
    // Call the given function for each key/value pair in the map, in
    // order.
    forEach: function(f) {
        for(var i = 0; i < this.content.length; i += 2)f(this.content[i], this.content[i + 1]);
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by prepending the keys in this map that don't
    // appear in `map` before the keys in `map`.
    prepend: function(map) {
        map = $9ac5e8463c86a39c$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9ac5e8463c86a39c$var$OrderedMap(map.content.concat(this.subtract(map).content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a new map by appending the keys in this map that don't
    // appear in `map` after the keys in `map`.
    append: function(map) {
        map = $9ac5e8463c86a39c$var$OrderedMap.from(map);
        if (!map.size) return this;
        return new $9ac5e8463c86a39c$var$OrderedMap(this.subtract(map).content.concat(map.content));
    },
    // :: (union<Object, OrderedMap>) → OrderedMap
    // Create a map containing all the keys in this map that don't
    // appear in `map`.
    subtract: function(map) {
        var result = this;
        map = $9ac5e8463c86a39c$var$OrderedMap.from(map);
        for(var i = 0; i < map.content.length; i += 2)result = result.remove(map.content[i]);
        return result;
    },
    // :: () → Object
    // Turn ordered map into a plain object.
    toObject: function() {
        var result = {};
        this.forEach(function(key, value) {
            result[key] = value;
        });
        return result;
    },
    // :: number
    // The amount of keys in this map.
    get size () {
        return this.content.length >> 1;
    }
};
// :: (?union<Object, OrderedMap>) → OrderedMap
// Return a map with the given content. If null, create an empty
// map. If given an ordered map, return that map itself. If given an
// object, create a map from the object's properties.
$9ac5e8463c86a39c$var$OrderedMap.from = function(value) {
    if (value instanceof $9ac5e8463c86a39c$var$OrderedMap) return value;
    var content = [];
    if (value) for(var prop in value)content.push(prop, value[prop]);
    return new $9ac5e8463c86a39c$var$OrderedMap(content);
};
var $9ac5e8463c86a39c$export$2e2bcd8739ae039 = $9ac5e8463c86a39c$var$OrderedMap;


function $447e8d5afac257af$var$findDiffStart(a, b, pos) {
    for(let i = 0;; i++){
        if (i == a.childCount || i == b.childCount) return a.childCount == b.childCount ? null : pos;
        let childA = a.child(i), childB = b.child(i);
        if (childA == childB) {
            pos += childA.nodeSize;
            continue;
        }
        if (!childA.sameMarkup(childB)) return pos;
        if (childA.isText && childA.text != childB.text) {
            for(let j = 0; childA.text[j] == childB.text[j]; j++)pos++;
            return pos;
        }
        if (childA.content.size || childB.content.size) {
            let inner = $447e8d5afac257af$var$findDiffStart(childA.content, childB.content, pos + 1);
            if (inner != null) return inner;
        }
        pos += childA.nodeSize;
    }
}
function $447e8d5afac257af$var$findDiffEnd(a, b, posA, posB) {
    for(let iA = a.childCount, iB = b.childCount;;){
        if (iA == 0 || iB == 0) return iA == iB ? null : {
            a: posA,
            b: posB
        };
        let childA = a.child(--iA), childB = b.child(--iB), size = childA.nodeSize;
        if (childA == childB) {
            posA -= size;
            posB -= size;
            continue;
        }
        if (!childA.sameMarkup(childB)) return {
            a: posA,
            b: posB
        };
        if (childA.isText && childA.text != childB.text) {
            let same = 0, minSize = Math.min(childA.text.length, childB.text.length);
            while(same < minSize && childA.text[childA.text.length - same - 1] == childB.text[childB.text.length - same - 1]){
                same++;
                posA--;
                posB--;
            }
            return {
                a: posA,
                b: posB
            };
        }
        if (childA.content.size || childB.content.size) {
            let inner = $447e8d5afac257af$var$findDiffEnd(childA.content, childB.content, posA - 1, posB - 1);
            if (inner) return inner;
        }
        posA -= size;
        posB -= size;
    }
}
/**
A fragment represents a node's collection of child nodes.

Like nodes, fragments are persistent data structures, and you
should not mutate them or their content. Rather, you create new
instances whenever needed. The API tries to make this easy.
*/ class $447e8d5afac257af$export$ffb0004e005737fa {
    /**
    Invoke a callback for all descendant nodes between the given two
    positions (relative to start of this fragment). Doesn't descend
    into a node when the callback returns `false`.
    */ nodesBetween(from, to, f, nodeStart = 0, parent) {
        for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from && f(child, nodeStart + pos, parent || null, i) !== false && child.content.size) {
                let start = pos + 1;
                child.nodesBetween(Math.max(0, from - start), Math.min(child.content.size, to - start), f, nodeStart + start);
            }
            pos = end;
        }
    }
    /**
    Call the given callback for every descendant node. `pos` will be
    relative to the start of the fragment. The callback may return
    `false` to prevent traversal of a given node's children.
    */ descendants(f) {
        this.nodesBetween(0, this.size, f);
    }
    /**
    Extract the text between `from` and `to`. See the same method on
    [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
    */ textBetween(from, to, blockSeparator, leafText) {
        let text = "", first = true;
        this.nodesBetween(from, to, (node, pos)=>{
            let nodeText = node.isText ? node.text.slice(Math.max(from, pos) - pos, to - pos) : !node.isLeaf ? "" : leafText ? typeof leafText === "function" ? leafText(node) : leafText : node.type.spec.leafText ? node.type.spec.leafText(node) : "";
            if (node.isBlock && (node.isLeaf && nodeText || node.isTextblock) && blockSeparator) {
                if (first) first = false;
                else text += blockSeparator;
            }
            text += nodeText;
        }, 0);
        return text;
    }
    /**
    Create a new fragment containing the combined content of this
    fragment and the other.
    */ append(other) {
        if (!other.size) return this;
        if (!this.size) return other;
        let last = this.lastChild, first = other.firstChild, content = this.content.slice(), i = 0;
        if (last.isText && last.sameMarkup(first)) {
            content[content.length - 1] = last.withText(last.text + first.text);
            i = 1;
        }
        for(; i < other.content.length; i++)content.push(other.content[i]);
        return new $447e8d5afac257af$export$ffb0004e005737fa(content, this.size + other.size);
    }
    /**
    Cut out the sub-fragment between the two given positions.
    */ cut(from, to = this.size) {
        if (from == 0 && to == this.size) return this;
        let result = [], size = 0;
        if (to > from) for(let i = 0, pos = 0; pos < to; i++){
            let child = this.content[i], end = pos + child.nodeSize;
            if (end > from) {
                if (pos < from || end > to) {
                    if (child.isText) child = child.cut(Math.max(0, from - pos), Math.min(child.text.length, to - pos));
                    else child = child.cut(Math.max(0, from - pos - 1), Math.min(child.content.size, to - pos - 1));
                }
                result.push(child);
                size += child.nodeSize;
            }
            pos = end;
        }
        return new $447e8d5afac257af$export$ffb0004e005737fa(result, size);
    }
    /**
    @internal
    */ cutByIndex(from, to) {
        if (from == to) return $447e8d5afac257af$export$ffb0004e005737fa.empty;
        if (from == 0 && to == this.content.length) return this;
        return new $447e8d5afac257af$export$ffb0004e005737fa(this.content.slice(from, to));
    }
    /**
    Create a new fragment in which the node at the given index is
    replaced by the given node.
    */ replaceChild(index, node) {
        let current = this.content[index];
        if (current == node) return this;
        let copy = this.content.slice();
        let size = this.size + node.nodeSize - current.nodeSize;
        copy[index] = node;
        return new $447e8d5afac257af$export$ffb0004e005737fa(copy, size);
    }
    /**
    Create a new fragment by prepending the given node to this
    fragment.
    */ addToStart(node) {
        return new $447e8d5afac257af$export$ffb0004e005737fa([
            node
        ].concat(this.content), this.size + node.nodeSize);
    }
    /**
    Create a new fragment by appending the given node to this
    fragment.
    */ addToEnd(node) {
        return new $447e8d5afac257af$export$ffb0004e005737fa(this.content.concat(node), this.size + node.nodeSize);
    }
    /**
    Compare this fragment to another one.
    */ eq(other) {
        if (this.content.length != other.content.length) return false;
        for(let i = 0; i < this.content.length; i++)if (!this.content[i].eq(other.content[i])) return false;
        return true;
    }
    /**
    The first child of the fragment, or `null` if it is empty.
    */ get firstChild() {
        return this.content.length ? this.content[0] : null;
    }
    /**
    The last child of the fragment, or `null` if it is empty.
    */ get lastChild() {
        return this.content.length ? this.content[this.content.length - 1] : null;
    }
    /**
    The number of child nodes in this fragment.
    */ get childCount() {
        return this.content.length;
    }
    /**
    Get the child node at the given index. Raise an error when the
    index is out of range.
    */ child(index) {
        let found = this.content[index];
        if (!found) throw new RangeError("Index " + index + " out of range for " + this);
        return found;
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content[index] || null;
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        for(let i = 0, p = 0; i < this.content.length; i++){
            let child = this.content[i];
            f(child, p, i);
            p += child.nodeSize;
        }
    }
    /**
    Find the first position at which this fragment and another
    fragment differ, or `null` if they are the same.
    */ findDiffStart(other, pos = 0) {
        return $447e8d5afac257af$var$findDiffStart(this, other, pos);
    }
    /**
    Find the first position, searching from the end, at which this
    fragment and the given fragment differ, or `null` if they are
    the same. Since this position will not be the same in both
    nodes, an object with two separate positions is returned.
    */ findDiffEnd(other, pos = this.size, otherPos = other.size) {
        return $447e8d5afac257af$var$findDiffEnd(this, other, pos, otherPos);
    }
    /**
    Find the index and inner offset corresponding to a given relative
    position in this fragment. The result object will be reused
    (overwritten) the next time the function is called. @internal
    */ findIndex(pos, round = -1) {
        if (pos == 0) return $447e8d5afac257af$var$retIndex(0, pos);
        if (pos == this.size) return $447e8d5afac257af$var$retIndex(this.content.length, pos);
        if (pos > this.size || pos < 0) throw new RangeError(`Position ${pos} outside of fragment (${this})`);
        for(let i = 0, curPos = 0;; i++){
            let cur = this.child(i), end = curPos + cur.nodeSize;
            if (end >= pos) {
                if (end == pos || round > 0) return $447e8d5afac257af$var$retIndex(i + 1, end);
                return $447e8d5afac257af$var$retIndex(i, curPos);
            }
            curPos = end;
        }
    }
    /**
    Return a debugging string that describes this fragment.
    */ toString() {
        return "<" + this.toStringInner() + ">";
    }
    /**
    @internal
    */ toStringInner() {
        return this.content.join(", ");
    }
    /**
    Create a JSON-serializeable representation of this fragment.
    */ toJSON() {
        return this.content.length ? this.content.map((n)=>n.toJSON()) : null;
    }
    /**
    Deserialize a fragment from its JSON representation.
    */ static fromJSON(schema, value) {
        if (!value) return $447e8d5afac257af$export$ffb0004e005737fa.empty;
        if (!Array.isArray(value)) throw new RangeError("Invalid input for Fragment.fromJSON");
        return new $447e8d5afac257af$export$ffb0004e005737fa(value.map(schema.nodeFromJSON));
    }
    /**
    Build a fragment from an array of nodes. Ensures that adjacent
    text nodes with the same marks are joined together.
    */ static fromArray(array) {
        if (!array.length) return $447e8d5afac257af$export$ffb0004e005737fa.empty;
        let joined, size = 0;
        for(let i = 0; i < array.length; i++){
            let node = array[i];
            size += node.nodeSize;
            if (i && node.isText && array[i - 1].sameMarkup(node)) {
                if (!joined) joined = array.slice(0, i);
                joined[joined.length - 1] = node.withText(joined[joined.length - 1].text + node.text);
            } else if (joined) joined.push(node);
        }
        return new $447e8d5afac257af$export$ffb0004e005737fa(joined || array, size);
    }
    /**
    Create a fragment from something that can be interpreted as a
    set of nodes. For `null`, it returns the empty fragment. For a
    fragment, the fragment itself. For a node or array of nodes, a
    fragment containing those nodes.
    */ static from(nodes) {
        if (!nodes) return $447e8d5afac257af$export$ffb0004e005737fa.empty;
        if (nodes instanceof $447e8d5afac257af$export$ffb0004e005737fa) return nodes;
        if (Array.isArray(nodes)) return this.fromArray(nodes);
        if (nodes.attrs) return new $447e8d5afac257af$export$ffb0004e005737fa([
            nodes
        ], nodes.nodeSize);
        throw new RangeError("Can not convert " + nodes + " to a Fragment" + (nodes.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
    }
    /**
    @internal
    */ constructor(/**
    The child nodes in this fragment.
    */ content, size){
        this.content = content;
        this.size = size || 0;
        if (size == null) for(let i = 0; i < content.length; i++)this.size += content[i].nodeSize;
    }
}
/**
An empty fragment. Intended to be reused whenever a node doesn't
contain anything (rather than allocating a new empty fragment for
each leaf node).
*/ $447e8d5afac257af$export$ffb0004e005737fa.empty = new $447e8d5afac257af$export$ffb0004e005737fa([], 0);
const $447e8d5afac257af$var$found = {
    index: 0,
    offset: 0
};
function $447e8d5afac257af$var$retIndex(index, offset) {
    $447e8d5afac257af$var$found.index = index;
    $447e8d5afac257af$var$found.offset = offset;
    return $447e8d5afac257af$var$found;
}
function $447e8d5afac257af$var$compareDeep(a, b) {
    if (a === b) return true;
    if (!(a && typeof a == "object") || !(b && typeof b == "object")) return false;
    let array = Array.isArray(a);
    if (Array.isArray(b) != array) return false;
    if (array) {
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!$447e8d5afac257af$var$compareDeep(a[i], b[i])) return false;
    } else {
        for(let p in a)if (!(p in b) || !$447e8d5afac257af$var$compareDeep(a[p], b[p])) return false;
        for(let p in b)if (!(p in a)) return false;
    }
    return true;
}
/**
A mark is a piece of information that can be attached to a node,
such as it being emphasized, in code font, or a link. It has a
type and optionally a set of attributes that provide further
information (such as the target of the link). Marks are created
through a `Schema`, which controls which types exist and which
attributes they have.
*/ class $447e8d5afac257af$export$c9d15bcfc6d42044 {
    /**
    Given a set of marks, create a new set which contains this one as
    well, in the right position. If this mark is already in the set,
    the set itself is returned. If any marks that are set to be
    [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
    those are replaced by this one.
    */ addToSet(set) {
        let copy, placed = false;
        for(let i = 0; i < set.length; i++){
            let other = set[i];
            if (this.eq(other)) return set;
            if (this.type.excludes(other.type)) {
                if (!copy) copy = set.slice(0, i);
            } else if (other.type.excludes(this.type)) return set;
            else {
                if (!placed && other.type.rank > this.type.rank) {
                    if (!copy) copy = set.slice(0, i);
                    copy.push(this);
                    placed = true;
                }
                if (copy) copy.push(other);
            }
        }
        if (!copy) copy = set.slice();
        if (!placed) copy.push(this);
        return copy;
    }
    /**
    Remove this mark from the given set, returning a new set. If this
    mark is not in the set, the set itself is returned.
    */ removeFromSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return set.slice(0, i).concat(set.slice(i + 1));
        return set;
    }
    /**
    Test whether this mark is in the given set of marks.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (this.eq(set[i])) return true;
        return false;
    }
    /**
    Test whether this mark has the same type and attributes as
    another mark.
    */ eq(other) {
        return this == other || this.type == other.type && $447e8d5afac257af$var$compareDeep(this.attrs, other.attrs);
    }
    /**
    Convert this mark to a JSON-serializeable representation.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        return obj;
    }
    /**
    Deserialize a mark from JSON.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Mark.fromJSON");
        let type = schema.marks[json.type];
        if (!type) throw new RangeError(`There is no mark type ${json.type} in this schema`);
        let mark = type.create(json.attrs);
        type.checkAttrs(mark.attrs);
        return mark;
    }
    /**
    Test whether two sets of marks are identical.
    */ static sameSet(a, b) {
        if (a == b) return true;
        if (a.length != b.length) return false;
        for(let i = 0; i < a.length; i++)if (!a[i].eq(b[i])) return false;
        return true;
    }
    /**
    Create a properly sorted mark set from null, a single mark, or an
    unsorted array of marks.
    */ static setFrom(marks) {
        if (!marks || Array.isArray(marks) && marks.length == 0) return $447e8d5afac257af$export$c9d15bcfc6d42044.none;
        if (marks instanceof $447e8d5afac257af$export$c9d15bcfc6d42044) return [
            marks
        ];
        let copy = marks.slice();
        copy.sort((a, b)=>a.type.rank - b.type.rank);
        return copy;
    }
    /**
    @internal
    */ constructor(/**
    The type of this mark.
    */ type, /**
    The attributes associated with this mark.
    */ attrs){
        this.type = type;
        this.attrs = attrs;
    }
}
/**
The empty set of marks.
*/ $447e8d5afac257af$export$c9d15bcfc6d42044.none = [];
/**
Error type raised by [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) when
given an invalid replacement.
*/ class $447e8d5afac257af$export$6de0e778727af3f2 extends Error {
}
/*
ReplaceError = function(this: any, message: string) {
  let err = Error.call(this, message)
  ;(err as any).__proto__ = ReplaceError.prototype
  return err
} as any

ReplaceError.prototype = Object.create(Error.prototype)
ReplaceError.prototype.constructor = ReplaceError
ReplaceError.prototype.name = "ReplaceError"
*/ /**
A slice represents a piece cut out of a larger document. It
stores not only a fragment, but also the depth up to which nodes on
both side are ‘open’ (cut through).
*/ class $447e8d5afac257af$export$b3f2e2de3a8baa1e {
    /**
    The size this slice would add when inserted into a document.
    */ get size() {
        return this.content.size - this.openStart - this.openEnd;
    }
    /**
    @internal
    */ insertAt(pos, fragment) {
        let content = $447e8d5afac257af$var$insertInto(this.content, pos + this.openStart, fragment);
        return content && new $447e8d5afac257af$export$b3f2e2de3a8baa1e(content, this.openStart, this.openEnd);
    }
    /**
    @internal
    */ removeBetween(from, to) {
        return new $447e8d5afac257af$export$b3f2e2de3a8baa1e($447e8d5afac257af$var$removeRange(this.content, from + this.openStart, to + this.openStart), this.openStart, this.openEnd);
    }
    /**
    Tests whether this slice is equal to another slice.
    */ eq(other) {
        return this.content.eq(other.content) && this.openStart == other.openStart && this.openEnd == other.openEnd;
    }
    /**
    @internal
    */ toString() {
        return this.content + "(" + this.openStart + "," + this.openEnd + ")";
    }
    /**
    Convert a slice to a JSON-serializable representation.
    */ toJSON() {
        if (!this.content.size) return null;
        let json = {
            content: this.content.toJSON()
        };
        if (this.openStart > 0) json.openStart = this.openStart;
        if (this.openEnd > 0) json.openEnd = this.openEnd;
        return json;
    }
    /**
    Deserialize a slice from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) return $447e8d5afac257af$export$b3f2e2de3a8baa1e.empty;
        let openStart = json.openStart || 0, openEnd = json.openEnd || 0;
        if (typeof openStart != "number" || typeof openEnd != "number") throw new RangeError("Invalid input for Slice.fromJSON");
        return new $447e8d5afac257af$export$b3f2e2de3a8baa1e($447e8d5afac257af$export$ffb0004e005737fa.fromJSON(schema, json.content), openStart, openEnd);
    }
    /**
    Create a slice from a fragment by taking the maximum possible
    open value on both side of the fragment.
    */ static maxOpen(fragment, openIsolating = true) {
        let openStart = 0, openEnd = 0;
        for(let n = fragment.firstChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.firstChild)openStart++;
        for(let n = fragment.lastChild; n && !n.isLeaf && (openIsolating || !n.type.spec.isolating); n = n.lastChild)openEnd++;
        return new $447e8d5afac257af$export$b3f2e2de3a8baa1e(fragment, openStart, openEnd);
    }
    /**
    Create a slice. When specifying a non-zero open depth, you must
    make sure that there are nodes of at least that depth at the
    appropriate side of the fragment—i.e. if the fragment is an
    empty paragraph node, `openStart` and `openEnd` can't be greater
    than 1.
    
    It is not necessary for the content of open nodes to conform to
    the schema's content constraints, though it should be a valid
    start/end/middle for such a node, depending on which sides are
    open.
    */ constructor(/**
    The slice's content.
    */ content, /**
    The open depth at the start of the fragment.
    */ openStart, /**
    The open depth at the end.
    */ openEnd){
        this.content = content;
        this.openStart = openStart;
        this.openEnd = openEnd;
    }
}
/**
The empty slice.
*/ $447e8d5afac257af$export$b3f2e2de3a8baa1e.empty = new $447e8d5afac257af$export$b3f2e2de3a8baa1e($447e8d5afac257af$export$ffb0004e005737fa.empty, 0, 0);
function $447e8d5afac257af$var$removeRange(content, from, to) {
    let { index: index, offset: offset } = content.findIndex(from), child = content.maybeChild(index);
    let { index: indexTo, offset: offsetTo } = content.findIndex(to);
    if (offset == from || child.isText) {
        if (offsetTo != to && !content.child(indexTo).isText) throw new RangeError("Removing non-flat range");
        return content.cut(0, from).append(content.cut(to));
    }
    if (index != indexTo) throw new RangeError("Removing non-flat range");
    return content.replaceChild(index, child.copy($447e8d5afac257af$var$removeRange(child.content, from - offset - 1, to - offset - 1)));
}
function $447e8d5afac257af$var$insertInto(content, dist, insert, parent) {
    let { index: index, offset: offset } = content.findIndex(dist), child = content.maybeChild(index);
    if (offset == dist || child.isText) {
        if (parent && !parent.canReplace(index, index, insert)) return null;
        return content.cut(0, dist).append(insert).append(content.cut(dist));
    }
    let inner = $447e8d5afac257af$var$insertInto(child.content, dist - offset - 1, insert);
    return inner && content.replaceChild(index, child.copy(inner));
}
function $447e8d5afac257af$var$replace($from, $to, slice) {
    if (slice.openStart > $from.depth) throw new $447e8d5afac257af$export$6de0e778727af3f2("Inserted content deeper than insertion position");
    if ($from.depth - slice.openStart != $to.depth - slice.openEnd) throw new $447e8d5afac257af$export$6de0e778727af3f2("Inconsistent open depths");
    return $447e8d5afac257af$var$replaceOuter($from, $to, slice, 0);
}
function $447e8d5afac257af$var$replaceOuter($from, $to, slice, depth) {
    let index = $from.index(depth), node = $from.node(depth);
    if (index == $to.index(depth) && depth < $from.depth - slice.openStart) {
        let inner = $447e8d5afac257af$var$replaceOuter($from, $to, slice, depth + 1);
        return node.copy(node.content.replaceChild(index, inner));
    } else if (!slice.content.size) return $447e8d5afac257af$var$close(node, $447e8d5afac257af$var$replaceTwoWay($from, $to, depth));
    else if (!slice.openStart && !slice.openEnd && $from.depth == depth && $to.depth == depth) {
        let parent = $from.parent, content = parent.content;
        return $447e8d5afac257af$var$close(parent, content.cut(0, $from.parentOffset).append(slice.content).append(content.cut($to.parentOffset)));
    } else {
        let { start: start, end: end } = $447e8d5afac257af$var$prepareSliceForReplace(slice, $from);
        return $447e8d5afac257af$var$close(node, $447e8d5afac257af$var$replaceThreeWay($from, start, end, $to, depth));
    }
}
function $447e8d5afac257af$var$checkJoin(main, sub) {
    if (!sub.type.compatibleContent(main.type)) throw new $447e8d5afac257af$export$6de0e778727af3f2("Cannot join " + sub.type.name + " onto " + main.type.name);
}
function $447e8d5afac257af$var$joinable($before, $after, depth) {
    let node = $before.node(depth);
    $447e8d5afac257af$var$checkJoin(node, $after.node(depth));
    return node;
}
function $447e8d5afac257af$var$addNode(child, target) {
    let last = target.length - 1;
    if (last >= 0 && child.isText && child.sameMarkup(target[last])) target[last] = child.withText(target[last].text + child.text);
    else target.push(child);
}
function $447e8d5afac257af$var$addRange($start, $end, depth, target) {
    let node = ($end || $start).node(depth);
    let startIndex = 0, endIndex = $end ? $end.index(depth) : node.childCount;
    if ($start) {
        startIndex = $start.index(depth);
        if ($start.depth > depth) startIndex++;
        else if ($start.textOffset) {
            $447e8d5afac257af$var$addNode($start.nodeAfter, target);
            startIndex++;
        }
    }
    for(let i = startIndex; i < endIndex; i++)$447e8d5afac257af$var$addNode(node.child(i), target);
    if ($end && $end.depth == depth && $end.textOffset) $447e8d5afac257af$var$addNode($end.nodeBefore, target);
}
function $447e8d5afac257af$var$close(node, content) {
    node.type.checkContent(content);
    return node.copy(content);
}
function $447e8d5afac257af$var$replaceThreeWay($from, $start, $end, $to, depth) {
    let openStart = $from.depth > depth && $447e8d5afac257af$var$joinable($from, $start, depth + 1);
    let openEnd = $to.depth > depth && $447e8d5afac257af$var$joinable($end, $to, depth + 1);
    let content = [];
    $447e8d5afac257af$var$addRange(null, $from, depth, content);
    if (openStart && openEnd && $start.index(depth) == $end.index(depth)) {
        $447e8d5afac257af$var$checkJoin(openStart, openEnd);
        $447e8d5afac257af$var$addNode($447e8d5afac257af$var$close(openStart, $447e8d5afac257af$var$replaceThreeWay($from, $start, $end, $to, depth + 1)), content);
    } else {
        if (openStart) $447e8d5afac257af$var$addNode($447e8d5afac257af$var$close(openStart, $447e8d5afac257af$var$replaceTwoWay($from, $start, depth + 1)), content);
        $447e8d5afac257af$var$addRange($start, $end, depth, content);
        if (openEnd) $447e8d5afac257af$var$addNode($447e8d5afac257af$var$close(openEnd, $447e8d5afac257af$var$replaceTwoWay($end, $to, depth + 1)), content);
    }
    $447e8d5afac257af$var$addRange($to, null, depth, content);
    return new $447e8d5afac257af$export$ffb0004e005737fa(content);
}
function $447e8d5afac257af$var$replaceTwoWay($from, $to, depth) {
    let content = [];
    $447e8d5afac257af$var$addRange(null, $from, depth, content);
    if ($from.depth > depth) {
        let type = $447e8d5afac257af$var$joinable($from, $to, depth + 1);
        $447e8d5afac257af$var$addNode($447e8d5afac257af$var$close(type, $447e8d5afac257af$var$replaceTwoWay($from, $to, depth + 1)), content);
    }
    $447e8d5afac257af$var$addRange($to, null, depth, content);
    return new $447e8d5afac257af$export$ffb0004e005737fa(content);
}
function $447e8d5afac257af$var$prepareSliceForReplace(slice, $along) {
    let extra = $along.depth - slice.openStart, parent = $along.node(extra);
    let node = parent.copy(slice.content);
    for(let i = extra - 1; i >= 0; i--)node = $along.node(i).copy($447e8d5afac257af$export$ffb0004e005737fa.from(node));
    return {
        start: node.resolveNoCache(slice.openStart + extra),
        end: node.resolveNoCache(node.content.size - slice.openEnd - extra)
    };
}
/**
You can [_resolve_](https://prosemirror.net/docs/ref/#model.Node.resolve) a position to get more
information about it. Objects of this class represent such a
resolved position, providing various pieces of context
information, and some helper methods.

Throughout this interface, methods that take an optional `depth`
parameter will interpret undefined as `this.depth` and negative
numbers as `this.depth + value`.
*/ class $447e8d5afac257af$export$b2a42f82e59e4b19 {
    /**
    @internal
    */ resolveDepth(val) {
        if (val == null) return this.depth;
        if (val < 0) return this.depth + val;
        return val;
    }
    /**
    The parent node that the position points into. Note that even if
    a position points into a text node, that node is not considered
    the parent—text nodes are ‘flat’ in this model, and have no content.
    */ get parent() {
        return this.node(this.depth);
    }
    /**
    The root node in which the position was resolved.
    */ get doc() {
        return this.node(0);
    }
    /**
    The ancestor node at the given level. `p.node(p.depth)` is the
    same as `p.parent`.
    */ node(depth) {
        return this.path[this.resolveDepth(depth) * 3];
    }
    /**
    The index into the ancestor at the given level. If this points
    at the 3rd node in the 2nd paragraph on the top level, for
    example, `p.index(0)` is 1 and `p.index(1)` is 2.
    */ index(depth) {
        return this.path[this.resolveDepth(depth) * 3 + 1];
    }
    /**
    The index pointing after this position into the ancestor at the
    given level.
    */ indexAfter(depth) {
        depth = this.resolveDepth(depth);
        return this.index(depth) + (depth == this.depth && !this.textOffset ? 0 : 1);
    }
    /**
    The (absolute) position at the start of the node at the given
    level.
    */ start(depth) {
        depth = this.resolveDepth(depth);
        return depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
    }
    /**
    The (absolute) position at the end of the node at the given
    level.
    */ end(depth) {
        depth = this.resolveDepth(depth);
        return this.start(depth) + this.node(depth).content.size;
    }
    /**
    The (absolute) position directly before the wrapping node at the
    given level, or, when `depth` is `this.depth + 1`, the original
    position.
    */ before(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position before the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1];
    }
    /**
    The (absolute) position directly after the wrapping node at the
    given level, or the original position when `depth` is `this.depth + 1`.
    */ after(depth) {
        depth = this.resolveDepth(depth);
        if (!depth) throw new RangeError("There is no position after the top-level node");
        return depth == this.depth + 1 ? this.pos : this.path[depth * 3 - 1] + this.path[depth * 3].nodeSize;
    }
    /**
    When this position points into a text node, this returns the
    distance between the position and the start of the text node.
    Will be zero for positions that point between nodes.
    */ get textOffset() {
        return this.pos - this.path[this.path.length - 1];
    }
    /**
    Get the node directly after the position, if any. If the position
    points into a text node, only the part of that node after the
    position is returned.
    */ get nodeAfter() {
        let parent = this.parent, index = this.index(this.depth);
        if (index == parent.childCount) return null;
        let dOff = this.pos - this.path[this.path.length - 1], child = parent.child(index);
        return dOff ? parent.child(index).cut(dOff) : child;
    }
    /**
    Get the node directly before the position, if any. If the
    position points into a text node, only the part of that node
    before the position is returned.
    */ get nodeBefore() {
        let index = this.index(this.depth);
        let dOff = this.pos - this.path[this.path.length - 1];
        if (dOff) return this.parent.child(index).cut(0, dOff);
        return index == 0 ? null : this.parent.child(index - 1);
    }
    /**
    Get the position at the given index in the parent node at the
    given depth (which defaults to `this.depth`).
    */ posAtIndex(index, depth) {
        depth = this.resolveDepth(depth);
        let node = this.path[depth * 3], pos = depth == 0 ? 0 : this.path[depth * 3 - 1] + 1;
        for(let i = 0; i < index; i++)pos += node.child(i).nodeSize;
        return pos;
    }
    /**
    Get the marks at this position, factoring in the surrounding
    marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
    position is at the start of a non-empty node, the marks of the
    node after it (if any) are returned.
    */ marks() {
        let parent = this.parent, index = this.index();
        // In an empty parent, return the empty array
        if (parent.content.size == 0) return $447e8d5afac257af$export$c9d15bcfc6d42044.none;
        // When inside a text node, just return the text node's marks
        if (this.textOffset) return parent.child(index).marks;
        let main = parent.maybeChild(index - 1), other = parent.maybeChild(index);
        // If the `after` flag is true of there is no node before, make
        // the node after this position the main reference.
        if (!main) {
            let tmp = main;
            main = other;
            other = tmp;
        }
        // Use all marks in the main node, except those that have
        // `inclusive` set to false and are not present in the other node.
        let marks = main.marks;
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!other || !marks[i].isInSet(other.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    Get the marks after the current position, if any, except those
    that are non-inclusive and not present at position `$end`. This
    is mostly useful for getting the set of marks to preserve after a
    deletion. Will return `null` if this position is at the end of
    its parent node or its parent node isn't a textblock (in which
    case no marks should be preserved).
    */ marksAcross($end) {
        let after = this.parent.maybeChild(this.index());
        if (!after || !after.isInline) return null;
        let marks = after.marks, next = $end.parent.maybeChild($end.index());
        for(var i = 0; i < marks.length; i++)if (marks[i].type.spec.inclusive === false && (!next || !marks[i].isInSet(next.marks))) marks = marks[i--].removeFromSet(marks);
        return marks;
    }
    /**
    The depth up to which this position and the given (non-resolved)
    position share the same parent nodes.
    */ sharedDepth(pos) {
        for(let depth = this.depth; depth > 0; depth--)if (this.start(depth) <= pos && this.end(depth) >= pos) return depth;
        return 0;
    }
    /**
    Returns a range based on the place where this position and the
    given position diverge around block content. If both point into
    the same textblock, for example, a range around that textblock
    will be returned. If they point into different blocks, the range
    around those blocks in their shared ancestor is returned. You can
    pass in an optional predicate that will be called with a parent
    node to see if a range into that parent is acceptable.
    */ blockRange(other = this, pred) {
        if (other.pos < this.pos) return other.blockRange(this);
        for(let d = this.depth - (this.parent.inlineContent || this.pos == other.pos ? 1 : 0); d >= 0; d--)if (other.pos <= this.end(d) && (!pred || pred(this.node(d)))) return new $447e8d5afac257af$export$7bc461ceb770fb16(this, other, d);
        return null;
    }
    /**
    Query whether the given position shares the same parent node.
    */ sameParent(other) {
        return this.pos - this.parentOffset == other.pos - other.parentOffset;
    }
    /**
    Return the greater of this and the given position.
    */ max(other) {
        return other.pos > this.pos ? other : this;
    }
    /**
    Return the smaller of this and the given position.
    */ min(other) {
        return other.pos < this.pos ? other : this;
    }
    /**
    @internal
    */ toString() {
        let str = "";
        for(let i = 1; i <= this.depth; i++)str += (str ? "/" : "") + this.node(i).type.name + "_" + this.index(i - 1);
        return str + ":" + this.parentOffset;
    }
    /**
    @internal
    */ static resolve(doc, pos) {
        if (!(pos >= 0 && pos <= doc.content.size)) throw new RangeError("Position " + pos + " out of range");
        let path = [];
        let start = 0, parentOffset = pos;
        for(let node = doc;;){
            let { index: index, offset: offset } = node.content.findIndex(parentOffset);
            let rem = parentOffset - offset;
            path.push(node, index, start + offset);
            if (!rem) break;
            node = node.child(index);
            if (node.isText) break;
            parentOffset = rem - 1;
            start += offset + 1;
        }
        return new $447e8d5afac257af$export$b2a42f82e59e4b19(pos, path, parentOffset);
    }
    /**
    @internal
    */ static resolveCached(doc, pos) {
        let cache = $447e8d5afac257af$var$resolveCache.get(doc);
        if (cache) for(let i = 0; i < cache.elts.length; i++){
            let elt = cache.elts[i];
            if (elt.pos == pos) return elt;
        }
        else $447e8d5afac257af$var$resolveCache.set(doc, cache = new $447e8d5afac257af$var$ResolveCache);
        let result = cache.elts[cache.i] = $447e8d5afac257af$export$b2a42f82e59e4b19.resolve(doc, pos);
        cache.i = (cache.i + 1) % $447e8d5afac257af$var$resolveCacheSize;
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The position that was resolved.
    */ pos, /**
    @internal
    */ path, /**
    The offset this position has into its parent node.
    */ parentOffset){
        this.pos = pos;
        this.path = path;
        this.parentOffset = parentOffset;
        this.depth = path.length / 3 - 1;
    }
}
class $447e8d5afac257af$var$ResolveCache {
    constructor(){
        this.elts = [];
        this.i = 0;
    }
}
const $447e8d5afac257af$var$resolveCacheSize = 12, $447e8d5afac257af$var$resolveCache = new WeakMap();
/**
Represents a flat range of content, i.e. one that starts and
ends in the same node.
*/ class $447e8d5afac257af$export$7bc461ceb770fb16 {
    /**
    The position at the start of the range.
    */ get start() {
        return this.$from.before(this.depth + 1);
    }
    /**
    The position at the end of the range.
    */ get end() {
        return this.$to.after(this.depth + 1);
    }
    /**
    The parent node that the range points into.
    */ get parent() {
        return this.$from.node(this.depth);
    }
    /**
    The start index of the range in the parent node.
    */ get startIndex() {
        return this.$from.index(this.depth);
    }
    /**
    The end index of the range in the parent node.
    */ get endIndex() {
        return this.$to.indexAfter(this.depth);
    }
    /**
    Construct a node range. `$from` and `$to` should point into the
    same node until at least the given `depth`, since a node range
    denotes an adjacent set of nodes in a single parent node.
    */ constructor(/**
    A resolved position along the start of the content. May have a
    `depth` greater than this object's `depth` property, since
    these are the positions that were used to compute the range,
    not re-resolved positions directly at its boundaries.
    */ $from, /**
    A position along the end of the content. See
    caveat for [`$from`](https://prosemirror.net/docs/ref/#model.NodeRange.$from).
    */ $to, /**
    The depth of the node that this range points into.
    */ depth){
        this.$from = $from;
        this.$to = $to;
        this.depth = depth;
    }
}
const $447e8d5afac257af$var$emptyAttrs = Object.create(null);
/**
This class represents a node in the tree that makes up a
ProseMirror document. So a document is an instance of `Node`, with
children that are also instances of `Node`.

Nodes are persistent data structures. Instead of changing them, you
create new ones with the content you want. Old ones keep pointing
at the old document shape. This is made cheaper by sharing
structure between the old and new data as much as possible, which a
tree shape like this (without back pointers) makes easy.

**Do not** directly mutate the properties of a `Node` object. See
[the guide](/docs/guide/#doc) for more information.
*/ class $447e8d5afac257af$export$85c928794f8d04d4 {
    /**
    The array of this node's child nodes.
    */ get children() {
        return this.content.content;
    }
    /**
    The size of this node, as defined by the integer-based [indexing
    scheme](/docs/guide/#doc.indexing). For text nodes, this is the
    amount of characters. For other leaf nodes, it is one. For
    non-leaf nodes, it is the size of the content plus two (the
    start and end token).
    */ get nodeSize() {
        return this.isLeaf ? 1 : 2 + this.content.size;
    }
    /**
    The number of children that the node has.
    */ get childCount() {
        return this.content.childCount;
    }
    /**
    Get the child node at the given index. Raises an error when the
    index is out of range.
    */ child(index) {
        return this.content.child(index);
    }
    /**
    Get the child node at the given index, if it exists.
    */ maybeChild(index) {
        return this.content.maybeChild(index);
    }
    /**
    Call `f` for every child node, passing the node, its offset
    into this parent node, and its index.
    */ forEach(f) {
        this.content.forEach(f);
    }
    /**
    Invoke a callback for all descendant nodes recursively between
    the given two positions that are relative to start of this
    node's content. The callback is invoked with the node, its
    position relative to the original node (method receiver),
    its parent node, and its child index. When the callback returns
    false for a given node, that node's children will not be
    recursed over. The last parameter can be used to specify a
    starting position to count from.
    */ nodesBetween(from, to, f, startPos = 0) {
        this.content.nodesBetween(from, to, f, startPos, this);
    }
    /**
    Call the given callback for every descendant node. Doesn't
    descend into a node when the callback returns `false`.
    */ descendants(f) {
        this.nodesBetween(0, this.content.size, f);
    }
    /**
    Concatenates all the text nodes found in this fragment and its
    children.
    */ get textContent() {
        return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
    }
    /**
    Get all text between positions `from` and `to`. When
    `blockSeparator` is given, it will be inserted to separate text
    from different block nodes. If `leafText` is given, it'll be
    inserted for every non-text leaf node encountered, otherwise
    [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
    */ textBetween(from, to, blockSeparator, leafText) {
        return this.content.textBetween(from, to, blockSeparator, leafText);
    }
    /**
    Returns this node's first child, or `null` if there are no
    children.
    */ get firstChild() {
        return this.content.firstChild;
    }
    /**
    Returns this node's last child, or `null` if there are no
    children.
    */ get lastChild() {
        return this.content.lastChild;
    }
    /**
    Test whether two nodes represent the same piece of document.
    */ eq(other) {
        return this == other || this.sameMarkup(other) && this.content.eq(other.content);
    }
    /**
    Compare the markup (type, attributes, and marks) of this node to
    those of another. Returns `true` if both have the same markup.
    */ sameMarkup(other) {
        return this.hasMarkup(other.type, other.attrs, other.marks);
    }
    /**
    Check whether this node's markup correspond to the given type,
    attributes, and marks.
    */ hasMarkup(type, attrs, marks) {
        return this.type == type && $447e8d5afac257af$var$compareDeep(this.attrs, attrs || type.defaultAttrs || $447e8d5afac257af$var$emptyAttrs) && $447e8d5afac257af$export$c9d15bcfc6d42044.sameSet(this.marks, marks || $447e8d5afac257af$export$c9d15bcfc6d42044.none);
    }
    /**
    Create a new node with the same markup as this node, containing
    the given content (or empty, if no content is given).
    */ copy(content = null) {
        if (content == this.content) return this;
        return new $447e8d5afac257af$export$85c928794f8d04d4(this.type, this.attrs, content, this.marks);
    }
    /**
    Create a copy of this node, with the given set of marks instead
    of the node's own marks.
    */ mark(marks) {
        return marks == this.marks ? this : new $447e8d5afac257af$export$85c928794f8d04d4(this.type, this.attrs, this.content, marks);
    }
    /**
    Create a copy of this node with only the content between the
    given positions. If `to` is not given, it defaults to the end of
    the node.
    */ cut(from, to = this.content.size) {
        if (from == 0 && to == this.content.size) return this;
        return this.copy(this.content.cut(from, to));
    }
    /**
    Cut out the part of the document between the given positions, and
    return it as a `Slice` object.
    */ slice(from, to = this.content.size, includeParents = false) {
        if (from == to) return $447e8d5afac257af$export$b3f2e2de3a8baa1e.empty;
        let $from = this.resolve(from), $to = this.resolve(to);
        let depth = includeParents ? 0 : $from.sharedDepth(to);
        let start = $from.start(depth), node = $from.node(depth);
        let content = node.content.cut($from.pos - start, $to.pos - start);
        return new $447e8d5afac257af$export$b3f2e2de3a8baa1e(content, $from.depth - depth, $to.depth - depth);
    }
    /**
    Replace the part of the document between the given positions with
    the given slice. The slice must 'fit', meaning its open sides
    must be able to connect to the surrounding content, and its
    content nodes must be valid children for the node they are placed
    into. If any of this is violated, an error of type
    [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
    */ replace(from, to, slice) {
        return $447e8d5afac257af$var$replace(this.resolve(from), this.resolve(to), slice);
    }
    /**
    Find the node directly after the given position.
    */ nodeAt(pos) {
        for(let node = this;;){
            let { index: index, offset: offset } = node.content.findIndex(pos);
            node = node.maybeChild(index);
            if (!node) return null;
            if (offset == pos || node.isText) return node;
            pos -= offset + 1;
        }
    }
    /**
    Find the (direct) child node after the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childAfter(pos) {
        let { index: index, offset: offset } = this.content.findIndex(pos);
        return {
            node: this.content.maybeChild(index),
            index: index,
            offset: offset
        };
    }
    /**
    Find the (direct) child node before the given offset, if any,
    and return it along with its index and offset relative to this
    node.
    */ childBefore(pos) {
        if (pos == 0) return {
            node: null,
            index: 0,
            offset: 0
        };
        let { index: index, offset: offset } = this.content.findIndex(pos);
        if (offset < pos) return {
            node: this.content.child(index),
            index: index,
            offset: offset
        };
        let node = this.content.child(index - 1);
        return {
            node: node,
            index: index - 1,
            offset: offset - node.nodeSize
        };
    }
    /**
    Resolve the given position in the document, returning an
    [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
    */ resolve(pos) {
        return $447e8d5afac257af$export$b2a42f82e59e4b19.resolveCached(this, pos);
    }
    /**
    @internal
    */ resolveNoCache(pos) {
        return $447e8d5afac257af$export$b2a42f82e59e4b19.resolve(this, pos);
    }
    /**
    Test whether a given mark or mark type occurs in this document
    between the two given positions.
    */ rangeHasMark(from, to, type) {
        let found = false;
        if (to > from) this.nodesBetween(from, to, (node)=>{
            if (type.isInSet(node.marks)) found = true;
            return !found;
        });
        return found;
    }
    /**
    True when this is a block (non-inline node)
    */ get isBlock() {
        return this.type.isBlock;
    }
    /**
    True when this is a textblock node, a block node with inline
    content.
    */ get isTextblock() {
        return this.type.isTextblock;
    }
    /**
    True when this node allows inline content.
    */ get inlineContent() {
        return this.type.inlineContent;
    }
    /**
    True when this is an inline node (a text node or a node that can
    appear among text).
    */ get isInline() {
        return this.type.isInline;
    }
    /**
    True when this is a text node.
    */ get isText() {
        return this.type.isText;
    }
    /**
    True when this is a leaf node.
    */ get isLeaf() {
        return this.type.isLeaf;
    }
    /**
    True when this is an atom, i.e. when it does not have directly
    editable content. This is usually the same as `isLeaf`, but can
    be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
    on a node's spec (typically used when the node is displayed as
    an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
    */ get isAtom() {
        return this.type.isAtom;
    }
    /**
    Return a string representation of this node for debugging
    purposes.
    */ toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        let name = this.type.name;
        if (this.content.size) name += "(" + this.content.toStringInner() + ")";
        return $447e8d5afac257af$var$wrapMarks(this.marks, name);
    }
    /**
    Get the content match in this node at the given index.
    */ contentMatchAt(index) {
        let match = this.type.contentMatch.matchFragment(this.content, 0, index);
        if (!match) throw new Error("Called contentMatchAt on a node with invalid content");
        return match;
    }
    /**
    Test whether replacing the range between `from` and `to` (by
    child index) with the given replacement fragment (which defaults
    to the empty fragment) would leave the node's content valid. You
    can optionally pass `start` and `end` indices into the
    replacement fragment.
    */ canReplace(from, to, replacement = $447e8d5afac257af$export$ffb0004e005737fa.empty, start = 0, end = replacement.childCount) {
        let one = this.contentMatchAt(from).matchFragment(replacement, start, end);
        let two = one && one.matchFragment(this.content, to);
        if (!two || !two.validEnd) return false;
        for(let i = start; i < end; i++)if (!this.type.allowsMarks(replacement.child(i).marks)) return false;
        return true;
    }
    /**
    Test whether replacing the range `from` to `to` (by index) with
    a node of the given type would leave the node's content valid.
    */ canReplaceWith(from, to, type, marks) {
        if (marks && !this.type.allowsMarks(marks)) return false;
        let start = this.contentMatchAt(from).matchType(type);
        let end = start && start.matchFragment(this.content, to);
        return end ? end.validEnd : false;
    }
    /**
    Test whether the given node's content could be appended to this
    node. If that node is empty, this will only return true if there
    is at least one node type that can appear in both nodes (to avoid
    merging completely incompatible nodes).
    */ canAppend(other) {
        if (other.content.size) return this.canReplace(this.childCount, this.childCount, other.content);
        else return this.type.compatibleContent(other.type);
    }
    /**
    Check whether this node and its descendants conform to the
    schema, and raise an exception when they do not.
    */ check() {
        this.type.checkContent(this.content);
        this.type.checkAttrs(this.attrs);
        let copy = $447e8d5afac257af$export$c9d15bcfc6d42044.none;
        for(let i = 0; i < this.marks.length; i++){
            let mark = this.marks[i];
            mark.type.checkAttrs(mark.attrs);
            copy = mark.addToSet(copy);
        }
        if (!$447e8d5afac257af$export$c9d15bcfc6d42044.sameSet(copy, this.marks)) throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((m)=>m.type.name)}`);
        this.content.forEach((node)=>node.check());
    }
    /**
    Return a JSON-serializeable representation of this node.
    */ toJSON() {
        let obj = {
            type: this.type.name
        };
        for(let _ in this.attrs){
            obj.attrs = this.attrs;
            break;
        }
        if (this.content.size) obj.content = this.content.toJSON();
        if (this.marks.length) obj.marks = this.marks.map((n)=>n.toJSON());
        return obj;
    }
    /**
    Deserialize a node from its JSON representation.
    */ static fromJSON(schema, json) {
        if (!json) throw new RangeError("Invalid input for Node.fromJSON");
        let marks = undefined;
        if (json.marks) {
            if (!Array.isArray(json.marks)) throw new RangeError("Invalid mark data for Node.fromJSON");
            marks = json.marks.map(schema.markFromJSON);
        }
        if (json.type == "text") {
            if (typeof json.text != "string") throw new RangeError("Invalid text node in JSON");
            return schema.text(json.text, marks);
        }
        let content = $447e8d5afac257af$export$ffb0004e005737fa.fromJSON(schema, json.content);
        let node = schema.nodeType(json.type).create(json.attrs, content, marks);
        node.type.checkAttrs(node.attrs);
        return node;
    }
    /**
    @internal
    */ constructor(/**
    The type of node that this is.
    */ type, /**
    An object mapping attribute names to values. The kind of
    attributes allowed and required are
    [determined](https://prosemirror.net/docs/ref/#model.NodeSpec.attrs) by the node type.
    */ attrs, // A fragment holding the node's children.
    content, /**
    The marks (things like whether it is emphasized or part of a
    link) applied to this node.
    */ marks = $447e8d5afac257af$export$c9d15bcfc6d42044.none){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.content = content || $447e8d5afac257af$export$ffb0004e005737fa.empty;
    }
}
$447e8d5afac257af$export$85c928794f8d04d4.prototype.text = undefined;
class $447e8d5afac257af$var$TextNode extends $447e8d5afac257af$export$85c928794f8d04d4 {
    toString() {
        if (this.type.spec.toDebugString) return this.type.spec.toDebugString(this);
        return $447e8d5afac257af$var$wrapMarks(this.marks, JSON.stringify(this.text));
    }
    get textContent() {
        return this.text;
    }
    textBetween(from, to) {
        return this.text.slice(from, to);
    }
    get nodeSize() {
        return this.text.length;
    }
    mark(marks) {
        return marks == this.marks ? this : new $447e8d5afac257af$var$TextNode(this.type, this.attrs, this.text, marks);
    }
    withText(text) {
        if (text == this.text) return this;
        return new $447e8d5afac257af$var$TextNode(this.type, this.attrs, text, this.marks);
    }
    cut(from = 0, to = this.text.length) {
        if (from == 0 && to == this.text.length) return this;
        return this.withText(this.text.slice(from, to));
    }
    eq(other) {
        return this.sameMarkup(other) && this.text == other.text;
    }
    toJSON() {
        let base = super.toJSON();
        base.text = this.text;
        return base;
    }
    /**
    @internal
    */ constructor(type, attrs, content, marks){
        super(type, attrs, null, marks);
        if (!content) throw new RangeError("Empty text nodes are not allowed");
        this.text = content;
    }
}
function $447e8d5afac257af$var$wrapMarks(marks, str) {
    for(let i = marks.length - 1; i >= 0; i--)str = marks[i].type.name + "(" + str + ")";
    return str;
}
/**
Instances of this class represent a match state of a node type's
[content expression](https://prosemirror.net/docs/ref/#model.NodeSpec.content), and can be used to
find out whether further content matches here, and whether a given
position is a valid end of the node.
*/ class $447e8d5afac257af$export$364ed450558d7ec4 {
    /**
    @internal
    */ static parse(string, nodeTypes) {
        let stream = new $447e8d5afac257af$var$TokenStream(string, nodeTypes);
        if (stream.next == null) return $447e8d5afac257af$export$364ed450558d7ec4.empty;
        let expr = $447e8d5afac257af$var$parseExpr(stream);
        if (stream.next) stream.err("Unexpected trailing text");
        let match = $447e8d5afac257af$var$dfa($447e8d5afac257af$var$nfa(expr));
        $447e8d5afac257af$var$checkForDeadEnds(match, stream);
        return match;
    }
    /**
    Match a node type, returning a match after that node if
    successful.
    */ matchType(type) {
        for(let i = 0; i < this.next.length; i++)if (this.next[i].type == type) return this.next[i].next;
        return null;
    }
    /**
    Try to match a fragment. Returns the resulting match when
    successful.
    */ matchFragment(frag, start = 0, end = frag.childCount) {
        let cur = this;
        for(let i = start; cur && i < end; i++)cur = cur.matchType(frag.child(i).type);
        return cur;
    }
    /**
    @internal
    */ get inlineContent() {
        return this.next.length != 0 && this.next[0].type.isInline;
    }
    /**
    Get the first matching node type at this match position that can
    be generated.
    */ get defaultType() {
        for(let i = 0; i < this.next.length; i++){
            let { type: type } = this.next[i];
            if (!(type.isText || type.hasRequiredAttrs())) return type;
        }
        return null;
    }
    /**
    @internal
    */ compatible(other) {
        for(let i = 0; i < this.next.length; i++)for(let j = 0; j < other.next.length; j++)if (this.next[i].type == other.next[j].type) return true;
        return false;
    }
    /**
    Try to match the given fragment, and if that fails, see if it can
    be made to match by inserting nodes in front of it. When
    successful, return a fragment of inserted nodes (which may be
    empty if nothing had to be inserted). When `toEnd` is true, only
    return a fragment if the resulting match goes to the end of the
    content expression.
    */ fillBefore(after, toEnd = false, startIndex = 0) {
        let seen = [
            this
        ];
        function search(match, types) {
            let finished = match.matchFragment(after, startIndex);
            if (finished && (!toEnd || finished.validEnd)) return $447e8d5afac257af$export$ffb0004e005737fa.from(types.map((tp)=>tp.createAndFill()));
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!(type.isText || type.hasRequiredAttrs()) && seen.indexOf(next) == -1) {
                    seen.push(next);
                    let found = search(next, types.concat(type));
                    if (found) return found;
                }
            }
            return null;
        }
        return search(this, []);
    }
    /**
    Find a set of wrapping node types that would allow a node of the
    given type to appear at this position. The result may be empty
    (when it fits directly) and will be null when no such wrapping
    exists.
    */ findWrapping(target) {
        for(let i = 0; i < this.wrapCache.length; i += 2)if (this.wrapCache[i] == target) return this.wrapCache[i + 1];
        let computed = this.computeWrapping(target);
        this.wrapCache.push(target, computed);
        return computed;
    }
    /**
    @internal
    */ computeWrapping(target) {
        let seen = Object.create(null), active = [
            {
                match: this,
                type: null,
                via: null
            }
        ];
        while(active.length){
            let current = active.shift(), match = current.match;
            if (match.matchType(target)) {
                let result = [];
                for(let obj = current; obj.type; obj = obj.via)result.push(obj.type);
                return result.reverse();
            }
            for(let i = 0; i < match.next.length; i++){
                let { type: type, next: next } = match.next[i];
                if (!type.isLeaf && !type.hasRequiredAttrs() && !(type.name in seen) && (!current.type || next.validEnd)) {
                    active.push({
                        match: type.contentMatch,
                        type: type,
                        via: current
                    });
                    seen[type.name] = true;
                }
            }
        }
        return null;
    }
    /**
    The number of outgoing edges this node has in the finite
    automaton that describes the content expression.
    */ get edgeCount() {
        return this.next.length;
    }
    /**
    Get the _n_​th outgoing edge from this node in the finite
    automaton that describes the content expression.
    */ edge(n) {
        if (n >= this.next.length) throw new RangeError(`There's no ${n}th edge in this content match`);
        return this.next[n];
    }
    /**
    @internal
    */ toString() {
        let seen = [];
        function scan(m) {
            seen.push(m);
            for(let i = 0; i < m.next.length; i++)if (seen.indexOf(m.next[i].next) == -1) scan(m.next[i].next);
        }
        scan(this);
        return seen.map((m, i)=>{
            let out = i + (m.validEnd ? "*" : " ") + " ";
            for(let i = 0; i < m.next.length; i++)out += (i ? ", " : "") + m.next[i].type.name + "->" + seen.indexOf(m.next[i].next);
            return out;
        }).join("\n");
    }
    /**
    @internal
    */ constructor(/**
    True when this match state represents a valid end of the node.
    */ validEnd){
        this.validEnd = validEnd;
        /**
        @internal
        */ this.next = [];
        /**
        @internal
        */ this.wrapCache = [];
    }
}
/**
@internal
*/ $447e8d5afac257af$export$364ed450558d7ec4.empty = new $447e8d5afac257af$export$364ed450558d7ec4(true);
class $447e8d5afac257af$var$TokenStream {
    get next() {
        return this.tokens[this.pos];
    }
    eat(tok) {
        return this.next == tok && (this.pos++ || true);
    }
    err(str) {
        throw new SyntaxError(str + " (in content expression '" + this.string + "')");
    }
    constructor(string, nodeTypes){
        this.string = string;
        this.nodeTypes = nodeTypes;
        this.inline = null;
        this.pos = 0;
        this.tokens = string.split(/\s*(?=\b|\W|$)/);
        if (this.tokens[this.tokens.length - 1] == "") this.tokens.pop();
        if (this.tokens[0] == "") this.tokens.shift();
    }
}
function $447e8d5afac257af$var$parseExpr(stream) {
    let exprs = [];
    do exprs.push($447e8d5afac257af$var$parseExprSeq(stream));
    while (stream.eat("|"));
    return exprs.length == 1 ? exprs[0] : {
        type: "choice",
        exprs: exprs
    };
}
function $447e8d5afac257af$var$parseExprSeq(stream) {
    let exprs = [];
    do exprs.push($447e8d5afac257af$var$parseExprSubscript(stream));
    while (stream.next && stream.next != ")" && stream.next != "|");
    return exprs.length == 1 ? exprs[0] : {
        type: "seq",
        exprs: exprs
    };
}
function $447e8d5afac257af$var$parseExprSubscript(stream) {
    let expr = $447e8d5afac257af$var$parseExprAtom(stream);
    for(;;){
        if (stream.eat("+")) expr = {
            type: "plus",
            expr: expr
        };
        else if (stream.eat("*")) expr = {
            type: "star",
            expr: expr
        };
        else if (stream.eat("?")) expr = {
            type: "opt",
            expr: expr
        };
        else if (stream.eat("{")) expr = $447e8d5afac257af$var$parseExprRange(stream, expr);
        else break;
    }
    return expr;
}
function $447e8d5afac257af$var$parseNum(stream) {
    if (/\D/.test(stream.next)) stream.err("Expected number, got '" + stream.next + "'");
    let result = Number(stream.next);
    stream.pos++;
    return result;
}
function $447e8d5afac257af$var$parseExprRange(stream, expr) {
    let min = $447e8d5afac257af$var$parseNum(stream), max = min;
    if (stream.eat(",")) {
        if (stream.next != "}") max = $447e8d5afac257af$var$parseNum(stream);
        else max = -1;
    }
    if (!stream.eat("}")) stream.err("Unclosed braced range");
    return {
        type: "range",
        min: min,
        max: max,
        expr: expr
    };
}
function $447e8d5afac257af$var$resolveName(stream, name) {
    let types = stream.nodeTypes, type = types[name];
    if (type) return [
        type
    ];
    let result = [];
    for(let typeName in types){
        let type = types[typeName];
        if (type.isInGroup(name)) result.push(type);
    }
    if (result.length == 0) stream.err("No node type or group '" + name + "' found");
    return result;
}
function $447e8d5afac257af$var$parseExprAtom(stream) {
    if (stream.eat("(")) {
        let expr = $447e8d5afac257af$var$parseExpr(stream);
        if (!stream.eat(")")) stream.err("Missing closing paren");
        return expr;
    } else if (!/\W/.test(stream.next)) {
        let exprs = $447e8d5afac257af$var$resolveName(stream, stream.next).map((type)=>{
            if (stream.inline == null) stream.inline = type.isInline;
            else if (stream.inline != type.isInline) stream.err("Mixing inline and block content");
            return {
                type: "name",
                value: type
            };
        });
        stream.pos++;
        return exprs.length == 1 ? exprs[0] : {
            type: "choice",
            exprs: exprs
        };
    } else stream.err("Unexpected token '" + stream.next + "'");
}
// Construct an NFA from an expression as returned by the parser. The
// NFA is represented as an array of states, which are themselves
// arrays of edges, which are `{term, to}` objects. The first state is
// the entry state and the last node is the success state.
//
// Note that unlike typical NFAs, the edge ordering in this one is
// significant, in that it is used to contruct filler content when
// necessary.
function $447e8d5afac257af$var$nfa(expr) {
    let nfa = [
        []
    ];
    connect(compile(expr, 0), node());
    return nfa;
    function node() {
        return nfa.push([]) - 1;
    }
    function edge(from, to, term) {
        let edge = {
            term: term,
            to: to
        };
        nfa[from].push(edge);
        return edge;
    }
    function connect(edges, to) {
        edges.forEach((edge)=>edge.to = to);
    }
    function compile(expr, from) {
        if (expr.type == "choice") return expr.exprs.reduce((out, expr)=>out.concat(compile(expr, from)), []);
        else if (expr.type == "seq") for(let i = 0;; i++){
            let next = compile(expr.exprs[i], from);
            if (i == expr.exprs.length - 1) return next;
            connect(next, from = node());
        }
        else if (expr.type == "star") {
            let loop = node();
            edge(from, loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "plus") {
            let loop = node();
            connect(compile(expr.expr, from), loop);
            connect(compile(expr.expr, loop), loop);
            return [
                edge(loop)
            ];
        } else if (expr.type == "opt") return [
            edge(from)
        ].concat(compile(expr.expr, from));
        else if (expr.type == "range") {
            let cur = from;
            for(let i = 0; i < expr.min; i++){
                let next = node();
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            if (expr.max == -1) connect(compile(expr.expr, cur), cur);
            else for(let i = expr.min; i < expr.max; i++){
                let next = node();
                edge(cur, next);
                connect(compile(expr.expr, cur), next);
                cur = next;
            }
            return [
                edge(cur)
            ];
        } else if (expr.type == "name") return [
            edge(from, undefined, expr.value)
        ];
        else throw new Error("Unknown expr type");
    }
}
function $447e8d5afac257af$var$cmp(a, b) {
    return b - a;
}
// Get the set of nodes reachable by null edges from `node`. Omit
// nodes with only a single null-out-edge, since they may lead to
// needless duplicated nodes.
function $447e8d5afac257af$var$nullFrom(nfa, node) {
    let result = [];
    scan(node);
    return result.sort($447e8d5afac257af$var$cmp);
    function scan(node) {
        let edges = nfa[node];
        if (edges.length == 1 && !edges[0].term) return scan(edges[0].to);
        result.push(node);
        for(let i = 0; i < edges.length; i++){
            let { term: term, to: to } = edges[i];
            if (!term && result.indexOf(to) == -1) scan(to);
        }
    }
}
// Compiles an NFA as produced by `nfa` into a DFA, modeled as a set
// of state objects (`ContentMatch` instances) with transitions
// between them.
function $447e8d5afac257af$var$dfa(nfa) {
    let labeled = Object.create(null);
    return explore($447e8d5afac257af$var$nullFrom(nfa, 0));
    function explore(states) {
        let out = [];
        states.forEach((node)=>{
            nfa[node].forEach(({ term: term, to: to })=>{
                if (!term) return;
                let set;
                for(let i = 0; i < out.length; i++)if (out[i][0] == term) set = out[i][1];
                $447e8d5afac257af$var$nullFrom(nfa, to).forEach((node)=>{
                    if (!set) out.push([
                        term,
                        set = []
                    ]);
                    if (set.indexOf(node) == -1) set.push(node);
                });
            });
        });
        let state = labeled[states.join(",")] = new $447e8d5afac257af$export$364ed450558d7ec4(states.indexOf(nfa.length - 1) > -1);
        for(let i = 0; i < out.length; i++){
            let states = out[i][1].sort($447e8d5afac257af$var$cmp);
            state.next.push({
                type: out[i][0],
                next: labeled[states.join(",")] || explore(states)
            });
        }
        return state;
    }
}
function $447e8d5afac257af$var$checkForDeadEnds(match, stream) {
    for(let i = 0, work = [
        match
    ]; i < work.length; i++){
        let state = work[i], dead = !state.validEnd, nodes = [];
        for(let j = 0; j < state.next.length; j++){
            let { type: type, next: next } = state.next[j];
            nodes.push(type.name);
            if (dead && !(type.isText || type.hasRequiredAttrs())) dead = false;
            if (work.indexOf(next) == -1) work.push(next);
        }
        if (dead) stream.err("Only non-generatable nodes (" + nodes.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
    }
}
// For node types where all attrs have a default value (or which don't
// have any attributes), build up a single reusable default attribute
// object, and use it for all nodes that don't specify specific
// attributes.
function $447e8d5afac257af$var$defaultAttrs(attrs) {
    let defaults = Object.create(null);
    for(let attrName in attrs){
        let attr = attrs[attrName];
        if (!attr.hasDefault) return null;
        defaults[attrName] = attr.default;
    }
    return defaults;
}
function $447e8d5afac257af$var$computeAttrs(attrs, value) {
    let built = Object.create(null);
    for(let name in attrs){
        let given = value && value[name];
        if (given === undefined) {
            let attr = attrs[name];
            if (attr.hasDefault) given = attr.default;
            else throw new RangeError("No value supplied for attribute " + name);
        }
        built[name] = given;
    }
    return built;
}
function $447e8d5afac257af$var$checkAttrs(attrs, values, type, name) {
    for(let name in values)if (!(name in attrs)) throw new RangeError(`Unsupported attribute ${name} for ${type} of type ${name}`);
    for(let name in attrs){
        let attr = attrs[name];
        if (attr.validate) attr.validate(values[name]);
    }
}
function $447e8d5afac257af$var$initAttrs(typeName, attrs) {
    let result = Object.create(null);
    if (attrs) for(let name in attrs)result[name] = new $447e8d5afac257af$var$Attribute(typeName, name, attrs[name]);
    return result;
}
/**
Node types are objects allocated once per `Schema` and used to
[tag](https://prosemirror.net/docs/ref/#model.Node.type) `Node` instances. They contain information
about the node type, such as its name and what kind of node it
represents.
*/ class $447e8d5afac257af$export$f06e977173f1857c {
    /**
    True if this is an inline type.
    */ get isInline() {
        return !this.isBlock;
    }
    /**
    True if this is a textblock type, a block that contains inline
    content.
    */ get isTextblock() {
        return this.isBlock && this.inlineContent;
    }
    /**
    True for node types that allow no content.
    */ get isLeaf() {
        return this.contentMatch == $447e8d5afac257af$export$364ed450558d7ec4.empty;
    }
    /**
    True when this node is an atom, i.e. when it does not have
    directly editable content.
    */ get isAtom() {
        return this.isLeaf || !!this.spec.atom;
    }
    /**
    Return true when this node type is part of the given
    [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
    */ isInGroup(group) {
        return this.groups.indexOf(group) > -1;
    }
    /**
    The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
    */ get whitespace() {
        return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
    }
    /**
    Tells you whether this node type has any required attributes.
    */ hasRequiredAttrs() {
        for(let n in this.attrs)if (this.attrs[n].isRequired) return true;
        return false;
    }
    /**
    Indicates whether this node allows some of the same content as
    the given node type.
    */ compatibleContent(other) {
        return this == other || this.contentMatch.compatible(other.contentMatch);
    }
    /**
    @internal
    */ computeAttrs(attrs) {
        if (!attrs && this.defaultAttrs) return this.defaultAttrs;
        else return $447e8d5afac257af$var$computeAttrs(this.attrs, attrs);
    }
    /**
    Create a `Node` of this type. The given attributes are
    checked and defaulted (you can pass `null` to use the type's
    defaults entirely, if no required attributes exist). `content`
    may be a `Fragment`, a node, an array of nodes, or
    `null`. Similarly `marks` may be `null` to default to the empty
    set of marks.
    */ create(attrs = null, content, marks) {
        if (this.isText) throw new Error("NodeType.create can't construct text nodes");
        return new $447e8d5afac257af$export$85c928794f8d04d4(this, this.computeAttrs(attrs), $447e8d5afac257af$export$ffb0004e005737fa.from(content), $447e8d5afac257af$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
    against the node type's content restrictions, and throw an error
    if it doesn't match.
    */ createChecked(attrs = null, content, marks) {
        content = $447e8d5afac257af$export$ffb0004e005737fa.from(content);
        this.checkContent(content);
        return new $447e8d5afac257af$export$85c928794f8d04d4(this, this.computeAttrs(attrs), content, $447e8d5afac257af$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
    necessary to add nodes to the start or end of the given fragment
    to make it fit the node. If no fitting wrapping can be found,
    return null. Note that, due to the fact that required nodes can
    always be created, this will always succeed if you pass null or
    `Fragment.empty` as content.
    */ createAndFill(attrs = null, content, marks) {
        attrs = this.computeAttrs(attrs);
        content = $447e8d5afac257af$export$ffb0004e005737fa.from(content);
        if (content.size) {
            let before = this.contentMatch.fillBefore(content);
            if (!before) return null;
            content = before.append(content);
        }
        let matched = this.contentMatch.matchFragment(content);
        let after = matched && matched.fillBefore($447e8d5afac257af$export$ffb0004e005737fa.empty, true);
        if (!after) return null;
        return new $447e8d5afac257af$export$85c928794f8d04d4(this, attrs, content.append(after), $447e8d5afac257af$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Returns true if the given fragment is valid content for this node
    type.
    */ validContent(content) {
        let result = this.contentMatch.matchFragment(content);
        if (!result || !result.validEnd) return false;
        for(let i = 0; i < content.childCount; i++)if (!this.allowsMarks(content.child(i).marks)) return false;
        return true;
    }
    /**
    Throws a RangeError if the given fragment is not valid content for this
    node type.
    @internal
    */ checkContent(content) {
        if (!this.validContent(content)) throw new RangeError(`Invalid content for node ${this.name}: ${content.toString().slice(0, 50)}`);
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $447e8d5afac257af$var$checkAttrs(this.attrs, attrs, "node", this.name);
    }
    /**
    Check whether the given mark type is allowed in this node.
    */ allowsMarkType(markType) {
        return this.markSet == null || this.markSet.indexOf(markType) > -1;
    }
    /**
    Test whether the given set of marks are allowed in this node.
    */ allowsMarks(marks) {
        if (this.markSet == null) return true;
        for(let i = 0; i < marks.length; i++)if (!this.allowsMarkType(marks[i].type)) return false;
        return true;
    }
    /**
    Removes the marks that are not allowed in this node from the given set.
    */ allowedMarks(marks) {
        if (this.markSet == null) return marks;
        let copy;
        for(let i = 0; i < marks.length; i++){
            if (!this.allowsMarkType(marks[i].type)) {
                if (!copy) copy = marks.slice(0, i);
            } else if (copy) copy.push(marks[i]);
        }
        return !copy ? marks : copy.length ? copy : $447e8d5afac257af$export$c9d15bcfc6d42044.none;
    }
    /**
    @internal
    */ static compile(nodes, schema) {
        let result = Object.create(null);
        nodes.forEach((name, spec)=>result[name] = new $447e8d5afac257af$export$f06e977173f1857c(name, schema, spec));
        let topType = schema.spec.topNode || "doc";
        if (!result[topType]) throw new RangeError("Schema is missing its top node type ('" + topType + "')");
        if (!result.text) throw new RangeError("Every schema needs a 'text' type");
        for(let _ in result.text.attrs)throw new RangeError("The text node type should not have attributes");
        return result;
    }
    /**
    @internal
    */ constructor(/**
    The name the node type has in this schema.
    */ name, /**
    A link back to the `Schema` the node type belongs to.
    */ schema, /**
    The spec that this type is based on
    */ spec){
        this.name = name;
        this.schema = schema;
        this.spec = spec;
        /**
        The set of marks allowed in this node. `null` means all marks
        are allowed.
        */ this.markSet = null;
        this.groups = spec.group ? spec.group.split(" ") : [];
        this.attrs = $447e8d5afac257af$var$initAttrs(name, spec.attrs);
        this.defaultAttrs = $447e8d5afac257af$var$defaultAttrs(this.attrs);
        this.contentMatch = null;
        this.inlineContent = null;
        this.isBlock = !(spec.inline || name == "text");
        this.isText = name == "text";
    }
}
function $447e8d5afac257af$var$validateType(typeName, attrName, type) {
    let types = type.split("|");
    return (value)=>{
        let name = value === null ? "null" : typeof value;
        if (types.indexOf(name) < 0) throw new RangeError(`Expected value of type ${types} for attribute ${attrName} on type ${typeName}, got ${name}`);
    };
}
// Attribute descriptors
class $447e8d5afac257af$var$Attribute {
    get isRequired() {
        return !this.hasDefault;
    }
    constructor(typeName, attrName, options){
        this.hasDefault = Object.prototype.hasOwnProperty.call(options, "default");
        this.default = options.default;
        this.validate = typeof options.validate == "string" ? $447e8d5afac257af$var$validateType(typeName, attrName, options.validate) : options.validate;
    }
}
// Marks
/**
Like nodes, marks (which are associated with nodes to signify
things like emphasis or being part of a link) are
[tagged](https://prosemirror.net/docs/ref/#model.Mark.type) with type objects, which are
instantiated once per `Schema`.
*/ class $447e8d5afac257af$export$b6a78689043c6521 {
    /**
    Create a mark of this type. `attrs` may be `null` or an object
    containing only some of the mark's attributes. The others, if
    they have defaults, will be added.
    */ create(attrs = null) {
        if (!attrs && this.instance) return this.instance;
        return new $447e8d5afac257af$export$c9d15bcfc6d42044(this, $447e8d5afac257af$var$computeAttrs(this.attrs, attrs));
    }
    /**
    @internal
    */ static compile(marks, schema) {
        let result = Object.create(null), rank = 0;
        marks.forEach((name, spec)=>result[name] = new $447e8d5afac257af$export$b6a78689043c6521(name, rank++, schema, spec));
        return result;
    }
    /**
    When there is a mark of this type in the given set, a new set
    without it is returned. Otherwise, the input set is returned.
    */ removeFromSet(set) {
        for(var i = 0; i < set.length; i++)if (set[i].type == this) {
            set = set.slice(0, i).concat(set.slice(i + 1));
            i--;
        }
        return set;
    }
    /**
    Tests whether there is a mark of this type in the given set.
    */ isInSet(set) {
        for(let i = 0; i < set.length; i++)if (set[i].type == this) return set[i];
    }
    /**
    @internal
    */ checkAttrs(attrs) {
        $447e8d5afac257af$var$checkAttrs(this.attrs, attrs, "mark", this.name);
    }
    /**
    Queries whether a given mark type is
    [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
    */ excludes(other) {
        return this.excluded.indexOf(other) > -1;
    }
    /**
    @internal
    */ constructor(/**
    The name of the mark type.
    */ name, /**
    @internal
    */ rank, /**
    The schema that this mark type instance is part of.
    */ schema, /**
    The spec on which the type is based.
    */ spec){
        this.name = name;
        this.rank = rank;
        this.schema = schema;
        this.spec = spec;
        this.attrs = $447e8d5afac257af$var$initAttrs(name, spec.attrs);
        this.excluded = null;
        let defaults = $447e8d5afac257af$var$defaultAttrs(this.attrs);
        this.instance = defaults ? new $447e8d5afac257af$export$c9d15bcfc6d42044(this, defaults) : null;
    }
}
/**
A document schema. Holds [node](https://prosemirror.net/docs/ref/#model.NodeType) and [mark
type](https://prosemirror.net/docs/ref/#model.MarkType) objects for the nodes and marks that may
occur in conforming documents, and provides functionality for
creating and deserializing such documents.

When given, the type parameters provide the names of the nodes and
marks in this schema.
*/ class $447e8d5afac257af$export$19342e026b58ebb7 {
    /**
    Create a node in this schema. The `type` may be a string or a
    `NodeType` instance. Attributes will be extended with defaults,
    `content` may be a `Fragment`, `null`, a `Node`, or an array of
    nodes.
    */ node(type, attrs = null, content, marks) {
        if (typeof type == "string") type = this.nodeType(type);
        else if (!(type instanceof $447e8d5afac257af$export$f06e977173f1857c)) throw new RangeError("Invalid node type: " + type);
        else if (type.schema != this) throw new RangeError("Node type from different schema used (" + type.name + ")");
        return type.createChecked(attrs, content, marks);
    }
    /**
    Create a text node in the schema. Empty text nodes are not
    allowed.
    */ text(text, marks) {
        let type = this.nodes.text;
        return new $447e8d5afac257af$var$TextNode(type, type.defaultAttrs, text, $447e8d5afac257af$export$c9d15bcfc6d42044.setFrom(marks));
    }
    /**
    Create a mark with the given type and attributes.
    */ mark(type, attrs) {
        if (typeof type == "string") type = this.marks[type];
        return type.create(attrs);
    }
    /**
    Deserialize a node from its JSON representation. This method is
    bound.
    */ nodeFromJSON(json) {
        return $447e8d5afac257af$export$85c928794f8d04d4.fromJSON(this, json);
    }
    /**
    Deserialize a mark from its JSON representation. This method is
    bound.
    */ markFromJSON(json) {
        return $447e8d5afac257af$export$c9d15bcfc6d42044.fromJSON(this, json);
    }
    /**
    @internal
    */ nodeType(name) {
        let found = this.nodes[name];
        if (!found) throw new RangeError("Unknown node type: " + name);
        return found;
    }
    /**
    Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
    */ constructor(spec){
        /**
        The [linebreak
        replacement](https://prosemirror.net/docs/ref/#model.NodeSpec.linebreakReplacement) node defined
        in this schema, if any.
        */ this.linebreakReplacement = null;
        /**
        An object for storing whatever values modules may want to
        compute and cache per schema. (If you want to store something
        in it, try to use property names unlikely to clash.)
        */ this.cached = Object.create(null);
        let instanceSpec = this.spec = {};
        for(let prop in spec)instanceSpec[prop] = spec[prop];
        instanceSpec.nodes = (0, $9ac5e8463c86a39c$export$2e2bcd8739ae039).from(spec.nodes), instanceSpec.marks = (0, $9ac5e8463c86a39c$export$2e2bcd8739ae039).from(spec.marks || {}), this.nodes = $447e8d5afac257af$export$f06e977173f1857c.compile(this.spec.nodes, this);
        this.marks = $447e8d5afac257af$export$b6a78689043c6521.compile(this.spec.marks, this);
        let contentExprCache = Object.create(null);
        for(let prop in this.nodes){
            if (prop in this.marks) throw new RangeError(prop + " can not be both a node and a mark");
            let type = this.nodes[prop], contentExpr = type.spec.content || "", markExpr = type.spec.marks;
            type.contentMatch = contentExprCache[contentExpr] || (contentExprCache[contentExpr] = $447e8d5afac257af$export$364ed450558d7ec4.parse(contentExpr, this.nodes));
            type.inlineContent = type.contentMatch.inlineContent;
            if (type.spec.linebreakReplacement) {
                if (this.linebreakReplacement) throw new RangeError("Multiple linebreak nodes defined");
                if (!type.isInline || !type.isLeaf) throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
                this.linebreakReplacement = type;
            }
            type.markSet = markExpr == "_" ? null : markExpr ? $447e8d5afac257af$var$gatherMarks(this, markExpr.split(" ")) : markExpr == "" || !type.inlineContent ? [] : null;
        }
        for(let prop in this.marks){
            let type = this.marks[prop], excl = type.spec.excludes;
            type.excluded = excl == null ? [
                type
            ] : excl == "" ? [] : $447e8d5afac257af$var$gatherMarks(this, excl.split(" "));
        }
        this.nodeFromJSON = this.nodeFromJSON.bind(this);
        this.markFromJSON = this.markFromJSON.bind(this);
        this.topNodeType = this.nodes[this.spec.topNode || "doc"];
        this.cached.wrappings = Object.create(null);
    }
}
function $447e8d5afac257af$var$gatherMarks(schema, marks) {
    let found = [];
    for(let i = 0; i < marks.length; i++){
        let name = marks[i], mark = schema.marks[name], ok = mark;
        if (mark) found.push(mark);
        else for(let prop in schema.marks){
            let mark = schema.marks[prop];
            if (name == "_" || mark.spec.group && mark.spec.group.split(" ").indexOf(name) > -1) found.push(ok = mark);
        }
        if (!ok) throw new SyntaxError("Unknown mark type: '" + marks[i] + "'");
    }
    return found;
}
function $447e8d5afac257af$var$isTagRule(rule) {
    return rule.tag != null;
}
function $447e8d5afac257af$var$isStyleRule(rule) {
    return rule.style != null;
}
/**
A DOM parser represents a strategy for parsing DOM content into a
ProseMirror document conforming to a given schema. Its behavior is
defined by an array of [rules](https://prosemirror.net/docs/ref/#model.ParseRule).
*/ class $447e8d5afac257af$export$1059c6e7d2ce5669 {
    /**
    Parse a document from the content of a DOM node.
    */ parse(dom, options = {}) {
        let context = new $447e8d5afac257af$var$ParseContext(this, options, false);
        context.addAll(dom, $447e8d5afac257af$export$c9d15bcfc6d42044.none, options.from, options.to);
        return context.finish();
    }
    /**
    Parses the content of the given DOM node, like
    [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
    options. But unlike that method, which produces a whole node,
    this one returns a slice that is open at the sides, meaning that
    the schema constraints aren't applied to the start of nodes to
    the left of the input and the end of nodes at the end.
    */ parseSlice(dom, options = {}) {
        let context = new $447e8d5afac257af$var$ParseContext(this, options, true);
        context.addAll(dom, $447e8d5afac257af$export$c9d15bcfc6d42044.none, options.from, options.to);
        return $447e8d5afac257af$export$b3f2e2de3a8baa1e.maxOpen(context.finish());
    }
    /**
    @internal
    */ matchTag(dom, context, after) {
        for(let i = after ? this.tags.indexOf(after) + 1 : 0; i < this.tags.length; i++){
            let rule = this.tags[i];
            if ($447e8d5afac257af$var$matches(dom, rule.tag) && (rule.namespace === undefined || dom.namespaceURI == rule.namespace) && (!rule.context || context.matchesContext(rule.context))) {
                if (rule.getAttrs) {
                    let result = rule.getAttrs(dom);
                    if (result === false) continue;
                    rule.attrs = result || undefined;
                }
                return rule;
            }
        }
    }
    /**
    @internal
    */ matchStyle(prop, value, context, after) {
        for(let i = after ? this.styles.indexOf(after) + 1 : 0; i < this.styles.length; i++){
            let rule = this.styles[i], style = rule.style;
            if (style.indexOf(prop) != 0 || rule.context && !context.matchesContext(rule.context) || // Test that the style string either precisely matches the prop,
            // or has an '=' sign after the prop, followed by the given
            // value.
            style.length > prop.length && (style.charCodeAt(prop.length) != 61 || style.slice(prop.length + 1) != value)) continue;
            if (rule.getAttrs) {
                let result = rule.getAttrs(value);
                if (result === false) continue;
                rule.attrs = result || undefined;
            }
            return rule;
        }
    }
    /**
    @internal
    */ static schemaRules(schema) {
        let result = [];
        function insert(rule) {
            let priority = rule.priority == null ? 50 : rule.priority, i = 0;
            for(; i < result.length; i++){
                let next = result[i], nextPriority = next.priority == null ? 50 : next.priority;
                if (nextPriority < priority) break;
            }
            result.splice(i, 0, rule);
        }
        for(let name in schema.marks){
            let rules = schema.marks[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $447e8d5afac257af$var$copy(rule));
                if (!(rule.mark || rule.ignore || rule.clearMark)) rule.mark = name;
            });
        }
        for(let name in schema.nodes){
            let rules = schema.nodes[name].spec.parseDOM;
            if (rules) rules.forEach((rule)=>{
                insert(rule = $447e8d5afac257af$var$copy(rule));
                if (!(rule.node || rule.ignore || rule.mark)) rule.node = name;
            });
        }
        return result;
    }
    /**
    Construct a DOM parser using the parsing rules listed in a
    schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
    [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
    */ static fromSchema(schema) {
        return schema.cached.domParser || (schema.cached.domParser = new $447e8d5afac257af$export$1059c6e7d2ce5669(schema, $447e8d5afac257af$export$1059c6e7d2ce5669.schemaRules(schema)));
    }
    /**
    Create a parser that targets the given schema, using the given
    parsing rules.
    */ constructor(/**
    The schema into which the parser parses.
    */ schema, /**
    The set of [parse rules](https://prosemirror.net/docs/ref/#model.ParseRule) that the parser
    uses, in order of precedence.
    */ rules){
        this.schema = schema;
        this.rules = rules;
        /**
        @internal
        */ this.tags = [];
        /**
        @internal
        */ this.styles = [];
        let matchedStyles = this.matchedStyles = [];
        rules.forEach((rule)=>{
            if ($447e8d5afac257af$var$isTagRule(rule)) this.tags.push(rule);
            else if ($447e8d5afac257af$var$isStyleRule(rule)) {
                let prop = /[^=]*/.exec(rule.style)[0];
                if (matchedStyles.indexOf(prop) < 0) matchedStyles.push(prop);
                this.styles.push(rule);
            }
        });
        // Only normalize list elements when lists in the schema can't directly contain themselves
        this.normalizeLists = !this.tags.some((r)=>{
            if (!/^(ul|ol)\b/.test(r.tag) || !r.node) return false;
            let node = schema.nodes[r.node];
            return node.contentMatch.matchType(node);
        });
    }
}
const $447e8d5afac257af$var$blockTags = {
    address: true,
    article: true,
    aside: true,
    blockquote: true,
    canvas: true,
    dd: true,
    div: true,
    dl: true,
    fieldset: true,
    figcaption: true,
    figure: true,
    footer: true,
    form: true,
    h1: true,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    h6: true,
    header: true,
    hgroup: true,
    hr: true,
    li: true,
    noscript: true,
    ol: true,
    output: true,
    p: true,
    pre: true,
    section: true,
    table: true,
    tfoot: true,
    ul: true
};
const $447e8d5afac257af$var$ignoreTags = {
    head: true,
    noscript: true,
    object: true,
    script: true,
    style: true,
    title: true
};
const $447e8d5afac257af$var$listTags = {
    ol: true,
    ul: true
};
// Using a bitfield for node context options
const $447e8d5afac257af$var$OPT_PRESERVE_WS = 1, $447e8d5afac257af$var$OPT_PRESERVE_WS_FULL = 2, $447e8d5afac257af$var$OPT_OPEN_LEFT = 4;
function $447e8d5afac257af$var$wsOptionsFor(type, preserveWhitespace, base) {
    if (preserveWhitespace != null) return (preserveWhitespace ? $447e8d5afac257af$var$OPT_PRESERVE_WS : 0) | (preserveWhitespace === "full" ? $447e8d5afac257af$var$OPT_PRESERVE_WS_FULL : 0);
    return type && type.whitespace == "pre" ? $447e8d5afac257af$var$OPT_PRESERVE_WS | $447e8d5afac257af$var$OPT_PRESERVE_WS_FULL : base & ~$447e8d5afac257af$var$OPT_OPEN_LEFT;
}
class $447e8d5afac257af$var$NodeContext {
    findWrapping(node) {
        if (!this.match) {
            if (!this.type) return [];
            let fill = this.type.contentMatch.fillBefore($447e8d5afac257af$export$ffb0004e005737fa.from(node));
            if (fill) this.match = this.type.contentMatch.matchFragment(fill);
            else {
                let start = this.type.contentMatch, wrap;
                if (wrap = start.findWrapping(node.type)) {
                    this.match = start;
                    return wrap;
                } else return null;
            }
        }
        return this.match.findWrapping(node.type);
    }
    finish(openEnd) {
        if (!(this.options & $447e8d5afac257af$var$OPT_PRESERVE_WS)) {
            let last = this.content[this.content.length - 1], m;
            if (last && last.isText && (m = /[ \t\r\n\u000c]+$/.exec(last.text))) {
                let text = last;
                if (last.text.length == m[0].length) this.content.pop();
                else this.content[this.content.length - 1] = text.withText(text.text.slice(0, text.text.length - m[0].length));
            }
        }
        let content = $447e8d5afac257af$export$ffb0004e005737fa.from(this.content);
        if (!openEnd && this.match) content = content.append(this.match.fillBefore($447e8d5afac257af$export$ffb0004e005737fa.empty, true));
        return this.type ? this.type.create(this.attrs, content, this.marks) : content;
    }
    inlineContext(node) {
        if (this.type) return this.type.inlineContent;
        if (this.content.length) return this.content[0].isInline;
        return node.parentNode && !$447e8d5afac257af$var$blockTags.hasOwnProperty(node.parentNode.nodeName.toLowerCase());
    }
    constructor(type, attrs, marks, solid, match, options){
        this.type = type;
        this.attrs = attrs;
        this.marks = marks;
        this.solid = solid;
        this.options = options;
        this.content = [];
        // Marks applied to the node's children
        this.activeMarks = $447e8d5afac257af$export$c9d15bcfc6d42044.none;
        this.match = match || (options & $447e8d5afac257af$var$OPT_OPEN_LEFT ? null : type.contentMatch);
    }
}
class $447e8d5afac257af$var$ParseContext {
    get top() {
        return this.nodes[this.open];
    }
    // Add a DOM node to the content. Text is inserted as text node,
    // otherwise, the node is passed to `addElement` or, if it has a
    // `style` attribute, `addElementWithStyles`.
    addDOM(dom, marks) {
        if (dom.nodeType == 3) this.addTextNode(dom, marks);
        else if (dom.nodeType == 1) this.addElement(dom, marks);
    }
    addTextNode(dom, marks) {
        let value = dom.nodeValue;
        let top = this.top, preserveWS = top.options & $447e8d5afac257af$var$OPT_PRESERVE_WS_FULL ? "full" : this.localPreserveWS || (top.options & $447e8d5afac257af$var$OPT_PRESERVE_WS) > 0;
        if (preserveWS === "full" || top.inlineContext(dom) || /[^ \t\r\n\u000c]/.test(value)) {
            if (!preserveWS) {
                value = value.replace(/[ \t\r\n\u000c]+/g, " ");
                // If this starts with whitespace, and there is no node before it, or
                // a hard break, or a text node that ends with whitespace, strip the
                // leading space.
                if (/^[ \t\r\n\u000c]/.test(value) && this.open == this.nodes.length - 1) {
                    let nodeBefore = top.content[top.content.length - 1];
                    let domNodeBefore = dom.previousSibling;
                    if (!nodeBefore || domNodeBefore && domNodeBefore.nodeName == 'BR' || nodeBefore.isText && /[ \t\r\n\u000c]$/.test(nodeBefore.text)) value = value.slice(1);
                }
            } else if (preserveWS !== "full") value = value.replace(/\r?\n|\r/g, " ");
            else value = value.replace(/\r\n?/g, "\n");
            if (value) this.insertNode(this.parser.schema.text(value), marks);
            this.findInText(dom);
        } else this.findInside(dom);
    }
    // Try to find a handler for the given tag and use that to parse. If
    // none is found, the element's content nodes are added directly.
    addElement(dom, marks, matchAfter) {
        let outerWS = this.localPreserveWS, top = this.top;
        if (dom.tagName == "PRE" || /pre/.test(dom.style && dom.style.whiteSpace)) this.localPreserveWS = true;
        let name = dom.nodeName.toLowerCase(), ruleID;
        if ($447e8d5afac257af$var$listTags.hasOwnProperty(name) && this.parser.normalizeLists) $447e8d5afac257af$var$normalizeList(dom);
        let rule = this.options.ruleFromNode && this.options.ruleFromNode(dom) || (ruleID = this.parser.matchTag(dom, this, matchAfter));
        out: if (rule ? rule.ignore : $447e8d5afac257af$var$ignoreTags.hasOwnProperty(name)) {
            this.findInside(dom);
            this.ignoreFallback(dom, marks);
        } else if (!rule || rule.skip || rule.closeParent) {
            if (rule && rule.closeParent) this.open = Math.max(0, this.open - 1);
            else if (rule && rule.skip.nodeType) dom = rule.skip;
            let sync, oldNeedsBlock = this.needsBlock;
            if ($447e8d5afac257af$var$blockTags.hasOwnProperty(name)) {
                if (top.content.length && top.content[0].isInline && this.open) {
                    this.open--;
                    top = this.top;
                }
                sync = true;
                if (!top.type) this.needsBlock = true;
            } else if (!dom.firstChild) {
                this.leafFallback(dom, marks);
                break out;
            }
            let innerMarks = rule && rule.skip ? marks : this.readStyles(dom, marks);
            if (innerMarks) this.addAll(dom, innerMarks);
            if (sync) this.sync(top);
            this.needsBlock = oldNeedsBlock;
        } else {
            let innerMarks = this.readStyles(dom, marks);
            if (innerMarks) this.addElementByRule(dom, rule, innerMarks, rule.consuming === false ? ruleID : undefined);
        }
        this.localPreserveWS = outerWS;
    }
    // Called for leaf DOM nodes that would otherwise be ignored
    leafFallback(dom, marks) {
        if (dom.nodeName == "BR" && this.top.type && this.top.type.inlineContent) this.addTextNode(dom.ownerDocument.createTextNode("\n"), marks);
    }
    // Called for ignored nodes
    ignoreFallback(dom, marks) {
        // Ignored BR nodes should at least create an inline context
        if (dom.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent)) this.findPlace(this.parser.schema.text("-"), marks);
    }
    // Run any style parser associated with the node's styles. Either
    // return an updated array of marks, or null to indicate some of the
    // styles had a rule with `ignore` set.
    readStyles(dom, marks) {
        let styles = dom.style;
        // Because many properties will only show up in 'normalized' form
        // in `style.item` (i.e. text-decoration becomes
        // text-decoration-line, text-decoration-color, etc), we directly
        // query the styles mentioned in our rules instead of iterating
        // over the items.
        if (styles && styles.length) for(let i = 0; i < this.parser.matchedStyles.length; i++){
            let name = this.parser.matchedStyles[i], value = styles.getPropertyValue(name);
            if (value) for(let after = undefined;;){
                let rule = this.parser.matchStyle(name, value, this, after);
                if (!rule) break;
                if (rule.ignore) return null;
                if (rule.clearMark) marks = marks.filter((m)=>!rule.clearMark(m));
                else marks = marks.concat(this.parser.schema.marks[rule.mark].create(rule.attrs));
                if (rule.consuming === false) after = rule;
                else break;
            }
        }
        return marks;
    }
    // Look up a handler for the given node. If none are found, return
    // false. Otherwise, apply it, use its return value to drive the way
    // the node's content is wrapped, and return true.
    addElementByRule(dom, rule, marks, continueAfter) {
        let sync, nodeType;
        if (rule.node) {
            nodeType = this.parser.schema.nodes[rule.node];
            if (!nodeType.isLeaf) {
                let inner = this.enter(nodeType, rule.attrs || null, marks, rule.preserveWhitespace);
                if (inner) {
                    sync = true;
                    marks = inner;
                }
            } else if (!this.insertNode(nodeType.create(rule.attrs), marks)) this.leafFallback(dom, marks);
        } else {
            let markType = this.parser.schema.marks[rule.mark];
            marks = marks.concat(markType.create(rule.attrs));
        }
        let startIn = this.top;
        if (nodeType && nodeType.isLeaf) this.findInside(dom);
        else if (continueAfter) this.addElement(dom, marks, continueAfter);
        else if (rule.getContent) {
            this.findInside(dom);
            rule.getContent(dom, this.parser.schema).forEach((node)=>this.insertNode(node, marks));
        } else {
            let contentDOM = dom;
            if (typeof rule.contentElement == "string") contentDOM = dom.querySelector(rule.contentElement);
            else if (typeof rule.contentElement == "function") contentDOM = rule.contentElement(dom);
            else if (rule.contentElement) contentDOM = rule.contentElement;
            this.findAround(dom, contentDOM, true);
            this.addAll(contentDOM, marks);
            this.findAround(dom, contentDOM, false);
        }
        if (sync && this.sync(startIn)) this.open--;
    }
    // Add all child nodes between `startIndex` and `endIndex` (or the
    // whole node, if not given). If `sync` is passed, use it to
    // synchronize after every block element.
    addAll(parent, marks, startIndex, endIndex) {
        let index = startIndex || 0;
        for(let dom = startIndex ? parent.childNodes[startIndex] : parent.firstChild, end = endIndex == null ? null : parent.childNodes[endIndex]; dom != end; dom = dom.nextSibling, ++index){
            this.findAtPoint(parent, index);
            this.addDOM(dom, marks);
        }
        this.findAtPoint(parent, index);
    }
    // Try to find a way to fit the given node type into the current
    // context. May add intermediate wrappers and/or leave non-solid
    // nodes that we're in.
    findPlace(node, marks) {
        let route, sync;
        for(let depth = this.open; depth >= 0; depth--){
            let cx = this.nodes[depth];
            let found = cx.findWrapping(node);
            if (found && (!route || route.length > found.length)) {
                route = found;
                sync = cx;
                if (!found.length) break;
            }
            if (cx.solid) break;
        }
        if (!route) return null;
        this.sync(sync);
        for(let i = 0; i < route.length; i++)marks = this.enterInner(route[i], null, marks, false);
        return marks;
    }
    // Try to insert the given node, adjusting the context when needed.
    insertNode(node, marks) {
        if (node.isInline && this.needsBlock && !this.top.type) {
            let block = this.textblockFromContext();
            if (block) marks = this.enterInner(block, null, marks);
        }
        let innerMarks = this.findPlace(node, marks);
        if (innerMarks) {
            this.closeExtra();
            let top = this.top;
            if (top.match) top.match = top.match.matchType(node.type);
            let nodeMarks = $447e8d5afac257af$export$c9d15bcfc6d42044.none;
            for (let m of innerMarks.concat(node.marks))if (top.type ? top.type.allowsMarkType(m.type) : $447e8d5afac257af$var$markMayApply(m.type, node.type)) nodeMarks = m.addToSet(nodeMarks);
            top.content.push(node.mark(nodeMarks));
            return true;
        }
        return false;
    }
    // Try to start a node of the given type, adjusting the context when
    // necessary.
    enter(type, attrs, marks, preserveWS) {
        let innerMarks = this.findPlace(type.create(attrs), marks);
        if (innerMarks) innerMarks = this.enterInner(type, attrs, marks, true, preserveWS);
        return innerMarks;
    }
    // Open a node of the given type
    enterInner(type, attrs, marks, solid = false, preserveWS) {
        this.closeExtra();
        let top = this.top;
        top.match = top.match && top.match.matchType(type);
        let options = $447e8d5afac257af$var$wsOptionsFor(type, preserveWS, top.options);
        if (top.options & $447e8d5afac257af$var$OPT_OPEN_LEFT && top.content.length == 0) options |= $447e8d5afac257af$var$OPT_OPEN_LEFT;
        let applyMarks = $447e8d5afac257af$export$c9d15bcfc6d42044.none;
        marks = marks.filter((m)=>{
            if (top.type ? top.type.allowsMarkType(m.type) : $447e8d5afac257af$var$markMayApply(m.type, type)) {
                applyMarks = m.addToSet(applyMarks);
                return false;
            }
            return true;
        });
        this.nodes.push(new $447e8d5afac257af$var$NodeContext(type, attrs, applyMarks, solid, null, options));
        this.open++;
        return marks;
    }
    // Make sure all nodes above this.open are finished and added to
    // their parents
    closeExtra(openEnd = false) {
        let i = this.nodes.length - 1;
        if (i > this.open) {
            for(; i > this.open; i--)this.nodes[i - 1].content.push(this.nodes[i].finish(openEnd));
            this.nodes.length = this.open + 1;
        }
    }
    finish() {
        this.open = 0;
        this.closeExtra(this.isOpen);
        return this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
    }
    sync(to) {
        for(let i = this.open; i >= 0; i--){
            if (this.nodes[i] == to) {
                this.open = i;
                return true;
            } else if (this.localPreserveWS) this.nodes[i].options |= $447e8d5afac257af$var$OPT_PRESERVE_WS;
        }
        return false;
    }
    get currentPos() {
        this.closeExtra();
        let pos = 0;
        for(let i = this.open; i >= 0; i--){
            let content = this.nodes[i].content;
            for(let j = content.length - 1; j >= 0; j--)pos += content[j].nodeSize;
            if (i) pos++;
        }
        return pos;
    }
    findAtPoint(parent, offset) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == parent && this.find[i].offset == offset) this.find[i].pos = this.currentPos;
        }
    }
    findInside(parent) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) this.find[i].pos = this.currentPos;
        }
    }
    findAround(parent, content, before) {
        if (parent != content && this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].pos == null && parent.nodeType == 1 && parent.contains(this.find[i].node)) {
                let pos = content.compareDocumentPosition(this.find[i].node);
                if (pos & (before ? 2 : 4)) this.find[i].pos = this.currentPos;
            }
        }
    }
    findInText(textNode) {
        if (this.find) {
            for(let i = 0; i < this.find.length; i++)if (this.find[i].node == textNode) this.find[i].pos = this.currentPos - (textNode.nodeValue.length - this.find[i].offset);
        }
    }
    // Determines whether the given context string matches this context.
    matchesContext(context) {
        if (context.indexOf("|") > -1) return context.split(/\s*\|\s*/).some(this.matchesContext, this);
        let parts = context.split("/");
        let option = this.options.context;
        let useRoot = !this.isOpen && (!option || option.parent.type == this.nodes[0].type);
        let minDepth = -(option ? option.depth + 1 : 0) + (useRoot ? 0 : 1);
        let match = (i, depth)=>{
            for(; i >= 0; i--){
                let part = parts[i];
                if (part == "") {
                    if (i == parts.length - 1 || i == 0) continue;
                    for(; depth >= minDepth; depth--)if (match(i - 1, depth)) return true;
                    return false;
                } else {
                    let next = depth > 0 || depth == 0 && useRoot ? this.nodes[depth].type : option && depth >= minDepth ? option.node(depth - minDepth).type : null;
                    if (!next || next.name != part && !next.isInGroup(part)) return false;
                    depth--;
                }
            }
            return true;
        };
        return match(parts.length - 1, this.open);
    }
    textblockFromContext() {
        let $context = this.options.context;
        if ($context) for(let d = $context.depth; d >= 0; d--){
            let deflt = $context.node(d).contentMatchAt($context.indexAfter(d)).defaultType;
            if (deflt && deflt.isTextblock && deflt.defaultAttrs) return deflt;
        }
        for(let name in this.parser.schema.nodes){
            let type = this.parser.schema.nodes[name];
            if (type.isTextblock && type.defaultAttrs) return type;
        }
    }
    constructor(// The parser we are using.
    parser, // The options passed to this parse.
    options, isOpen){
        this.parser = parser;
        this.options = options;
        this.isOpen = isOpen;
        this.open = 0;
        this.localPreserveWS = false;
        let topNode = options.topNode, topContext;
        let topOptions = $447e8d5afac257af$var$wsOptionsFor(null, options.preserveWhitespace, 0) | (isOpen ? $447e8d5afac257af$var$OPT_OPEN_LEFT : 0);
        if (topNode) topContext = new $447e8d5afac257af$var$NodeContext(topNode.type, topNode.attrs, $447e8d5afac257af$export$c9d15bcfc6d42044.none, true, options.topMatch || topNode.type.contentMatch, topOptions);
        else if (isOpen) topContext = new $447e8d5afac257af$var$NodeContext(null, null, $447e8d5afac257af$export$c9d15bcfc6d42044.none, true, null, topOptions);
        else topContext = new $447e8d5afac257af$var$NodeContext(parser.schema.topNodeType, null, $447e8d5afac257af$export$c9d15bcfc6d42044.none, true, null, topOptions);
        this.nodes = [
            topContext
        ];
        this.find = options.findPositions;
        this.needsBlock = false;
    }
}
// Kludge to work around directly nested list nodes produced by some
// tools and allowed by browsers to mean that the nested list is
// actually part of the list item above it.
function $447e8d5afac257af$var$normalizeList(dom) {
    for(let child = dom.firstChild, prevItem = null; child; child = child.nextSibling){
        let name = child.nodeType == 1 ? child.nodeName.toLowerCase() : null;
        if (name && $447e8d5afac257af$var$listTags.hasOwnProperty(name) && prevItem) {
            prevItem.appendChild(child);
            child = prevItem;
        } else if (name == "li") prevItem = child;
        else if (name) prevItem = null;
    }
}
// Apply a CSS selector.
function $447e8d5afac257af$var$matches(dom, selector) {
    return (dom.matches || dom.msMatchesSelector || dom.webkitMatchesSelector || dom.mozMatchesSelector).call(dom, selector);
}
function $447e8d5afac257af$var$copy(obj) {
    let copy = {};
    for(let prop in obj)copy[prop] = obj[prop];
    return copy;
}
// Used when finding a mark at the top level of a fragment parse.
// Checks whether it would be reasonable to apply a given mark type to
// a given node, by looking at the way the mark occurs in the schema.
function $447e8d5afac257af$var$markMayApply(markType, nodeType) {
    let nodes = nodeType.schema.nodes;
    for(let name in nodes){
        let parent = nodes[name];
        if (!parent.allowsMarkType(markType)) continue;
        let seen = [], scan = (match)=>{
            seen.push(match);
            for(let i = 0; i < match.edgeCount; i++){
                let { type: type, next: next } = match.edge(i);
                if (type == nodeType) return true;
                if (seen.indexOf(next) < 0 && scan(next)) return true;
            }
        };
        if (scan(parent.contentMatch)) return true;
    }
}
/**
A DOM serializer knows how to convert ProseMirror nodes and
marks of various types to DOM nodes.
*/ class $447e8d5afac257af$export$3476b78f8f5a8b72 {
    /**
    Serialize the content of this fragment to a DOM fragment. When
    not in the browser, the `document` option, containing a DOM
    document, should be passed so that the serializer can create
    nodes.
    */ serializeFragment(fragment, options = {}, target) {
        if (!target) target = $447e8d5afac257af$var$doc(options).createDocumentFragment();
        let top = target, active = [];
        fragment.forEach((node)=>{
            if (active.length || node.marks.length) {
                let keep = 0, rendered = 0;
                while(keep < active.length && rendered < node.marks.length){
                    let next = node.marks[rendered];
                    if (!this.marks[next.type.name]) {
                        rendered++;
                        continue;
                    }
                    if (!next.eq(active[keep][0]) || next.type.spec.spanning === false) break;
                    keep++;
                    rendered++;
                }
                while(keep < active.length)top = active.pop()[1];
                while(rendered < node.marks.length){
                    let add = node.marks[rendered++];
                    let markDOM = this.serializeMark(add, node.isInline, options);
                    if (markDOM) {
                        active.push([
                            add,
                            top
                        ]);
                        top.appendChild(markDOM.dom);
                        top = markDOM.contentDOM || markDOM.dom;
                    }
                }
            }
            top.appendChild(this.serializeNodeInner(node, options));
        });
        return target;
    }
    /**
    @internal
    */ serializeNodeInner(node, options) {
        let { dom: dom, contentDOM: contentDOM } = $447e8d5afac257af$var$renderSpec($447e8d5afac257af$var$doc(options), this.nodes[node.type.name](node), null, node.attrs);
        if (contentDOM) {
            if (node.isLeaf) throw new RangeError("Content hole not allowed in a leaf node spec");
            this.serializeFragment(node.content, options, contentDOM);
        }
        return dom;
    }
    /**
    Serialize this node to a DOM node. This can be useful when you
    need to serialize a part of a document, as opposed to the whole
    document. To serialize a whole document, use
    [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
    its [content](https://prosemirror.net/docs/ref/#model.Node.content).
    */ serializeNode(node, options = {}) {
        let dom = this.serializeNodeInner(node, options);
        for(let i = node.marks.length - 1; i >= 0; i--){
            let wrap = this.serializeMark(node.marks[i], node.isInline, options);
            if (wrap) {
                (wrap.contentDOM || wrap.dom).appendChild(dom);
                dom = wrap.dom;
            }
        }
        return dom;
    }
    /**
    @internal
    */ serializeMark(mark, inline, options = {}) {
        let toDOM = this.marks[mark.type.name];
        return toDOM && $447e8d5afac257af$var$renderSpec($447e8d5afac257af$var$doc(options), toDOM(mark, inline), null, mark.attrs);
    }
    static renderSpec(doc, structure, xmlNS = null, blockArraysIn) {
        return $447e8d5afac257af$var$renderSpec(doc, structure, xmlNS, blockArraysIn);
    }
    /**
    Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
    properties in a schema's node and mark specs.
    */ static fromSchema(schema) {
        return schema.cached.domSerializer || (schema.cached.domSerializer = new $447e8d5afac257af$export$3476b78f8f5a8b72(this.nodesFromSchema(schema), this.marksFromSchema(schema)));
    }
    /**
    Gather the serializers in a schema's node specs into an object.
    This can be useful as a base to build a custom serializer from.
    */ static nodesFromSchema(schema) {
        let result = $447e8d5afac257af$var$gatherToDOM(schema.nodes);
        if (!result.text) result.text = (node)=>node.text;
        return result;
    }
    /**
    Gather the serializers in a schema's mark specs into an object.
    */ static marksFromSchema(schema) {
        return $447e8d5afac257af$var$gatherToDOM(schema.marks);
    }
    /**
    Create a serializer. `nodes` should map node names to functions
    that take a node and return a description of the corresponding
    DOM. `marks` does the same for mark names, but also gets an
    argument that tells it whether the mark's content is block or
    inline content (for typical use, it'll always be inline). A mark
    serializer may be `null` to indicate that marks of that type
    should not be serialized.
    */ constructor(/**
    The node serialization functions.
    */ nodes, /**
    The mark serialization functions.
    */ marks){
        this.nodes = nodes;
        this.marks = marks;
    }
}
function $447e8d5afac257af$var$gatherToDOM(obj) {
    let result = {};
    for(let name in obj){
        let toDOM = obj[name].spec.toDOM;
        if (toDOM) result[name] = toDOM;
    }
    return result;
}
function $447e8d5afac257af$var$doc(options) {
    return options.document || window.document;
}
const $447e8d5afac257af$var$suspiciousAttributeCache = new WeakMap();
function $447e8d5afac257af$var$suspiciousAttributes(attrs) {
    let value = $447e8d5afac257af$var$suspiciousAttributeCache.get(attrs);
    if (value === undefined) $447e8d5afac257af$var$suspiciousAttributeCache.set(attrs, value = $447e8d5afac257af$var$suspiciousAttributesInner(attrs));
    return value;
}
function $447e8d5afac257af$var$suspiciousAttributesInner(attrs) {
    let result = null;
    function scan(value) {
        if (value && typeof value == "object") {
            if (Array.isArray(value)) {
                if (typeof value[0] == "string") {
                    if (!result) result = [];
                    result.push(value);
                } else for(let i = 0; i < value.length; i++)scan(value[i]);
            } else for(let prop in value)scan(value[prop]);
        }
    }
    scan(attrs);
    return result;
}
function $447e8d5afac257af$var$renderSpec(doc, structure, xmlNS, blockArraysIn) {
    if (typeof structure == "string") return {
        dom: doc.createTextNode(structure)
    };
    if (structure.nodeType != null) return {
        dom: structure
    };
    if (structure.dom && structure.dom.nodeType != null) return structure;
    let tagName = structure[0], suspicious;
    if (typeof tagName != "string") throw new RangeError("Invalid array passed to renderSpec");
    if (blockArraysIn && (suspicious = $447e8d5afac257af$var$suspiciousAttributes(blockArraysIn)) && suspicious.indexOf(structure) > -1) throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
    let space = tagName.indexOf(" ");
    if (space > 0) {
        xmlNS = tagName.slice(0, space);
        tagName = tagName.slice(space + 1);
    }
    let contentDOM;
    let dom = xmlNS ? doc.createElementNS(xmlNS, tagName) : doc.createElement(tagName);
    let attrs = structure[1], start = 1;
    if (attrs && typeof attrs == "object" && attrs.nodeType == null && !Array.isArray(attrs)) {
        start = 2;
        for(let name in attrs)if (attrs[name] != null) {
            let space = name.indexOf(" ");
            if (space > 0) dom.setAttributeNS(name.slice(0, space), name.slice(space + 1), attrs[name]);
            else dom.setAttribute(name, attrs[name]);
        }
    }
    for(let i = start; i < structure.length; i++){
        let child = structure[i];
        if (child === 0) {
            if (i < structure.length - 1 || i > start) throw new RangeError("Content hole must be the only child of its parent node");
            return {
                dom: dom,
                contentDOM: dom
            };
        } else {
            let { dom: inner, contentDOM: innerContent } = $447e8d5afac257af$var$renderSpec(doc, child, xmlNS, blockArraysIn);
            dom.appendChild(inner);
            if (innerContent) {
                if (contentDOM) throw new RangeError("Multiple content holes");
                contentDOM = innerContent;
            }
        }
    }
    return {
        dom: dom,
        contentDOM: contentDOM
    };
}
module.exports["Fragment"] = $447e8d5afac257af$export$ffb0004e005737fa;
module.exports["Mark"] = $447e8d5afac257af$export$c9d15bcfc6d42044;
module.exports["ReplaceError"] = $447e8d5afac257af$export$6de0e778727af3f2;
module.exports["Slice"] = $447e8d5afac257af$export$b3f2e2de3a8baa1e;
module.exports["ResolvedPos"] = $447e8d5afac257af$export$b2a42f82e59e4b19;
module.exports["NodeRange"] = $447e8d5afac257af$export$7bc461ceb770fb16;
module.exports["Node"] = $447e8d5afac257af$export$85c928794f8d04d4;
module.exports["MarkType"] = $447e8d5afac257af$export$b6a78689043c6521;
module.exports["Schema"] = $447e8d5afac257af$export$19342e026b58ebb7;
module.exports["DOMParser"] = $447e8d5afac257af$export$1059c6e7d2ce5669;
module.exports["DOMSerializer"] = $447e8d5afac257af$export$3476b78f8f5a8b72;

});

parcelRegister("fO7hX", function(module, exports) {
const $5333024e654e859a$export$1c3aefb711c3a4cc = ()=>// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/gu, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
let $5333024e654e859a$var$staticValue = false;
const $5333024e654e859a$export$31b40729666a4ae0 = {
    setStatic (value) {
        $5333024e654e859a$var$staticValue = value;
    },
    generate () {
        return $5333024e654e859a$var$staticValue || $5333024e654e859a$export$1c3aefb711c3a4cc();
    }
};
module.exports["generateUuid"] = $5333024e654e859a$export$1c3aefb711c3a4cc;
module.exports["uuid"] = $5333024e654e859a$export$31b40729666a4ae0;

});

parcelRegister("4dOgb", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");


var $fDgwd = parcelRequire("fDgwd");

const $01446c8f39bf638d$var$parseDataConsumer = (maybeValue)=>{
    const sources = (0, $fDgwd.isDOMElement)(maybeValue) && maybeValue.getAttribute('data-sources');
    try {
        return sources ? {
            sources: JSON.parse(sources)
        } : false;
    } catch  {
        return false;
    }
};
const $01446c8f39bf638d$export$3024f02c495408d6 = (0, $6bXvD.dataConsumer)({
    parseDOM: [
        {
            tag: '[data-mark-type="dataConsumer"]',
            getAttrs: (maybeValue)=>$01446c8f39bf638d$var$parseDataConsumer(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'dataConsumer',
                'data-sources': JSON.stringify(mark.attrs.sources)
            }
        ];
    }
});
const $01446c8f39bf638d$export$54fd2c36b5cc6731 = (mark)=>{
    // // Remove intemediary state if we don't have any sources on data consumer
    // if (mark.attrs?.sources?.length < 1) {
    //   return null;
    // }
    return {
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).filter((key)=>key === 'sources' && mark.attrs[key].length > 0 && mark.attrs[key] !== null).reduce((acc, key)=>{
            return {
                ...acc,
                [key]: mark.attrs[key]
            };
        }, {})
    };
};
module.exports["dataConsumer"] = $01446c8f39bf638d$export$3024f02c495408d6;
module.exports["toJSON"] = $01446c8f39bf638d$export$54fd2c36b5cc6731;

});

parcelRegister("4r9Pq", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

function $9707c9a85f0acf37$var$getExpandAttrs(domNode) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true
    };
}
const $9707c9a85f0acf37$var$nodeSpecOptions = {
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: $9707c9a85f0acf37$var$getExpandAttrs
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $9707c9a85f0acf37$var$getExpandAttrs
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: $9707c9a85f0acf37$var$getExpandAttrs
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: $9707c9a85f0acf37$var$getExpandAttrs
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $9707c9a85f0acf37$export$7b80cba28d10b2c1 = (0, $17CG5.expand)($9707c9a85f0acf37$var$nodeSpecOptions);
const $9707c9a85f0acf37$export$2ae5e7565ff9ffa6 = (0, $17CG5.expand)({
    parseDOM: [
        {
            context: 'table//',
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $9707c9a85f0acf37$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        },
        {
            context: 'expand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $9707c9a85f0acf37$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        },
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $9707c9a85f0acf37$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="expand"]',
            getAttrs: (dom)=>{
                const attrs = $9707c9a85f0acf37$var$getExpandAttrs(dom);
                return {
                    ...attrs,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'expand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $9707c9a85f0acf37$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>!key.startsWith('__')).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
module.exports["expandWithNestedExpand"] = $9707c9a85f0acf37$export$7b80cba28d10b2c1;
module.exports["expandWithNestedExpandLocalId"] = $9707c9a85f0acf37$export$2ae5e7565ff9ffa6;
module.exports["toJSON"] = $9707c9a85f0acf37$export$54fd2c36b5cc6731;

});

parcelRegister("jTb2k", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");


var $fDgwd = parcelRequire("fDgwd");

const $ef70e7c461931cf1$var$parseFragment = (maybeValue)=>{
    if (!(0, $fDgwd.isDOMElement)(maybeValue)) return false;
    const name = maybeValue.getAttribute('data-name') ?? undefined;
    const localId = maybeValue.getAttribute('data-localId');
    if (!localId) return false;
    return {
        localId: localId,
        name: name
    };
};
const $ef70e7c461931cf1$export$f00aeb236b6f05af = (0, $6bXvD.fragment)({
    parseDOM: [
        {
            tag: '[data-mark-type="fragment"]',
            getAttrs: (maybeValue)=>$ef70e7c461931cf1$var$parseFragment(maybeValue)
        }
    ],
    toDOM (mark, inline) {
        const wrapperStyle = inline ? 'span' : 'div';
        return [
            wrapperStyle,
            {
                'data-mark-type': 'fragment',
                'data-name': mark.attrs.name,
                'data-localId': mark.attrs.localId
            }
        ];
    }
});
const $ef70e7c461931cf1$export$54fd2c36b5cc6731 = (mark)=>{
    return {
        type: mark.type.name,
        attrs: {
            localId: mark.attrs.localId,
            ...mark.attrs.name ? {
                name: mark.attrs.name
            } : {}
        }
    };
};
module.exports["fragment"] = $ef70e7c461931cf1$export$f00aeb236b6f05af;
module.exports["toJSON"] = $ef70e7c461931cf1$export$54fd2c36b5cc6731;

});

parcelRegister("gQUY7", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");


var $81OAa = parcelRequire("81OAa");

const $efb453a9fc9a838c$export$b5f67017585d1431 = (attribute)=>(domNode)=>{
        const dom = domNode;
        const href = dom.getAttribute(attribute) || '';
        const attrs = {
            __confluenceMetadata: dom.hasAttribute('__confluenceMetadata') ? JSON.parse(dom.getAttribute('__confluenceMetadata') || '') : undefined
        };
        if (!(0, $81OAa.isSafeUrl)(href)) return false;
        if ((0, $81OAa.isRootRelative)(href)) {
            attrs.href = href;
            return attrs;
        }
        attrs.href = (0, $81OAa.normalizeUrl)(href);
        return attrs;
    };
const $efb453a9fc9a838c$export$9c30223ca0a664fb = (0, $6bXvD.link)({
    parseDOM: [
        {
            tag: '[data-block-link]',
            getAttrs: $efb453a9fc9a838c$export$b5f67017585d1431('data-block-link'),
            contentElement: (node)=>{
                const clone = node.cloneNode(true);
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.removeAttribute('data-block-link');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                clone.setAttribute('data-skip-paste', 'true');
                const wrapper = document.createElement('div');
                wrapper.appendChild(clone);
                return wrapper;
            }
        },
        {
            tag: 'a[href]',
            getAttrs: $efb453a9fc9a838c$export$b5f67017585d1431('href')
        }
    ],
    toDOM (node, isInline) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = Object.keys(node.attrs).reduce((attrs, key)=>{
            if (key === '__confluenceMetadata') {
                if (node.attrs[key] !== null) attrs[key] = JSON.stringify(node.attrs[key]);
            } else if (key === 'href') attrs[key] = (0, $81OAa.isSafeUrl)(node.attrs[key]) ? node.attrs[key] : undefined;
            else // @ts-ignore
            attrs[key] = node.attrs[key];
            return attrs;
        }, {});
        if (isInline) return [
            'a',
            attrs
        ];
        return [
            'a',
            {
                ...attrs,
                ['data-block-link']: 'true',
                class: 'blockLink'
            },
            0
        ];
    }
});
const $efb453a9fc9a838c$var$OPTIONAL_ATTRS = [
    'title',
    'id',
    'collection',
    'occurrenceKey',
    '__confluenceMetadata'
];
const $efb453a9fc9a838c$export$54fd2c36b5cc6731 = (mark)=>({
        type: mark.type.name,
        attrs: Object.keys(mark.attrs).reduce((attrs, key)=>{
            if ($efb453a9fc9a838c$var$OPTIONAL_ATTRS.indexOf(key) === -1 || mark.attrs[key] !== null) attrs[key] = mark.attrs[key];
            return attrs;
        }, {})
    });
module.exports["link"] = $efb453a9fc9a838c$export$9c30223ca0a664fb;
module.exports["toJSON"] = $efb453a9fc9a838c$export$54fd2c36b5cc6731;

});

parcelRegister("81OAa", function(module, exports) {
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $2Gb84 = parcelRequire("2Gb84");


var $1oCLl = parcelRequire("1oCLl");

const $400778e5ff4046e6$var$whitelistedURLPatterns = [
    /^https?:\/\//imu,
    /^ftps?:\/\//imu,
    /^gopher:\/\//imu,
    /^integrity:\/\//imu,
    /^file:\/\//imu,
    /^smb:\/\//imu,
    /^dynamicsnav:\/\//imu,
    /^jamfselfservice:\/\//imu,
    /^\//imu,
    /^mailto:/imu,
    /^skype:/imu,
    /^callto:/imu,
    /^facetime:/imu,
    /^git:/imu,
    /^irc6?:/imu,
    /^news:/imu,
    /^nntp:/imu,
    /^feed:/imu,
    /^cvs:/imu,
    /^svn:/imu,
    /^mvn:/imu,
    /^ssh:/imu,
    /^scp:\/\//imu,
    /^sftp:\/\//imu,
    /^itms:/imu,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/imu,
    /^notes:\/\//imu,
    /^hipchat:\/\//imu,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/imu,
    /^sourcetree:\/\//imu,
    /^urn:/imu,
    /^tel:/imu,
    /^xmpp:/imu,
    /^telnet:/imu,
    /^vnc:/imu,
    /^rdp:/imu,
    /^whatsapp:/imu,
    /^slack:/imu,
    /^sips?:/imu,
    /^magnet:/imu,
    /^#/imu
];
const $400778e5ff4046e6$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url?.trim();
    if (urlTrimmed === undefined && (0, $1oCLl.expValEquals)('platform_editor_safe_url_trim_fix', 'isEnabled', true)) return true;
    // remove cast to string once we remove the experiment, as urlTrimmed will never be undefined at that point
    if (urlTrimmed.length === 0) return true;
    return $400778e5ff4046e6$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $400778e5ff4046e6$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
$400778e5ff4046e6$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$400778e5ff4046e6$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $400778e5ff4046e6$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/u
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$400778e5ff4046e6$export$8ccbde94d5c7f8e7.add('tel:', $400778e5ff4046e6$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$400778e5ff4046e6$export$8ccbde94d5c7f8e7.add('file:', $400778e5ff4046e6$var$urlWithoutSpacesValidator);
$400778e5ff4046e6$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $400778e5ff4046e6$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $400778e5ff4046e6$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$400778e5ff4046e6$var$tlds.push($400778e5ff4046e6$var$tlds2Char);
$400778e5ff4046e6$export$8ccbde94d5c7f8e7.tlds($400778e5ff4046e6$var$tlds, false);
const $400778e5ff4046e6$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/u;
const $400778e5ff4046e6$export$6f7d7761b97f967 = (text)=>{
    if (!$400778e5ff4046e6$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    substr = text.substr(startpos);
    while(substr){
        const link = (substr.match($400778e5ff4046e6$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($400778e5ff4046e6$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
            substr = text.substr(startpos);
        } else break;
    }
    return matches;
};
function $400778e5ff4046e6$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $400778e5ff4046e6$export$6f7d7761b97f967(str);
    if (!match.length) match = $400778e5ff4046e6$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $400778e5ff4046e6$export$6535eb414fa2c8b6(url) {
    const match = $400778e5ff4046e6$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $400778e5ff4046e6$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}
module.exports["isSafeUrl"] = $400778e5ff4046e6$export$c9f92f5469372e0f;
module.exports["linkify"] = $400778e5ff4046e6$export$8ccbde94d5c7f8e7;
module.exports["linkifyMatch"] = $400778e5ff4046e6$export$6f7d7761b97f967;
module.exports["getLinkMatch"] = $400778e5ff4046e6$export$ce9ae45aed3e4ec;
module.exports["normalizeUrl"] = $400778e5ff4046e6$export$6535eb414fa2c8b6;
module.exports["isRootRelative"] = $400778e5ff4046e6$export$23579274a7a24f7b;

});

parcelRegister("2Gb84", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $1f38230d0a1b4a0b$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $1f38230d0a1b4a0b$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $1f38230d0a1b4a0b$var$isString(obj) {
    return $1f38230d0a1b4a0b$var$_class(obj) === '[object String]';
}
function $1f38230d0a1b4a0b$var$isObject(obj) {
    return $1f38230d0a1b4a0b$var$_class(obj) === '[object Object]';
}
function $1f38230d0a1b4a0b$var$isRegExp(obj) {
    return $1f38230d0a1b4a0b$var$_class(obj) === '[object RegExp]';
}
function $1f38230d0a1b4a0b$var$isFunction(obj) {
    return $1f38230d0a1b4a0b$var$_class(obj) === '[object Function]';
}
function $1f38230d0a1b4a0b$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $1f38230d0a1b4a0b$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $1f38230d0a1b4a0b$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $1f38230d0a1b4a0b$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $1f38230d0a1b4a0b$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $1f38230d0a1b4a0b$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $1f38230d0a1b4a0b$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $1f38230d0a1b4a0b$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $1f38230d0a1b4a0b$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $1f38230d0a1b4a0b$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $1f38230d0a1b4a0b$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("aGmGa"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($1f38230d0a1b4a0b$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($1f38230d0a1b4a0b$var$isObject(val)) {
            if ($1f38230d0a1b4a0b$var$isRegExp(val.validate)) compiled.validate = $1f38230d0a1b4a0b$var$createValidator(val.validate);
            else if ($1f38230d0a1b4a0b$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($1f38230d0a1b4a0b$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $1f38230d0a1b4a0b$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($1f38230d0a1b4a0b$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $1f38230d0a1b4a0b$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($1f38230d0a1b4a0b$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|(' + self.re.host_fuzzy_test.source + ')|@', 'i');
    //
    // Cleanup
    //
    $1f38230d0a1b4a0b$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $1f38230d0a1b4a0b$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $1f38230d0a1b4a0b$var$createMatch(self, shift) {
    var match = new $1f38230d0a1b4a0b$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $1f38230d0a1b4a0b$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $1f38230d0a1b4a0b$var$LinkifyIt)) return new $1f38230d0a1b4a0b$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($1f38230d0a1b4a0b$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $1f38230d0a1b4a0b$var$assign({}, $1f38230d0a1b4a0b$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $1f38230d0a1b4a0b$var$assign({}, $1f38230d0a1b4a0b$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $1f38230d0a1b4a0b$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $1f38230d0a1b4a0b$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $1f38230d0a1b4a0b$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $1f38230d0a1b4a0b$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($1f38230d0a1b4a0b$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($1f38230d0a1b4a0b$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $1f38230d0a1b4a0b$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $1f38230d0a1b4a0b$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $1f38230d0a1b4a0b$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $1f38230d0a1b4a0b$var$LinkifyIt;

});

parcelRegister("aGmGa", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("6gKKW")).source;
    re.src_Cc = (parcelRequire("7wkNx")).source;
    re.src_Z = (parcelRequire("4QTDX")).source;
    re.src_P = (parcelRequire("eSMp5")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-;]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,}[a-zA-Z0-9%/&]|' + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + ',(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    ';(?!' + re.src_ZCc + ').|' + // allow `;` if not followed by space-like char
    '\\!+(?!' + re.src_ZCc + '|[!]).|' + // allow `!!!` in paths, but not at the end
    '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + '(?:' + re.src_pseudo_letter + '(?:-|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|"|\\(|' + re.src_ZCc + ')' + '(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});

parcelRegister("6gKKW", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("7wkNx", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("4QTDX", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;

});

parcelRegister("eSMp5", function(module, exports) {
module.exports = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});

parcelRegister("jblCI", function(module, exports) {
var $37123857e5729432$export$4d41558722ac7eed = /*#__PURE__*/ function(WidthType) {
    WidthType["PIXEL"] = "pixel";
    WidthType["PERCENTAGE"] = "percentage";
    return WidthType;
}({});



var $fDgwd = parcelRequire("fDgwd");


var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $a6d50f288d3841d7$export$bb3fe706be61f640 = {
    width: {
        default: null
    },
    layout: {
        default: 'center'
    }
};
const $a6d50f288d3841d7$export$5a1e124099b60c6b = ({ withCaption: withCaption = false, withExtendedWidthTypes: withExtendedWidthTypes = false, generateLocalId: generateLocalId = false })=>{
    const getAttrs = (dom)=>{
        if (!(0, $fDgwd.isDOMElement)(dom)) // this should never happen
        return {
            layout: 'center'
        };
        const layout = dom.getAttribute('data-layout') || 'center';
        const width = Number(dom.getAttribute('data-width')) || null;
        const widthType = dom.getAttribute('data-width-type');
        if (generateLocalId) return {
            layout: layout,
            width: width,
            widthType: widthType,
            localId: (0, $fO7hX.uuid).generate()
        };
        if (withExtendedWidthTypes) return {
            layout: layout,
            width: width,
            widthType: widthType
        };
        else if (widthType === (0, $37123857e5729432$export$4d41558722ac7eed).PIXEL) // if editor does not support widthType attribute.
        // We ignore width and widthType together.
        return {
            layout: layout
        };
        else return {
            layout: layout,
            width: width
        };
    };
    const getAttrsFromNode = (node)=>{
        const { layout: layout, width: width } = node.attrs;
        const attrs = {
            'data-node-type': 'mediaSingle',
            'data-layout': layout,
            'data-width': ''
        };
        if (generateLocalId) attrs['data-local-id'] = node?.attrs?.localId || undefined;
        if (width) attrs['data-width'] = isFinite(width) && Math.floor(width) === width ? width : width.toFixed(2);
        if (withExtendedWidthTypes && node.attrs.widthType) {
            const { widthType: widthType } = node.attrs;
            return {
                ...attrs,
                'data-width-type': widthType || (0, $37123857e5729432$export$4d41558722ac7eed).PERCENTAGE
            };
        }
        return attrs;
    };
    if (withExtendedWidthTypes && withCaption) return (0, $17CG5.mediaSingleFull)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (withExtendedWidthTypes && !withCaption) return (0, $17CG5.mediaSingleWidthType)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    if (!withExtendedWidthTypes && withCaption) return (0, $17CG5.mediaSingleCaption)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
    return (0, $17CG5.mediaSingle)({
        parseDOM: [
            {
                tag: 'div[data-node-type="mediaSingle"]',
                getAttrs: getAttrs
            }
        ],
        toDOM (node) {
            return [
                'div',
                getAttrsFromNode(node),
                0
            ];
        }
    });
};
const $a6d50f288d3841d7$export$969fe3781ca15058 = $a6d50f288d3841d7$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: false
});
const $a6d50f288d3841d7$export$d35e6c006d4abdfb = $a6d50f288d3841d7$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: false
});
const $a6d50f288d3841d7$export$9c58e19811ce4cf5 = $a6d50f288d3841d7$export$5a1e124099b60c6b({
    withCaption: false,
    withExtendedWidthTypes: true
});
const $a6d50f288d3841d7$export$7e767666f2ce108a = $a6d50f288d3841d7$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true
});
const $a6d50f288d3841d7$export$75376a385837c942 = $a6d50f288d3841d7$export$5a1e124099b60c6b({
    withCaption: true,
    withExtendedWidthTypes: true,
    generateLocalId: true
});
const $a6d50f288d3841d7$export$54fd2c36b5cc6731 = (node)=>({
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if (node.attrs[key] !== null) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
module.exports["mediaSingleSpec"] = $a6d50f288d3841d7$export$5a1e124099b60c6b;
module.exports["mediaSingle"] = $a6d50f288d3841d7$export$969fe3781ca15058;
module.exports["mediaSingleWithCaption"] = $a6d50f288d3841d7$export$d35e6c006d4abdfb;
module.exports["mediaSingleWithWidthType"] = $a6d50f288d3841d7$export$9c58e19811ce4cf5;
module.exports["mediaSingleFull"] = $a6d50f288d3841d7$export$7e767666f2ce108a;
module.exports["mediaSingleFullWithLocalId"] = $a6d50f288d3841d7$export$75376a385837c942;
module.exports["toJSON"] = $a6d50f288d3841d7$export$54fd2c36b5cc6731;

});

parcelRegister("kZ3vg", function(module, exports) {

var $hbMKq = parcelRequire("hbMKq");


var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $f69672539fde5643$export$bb3fe706be61f640 = (0, $17CG5.media)({}).attrs;
const $f69672539fde5643$export$f84fdfb973c05bd8 = (str)=>// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    str.replace(/([^A-Z]+)([A-Z])/gu, (_, x, y)=>`${x}-${y.toLowerCase()}`);
const $f69672539fde5643$export$111130fa8968d741 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
from, // eslint-disable-next-line @typescript-eslint/no-explicit-any
to, attributes, map)=>{
    const attrs = attributes || {};
    Object.keys(attrs).forEach((key)=>{
        if (key[0] === '_' && key[1] === '_' && from[key]) to[map ? map(key) : key] = from[key];
    });
};
const $f69672539fde5643$export$35bdbf5bc8caa677 = (attributes, inline = false, generateLocalId = false)=>{
    const domNodeType = inline ? 'span' : 'div';
    const nodeName = inline ? 'mediaInline' : 'media';
    const parseDOM = [
        {
            tag: `${domNodeType}[data-node-type="${nodeName}"]`,
            getAttrs: (dom)=>{
                const attrs = {};
                if (attributes) Object.keys(attributes).forEach((k)=>{
                    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                    const key = $f69672539fde5643$export$f84fdfb973c05bd8(k).replace(/^__/u, '');
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    const value = dom.getAttribute(`data-${key}`) || '';
                    if (value) attrs[k] = value;
                });
                // Need to do validation & type conversion manually
                if (attrs.__fileSize) attrs.__fileSize = +attrs.__fileSize;
                const width = Number(attrs.width);
                if (typeof width !== 'undefined' && !isNaN(width)) attrs.width = width;
                const height = Number(attrs.height);
                if (typeof height !== 'undefined' && !isNaN(height)) attrs.height = height;
                if (generateLocalId) attrs.localId = (0, $fO7hX.uuid).generate();
                return attrs;
            }
        },
        // Don't match data URI
        {
            tag: 'img[src^="data:image"]',
            ignore: true
        }
    ];
    const toDOM = (node)=>{
        const attrs = {
            'data-id': node.attrs.id,
            'data-node-type': `${nodeName}`,
            'data-type': node.attrs.type,
            'data-collection': node.attrs.collection,
            'data-occurrence-key': node.attrs.occurrenceKey,
            'data-width': node.attrs.width,
            'data-height': node.attrs.height,
            'data-url': node.attrs.url,
            'data-alt': node.attrs.alt,
            'data-local-id': node.attrs.localId || undefined,
            // toDOM is used for static rendering as well as editor rendering. This comes into play for
            // emails, copy/paste, etc, so the title and styling here *is* useful (despite a React-based
            // node view being used for editing).
            title: 'Attachment',
            // Manually kept in sync with the style of media cards. The goal is to render a plain gray
            // rectangle that provides an affordance for media.
            style: `display: inline-block; border-radius: 3px; background: ${(0, $hbMKq.N30)}; box-shadow: 0 1px 1px rgba(9, 30, 66, 0.2), 0 0 1px 0 rgba(9, 30, 66, 0.24);`
        };
        $f69672539fde5643$export$111130fa8968d741(node.attrs, attrs, attributes, (key)=>`data-${$f69672539fde5643$export$f84fdfb973c05bd8(key.slice(2))}`);
        return [
            `${domNodeType}`,
            attrs
        ];
    };
    if (inline) return (0, $17CG5.mediaInline)({
        parseDOM: parseDOM,
        toDOM: toDOM
    });
    return (0, $17CG5.media)({
        parseDOM: [
            ...parseDOM,
            {
                // media-inline.ts uses this same function to generate the nodespec
                // this ensures that we don't make a media inline out of a copied image
                // https://product-fabric.atlassian.net/browse/EDM-2996
                tag: 'img:not(.smart-link-icon)',
                getAttrs: (dom)=>{
                    // eslint-disable-next-line @typescript-eslint/no-explicit-any
                    const attrs = {
                        type: 'external',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        url: dom.getAttribute('src') || '',
                        // eslint-disable-next-line @atlaskit/editor/no-as-casting
                        alt: dom.getAttribute('alt') || ''
                    };
                    if (generateLocalId) attrs.localId = (0, $fO7hX.uuid).generate();
                    return attrs;
                }
            }
        ],
        toDOM: toDOM
    });
};
const $f69672539fde5643$export$987d49ffe1b0900f = $f69672539fde5643$export$35bdbf5bc8caa677($f69672539fde5643$export$bb3fe706be61f640, false, false);
const $f69672539fde5643$export$8446e47a4c7fd000 = $f69672539fde5643$export$35bdbf5bc8caa677({
    ...$f69672539fde5643$export$bb3fe706be61f640,
    localId: {
        default: (0, $fO7hX.uuid).generate()
    }
}, false, true);
/**
 * There's no concept of optional property in ProseMirror. It sets value as `null`
 * when there's no use of any property. We are filtering out all private & optional attrs here.
 */ const $f69672539fde5643$var$optionalAttributes = [
    'occurrenceKey',
    'width',
    'height',
    'url',
    'alt',
    'localId'
];
const $f69672539fde5643$var$externalOnlyAttributes = [
    'type',
    'url',
    'width',
    'height',
    'alt',
    'localId'
];
const $f69672539fde5643$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs)// Strip private attributes e.g. __fileName, __fileSize, __fileMimeType, etc.
        .filter((key)=>!(key[0] === '_' && key[1] === '_'))// eslint-disable-next-line @typescript-eslint/no-explicit-any
        .reduce((obj, key)=>{
            if (node.attrs.type === 'external' && $f69672539fde5643$var$externalOnlyAttributes.indexOf(key) === -1) return obj;
            if ($f69672539fde5643$var$optionalAttributes.indexOf(key) > -1 && (node.attrs[key] === null || node.attrs[key] === '')) return obj;
            if ([
                'width',
                'height'
            ].indexOf(key) !== -1) {
                obj[key] = Number(node.attrs[key]);
                return obj;
            }
            obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
module.exports["copyPrivateAttributes"] = $f69672539fde5643$export$111130fa8968d741;
module.exports["createMediaSpec"] = $f69672539fde5643$export$35bdbf5bc8caa677;
module.exports["media"] = $f69672539fde5643$export$987d49ffe1b0900f;
module.exports["toJSON"] = $f69672539fde5643$export$54fd2c36b5cc6731;

});

parcelRegister("hbMKq", function(module, exports) {
// @ts-ignore
// eslint-disable-next-line import/no-namespace
var $764b67d5f16b57c2$exports = {};
$764b67d5f16b57c2$exports = JSON.parse("{\"aliceblue\":\"#f0f8ff\",\"antiquewhite\":\"#faebd7\",\"aqua\":\"#00ffff\",\"aquamarine\":\"#7fffd4\",\"azure\":\"#f0ffff\",\"beige\":\"#f5f5dc\",\"bisque\":\"#ffe4c4\",\"black\":\"#000000\",\"blanchedalmond\":\"#ffebcd\",\"blue\":\"#0000ff\",\"blueviolet\":\"#8a2be2\",\"brown\":\"#a52a2a\",\"burlywood\":\"#deb887\",\"cadetblue\":\"#5f9ea0\",\"chartreuse\":\"#7fff00\",\"chocolate\":\"#d2691e\",\"coral\":\"#ff7f50\",\"cornflowerblue\":\"#6495ed\",\"cornsilk\":\"#fff8dc\",\"crimson\":\"#dc143c\",\"cyan\":\"#00ffff\",\"darkblue\":\"#00008b\",\"darkcyan\":\"#008b8b\",\"darkgoldenrod\":\"#b8860b\",\"darkgray\":\"#a9a9a9\",\"darkgreen\":\"#006400\",\"darkgrey\":\"#a9a9a9\",\"darkkhaki\":\"#bdb76b\",\"darkmagenta\":\"#8b008b\",\"darkolivegreen\":\"#556b2f\",\"darkorange\":\"#ff8c00\",\"darkorchid\":\"#9932cc\",\"darkred\":\"#8b0000\",\"darksalmon\":\"#e9967a\",\"darkseagreen\":\"#8fbc8f\",\"darkslateblue\":\"#483d8b\",\"darkslategray\":\"#2f4f4f\",\"darkslategrey\":\"#2f4f4f\",\"darkturquoise\":\"#00ced1\",\"darkviolet\":\"#9400d3\",\"deeppink\":\"#ff1493\",\"deepskyblue\":\"#00bfff\",\"dimgray\":\"#696969\",\"dimgrey\":\"#696969\",\"dodgerblue\":\"#1e90ff\",\"firebrick\":\"#b22222\",\"floralwhite\":\"#fffaf0\",\"forestgreen\":\"#228b22\",\"fuchsia\":\"#ff00ff\",\"gainsboro\":\"#dcdcdc\",\"ghostwhite\":\"#f8f8ff\",\"gold\":\"#ffd700\",\"goldenrod\":\"#daa520\",\"gray\":\"#808080\",\"green\":\"#008000\",\"greenyellow\":\"#adff2f\",\"grey\":\"#808080\",\"honeydew\":\"#f0fff0\",\"hotpink\":\"#ff69b4\",\"indianred\":\"#cd5c5c\",\"indigo\":\"#4b0082\",\"ivory\":\"#fffff0\",\"khaki\":\"#f0e68c\",\"lavender\":\"#e6e6fa\",\"lavenderblush\":\"#fff0f5\",\"lawngreen\":\"#7cfc00\",\"lemonchiffon\":\"#fffacd\",\"lightblue\":\"#add8e6\",\"lightcoral\":\"#f08080\",\"lightcyan\":\"#e0ffff\",\"lightgoldenrodyellow\":\"#fafad2\",\"lightgray\":\"#d3d3d3\",\"lightgreen\":\"#90ee90\",\"lightgrey\":\"#d3d3d3\",\"lightpink\":\"#ffb6c1\",\"lightsalmon\":\"#ffa07a\",\"lightseagreen\":\"#20b2aa\",\"lightskyblue\":\"#87cefa\",\"lightslategray\":\"#778899\",\"lightslategrey\":\"#778899\",\"lightsteelblue\":\"#b0c4de\",\"lightyellow\":\"#ffffe0\",\"lime\":\"#00ff00\",\"limegreen\":\"#32cd32\",\"linen\":\"#faf0e6\",\"magenta\":\"#ff00ff\",\"maroon\":\"#800000\",\"mediumaquamarine\":\"#66cdaa\",\"mediumblue\":\"#0000cd\",\"mediumorchid\":\"#ba55d3\",\"mediumpurple\":\"#9370db\",\"mediumseagreen\":\"#3cb371\",\"mediumslateblue\":\"#7b68ee\",\"mediumspringgreen\":\"#00fa9a\",\"mediumturquoise\":\"#48d1cc\",\"mediumvioletred\":\"#c71585\",\"midnightblue\":\"#191970\",\"mintcream\":\"#f5fffa\",\"mistyrose\":\"#ffe4e1\",\"moccasin\":\"#ffe4b5\",\"navajowhite\":\"#ffdead\",\"navy\":\"#000080\",\"oldlace\":\"#fdf5e6\",\"olive\":\"#808000\",\"olivedrab\":\"#6b8e23\",\"orange\":\"#ffa500\",\"orangered\":\"#ff4500\",\"orchid\":\"#da70d6\",\"palegoldenrod\":\"#eee8aa\",\"palegreen\":\"#98fb98\",\"paleturquoise\":\"#afeeee\",\"palevioletred\":\"#db7093\",\"papayawhip\":\"#ffefd5\",\"peachpuff\":\"#ffdab9\",\"peru\":\"#cd853f\",\"pink\":\"#ffc0cb\",\"plum\":\"#dda0dd\",\"powderblue\":\"#b0e0e6\",\"purple\":\"#800080\",\"rebeccapurple\":\"#663399\",\"red\":\"#ff0000\",\"rosybrown\":\"#bc8f8f\",\"royalblue\":\"#4169e1\",\"saddlebrown\":\"#8b4513\",\"salmon\":\"#fa8072\",\"sandybrown\":\"#f4a460\",\"seagreen\":\"#2e8b57\",\"seashell\":\"#fff5ee\",\"sienna\":\"#a0522d\",\"silver\":\"#c0c0c0\",\"skyblue\":\"#87ceeb\",\"slateblue\":\"#6a5acd\",\"slategray\":\"#708090\",\"slategrey\":\"#708090\",\"snow\":\"#fffafa\",\"springgreen\":\"#00ff7f\",\"steelblue\":\"#4682b4\",\"tan\":\"#d2b48c\",\"teal\":\"#008080\",\"thistle\":\"#d8bfd8\",\"tomato\":\"#ff6347\",\"turquoise\":\"#40e0d0\",\"violet\":\"#ee82ee\",\"wheat\":\"#f5deb3\",\"white\":\"#ffffff\",\"whitesmoke\":\"#f5f5f5\",\"yellow\":\"#ffff00\",\"yellowgreen\":\"#9acd32\"}");


const $f22bfb9207d741ca$export$4b84fd0e2c617bd = '#FFEBE6';
const $f22bfb9207d741ca$export$b34b069eff244586 = '#FFBDAD';
const $f22bfb9207d741ca$export$be802dd0d8b57f35 = '#FF8F73';
const $f22bfb9207d741ca$export$4a7404f376229999 = '#FF5630';
const $f22bfb9207d741ca$export$2010d0fb4295b346 = '#DE350B';
const $f22bfb9207d741ca$export$2837b5a1a71d5c02 = '#BF2600';
const $f22bfb9207d741ca$export$8d9596b529bbb9cf = '#FFFAE6';
const $f22bfb9207d741ca$export$41060a744ab0b7ae = '#FFF0B3';
const $f22bfb9207d741ca$export$5aae31392d72caaa = '#FFC400';
const $f22bfb9207d741ca$export$fc857b6f8771648a = '#F8E6A0';
const $f22bfb9207d741ca$export$59619663aa6500fb = '#FF991F';
const $f22bfb9207d741ca$export$874739ea9e379ab6 = '#FF8B00';
const $f22bfb9207d741ca$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $f22bfb9207d741ca$export$69a3bf21b9686c2b = '#ABF5D1';
const $f22bfb9207d741ca$export$747d86715d4175de = '#57D9A3';
const $f22bfb9207d741ca$export$940e1f69e873f202 = '#36B37E';
const $f22bfb9207d741ca$export$a49394138f7b8e85 = '#00875A';
const $f22bfb9207d741ca$export$6fa04827ac68a4fb = '#006644';
const $f22bfb9207d741ca$export$226de0355ed012f8 = '#DEEBFF';
const $f22bfb9207d741ca$export$8c13c2ee36917869 = '#B3D4FF';
const $f22bfb9207d741ca$export$ecfc1dff386a3e7a = '#4C9AFF';
const $f22bfb9207d741ca$export$b3de0ae08da2ce64 = '#0052CC';
const $f22bfb9207d741ca$export$a6ee3d71bc067634 = '#0747A6';
const $f22bfb9207d741ca$export$f72948ef771f6f15 = '#D3F1A7';
const $f22bfb9207d741ca$export$29a4f05edc054374 = '#FFFFFF';
const $f22bfb9207d741ca$export$9fdfb749e33cdf97 = '#F4F5F7';
const $f22bfb9207d741ca$export$3e51e8f1440314ba = '#EBECF0';
const $f22bfb9207d741ca$export$1ce2d1575d444ceb = '#DFE1E6';
const $f22bfb9207d741ca$export$8754fc7e6d8b3000 = '#C1C7D0';
const $f22bfb9207d741ca$export$c2e91cbeada39b8b = '#B3BAC5';
const $f22bfb9207d741ca$export$eaa8c8a70ac22806 = '#97A0AF';
const $f22bfb9207d741ca$export$7c87d337fb91a97d = '#8993A4';
const $f22bfb9207d741ca$export$f563ee71e9ee74cd = '#6B778C';
const $f22bfb9207d741ca$export$e2ef2124cf4024b1 = '#5E6C84';
const $f22bfb9207d741ca$export$1ae1cebe22dcedb4 = '#DCDFE4';
const $f22bfb9207d741ca$export$13609db0e6812ab8 = '#091E4224';
const $f22bfb9207d741ca$export$c39c0fe0f26207ae = '#42526E';
const $f22bfb9207d741ca$export$7090862dc3038a9f = '#758195';
const $f22bfb9207d741ca$export$7d61b15e0da132af = '#172B4D';
const $f22bfb9207d741ca$export$f78789c8b01753cd = '#172B4D';
const $f22bfb9207d741ca$export$a19f0c33186f7767 = '#FDD0EC';
const $f22bfb9207d741ca$export$51716a84e62e022c = '#FEDEC8';
const $f22bfb9207d741ca$export$363e4475840015bb = '#EAE6FF';
const $f22bfb9207d741ca$export$4b0a4417ed59760f = '#C0B6F2';
const $f22bfb9207d741ca$export$6011520a64d9a187 = '#998DD9';
const $f22bfb9207d741ca$export$a7175d4e9206bc80 = '#DFD8FD';
const $f22bfb9207d741ca$export$b48405b95304b5a1 = '#6554C0';
const $f22bfb9207d741ca$export$c71e4279dd54a18d = '#5243AA';
const $f22bfb9207d741ca$export$147899de772240ec = '#403294';
const $f22bfb9207d741ca$export$2cf711fe14c66f06 = '#E6FCFF';
const $f22bfb9207d741ca$export$7a8f4d33f6f9772c = '#B3F5FF';
const $f22bfb9207d741ca$export$776c9c497ef08533 = '#79E2F2';
const $f22bfb9207d741ca$export$69cb3ca10c1e330e = '#C6EDFB';
const $f22bfb9207d741ca$export$9dc1ef0f3f48059b = '#00B8D9';
const $f22bfb9207d741ca$export$6036577f95c3877e = '#008DA6';
function $f22bfb9207d741ca$export$b61655071712e690(color, defaultColor) {
    if (!color) return null;
    // Normalize to hex
    color = color.trim().toLowerCase();
    if ($f22bfb9207d741ca$export$8a9b6341a7c96bc(color)) // Normalize 3-hex to 6-hex colours
    {
        if (color.length === 4) color = color.split('').map((c)=>c === '#' ? '#' : `${c}${c}`).join('');
    } else if ($f22bfb9207d741ca$export$e698776ec826343(color)) return $f22bfb9207d741ca$export$34d09c4a771c46ef(color);
    else {
        // http://dev.w3.org/csswg/css-color/#named-colors
        if (color === 'default') return null;
        else if (// eslint-disable-next-line @typescript-eslint/no-explicit-any
        $764b67d5f16b57c2$exports.default && // eslint-disable-next-line @typescript-eslint/no-explicit-any
        $764b67d5f16b57c2$exports.default[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $764b67d5f16b57c2$exports.default[color];
        else if ($764b67d5f16b57c2$exports && $764b67d5f16b57c2$exports[color]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        color = $764b67d5f16b57c2$exports[color];
        else return null;
    }
    if (color === defaultColor) return null;
    return color;
}
function $f22bfb9207d741ca$export$5a544e13ad4e1fa5(color) {
    if (!$f22bfb9207d741ca$export$8a9b6341a7c96bc(color)) return null;
    let colorBits = color.substring(1).split('');
    if (colorBits.length === 3) colorBits = [
        colorBits[0],
        colorBits[0],
        colorBits[1],
        colorBits[1],
        colorBits[2],
        colorBits[2]
    ];
    const rgb = Number(`0x${colorBits.join('')}`);
    return `rgb(${rgb >> 16 & 255},${rgb >> 8 & 255},${rgb & 255})`;
}
function $f22bfb9207d741ca$export$9665a07d9187b414(rawColor, alpha) {
    const color = $f22bfb9207d741ca$export$b61655071712e690(rawColor);
    if (!color) return null;
    const hex2rgb = (color)=>{
        // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return color.match(/[a-z0-9]{2}/giu).map((hex)=>parseInt(hex, 16));
    };
    return `rgba(${hex2rgb(color).concat(alpha).join(',')})`;
}
function $f22bfb9207d741ca$export$34d09c4a771c46ef(value) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const matches = value.match(/(0?\.?\d{1,3})%?\b/gu);
    if (matches && matches.length >= 3) {
        const [red, green, blue] = matches.map(Number);
        return '#' + (blue | green << 8 | red << 16 | 16777216).toString(16).slice(1);
    }
    return null;
}
function $f22bfb9207d741ca$export$e698776ec826343(color) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    return /rgba?\(/u.test(color);
}
function $f22bfb9207d741ca$export$8a9b6341a7c96bc(color) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    return /^#([A-Fa-f0-9]{3}){1,2}$/u.test(color);
}
module.exports["R50"] = $f22bfb9207d741ca$export$4b84fd0e2c617bd;
module.exports["R75"] = $f22bfb9207d741ca$export$b34b069eff244586;
module.exports["R100"] = $f22bfb9207d741ca$export$be802dd0d8b57f35;
module.exports["R300"] = $f22bfb9207d741ca$export$4a7404f376229999;
module.exports["R500"] = $f22bfb9207d741ca$export$2837b5a1a71d5c02;
module.exports["Y50"] = $f22bfb9207d741ca$export$8d9596b529bbb9cf;
module.exports["Y75"] = $f22bfb9207d741ca$export$41060a744ab0b7ae;
module.exports["Y200"] = $f22bfb9207d741ca$export$5aae31392d72caaa;
module.exports["Yellow200"] = $f22bfb9207d741ca$export$fc857b6f8771648a;
module.exports["Y400"] = $f22bfb9207d741ca$export$59619663aa6500fb;
module.exports["G50"] = $f22bfb9207d741ca$export$8a6341c32b6a3ee6;
module.exports["G75"] = $f22bfb9207d741ca$export$69a3bf21b9686c2b;
module.exports["G200"] = $f22bfb9207d741ca$export$747d86715d4175de;
module.exports["G300"] = $f22bfb9207d741ca$export$940e1f69e873f202;
module.exports["G500"] = $f22bfb9207d741ca$export$6fa04827ac68a4fb;
module.exports["B50"] = $f22bfb9207d741ca$export$226de0355ed012f8;
module.exports["B75"] = $f22bfb9207d741ca$export$8c13c2ee36917869;
module.exports["B100"] = $f22bfb9207d741ca$export$ecfc1dff386a3e7a;
module.exports["B400"] = $f22bfb9207d741ca$export$b3de0ae08da2ce64;
module.exports["B500"] = $f22bfb9207d741ca$export$a6ee3d71bc067634;
module.exports["L200"] = $f22bfb9207d741ca$export$f72948ef771f6f15;
module.exports["N0"] = $f22bfb9207d741ca$export$29a4f05edc054374;
module.exports["N20"] = $f22bfb9207d741ca$export$9fdfb749e33cdf97;
module.exports["N30"] = $f22bfb9207d741ca$export$3e51e8f1440314ba;
module.exports["N60"] = $f22bfb9207d741ca$export$c2e91cbeada39b8b;
module.exports["N80"] = $f22bfb9207d741ca$export$eaa8c8a70ac22806;
module.exports["Neutral300"] = $f22bfb9207d741ca$export$1ae1cebe22dcedb4;
module.exports["N300A"] = $f22bfb9207d741ca$export$13609db0e6812ab8;
module.exports["N600"] = $f22bfb9207d741ca$export$7090862dc3038a9f;
module.exports["N800"] = $f22bfb9207d741ca$export$7d61b15e0da132af;
module.exports["N1000"] = $f22bfb9207d741ca$export$f78789c8b01753cd;
module.exports["M200"] = $f22bfb9207d741ca$export$a19f0c33186f7767;
module.exports["O200"] = $f22bfb9207d741ca$export$51716a84e62e022c;
module.exports["P50"] = $f22bfb9207d741ca$export$363e4475840015bb;
module.exports["P75"] = $f22bfb9207d741ca$export$4b0a4417ed59760f;
module.exports["P100"] = $f22bfb9207d741ca$export$6011520a64d9a187;
module.exports["P200"] = $f22bfb9207d741ca$export$a7175d4e9206bc80;
module.exports["P300"] = $f22bfb9207d741ca$export$b48405b95304b5a1;
module.exports["P500"] = $f22bfb9207d741ca$export$147899de772240ec;
module.exports["T50"] = $f22bfb9207d741ca$export$2cf711fe14c66f06;
module.exports["T75"] = $f22bfb9207d741ca$export$7a8f4d33f6f9772c;
module.exports["T100"] = $f22bfb9207d741ca$export$776c9c497ef08533;
module.exports["T200"] = $f22bfb9207d741ca$export$69cb3ca10c1e330e;
module.exports["T300"] = $f22bfb9207d741ca$export$9dc1ef0f3f48059b;
module.exports["T500"] = $f22bfb9207d741ca$export$6036577f95c3877e;
module.exports["normalizeHexColor"] = $f22bfb9207d741ca$export$b61655071712e690;
module.exports["isHex"] = $f22bfb9207d741ca$export$8a9b6341a7c96bc;
module.exports["isRgb"] = $f22bfb9207d741ca$export$e698776ec826343;
module.exports["rgbToHex"] = $f22bfb9207d741ca$export$34d09c4a771c46ef;
module.exports["hexToRgb"] = $f22bfb9207d741ca$export$5a544e13ad4e1fa5;
module.exports["hexToRgba"] = $f22bfb9207d741ca$export$9665a07d9187b414;

});

parcelRegister("CmplZ", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $17CG5 = parcelRequire("17CG5");

var $593e00bd41c1449c$export$abebb208988c258 = /*#__PURE__*/ function(USER_TYPES) {
    USER_TYPES["DEFAULT"] = "DEFAULT";
    USER_TYPES["SPECIAL"] = "SPECIAL";
    USER_TYPES["APP"] = "APP";
    return USER_TYPES;
}({});
const $593e00bd41c1449c$export$db83999c14438df4 = (0, $17CG5.mention)({
    parseDOM: [
        {
            tag: 'span[data-mention-id]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-mention-id') || $593e00bd41c1449c$export$db83999c14438df4.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: dom.textContent || $593e00bd41c1449c$export$db83999c14438df4.attrs.text.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    accessLevel: dom.getAttribute('data-access-level') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $593e00bd41c1449c$export$db83999c14438df4.attrs.accessLevel.default,
                    localId: (0, $fO7hX.uuid).generate()
                };
                const userType = dom.getAttribute('data-user-type');
                if ($593e00bd41c1449c$export$abebb208988c258[userType]) attrs.userType = userType;
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { id: id, accessLevel: accessLevel, text: text, userType: userType, localId: localId } = node.attrs;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const attrs = {
            'data-mention-id': id,
            'data-access-level': accessLevel,
            contenteditable: 'false'
        };
        if (localId) attrs['data-local-id'] = localId;
        if (userType) attrs['data-user-type'] = userType;
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $593e00bd41c1449c$var$isOptional = (key)=>{
    return [
        'userType',
        'localId'
    ].indexOf(key) > -1;
};
const $593e00bd41c1449c$export$54fd2c36b5cc6731 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            if ($593e00bd41c1449c$var$isOptional(key) && !node.attrs[key]) return obj;
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
module.exports["mention"] = $593e00bd41c1449c$export$db83999c14438df4;
module.exports["toJSON"] = $593e00bd41c1449c$export$54fd2c36b5cc6731;

});

parcelRegister("63Ztt", function(module, exports) {

var $dCzEh = parcelRequire("dCzEh");


var $hbMKq = parcelRequire("hbMKq");


var $fO7hX = parcelRequire("fO7hX");


var $aDU6C = parcelRequire("aDU6C");


var $17CG5 = parcelRequire("17CG5");

const $b5d0e562db315ca2$export$9cfceb893b24742a = 'pm-table';
const $b5d0e562db315ca2$export$69cb4c3f80383763 = `${$b5d0e562db315ca2$export$9cfceb893b24742a}-cell-content-wrap`;
const $b5d0e562db315ca2$export$7b07d37d879c957f = `${$b5d0e562db315ca2$export$9cfceb893b24742a}-header-content-wrap`;
const $b5d0e562db315ca2$export$8dd42a84cd52da07 = `${$b5d0e562db315ca2$export$9cfceb893b24742a}-cell-nodeview-wrapper`;
const $b5d0e562db315ca2$export$5e26a5c19f0865d8 = `${$b5d0e562db315ca2$export$9cfceb893b24742a}-cell-nodeview-content-dom`;
const $b5d0e562db315ca2$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND = (0, $hbMKq.N20).toLocaleLowerCase();
const $b5d0e562db315ca2$export$43977bde391e007 = (dom, defaultValues = {})=>{
    const widthAttr = dom.getAttribute('data-colwidth');
    const width = // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    widthAttr && /^\d+(,\d+)*$/u.test(widthAttr) ? widthAttr.split(',').map((str)=>Number(str)) : null;
    const colspan = Number(dom.getAttribute('colspan') || 1);
    let { backgroundColor: backgroundColor } = dom.style;
    /**
   * We have pivoted to store background color information in
   *  data-cell-background.
   * We will have original hex code (which we map to DST token)
   *  stored in data-cell-background, use that.
   * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
   */ const dataCellBackground = dom.getAttribute('data-cell-background');
    const dataCellBackgroundHexCode = dataCellBackground && (0, $hbMKq.isHex)(dataCellBackground) ? dataCellBackground : undefined;
    // ignore setting background attr if ds neutral token is detected
    if (backgroundColor.includes('--ds-background-neutral')) backgroundColor = '';
    else if (backgroundColor && (0, $hbMKq.isRgb)(backgroundColor)) {
        const result = (0, $hbMKq.rgbToHex)(backgroundColor);
        if (result !== null) backgroundColor = result;
    }
    const backgroundHexCode = dataCellBackgroundHexCode || (backgroundColor && backgroundColor !== defaultValues['background'] ? backgroundColor : null);
    const localId = defaultValues?.localId;
    return {
        colspan: colspan,
        rowspan: Number(dom.getAttribute('rowspan') || 1),
        colwidth: width && width.length === colspan ? width : null,
        background: backgroundHexCode,
        ...localId && {
            localId: localId
        }
    };
};
// these are for test only
let $b5d0e562db315ca2$var$testGlobalTheme;
const $b5d0e562db315ca2$export$fd7e0dd2b74807f7 = (theme)=>{
    $b5d0e562db315ca2$var$testGlobalTheme = theme;
};
// This is a minimal duplication of the method from @atlaskit/tokens
// to minimise the number of dependencies required as these changes are expected
// to be patched onto CR8.
const $b5d0e562db315ca2$var$getGlobalTheme = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($b5d0e562db315ca2$var$testGlobalTheme) return {
        colorMode: $b5d0e562db315ca2$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
const $b5d0e562db315ca2$var$cssVariablePattern = /^var\(--.*\)$/u;
const $b5d0e562db315ca2$export$363c8dda799bfe9c = (node)=>{
    const attrs = {};
    const nodeType = node.type.name;
    if (node.attrs.colspan !== 1) attrs.colspan = node.attrs.colspan;
    if (node.attrs.rowspan !== 1) attrs.rowspan = node.attrs.rowspan;
    if (node.attrs.colwidth) attrs['data-colwidth'] = node.attrs.colwidth.join(',');
    if (node.attrs.background) {
        const { background: background } = node.attrs;
        // to ensure that we don't overwrite product's style:
        // - it clears background color for <th> if its set to gray
        // - it clears background color for <td> if its set to white
        // - it clears background color for <th> if ds neutral token is detected
        const ignored = nodeType === 'tableHeader' && background === $b5d0e562db315ca2$export$8cc2833b5b349a1e.get('light gray') || nodeType === 'tableCell' && background === $b5d0e562db315ca2$export$8cc2833b5b349a1e.get('white') || nodeType === 'tableHeader' && background.includes('--ds-background-neutral');
        if (ignored) attrs.style = '';
        else {
            const color = (0, $hbMKq.isRgb)(background) && (0, $hbMKq.rgbToHex)(background) ? (0, $hbMKq.rgbToHex)(background) : background;
            /**
       * The Editor supports users pasting content from external sources with custom table cell backgrounds and having those
       * backgrounds persisted.
       *
       * This feature predates the introduction of dark mode.
       *
       * Without the inversion logic below, tokenised content (ie. text), can be hard to read when the user loads the page in dark mode.
       *
       * This introduces inversion of the presentation of the custom background color when the user is in dark mode.
       *
       * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
       * how we detect table cell background colors copied from external editor sources. Where we load the background color from a
       * seperate attribute (data-cell-background), instead of the inline style.
       *
       * See the following document for more details on this behaviour
       * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2892247168/Unsupported+custom+table+cell+background+colors+in+dark+theme+Editor+Job+Story
       */ const tokenColor = (0, $dCzEh.hexToEditorBackgroundPaletteRawValue)(color);
            if (tokenColor) attrs.style = `background-color: ${tokenColor};`;
            else if (/**
       * There was previously a bug in dark mode where we would attempt to invert
       * a design token in `getDarkModeLCHColor` causing issues.
       * If it's a design token we should return it as is.
       */ $b5d0e562db315ca2$var$cssVariablePattern.test(color)) attrs.style = `background-color: ${color};`;
            else // if we have a custom color, we need to check if we are in dark mode
            if ($b5d0e562db315ca2$var$getGlobalTheme().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
            attrs.style = `background-color: ${(0, $aDU6C.getDarkModeLCHColor)(color)};`;
            else // if we are in light mode, we can just set the color
            attrs.style = `background-color: ${background};`;
            /**
       * Storing hex code in data-cell-background because
       *  we want to have DST token (css variable) or
       *  DST token value (value (hex code) of css variable) in
       *  inline style to correct render table cell background
       *  based on selected theme.
       * Currently we rely on background color hex code stored in
       *  inline style.
       * Because of that when we copy and paste table, we end up
       *  having DST token or DST token value in ADF instead of
       *  original hex code which we map to DST token.
       * So, introducing data-cell-background.
       * More details at https://product-fabric.atlassian.net/wiki/spaces/EUXQ/pages/3472556903/Tokenising+tableCell+background+colors#Update-toDom-and-parseDom-to-store-and-read-background-color-from-data-cell-background-attribute.4
       */ if (color) attrs['data-cell-background'] = color;
            if (typeof color === 'string') attrs.colorname = $b5d0e562db315ca2$export$219b7f492ad209f8.get(color.toLowerCase());
        }
    }
    if (nodeType === 'tableHeader') attrs.class = $b5d0e562db315ca2$export$7b07d37d879c957f;
    else attrs.class = $b5d0e562db315ca2$export$69cb4c3f80383763;
    if (node?.attrs?.localId) attrs['data-local-id'] = node.attrs.localId;
    return attrs;
};
const $b5d0e562db315ca2$export$219b7f492ad209f8 = new Map();
const $b5d0e562db315ca2$export$95e9c925fbf01d1c = (0, $hbMKq.hexToRgba)((0, $hbMKq.N800), 0.12) || (0, $hbMKq.N0);
const $b5d0e562db315ca2$export$8cc2833b5b349a1e = new Map();
[
    [
        (0, $hbMKq.N0),
        'White'
    ],
    [
        (0, $hbMKq.B50),
        'Light blue'
    ],
    [
        (0, $hbMKq.T50),
        'Light teal'
    ],
    [
        (0, $hbMKq.G50),
        'Light green'
    ],
    [
        (0, $hbMKq.Y50),
        'Light yellow'
    ],
    [
        (0, $hbMKq.R50),
        'Light red'
    ],
    [
        (0, $hbMKq.P50),
        'Light purple'
    ],
    [
        (0, $hbMKq.N20),
        'Light gray'
    ],
    [
        (0, $hbMKq.B75),
        'Blue'
    ],
    [
        (0, $hbMKq.T75),
        'Teal'
    ],
    [
        (0, $hbMKq.G75),
        'Green'
    ],
    [
        (0, $hbMKq.Y75),
        'Yellow'
    ],
    [
        (0, $hbMKq.R75),
        'Red'
    ],
    [
        (0, $hbMKq.P75),
        'Purple'
    ],
    [
        (0, $hbMKq.N60),
        'Gray'
    ],
    [
        (0, $hbMKq.B100),
        'Dark blue'
    ],
    [
        (0, $hbMKq.T100),
        'Dark teal'
    ],
    [
        (0, $hbMKq.G200),
        'Dark green'
    ],
    [
        (0, $hbMKq.Y200),
        'Dark yellow'
    ],
    [
        (0, $hbMKq.R100),
        'Dark red'
    ],
    [
        (0, $hbMKq.P100),
        'Dark purple'
    ]
].forEach(([colorValue, colorName])=>{
    $b5d0e562db315ca2$export$219b7f492ad209f8.set(colorValue.toLowerCase(), colorName);
    $b5d0e562db315ca2$export$8cc2833b5b349a1e.set(colorName.toLowerCase(), colorValue.toLowerCase());
});
const $b5d0e562db315ca2$var$tableNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'table',
            getAttrs: (node)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = node;
                const breakoutWrapper = dom.parentElement?.parentElement;
                return {
                    isNumberColumnEnabled: dom.getAttribute('data-number-column') === 'true',
                    layout: // copying from editor
                    dom.getAttribute('data-layout') || // copying from renderer
                    breakoutWrapper?.getAttribute('data-layout') || 'default',
                    __autoSize: dom.getAttribute('data-autosize') === 'true',
                    localId: dom.getAttribute('data-table-local-id') || (0, $fO7hX.uuid).generate(),
                    width: Number(dom.getAttribute('data-table-width')) || null,
                    displayMode: dom.getAttribute('data-table-display-mode') || null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-number-column': node.attrs.isNumberColumnEnabled,
            'data-layout': node.attrs.layout,
            'data-autosize': node.attrs.__autoSize,
            'data-table-local-id': node.attrs.localId,
            'data-table-width': node.attrs.width,
            'data-table-display-mode': node.attrs.displayMode
        };
        return [
            'table',
            attrs,
            [
                'tbody',
                0
            ]
        ];
    }
};
// TODO: ED-5048 - Fix any, potential issue.
const $b5d0e562db315ca2$var$createTableSpec = ()=>(0, $17CG5.table)($b5d0e562db315ca2$var$tableNodeSpecOptions);
const $b5d0e562db315ca2$export$9852986a3ec5f6a0 = $b5d0e562db315ca2$var$createTableSpec();
const $b5d0e562db315ca2$export$90e634fbace1f0c4 = $b5d0e562db315ca2$var$createTableSpec();
const $b5d0e562db315ca2$export$3862de5c8c9098cf = $b5d0e562db315ca2$var$createTableSpec();
const $b5d0e562db315ca2$var$shouldIncludeAttribute = (key, value)=>!key.startsWith('__') && (key !== 'localId' || !!value);
const $b5d0e562db315ca2$export$1f92a2f429e06fa8 = (node)=>({
        attrs: Object.keys(node.attrs).filter((key)=>$b5d0e562db315ca2$var$shouldIncludeAttribute(key, node.attrs[key])).reduce((obj, key)=>{
            return {
                ...obj,
                [key]: node.attrs[key]
            };
        }, {})
    });
const $b5d0e562db315ca2$var$tableRowNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'tr'
        }
    ],
    toDOM () {
        return [
            'tr',
            0
        ];
    }
};
const $b5d0e562db315ca2$export$ce666bf02318c957 = (0, $17CG5.tableRow)($b5d0e562db315ca2$var$tableRowNodeSpecOptions);
const $b5d0e562db315ca2$var$cellAttrs = {
    colspan: {
        default: 1
    },
    rowspan: {
        default: 1
    },
    colwidth: {
        default: null
    },
    background: {
        default: null
    },
    localId: {
        default: null,
        optional: true
    }
};
const $b5d0e562db315ca2$var$tableCellNodeSpecOptions = {
    parseDOM: [
        // Ignore number cell copied from renderer
        {
            tag: '.ak-renderer-table-number-column',
            ignore: true
        },
        {
            tag: 'td',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (dom)=>$b5d0e562db315ca2$export$43977bde391e007(dom)
        }
    ],
    toDOM: (node)=>[
            'td',
            $b5d0e562db315ca2$export$363c8dda799bfe9c(node),
            0
        ]
};
const $b5d0e562db315ca2$export$e1e720e5f4603e6a = (0, $17CG5.tableCell)($b5d0e562db315ca2$var$tableCellNodeSpecOptions);
const $b5d0e562db315ca2$export$2ac34c099660f1a8 = (node)=>({
        attrs: Object.keys(node.attrs).reduce((obj, key)=>{
            // Only process keys that are defined in cellAttrs
            if ($b5d0e562db315ca2$var$cellAttrs[key] && $b5d0e562db315ca2$var$cellAttrs[key].default !== node.attrs[key]) obj[key] = node.attrs[key];
            return obj;
        }, {})
    });
const $b5d0e562db315ca2$var$tableHeaderNodeSpecOptions = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $b5d0e562db315ca2$export$43977bde391e007(dom, {
                    background: $b5d0e562db315ca2$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $b5d0e562db315ca2$export$363c8dda799bfe9c(node),
            0
        ]
};
const $b5d0e562db315ca2$export$48884d2a5190dc73 = (0, $17CG5.tableHeader)($b5d0e562db315ca2$var$tableHeaderNodeSpecOptions);
const $b5d0e562db315ca2$export$2af48797a1010bb1 = $b5d0e562db315ca2$export$2ac34c099660f1a8;
const $b5d0e562db315ca2$export$ce086a560a1d05f5 = (0, $17CG5.tableWithNestedTable)($b5d0e562db315ca2$var$tableNodeSpecOptions);
const $b5d0e562db315ca2$export$7d657479499397 = (0, $17CG5.tableRowWithNestedTable)($b5d0e562db315ca2$var$tableRowNodeSpecOptions);
const $b5d0e562db315ca2$export$abf39ca178940ff3 = (0, $17CG5.tableCellWithNestedTable)($b5d0e562db315ca2$var$tableCellNodeSpecOptions);
const $b5d0e562db315ca2$export$2a5a518232fa1a97 = (0, $17CG5.tableHeaderWithNestedTable)($b5d0e562db315ca2$var$tableHeaderNodeSpecOptions);
// table nodes with localId support
const $b5d0e562db315ca2$var$tableRowNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'tr',
            getAttrs: ()=>({
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'tr',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
};
const $b5d0e562db315ca2$export$c8f0853ac97552c9 = (0, $17CG5.tableRow)($b5d0e562db315ca2$var$tableRowNodeSpecOptionsWithLocalId);
const $b5d0e562db315ca2$var$tableCellNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'td',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $b5d0e562db315ca2$export$43977bde391e007(dom, {
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'td',
            $b5d0e562db315ca2$export$363c8dda799bfe9c(node),
            0
        ];
    }
};
const $b5d0e562db315ca2$export$db76cfd28a574029 = (0, $17CG5.tableCell)($b5d0e562db315ca2$var$tableCellNodeSpecOptionsWithLocalId);
const $b5d0e562db315ca2$var$tableHeaderNodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'th',
            getAttrs: (dom)=>// eslint-disable-next-line @atlaskit/editor/no-as-casting
                $b5d0e562db315ca2$export$43977bde391e007(dom, {
                    background: $b5d0e562db315ca2$var$DEFAULT_TABLE_HEADER_CELL_BACKGROUND,
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM: (node)=>[
            'th',
            $b5d0e562db315ca2$export$363c8dda799bfe9c(node),
            0
        ]
};
const $b5d0e562db315ca2$export$b82d2b1d8824143d = (0, $17CG5.tableHeader)($b5d0e562db315ca2$var$tableHeaderNodeSpecOptionsWithLocalId);
const $b5d0e562db315ca2$export$27926e30c8a74147 = (0, $17CG5.tableRowWithNestedTable)($b5d0e562db315ca2$var$tableRowNodeSpecOptionsWithLocalId);
const $b5d0e562db315ca2$export$e9fd700fafee293a = (0, $17CG5.tableCellWithNestedTable)($b5d0e562db315ca2$var$tableCellNodeSpecOptionsWithLocalId);
const $b5d0e562db315ca2$export$7928c3aeb4cd2213 = (0, $17CG5.tableHeaderWithNestedTable)($b5d0e562db315ca2$var$tableHeaderNodeSpecOptionsWithLocalId);
module.exports["tablePrefixSelector"] = $b5d0e562db315ca2$export$9cfceb893b24742a;
module.exports["tableCellSelector"] = $b5d0e562db315ca2$export$69cb4c3f80383763;
module.exports["tableHeaderSelector"] = $b5d0e562db315ca2$export$7b07d37d879c957f;
module.exports["tableCellContentWrapperSelector"] = $b5d0e562db315ca2$export$8dd42a84cd52da07;
module.exports["tableCellContentDomSelector"] = $b5d0e562db315ca2$export$5e26a5c19f0865d8;
module.exports["getCellAttrs"] = $b5d0e562db315ca2$export$43977bde391e007;
module.exports["getCellDomAttrs"] = $b5d0e562db315ca2$export$363c8dda799bfe9c;
module.exports["tableBackgroundColorNames"] = $b5d0e562db315ca2$export$8cc2833b5b349a1e;
module.exports["tableBackgroundColorPalette"] = $b5d0e562db315ca2$export$219b7f492ad209f8;
module.exports["tableBackgroundBorderColor"] = $b5d0e562db315ca2$export$95e9c925fbf01d1c;
module.exports["table"] = $b5d0e562db315ca2$export$9852986a3ec5f6a0;
module.exports["tableWithCustomWidth"] = $b5d0e562db315ca2$export$90e634fbace1f0c4;
module.exports["tableStage0"] = $b5d0e562db315ca2$export$3862de5c8c9098cf;
module.exports["tableToJSON"] = $b5d0e562db315ca2$export$1f92a2f429e06fa8;
module.exports["tableRow"] = $b5d0e562db315ca2$export$ce666bf02318c957;
module.exports["tableCell"] = $b5d0e562db315ca2$export$e1e720e5f4603e6a;
module.exports["toJSONTableCell"] = $b5d0e562db315ca2$export$2ac34c099660f1a8;
module.exports["tableHeader"] = $b5d0e562db315ca2$export$48884d2a5190dc73;
module.exports["toJSONTableHeader"] = $b5d0e562db315ca2$export$2af48797a1010bb1;
module.exports["tableWithNestedTable"] = $b5d0e562db315ca2$export$ce086a560a1d05f5;
module.exports["tableRowWithNestedTable"] = $b5d0e562db315ca2$export$7d657479499397;
module.exports["tableCellWithNestedTable"] = $b5d0e562db315ca2$export$abf39ca178940ff3;
module.exports["tableHeaderWithNestedTable"] = $b5d0e562db315ca2$export$2a5a518232fa1a97;
module.exports["tableRowWithLocalId"] = $b5d0e562db315ca2$export$c8f0853ac97552c9;
module.exports["tableCellWithLocalId"] = $b5d0e562db315ca2$export$db76cfd28a574029;
module.exports["tableHeaderWithLocalId"] = $b5d0e562db315ca2$export$b82d2b1d8824143d;
module.exports["tableRowWithNestedTableWithLocalId"] = $b5d0e562db315ca2$export$27926e30c8a74147;
module.exports["tableCellWithNestedTableWithLocalId"] = $b5d0e562db315ca2$export$e9fd700fafee293a;
module.exports["tableHeaderWithNestedTableWithLocalId"] = $b5d0e562db315ca2$export$7928c3aeb4cd2213;

});

parcelRegister("aDU6C", function(module, exports) {
const $e12c63595a776879$var$clamp = (i, min, max)=>Math.round(Math.min(Math.max(i, min), max));
const $e12c63595a776879$var$expandShorthandHex = (input)=>// @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    input.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/iu, (m, r, g, b)=>r + r + g + g + b + b);
const $e12c63595a776879$var$rgbFromHex = (input)=>{
    const fullHex = $e12c63595a776879$var$expandShorthandHex(input);
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/iu.exec(fullHex);
    return result === null ? null : {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    };
};
const $e12c63595a776879$var$rgbToHex = ({ r: r, g: g, b: b })=>{
    const convertComponent = (c)=>{
        const cBase16 = c.toString(16);
        return cBase16.length === 1 ? `0${cBase16}` : cBase16;
    };
    return `#${convertComponent(r)}${convertComponent(g)}${convertComponent(b)}`;
};
const $e12c63595a776879$var$rgbToXyz = (rgb)=>{
    const convertRgbComponent = (c)=>c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92;
    const convertXyzComponent = (c)=>c > 0.008856452 ? Math.pow(c, 1 / 3) : c / 0.12841855 + 0.137931034;
    const r = convertRgbComponent(rgb.r / 255);
    const g = convertRgbComponent(rgb.g / 255);
    const b = convertRgbComponent(rgb.b / 255);
    return {
        x: convertXyzComponent((0.4124564 * r + 0.3575761 * g + 0.1804375 * b) / 0.95047),
        y: convertXyzComponent(0.2126729 * r + 0.7151522 * g + 0.072175 * b),
        z: convertXyzComponent((0.0193339 * r + 0.119192 * g + 0.9503041 * b) / 1.08883)
    };
};
const $e12c63595a776879$var$xyzToLab = ({ x: x, y: y, z: z })=>({
        l: Math.max(116 * y - 16, 0),
        a: 500 * (x - y),
        b: 200 * (y - z)
    });
const $e12c63595a776879$var$labToLch = ({ l: l, a: a, b: b })=>{
    let h = (Math.atan2(b, a) * (180 / Math.PI) + 360) % 360;
    const c = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2));
    if (Math.round(c * 10000) === 0) h = Number.NaN;
    return {
        l: l,
        c: c,
        h: h
    };
};
const $e12c63595a776879$var$lchToLab = ({ l: l, c: c, h: h })=>{
    const convertH = Number.isNaN(h) ? 0 : h * (Math.PI / 180);
    return {
        l: l,
        a: Math.cos(convertH) * c,
        b: Math.sin(convertH) * c
    };
};
const $e12c63595a776879$var$labToXyz = ({ l: l, a: a, b: b })=>{
    const convertComponent = (c)=>c > 0.206896552 ? Math.pow(c, 3) : 0.12841855 * (c - 0.137931034);
    const y = (l + 16) / 116;
    const x = a / 500 + y;
    const z = y - b / 200;
    return {
        x: convertComponent(x) * 0.95047,
        y: convertComponent(y),
        z: convertComponent(z) * 1.08883
    };
};
const $e12c63595a776879$var$xyzToRgb = ({ x: x, y: y, z: z })=>{
    const convertComponent = (c)=>255 * (c <= 0.00304 ? 12.92 * c : 1.055 * Math.pow(c, 1 / 2.4) - 0.055);
    return {
        r: $e12c63595a776879$var$clamp(convertComponent(3.2404542 * x - 1.5371385 * y - 0.4985314 * z), 0, 255),
        g: $e12c63595a776879$var$clamp(convertComponent(-0.969266 * x + 1.8760108 * y + 0.041556 * z), 0, 255),
        b: $e12c63595a776879$var$clamp(convertComponent(0.0556434 * x - 0.2040259 * y + 1.0572252 * z), 0, 255)
    };
};
const $e12c63595a776879$var$rgbToLch = (rgb)=>$e12c63595a776879$var$labToLch($e12c63595a776879$var$xyzToLab($e12c63595a776879$var$rgbToXyz(rgb)));
const $e12c63595a776879$var$lchToRgb = (lch)=>$e12c63595a776879$var$xyzToRgb($e12c63595a776879$var$labToXyz($e12c63595a776879$var$lchToLab(lch)));
const $e12c63595a776879$export$313b8a8fcb34c3b8 = (color, newPercent)=>{
    const rgb = $e12c63595a776879$var$rgbFromHex(color);
    if (rgb === null) return color;
    // LCH (rather than HSL) gives the best results here as the L component in LCH is based on human color perception
    const lch = $e12c63595a776879$var$rgbToLch(rgb);
    lch.l = $e12c63595a776879$var$clamp(newPercent, 0, 100);
    return $e12c63595a776879$var$rgbToHex($e12c63595a776879$var$lchToRgb(lch));
};
const $e12c63595a776879$var$getLightness = (color)=>{
    const rgb = $e12c63595a776879$var$rgbFromHex(color);
    if (rgb === null) return 0;
    const lch = $e12c63595a776879$var$rgbToLch(rgb);
    return lch.l;
};
const $e12c63595a776879$export$a5065c3b8aacaf99 = (currentBackgroundColor)=>{
    const lightness = $e12c63595a776879$var$getLightness(currentBackgroundColor);
    const newLightness = Math.abs(100 - lightness);
    return $e12c63595a776879$export$313b8a8fcb34c3b8(currentBackgroundColor, newLightness).toUpperCase();
};
module.exports["getDarkModeLCHColor"] = $e12c63595a776879$export$a5065c3b8aacaf99;

});

parcelRegister("iyDxB", function(module, exports) {

var $2XqLN = parcelRequire("2XqLN");


var $4r9Pq = parcelRequire("4r9Pq");

var $aotp7 = parcelRequire("aotp7");

var $hVXQj = parcelRequire("hVXQj");

var $jl5Qf = parcelRequire("jl5Qf");

var $63Ztt = parcelRequire("63Ztt");

var $cXZ4C = parcelRequire("cXZ4C");


var $gktFz = parcelRequire("gktFz");

const $73b7ad2b07364d56$var$getDefaultSchemaConfig = ()=>{
    const defaultSchemaConfig = {
        nodes: [
            'doc',
            'paragraph',
            'text',
            'bulletList',
            'orderedList',
            'listItem',
            'heading',
            'blockquote',
            'codeBlock',
            'panel',
            'rule',
            'image',
            'caption',
            'mention',
            'media',
            'mediaGroup',
            'mediaSingle',
            'mediaInline',
            'confluenceUnsupportedBlock',
            'confluenceUnsupportedInline',
            'confluenceJiraIssue',
            'expand',
            'nestedExpand',
            'extension',
            'inlineExtension',
            'bodiedExtension',
            'hardBreak',
            'emoji',
            'table',
            'tableCell',
            'tableHeader',
            'tableRow',
            'decisionList',
            'decisionItem',
            'taskList',
            'taskItem',
            'blockTaskItem',
            'unknownBlock',
            'date',
            'status',
            'placeholder',
            'layoutSection',
            'layoutColumn',
            'inlineCard',
            'blockCard',
            'embedCard',
            'syncBlock',
            'bodiedSyncBlock',
            'unsupportedBlock',
            'unsupportedInline'
        ],
        marks: [
            'link',
            'em',
            'strong',
            'strike',
            'subsup',
            'underline',
            'code',
            'textColor',
            'backgroundColor',
            'confluenceInlineComment',
            'breakout',
            'alignment',
            'indentation',
            'annotation',
            'dataConsumer',
            'border',
            'unsupportedMark',
            'unsupportedNodeAttribute',
            'typeAheadQuery',
            'fragment'
        ]
    };
    return defaultSchemaConfig;
};
const $73b7ad2b07364d56$export$e4e3ac1fa64862db = $73b7ad2b07364d56$var$getDefaultSchemaConfig();
const $73b7ad2b07364d56$export$fd147e7d448dea03 = (0, $2XqLN.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
(stage = 'final')=>{
    const defaultSchemaConfig = $73b7ad2b07364d56$var$getDefaultSchemaConfig();
    if (stage === 'stage0') defaultSchemaConfig.customNodeSpecs = {
        layoutSection: (0, $hVXQj.layoutSectionWithSingleColumn),
        multiBodiedExtension: (0, $aotp7.multiBodiedExtension),
        extensionFrame: (0, $aotp7.extensionFrame),
        expand: (0, $4r9Pq.expandWithNestedExpand),
        listItem: (0, $jl5Qf.listItemWithFlexibleFirstChildStage0),
        taskList: (0, $cXZ4C.taskListWithFlexibleFirstChildStage0),
        table: (0, $63Ztt.tableWithNestedTable),
        tableRow: (0, $63Ztt.tableRowWithNestedTable),
        tableCell: (0, $63Ztt.tableCellWithNestedTable),
        tableHeader: (0, $63Ztt.tableHeaderWithNestedTable)
    };
    return (0, $gktFz.createSchema)(defaultSchemaConfig);
});
const $73b7ad2b07364d56$export$1db618b7b2275ea1 = $73b7ad2b07364d56$export$fd147e7d448dea03();
module.exports["defaultSchemaConfig"] = $73b7ad2b07364d56$export$e4e3ac1fa64862db;
module.exports["getSchemaBasedOnStage"] = $73b7ad2b07364d56$export$fd147e7d448dea03;
module.exports["defaultSchema"] = $73b7ad2b07364d56$export$1db618b7b2275ea1;

});

parcelRegister("aotp7", function(module, exports) {

var $jBO3b = parcelRequire("jBO3b");


var $17CG5 = parcelRequire("17CG5");

const $b964f25d11dcd349$export$4fdcae991fd743e7 = (0, $17CG5.extensionFrameStage0)({
    parseDOM: [
        {
            context: 'extensionFrame//',
            tag: 'div[data-extension-frame]',
            skip: true
        },
        {
            tag: 'div[data-extension-frame]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-extension-frame': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $b964f25d11dcd349$export$c3c04d555a8b9013 = (0, $17CG5.multiBodiedExtensionStage0)({
    parseDOM: [
        {
            context: 'multiBodiedExtension//',
            tag: '[data-node-type="multi-bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="multi-bodied-extension"]',
            getAttrs: (domNode)=>(0, $jBO3b.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'multi-bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["extensionFrame"] = $b964f25d11dcd349$export$4fdcae991fd743e7;
module.exports["multiBodiedExtension"] = $b964f25d11dcd349$export$c3c04d555a8b9013;

});

parcelRegister("hVXQj", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $c8a162c2cb1c0941$export$b3b6a70a7fa4a5be = (0, $17CG5.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c8a162c2cb1c0941$export$cdae19acb0a520fd = (0, $17CG5.layoutSectionFull)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-layout-section': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c8a162c2cb1c0941$export$4f9d8f623ff17117 = (0, $17CG5.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle
                } : {};
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c8a162c2cb1c0941$export$d9d3c69a64270b13 = (0, $17CG5.layoutSection)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: ()=>{
                const localId = (0, $fO7hX.uuid).generate();
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-local-id': localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $c8a162c2cb1c0941$export$64facded20dfd85c = (0, $17CG5.layoutSectionWithSingleColumnStage0)({
    parseDOM: [
        {
            context: 'layoutSection//|layoutColumn//',
            tag: 'div[data-layout-section]',
            skip: true
        },
        {
            tag: 'div[data-layout-section]',
            getAttrs: (dom)=>{
                const columnRuleStyle = dom.getAttribute('data-column-rule-style');
                const localId = (0, $fO7hX.uuid).generate();
                return columnRuleStyle ? {
                    columnRuleStyle: columnRuleStyle,
                    localId: localId
                } : {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const { columnRuleStyle: columnRuleStyle } = node.attrs;
        const attrs = {
            'data-layout-section': 'true',
            'data-column-rule-style': columnRuleStyle || undefined,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["layoutSection"] = $c8a162c2cb1c0941$export$b3b6a70a7fa4a5be;
module.exports["layoutSectionWithSingleColumn"] = $c8a162c2cb1c0941$export$4f9d8f623ff17117;
module.exports["layoutSectionWithLocalId"] = $c8a162c2cb1c0941$export$d9d3c69a64270b13;
module.exports["layoutSectionWithSingleColumnLocalId"] = $c8a162c2cb1c0941$export$64facded20dfd85c;

});

parcelRegister("jl5Qf", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $8d737b75ab2993d7$export$76c7e83ecc9cdf05 = (0, $17CG5.listItem)({
    parseDOM: [
        {
            tag: 'li'
        }
    ],
    toDOM () {
        return [
            'li',
            0
        ];
    }
});
const $8d737b75ab2993d7$export$483d52f09158e61c = (0, $17CG5.listItem)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'li',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
});
const $8d737b75ab2993d7$export$fcbecfed570fc881 = (0, $17CG5.listItemWithFlexibleFirstChildStage0)({
    parseDOM: [
        {
            tag: 'li',
            getAttrs: ()=>({
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'li',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
});
module.exports["listItem"] = $8d737b75ab2993d7$export$76c7e83ecc9cdf05;
module.exports["listItemWithLocalId"] = $8d737b75ab2993d7$export$483d52f09158e61c;
module.exports["listItemWithFlexibleFirstChildStage0"] = $8d737b75ab2993d7$export$fcbecfed570fc881;

});

parcelRegister("cXZ4C", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $b444989690d21d64$var$name = 'actionList';
const $b444989690d21d64$export$c0ec71adb7a18fb2 = `[data-node-type="${$b444989690d21d64$var$name}"]`;
const $b444989690d21d64$var$taskListParseDOMAndToDOM = {
    parseDOM: [
        {
            tag: `div${$b444989690d21d64$export$c0ec71adb7a18fb2}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $b444989690d21d64$var$name,
            'data-task-list-local-id': localId || 'local-task-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $b444989690d21d64$export$375b6afcc5f4d291 = (0, $17CG5.taskList)($b444989690d21d64$var$taskListParseDOMAndToDOM);
const $b444989690d21d64$var$taskListWithFlexibleFirstChild = (0, $17CG5.taskListWithFlexibleFirstChildStage0)($b444989690d21d64$var$taskListParseDOMAndToDOM);
const $b444989690d21d64$export$3c86306d85ad1f18 = {
    ...$b444989690d21d64$var$taskListWithFlexibleFirstChild,
    // Generated spec omits PM group; keep taskList in block content for doc validation.
    group: 'block'
};
module.exports["taskListSelector"] = $b444989690d21d64$export$c0ec71adb7a18fb2;
module.exports["taskList"] = $b444989690d21d64$export$375b6afcc5f4d291;
module.exports["taskListWithFlexibleFirstChildStage0"] = $b444989690d21d64$export$3c86306d85ad1f18;

});

parcelRegister("gktFz", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

// # What do marks exist?
//
// Marks are categorised into different groups. One motivation for this was to allow the `code` mark
// to exclude other marks, without needing to explicitly name them. Explicit naming requires the
// named mark to exist in the schema. This is undesirable because we want to construct different
// schemas that have different sets of nodes/marks.
//
// Groups provide a level of indirection, and solve this problem. For the immediate use-case, one
// group called "not_code" would have sufficed, but this an ultra-specialised to code.
// Mark group for font styling (e.g. bold, italic, underline, superscript).
const $ac11d57f776af241$export$4498a6080fed604c = 'fontStyle';
const $ac11d57f776af241$export$f8e8a5f34f6ea725 = 'searchQuery';
const $ac11d57f776af241$export$b395009ca7f092c7 = 'link';
const $ac11d57f776af241$export$9b982809044276a6 = 'color';
const $ac11d57f776af241$export$470d0905851e47a1 = 'alignment';
const $ac11d57f776af241$export$bacb7f4b06a06b22 = 'indentation';



var $9vHt3 = parcelRequire("9vHt3");


var $anbEX = parcelRequire("anbEX");

var $cUycv = parcelRequire("cUycv");

var $jvymJ = parcelRequire("jvymJ");

var $eINDz = parcelRequire("eINDz");

var $gWpm5 = parcelRequire("gWpm5");

var $lu7Ub = parcelRequire("lu7Ub");

var $6bXvD = parcelRequire("6bXvD");

const $463e51cd0f9dfe41$export$f3b72f8fc4684ecd = (0, $6bXvD.confluenceInlineComment)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="confluenceInlineComment"]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-mark-type': 'confluenceInlineComment',
                'data-reference': node.attrs.reference
            }
        ];
    }
});


var $4dOgb = parcelRequire("4dOgb");

var $a2CNw = parcelRequire("a2CNw");

var $i8M34 = parcelRequire("i8M34");

var $jTb2k = parcelRequire("jTb2k");

var $9LRzA = parcelRequire("9LRzA");

var $gQUY7 = parcelRequire("gQUY7");

var $dd67x = parcelRequire("dd67x");

var $bJD2s = parcelRequire("bJD2s");

var $ip8b2 = parcelRequire("ip8b2");

var $9GzMM = parcelRequire("9GzMM");

var $lSP4W = parcelRequire("lSP4W");

var $gKyPs = parcelRequire("gKyPs");

var $6eIpX = parcelRequire("6eIpX");

var $8KqSY = parcelRequire("8KqSY");


var $aGTRk = parcelRequire("aGTRk");

var $5elS6 = parcelRequire("5elS6");

var $4sfnB = parcelRequire("4sfnB");

var $3EiOU = parcelRequire("3EiOU");

var $ghpxT = parcelRequire("ghpxT");

var $kRG5M = parcelRequire("kRG5M");

var $4HD7y = parcelRequire("4HD7y");

var $fsHCc = parcelRequire("fsHCc");

var $aZa28 = parcelRequire("aZa28");

var $fnSCn = parcelRequire("fnSCn");

var $cAWza = parcelRequire("cAWza");

var $bpTLT = parcelRequire("bpTLT");

var $gClzS = parcelRequire("gClzS");

var $jRrsu = parcelRequire("jRrsu");

var $cfHGv = parcelRequire("cfHGv");

var $bIZRt = parcelRequire("bIZRt");

var $4r9Pq = parcelRequire("4r9Pq");

var $iIGXo = parcelRequire("iIGXo");

var $dGKc1 = parcelRequire("dGKc1");

var $2xxP6 = parcelRequire("2xxP6");

var $aotp7 = parcelRequire("aotp7");

var $aFNbc = parcelRequire("aFNbc");

var $j0UBv = parcelRequire("j0UBv");

var $dupND = parcelRequire("dupND");

var $aqHdD = parcelRequire("aqHdD");

var $u6ZFj = parcelRequire("u6ZFj");

var $lifsC = parcelRequire("lifsC");

var $hVXQj = parcelRequire("hVXQj");

var $jl5Qf = parcelRequire("jl5Qf");

var $kZ3vg = parcelRequire("kZ3vg");

var $6xrFZ = parcelRequire("6xrFZ");

var $bTc4a = parcelRequire("bTc4a");

var $jblCI = parcelRequire("jblCI");

var $CmplZ = parcelRequire("CmplZ");

var $iw2ID = parcelRequire("iw2ID");

var $fGuiW = parcelRequire("fGuiW");

var $eK2Ov = parcelRequire("eK2Ov");

var $jEypY = parcelRequire("jEypY");

var $bLhD4 = parcelRequire("bLhD4");

var $f4dR3 = parcelRequire("f4dR3");

var $8WAFY = parcelRequire("8WAFY");

var $63Ztt = parcelRequire("63Ztt");

var $cXZ4C = parcelRequire("cXZ4C");

var $bSuKu = parcelRequire("bSuKu");

var $h3652 = parcelRequire("h3652");

var $iSXnW = parcelRequire("iSXnW");

var $cre7m = parcelRequire("cre7m");

function $8943c349ac8d4365$var$addItems(builtInItems, config, customSpecs = {}) {
    if (!config) return {};
    /**
	 * Add built-in Node / Mark specs
	 */ const items = builtInItems.reduce((items, { name: name, spec: spec })=>{
        if (config.indexOf(name) !== -1) items[name] = customSpecs[name] || spec;
        return items;
    }, {});
    /**
	 * Add Custom Node / Mark specs
	 */ return Object.keys(customSpecs).reduce((items, name)=>{
        if (items[name]) return items;
        items[name] = customSpecs[name];
        return items;
    }, items);
}
// We use groups to allow schemas to be constructed in different shapes without changing node/mark
// specs, but this means nodes/marks are defined with groups that might never be used in the schema.
// In this scenario ProseMirror will complain and prevent the schema from being constructed.
//
// To avoid the problem, we include items that serve to "declare" the groups in the schema. This
// approach unfortunately leaves unused items in the schema, but has the benefit of avoiding the
// need to manipulate `exclude` or content expression values for potentially every schema item.
function $8943c349ac8d4365$var$groupDeclaration(name) {
    return {
        name: `__${name}GroupDeclaration`,
        spec: {
            group: name
        }
    };
}
const $8943c349ac8d4365$var$markGroupDeclarations = [
    $8943c349ac8d4365$var$groupDeclaration((0, $ac11d57f776af241$export$9b982809044276a6)),
    $8943c349ac8d4365$var$groupDeclaration((0, $ac11d57f776af241$export$4498a6080fed604c)),
    $8943c349ac8d4365$var$groupDeclaration((0, $ac11d57f776af241$export$f8e8a5f34f6ea725)),
    $8943c349ac8d4365$var$groupDeclaration((0, $ac11d57f776af241$export$b395009ca7f092c7))
];
const $8943c349ac8d4365$var$markGroupDeclarationsNames = $8943c349ac8d4365$var$markGroupDeclarations.map((groupMark)=>groupMark.name);
const $8943c349ac8d4365$var$nodesInOrder = [
    {
        name: 'doc',
        spec: (0, $jRrsu.doc)
    },
    {
        name: 'paragraph',
        spec: (0, $eK2Ov.paragraph)
    },
    {
        name: 'text',
        spec: (0, $bSuKu.text)
    },
    {
        name: 'bulletList',
        spec: (0, $ghpxT.bulletList)
    },
    {
        name: 'orderedList',
        spec: (0, $fGuiW.orderedListWithOrder)
    },
    {
        name: 'listItem',
        spec: (0, $jl5Qf.listItem)
    },
    {
        name: 'heading',
        spec: (0, $j0UBv.heading)
    },
    {
        name: 'blockquote',
        spec: (0, $iIGXo.extendedBlockquote)
    },
    {
        name: 'codeBlock',
        spec: (0, $4HD7y.codeBlock)
    },
    {
        name: 'panel',
        spec: (0, $dGKc1.extendedPanel)(true)
    },
    {
        name: 'rule',
        spec: (0, $bLhD4.rule)
    },
    {
        name: 'image',
        spec: (0, $dupND.image)
    },
    {
        name: 'mention',
        spec: (0, $CmplZ.mention)
    },
    {
        name: 'caption',
        spec: (0, $kRG5M.caption)
    },
    {
        name: 'media',
        spec: (0, $kZ3vg.media)
    },
    {
        name: 'mediaGroup',
        spec: (0, $6xrFZ.mediaGroup)
    },
    {
        name: 'mediaSingle',
        spec: (0, $jblCI.mediaSingleFull)
    },
    {
        name: 'mediaInline',
        spec: (0, $bTc4a.mediaInline)
    },
    {
        name: 'placeholder',
        spec: (0, $jEypY.placeholder)
    },
    {
        name: 'layoutSection',
        spec: (0, $hVXQj.layoutSection)
    },
    {
        name: 'layoutColumn',
        spec: (0, $lifsC.layoutColumn)
    },
    {
        name: 'hardBreak',
        spec: (0, $aFNbc.hardBreak)
    },
    {
        name: 'emoji',
        spec: (0, $bIZRt.emoji)
    },
    {
        name: 'table',
        spec: (0, $63Ztt.table)
    },
    {
        name: 'tableCell',
        spec: (0, $63Ztt.tableCell)
    },
    {
        name: 'tableRow',
        spec: (0, $63Ztt.tableRow)
    },
    {
        name: 'tableHeader',
        spec: (0, $63Ztt.tableHeader)
    },
    {
        name: 'confluenceJiraIssue',
        spec: (0, $fsHCc.confluenceJiraIssue)
    },
    {
        name: 'confluenceUnsupportedInline',
        spec: (0, $fnSCn.confluenceUnsupportedInline)
    },
    {
        name: 'confluenceUnsupportedBlock',
        spec: (0, $aZa28.confluenceUnsupportedBlock)
    },
    {
        name: 'decisionList',
        spec: (0, $gClzS.decisionList)
    },
    {
        name: 'decisionItem',
        spec: (0, $bpTLT.decisionItem)
    },
    {
        name: 'taskList',
        spec: (0, $cXZ4C.taskList)
    },
    {
        name: 'taskItem',
        spec: (0, $5elS6.taskItem)
    },
    {
        name: 'blockTaskItem',
        spec: (0, $5elS6.blockTaskItem)
    },
    {
        name: 'date',
        spec: (0, $cAWza.date)
    },
    {
        name: 'status',
        spec: (0, $f4dR3.status)
    },
    {
        name: 'expand',
        spec: (0, $4r9Pq.expandWithNestedExpand)
    },
    {
        name: 'nestedExpand',
        spec: (0, $iw2ID.nestedExpand)
    },
    {
        name: 'extension',
        spec: (0, $2xxP6.extension)
    },
    {
        name: 'inlineExtension',
        spec: (0, $u6ZFj.inlineExtension)
    },
    {
        name: 'bodiedExtension',
        spec: (0, $4sfnB.bodiedExtension)
    },
    {
        name: 'multiBodiedExtension',
        spec: (0, $aotp7.multiBodiedExtension)
    },
    {
        name: 'extensionFrame',
        spec: (0, $aotp7.extensionFrame)
    },
    {
        name: 'inlineCard',
        spec: (0, $aqHdD.inlineCard)
    },
    {
        name: 'blockCard',
        spec: (0, $aGTRk.blockCard)
    },
    {
        name: 'embedCard',
        spec: (0, $cfHGv.embedCard)
    },
    {
        name: 'syncBlock',
        spec: (0, $8WAFY.syncBlock)
    },
    {
        name: 'bodiedSyncBlock',
        spec: (0, $3EiOU.bodiedSyncBlock)
    },
    {
        name: 'unknownBlock',
        spec: (0, $h3652.default)
    },
    {
        name: 'unsupportedBlock',
        spec: (0, $iSXnW.unsupportedBlock)
    },
    {
        name: 'unsupportedInline',
        spec: (0, $cre7m.unsupportedInline)
    }
];
const $8943c349ac8d4365$var$marksInOrder = [
    {
        name: 'link',
        spec: (0, $gQUY7.link)
    },
    {
        name: 'em',
        spec: (0, $a2CNw.em)
    },
    {
        name: 'strong',
        spec: (0, $bJD2s.strong)
    },
    {
        name: 'textColor',
        spec: (0, $9GzMM.textColor)
    },
    {
        name: 'backgroundColor',
        spec: (0, $jvymJ.backgroundColor)
    },
    {
        name: 'strike',
        spec: (0, $dd67x.strike)
    },
    {
        name: 'subsup',
        spec: (0, $ip8b2.subsup)
    },
    {
        name: 'underline',
        spec: (0, $gKyPs.underline)
    },
    {
        name: 'code',
        spec: (0, $lu7Ub.code)
    },
    {
        name: 'typeAheadQuery',
        spec: (0, $lSP4W.typeAheadQuery)
    },
    {
        name: 'alignment',
        spec: (0, $anbEX.alignment)
    },
    {
        name: 'annotation',
        spec: (0, $cUycv.annotation)
    },
    {
        name: 'confluenceInlineComment',
        spec: (0, $463e51cd0f9dfe41$export$f3b72f8fc4684ecd)
    },
    ...$8943c349ac8d4365$var$markGroupDeclarations,
    {
        name: 'fontSize',
        spec: (0, $i8M34.fontSize)
    },
    {
        name: 'breakout',
        spec: (0, $gWpm5.breakout)
    },
    {
        name: 'dataConsumer',
        spec: (0, $4dOgb.dataConsumer)
    },
    {
        name: 'fragment',
        spec: (0, $jTb2k.fragment)
    },
    {
        name: 'indentation',
        spec: (0, $9LRzA.indentation)
    },
    {
        name: 'border',
        spec: (0, $eINDz.border)
    },
    {
        name: 'unsupportedMark',
        spec: (0, $6eIpX.unsupportedMark)
    },
    {
        name: 'unsupportedNodeAttribute',
        spec: (0, $8KqSY.unsupportedNodeAttribute)
    }
];
function $8943c349ac8d4365$export$2d0c32a809131488() {
    const nodes = $8943c349ac8d4365$var$nodesInOrder.reduce((acc, { name: name, spec: spec })=>{
        acc[name] = spec;
        return acc;
    }, {});
    const marks = $8943c349ac8d4365$var$marksInOrder.reduce((acc, { name: name, spec: spec })=>{
        acc[name] = spec;
        return acc;
    }, {});
    return {
        nodes: nodes,
        marks: marks
    };
}
function $8943c349ac8d4365$export$5f4ce795563f4211(config) {
    const { customNodeSpecs: customNodeSpecs, customMarkSpecs: customMarkSpecs } = config;
    const nodesConfig = Object.keys(customNodeSpecs || {}).concat(config.nodes);
    const marksConfig = Object.keys(customMarkSpecs || {}).concat(config.marks || []).concat($8943c349ac8d4365$var$markGroupDeclarationsNames);
    let nodes = $8943c349ac8d4365$var$addItems($8943c349ac8d4365$var$nodesInOrder, nodesConfig, customNodeSpecs);
    const marks = $8943c349ac8d4365$var$addItems($8943c349ac8d4365$var$marksInOrder, marksConfig, customMarkSpecs);
    nodes = (0, $9vHt3.sanitizeNodes)(nodes, marks);
    return new (0, $5SAOw.Schema)({
        nodes: nodes,
        marks: marks
    });
}
const $8943c349ac8d4365$export$c77b6d30da5276a1 = true;
module.exports["createSchema"] = $8943c349ac8d4365$export$5f4ce795563f4211;

});

parcelRegister("9vHt3", function(module, exports) {
function $73b08d50c9614640$export$daf54fed04c8fb77(nodes, supportedMarks) {
    const nodeNames = Object.keys(nodes);
    nodeNames.forEach((nodeKey)=>{
        const nodeSpec = {
            ...nodes[nodeKey]
        };
        if (nodeSpec.marks && nodeSpec.marks !== '_') nodeSpec.marks = nodeSpec.marks.split(' ').filter((mark)=>!!supportedMarks[mark]).join(' ');
        if (nodeSpec.content) nodeSpec.content = $73b08d50c9614640$var$sanitizeNodeSpecContent(nodes, nodeSpec.content);
        nodes[nodeKey] = nodeSpec;
    });
    return nodes;
}
function $73b08d50c9614640$var$sanitizeNodeSpecContent(nodes, rawContent) {
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    const content = rawContent.replace(/\W/gu, ' ');
    const contentKeys = content.split(' ');
    const unsupportedContentKeys = contentKeys.filter((contentKey)=>!$73b08d50c9614640$var$isContentSupported(nodes, contentKey));
    return unsupportedContentKeys.reduce((newContent, nodeName)=>$73b08d50c9614640$var$sanitizedContent(newContent, nodeName), rawContent);
}
function $73b08d50c9614640$var$sanitizedContent(content, invalidContent) {
    if (!invalidContent.length) return content || '';
    // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
    if (!content || !content.match(/\w/u)) return '';
    const pattern = `(${invalidContent}((\\s)*\\|)+)|((\\|(\\s)*)+${invalidContent}(\\+|\\*)?)|(${invalidContent}$)|(${invalidContent}(\\+|\\*))`;
    return content.replace(new RegExp(pattern, 'gu'), '').replace('  ', ' ').trim();
}
function $73b08d50c9614640$var$isContentSupported(nodes, contentKey) {
    const nodeKeys = Object.keys(nodes);
    // content is with valid node
    if (nodeKeys.indexOf(contentKey) > -1) return true;
    // content is with valid group
    for(const supportedKey in nodes)if (nodes.hasOwnProperty(supportedKey)) {
        const nodeSpec = nodes[supportedKey];
        if (nodeSpec && nodeSpec.group === contentKey) return true;
    }
    return false;
}
module.exports["sanitizeNodes"] = $73b08d50c9614640$export$daf54fed04c8fb77;

});

parcelRegister("anbEX", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

const $cda25ac3605d0080$export$be9cf49015769bbd = {
    end: 'right',
    right: 'end',
    center: 'center'
};
const $cda25ac3605d0080$export$8e53000a4ec837 = (0, $6bXvD.alignment)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-block-mark',
            getAttrs: (dom)=>{
                const align = dom.getAttribute('data-align');
                return align ? {
                    align: align
                } : false;
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: `fabric-editor-block-mark fabric-editor-alignment fabric-editor-align-${mark.attrs.align}`,
                'data-align': mark.attrs.align
            },
            0
        ];
    }
});
module.exports["alignmentPositionMap"] = $cda25ac3605d0080$export$be9cf49015769bbd;
module.exports["alignment"] = $cda25ac3605d0080$export$8e53000a4ec837;

});

parcelRegister("cUycv", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

var $2d22fa9fb38c7e7a$export$94aa2fc69ad33d19 = /*#__PURE__*/ function(AnnotationTypes) {
    AnnotationTypes["INLINE_COMMENT"] = "inlineComment";
    return AnnotationTypes;
}({});
var $2d22fa9fb38c7e7a$export$4bab14797673da9f = /*#__PURE__*/ function(AnnotationMarkStates) {
    AnnotationMarkStates["RESOLVED"] = "resolved";
    AnnotationMarkStates["ACTIVE"] = "active";
    return AnnotationMarkStates;
}({});
function $2d22fa9fb38c7e7a$export$93a98caa8bc6cb07({ id: id, annotationType: annotationType, state: state }) {
    const data = {
        'data-mark-type': 'annotation',
        'data-mark-annotation-type': annotationType,
        'data-id': id
    };
    if (state) return {
        ...data,
        'data-mark-annotation-state': state
    };
    return data;
}
const $2d22fa9fb38c7e7a$export$8512c9afa7b24c3b = (0, $6bXvD.annotation)({
    parseDOM: [
        {
            tag: 'span[data-mark-type="annotation"]',
            mark: 'annotation',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    id: dom.getAttribute('data-id'),
                    annotationType: dom.getAttribute('data-mark-annotation-type')
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        /*
        Data attributes on the DOM node are a temporary means of
        incrementally switching over to the Annotation mark. Once renderer
        provides native support for inline comments the data attributes on the
        DOM nodes will be removed.
      */ return [
            'span',
            {
                // Prettier will remove the quotes around class. This would cause some browsers
                // to not add this attribute properly, as its a reserved word.
                // prettier-ignore
                'class': 'fabric-editor-annotation',
                ...$2d22fa9fb38c7e7a$export$93a98caa8bc6cb07({
                    id: node.attrs.id,
                    annotationType: node.attrs.annotationType
                })
            },
            0
        ];
    }
});
module.exports["AnnotationTypes"] = $2d22fa9fb38c7e7a$export$94aa2fc69ad33d19;
module.exports["AnnotationMarkStates"] = $2d22fa9fb38c7e7a$export$4bab14797673da9f;
module.exports["buildDataAttributes"] = $2d22fa9fb38c7e7a$export$93a98caa8bc6cb07;
module.exports["annotation"] = $2d22fa9fb38c7e7a$export$8512c9afa7b24c3b;

});

parcelRegister("jvymJ", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");


var $dCzEh = parcelRequire("dCzEh");


var $hbMKq = parcelRequire("hbMKq");


var $9GzMM = parcelRequire("9GzMM");


var $aDU6C = parcelRequire("aDU6C");

const $b258531751ab2ba8$var$colorArrayPalette = [
    [
        (0, $hbMKq.Neutral300),
        'Gray'
    ],
    // token: color.background.accent.gray.subtler
    [
        (0, $hbMKq.P200),
        'Purple'
    ],
    // token: color.background.accent.purple.subtler
    [
        (0, $hbMKq.M200),
        'Magenta'
    ],
    // token: color.background.accent.magenta.subtler
    [
        (0, $hbMKq.O200),
        'Orange'
    ],
    // token: color.background.accent.orange.subtler
    [
        (0, $hbMKq.Yellow200),
        'Yellow'
    ],
    // token: color.background.accent.yellow.subtler
    [
        (0, $hbMKq.L200),
        'Lime'
    ],
    // token: color.background.accent.lime.subtler
    [
        (0, $hbMKq.T200),
        'Teal'
    ] // token: color.background.accent.teal.subtler
];
const $b258531751ab2ba8$export$14ec3f21a268e497 = new Map();
$b258531751ab2ba8$var$colorArrayPalette.forEach(([color, label])=>$b258531751ab2ba8$export$14ec3f21a268e497.set(color.toLowerCase(), label));
const $b258531751ab2ba8$export$8c5a050822fd698c = (0, $6bXvD.backgroundColor)({
    parseDOM: [
        {
            style: 'background-color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                if (value.match(/^rgb/iu)) hexColor = (0, $hbMKq.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $b258531751ab2ba8$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This is used to support the work-around that converts the hex color to
        // a design system token to enable light / dark mode (through a CSS variable --custom-palette-color)
        {
            tag: '.fabric-background-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.backgroundCustomColor;
                return hexColor && $b258531751ab2ba8$export$14ec3f21a268e497.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        /**
     * Documents can contain custom colors when content has been migrated from the old editor, or created via APIs.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * separate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $dCzEh.hexToEditorTextBackgroundPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ((0, $9GzMM.getGlobalTheme)().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $aDU6C.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-background-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-background-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-background-custom-color']: mark.attrs.color
            }
        ];
    }
});
module.exports["backgroundColorPalette"] = $b258531751ab2ba8$export$14ec3f21a268e497;
module.exports["backgroundColor"] = $b258531751ab2ba8$export$8c5a050822fd698c;

});

parcelRegister("9GzMM", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");


var $dCzEh = parcelRequire("dCzEh");


var $hbMKq = parcelRequire("hbMKq");


var $aDU6C = parcelRequire("aDU6C");

// used for extended palette in text color picker
const $3cdf898a0c90b9bd$var$colorArrayPalette = [
    // default row - first color is added programatically
    // [N800, 'Squid ink'], // default dark gray
    [
        (0, $hbMKq.B500),
        'Dark blue'
    ],
    // Chore coat
    [
        (0, $hbMKq.T500),
        'Dark teal'
    ],
    // Shabby chic
    [
        (0, $hbMKq.G500),
        'Dark green'
    ],
    // Keen green
    [
        (0, $hbMKq.Y400),
        'Orange'
    ],
    // Cheezy blasters
    [
        (0, $hbMKq.R500),
        'Dark red'
    ],
    // Dragon's blood
    [
        (0, $hbMKq.P500),
        'Dark purple'
    ],
    // Prince
    // row 2
    [
        (0, $hbMKq.N80),
        'Light gray'
    ],
    // Spooky ghost
    [
        (0, $hbMKq.B100),
        'Blue'
    ],
    // Arvo breeze
    [
        (0, $hbMKq.T300),
        'Teal'
    ],
    // Tamarama
    [
        (0, $hbMKq.G300),
        'Green'
    ],
    // Fine pine
    [
        (0, $hbMKq.Y200),
        'Yellow'
    ],
    // Pub mix
    [
        (0, $hbMKq.R300),
        'Red'
    ],
    // Poppy surprise
    [
        (0, $hbMKq.P300),
        'Purple'
    ],
    // Da' juice
    // row 3
    [
        (0, $hbMKq.N0),
        'White'
    ],
    [
        (0, $hbMKq.B75),
        'Light blue'
    ],
    // Schwag
    [
        (0, $hbMKq.T75),
        'Light teal'
    ],
    // Arctic chill
    [
        (0, $hbMKq.G75),
        'Light green'
    ],
    // Mintie
    [
        (0, $hbMKq.Y75),
        'Light yellow'
    ],
    // Dandelion whisper
    [
        (0, $hbMKq.R75),
        'Light red'
    ],
    // Bondi sunburn
    [
        (0, $hbMKq.P50),
        'Light purple'
    ] // Lavender secret
];
const $3cdf898a0c90b9bd$export$569885e57444f84a = new Map();
const $3cdf898a0c90b9bd$export$81e5ed9e84fe2e28 = $3cdf898a0c90b9bd$export$569885e57444f84a;
$3cdf898a0c90b9bd$var$colorArrayPalette.forEach(([color, label])=>$3cdf898a0c90b9bd$export$569885e57444f84a.set(color.toLowerCase(), label));
// these are for test only
let $3cdf898a0c90b9bd$var$testGlobalTheme;
const $3cdf898a0c90b9bd$export$fd7e0dd2b74807f7 = (theme)=>{
    $3cdf898a0c90b9bd$var$testGlobalTheme = theme;
};
const $3cdf898a0c90b9bd$export$813ecdf77207a053 = ()=>{
    // This should only be hit during tests.
    //
    // At time of writing Jest mocks are not working in this repository.
    if ($3cdf898a0c90b9bd$var$testGlobalTheme) return {
        colorMode: $3cdf898a0c90b9bd$var$testGlobalTheme
    };
    const element = document.documentElement;
    const colorMode = element.getAttribute('data-color-mode') || '';
    return {
        colorMode: colorMode
    };
};
const $3cdf898a0c90b9bd$export$32f78bffcd82ff28 = (0, $6bXvD.textColor)({
    parseDOM: [
        {
            style: 'color',
            getAttrs: (maybeValue)=>{
                const value = maybeValue;
                let hexColor;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                if (value.match(/^rgb/iu)) hexColor = (0, $hbMKq.rgbToHex)(value);
                else if (value[0] === '#') hexColor = value.toLowerCase();
                // else handle other colour formats
                return hexColor && $3cdf898a0c90b9bd$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        },
        // This rule ensures when loading from a renderer or editor where the
        // presented text color does not match the stored hex color -- that the
        // text color is preserved.
        //
        // This was initially introduced to ensure text-color marks were not lost
        // when text-color was used inside a link, and is now also used to support
        // where the hex color stored in ADF is used as an ID for a design system
        // token (and based on theme mode -- the presented color will change).
        {
            tag: '.fabric-text-color-mark',
            getAttrs: (maybeElement)=>{
                if (!(maybeElement instanceof HTMLElement)) return false;
                const hexColor = maybeElement.dataset.textCustomColor;
                return hexColor && $3cdf898a0c90b9bd$export$569885e57444f84a.has(hexColor) ? {
                    color: hexColor
                } : false;
            }
        }
    ],
    toDOM (mark) {
        let paletteColorValue;
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        /**
     * The Editor persists custom text colors when content has been migrated from the old editor, or created via
     * apis.
     *
     * This behaviour predates the introduction of dark mode.
     *
     * Without the inversion logic below, text with custom colors, can be hard to read when the user loads the page in dark mode.
     *
     * This introduces inversion of the presentation of the custom text colors when the user is in dark mode.
     *
     * This can be done without additional changes to account for users copying and pasting content inside the Editor, because of
     * how we detect text colors copied from external editor sources. Where we load the background color from a
     * seperate attribute (data-text-custom-color), instead of the inline style.
     *
     * See the following document for more details on this behaviour
     * https://hello.atlassian.net/wiki/spaces/CCECO/pages/2908658046/Unsupported+custom+text+colors+in+dark+theme+Editor+Job+Story
     */ const tokenColor = (0, $dCzEh.hexToEditorTextPaletteColor)(mark.attrs.color);
        if (tokenColor) paletteColorValue = tokenColor;
        else if ($3cdf898a0c90b9bd$export$813ecdf77207a053().colorMode === 'dark') // if we have a custom color, we need to check if we are in dark mode
        paletteColorValue = (0, $aDU6C.getDarkModeLCHColor)(mark.attrs.color);
        else // if we are in light mode, we can just set the color
        paletteColorValue = mark.attrs.color;
        return [
            'span',
            {
                class: 'fabric-text-color-mark',
                // Editor common has a common style which uses this css variable as the value for
                // the color property using the `fabric-text-color-mark` selector applied above.
                style: `--custom-palette-color: ${paletteColorValue}`,
                ['data-text-custom-color']: mark.attrs.color
            }
        ];
    }
});
module.exports["colorPalette"] = $3cdf898a0c90b9bd$export$569885e57444f84a;
module.exports["getGlobalTheme"] = $3cdf898a0c90b9bd$export$813ecdf77207a053;
module.exports["textColor"] = $3cdf898a0c90b9bd$export$32f78bffcd82ff28;

});

parcelRegister("eINDz", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");


var $dCzEh = parcelRequire("dCzEh");


var $hbMKq = parcelRequire("hbMKq");

const $f9353cf08011abf2$var$borderColorArrayPalette = [
    [
        (0, $hbMKq.N300A),
        'Subtle gray'
    ],
    [
        (0, $hbMKq.N600),
        'Gray'
    ],
    [
        (0, $hbMKq.N1000),
        'Bold gray'
    ]
];
const $f9353cf08011abf2$export$e4e044c989c86ca7 = new Map();
$f9353cf08011abf2$var$borderColorArrayPalette.forEach(([color, label])=>$f9353cf08011abf2$export$e4e044c989c86ca7.set(color.toLowerCase(), label));
const $f9353cf08011abf2$export$1edee58a52776cd9 = (0, $6bXvD.border)({
    parseDOM: [
        {
            tag: '[data-mark-type="border"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const color = (dom.getAttribute('data-color') ?? '').toLowerCase();
                const size = +(dom.getAttribute('data-size') ?? '0');
                return {
                    size: size > 3 ? 3 : size < 1 ? false : size,
                    color: $f9353cf08011abf2$export$e4e044c989c86ca7.has(color) ? color : false
                };
            }
        }
    ],
    toDOM (mark, isInline) {
        const wrapperStyle = isInline ? 'span' : 'div';
        // Note -- while there is no way to create custom colors using default tooling
        // the editor does supported ad hoc color values -- and there may be content
        // which has been migrated or created via apis which use such values.
        const paletteColorValue = (0, $dCzEh.hexToEditorBorderPaletteColor)(mark.attrs.color) || mark.attrs.color;
        return [
            wrapperStyle,
            {
                'data-mark-type': 'border',
                'data-color': mark.attrs.color,
                'data-size': mark.attrs.size,
                style: `--custom-palette-color: ${paletteColorValue}`
            }
        ];
    }
});
module.exports["borderColorPalette"] = $f9353cf08011abf2$export$e4e044c989c86ca7;
module.exports["border"] = $f9353cf08011abf2$export$1edee58a52776cd9;

});

parcelRegister("gWpm5", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

const $b305fbff812859d3$var$allowedTypes = [
    'wide',
    'full-width'
];
const $b305fbff812859d3$export$89015c65f1c75e3f = (0, $6bXvD.breakout)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-breakout-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const mode = dom.getAttribute('data-mode');
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const width = dom.getAttribute('data-width');
                return {
                    mode: $b305fbff812859d3$var$allowedTypes.indexOf(mode || '') === -1 ? 'wide' : mode,
                    width: width ? parseInt(width) : null
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-breakout-mark',
                'data-mode': mark.attrs.mode,
                'data-width': mark.attrs?.width
            },
            0
        ];
    }
});
module.exports["breakout"] = $b305fbff812859d3$export$89015c65f1c75e3f;

});

parcelRegister("lu7Ub", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

const $54c065d7a7f51a47$export$6565f9f03506010b = (0, $6bXvD.code)({
    parseDOM: [
        {
            tag: 'span.code',
            preserveWhitespace: true
        },
        {
            tag: 'code',
            preserveWhitespace: true
        },
        {
            tag: 'tt',
            preserveWhitespace: true
        },
        {
            tag: 'span',
            preserveWhitespace: true,
            getAttrs: (domNode)=>{
                const dom = domNode;
                if (dom.style.whiteSpace === 'pre') return {};
                if (dom.style.fontFamily && dom.style.fontFamily.toLowerCase().indexOf('monospace') >= 0) return {};
                return false;
            }
        }
    ],
    toDOM () {
        return [
            'span',
            {
                class: 'code',
                spellcheck: 'false'
            }
        ];
    }
});
module.exports["code"] = $54c065d7a7f51a47$export$6565f9f03506010b;

});

parcelRegister("a2CNw", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

const $ec3416c06c5c5f64$var$emDOM = [
    'em'
];
const $ec3416c06c5c5f64$export$c63c6f932822f543 = (0, $6bXvD.em)({
    parseDOM: [
        {
            tag: 'i'
        },
        {
            tag: 'em'
        },
        {
            style: 'font-style=italic'
        }
    ],
    toDOM () {
        return $ec3416c06c5c5f64$var$emDOM;
    }
});
module.exports["em"] = $ec3416c06c5c5f64$export$c63c6f932822f543;

});

parcelRegister("i8M34", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

const $9c9cbe48b36f8a98$var$allowedSizes = [
    'small'
];
const $9c9cbe48b36f8a98$export$85e3c3ca0c6fb93 = (0, $6bXvD.fontSize)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-font-size',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const fontSize = dom.getAttribute('data-font-size');
                return {
                    fontSize: $9c9cbe48b36f8a98$var$allowedSizes.indexOf(fontSize || '') === -1 ? 'small' : fontSize
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-font-size',
                'data-font-size': mark.attrs.fontSize
            },
            0
        ];
    }
});
module.exports["fontSize"] = $9c9cbe48b36f8a98$export$85e3c3ca0c6fb93;

});

parcelRegister("9LRzA", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

const $a1d13e13079f7b64$export$480c699bd4ec0d86 = (0, $6bXvD.indentation)({
    parseDOM: [
        {
            tag: 'div.fabric-editor-indentation-mark',
            getAttrs (dom) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const level = +(dom.getAttribute('data-level') || '0');
                return {
                    level: level > 6 ? 6 : level < 1 ? false : level
                };
            }
        }
    ],
    toDOM (mark) {
        return [
            'div',
            {
                class: 'fabric-editor-block-mark fabric-editor-indentation-mark',
                'data-level': mark.attrs.level
            },
            0
        ];
    }
});
module.exports["indentation"] = $a1d13e13079f7b64$export$480c699bd4ec0d86;

});

parcelRegister("dd67x", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

const $87d565dbc18b0ec8$export$4899a95d70ec5056 = (0, $6bXvD.strike)({
    parseDOM: [
        {
            tag: 'strike'
        },
        {
            tag: 's'
        },
        {
            tag: 'del'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'line-through' && null
        }
    ],
    toDOM () {
        return [
            's'
        ];
    }
});
module.exports["strike"] = $87d565dbc18b0ec8$export$4899a95d70ec5056;

});

parcelRegister("bJD2s", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

const $e8e060adf253eaee$var$strongDOM = [
    'strong'
];
const $e8e060adf253eaee$export$59ae2c325a998f89 = (0, $6bXvD.strong)({
    parseDOM: [
        {
            tag: 'strong'
        },
        // This works around a Google Docs misbehavior where
        // pasted content will be inexplicably wrapped in `<b>`
        // tags with a font-weight normal.
        {
            tag: 'b',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                return element.style.fontWeight !== 'normal' && null;
            }
        },
        {
            tag: 'span',
            getAttrs (node) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const element = node;
                const { fontWeight: fontWeight } = element.style;
                return typeof fontWeight === 'string' && (fontWeight === 'bold' || fontWeight === 'bolder' || // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                /^(bold(er)?|[5-9]\d{2,})$/u.test(fontWeight)) && null;
            }
        }
    ],
    toDOM () {
        return $e8e060adf253eaee$var$strongDOM;
    }
});
module.exports["strong"] = $e8e060adf253eaee$export$59ae2c325a998f89;

});

parcelRegister("ip8b2", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

function $6baf791720ddaa1e$var$getAttrFromVerticalAlign(node) {
    if (node === 'sub') return {
        type: 'sub'
    };
    if (node === 'super') return {
        type: 'sup'
    };
    return false;
}
const $6baf791720ddaa1e$export$b3401ee80eb31041 = (0, $6bXvD.subsup)({
    parseDOM: [
        {
            tag: 'sub',
            attrs: {
                type: 'sub'
            }
        },
        {
            tag: 'sup',
            attrs: {
                type: 'sup'
            }
        },
        {
            // Special case for pasting from Google Docs
            // Google Docs uses vertical align to denote subscript and super script
            style: 'vertical-align=super',
            getAttrs: (node)=>$6baf791720ddaa1e$var$getAttrFromVerticalAlign(node)
        },
        {
            style: 'vertical-align=sub',
            getAttrs: (node)=>$6baf791720ddaa1e$var$getAttrFromVerticalAlign(node)
        }
    ],
    toDOM (mark) {
        return [
            mark.attrs.type
        ];
    }
});
module.exports["subsup"] = $6baf791720ddaa1e$export$b3401ee80eb31041;

});

parcelRegister("lSP4W", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");


var $hbMKq = parcelRequire("hbMKq");

const $1458033bf0a4dc2a$export$20af3dabbb5538df = (0, $6bXvD.typeAheadQuery)({
    parseDOM: [
        {
            tag: 'span[data-type-ahead-query]'
        }
    ],
    toDOM (node) {
        return [
            'span',
            {
                'data-type-ahead-query': 'true',
                'data-trigger': node.attrs.trigger,
                style: `color: ${(0, $hbMKq.B400)}`
            }
        ];
    }
});
module.exports["typeAheadQuery"] = $1458033bf0a4dc2a$export$20af3dabbb5538df;

});

parcelRegister("gKyPs", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

const $0cf5819a7a430471$export$425327af25286e5e = (0, $6bXvD.underline)({
    parseDOM: [
        {
            tag: 'u'
        },
        {
            style: 'text-decoration',
            getAttrs: (value)=>value === 'underline' && null
        }
    ],
    toDOM () {
        return [
            'u'
        ];
    }
});
module.exports["underline"] = $0cf5819a7a430471$export$425327af25286e5e;

});

parcelRegister("6eIpX", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

const $9308ab1546b9548e$export$30d78d5eb6719bb8 = (0, $6bXvD.unsupportedMark)({
    toDOM () {
        return [
            'span'
        ];
    }
});
module.exports["unsupportedMark"] = $9308ab1546b9548e$export$30d78d5eb6719bb8;

});

parcelRegister("8KqSY", function(module, exports) {

var $6bXvD = parcelRequire("6bXvD");

const $eb340f39f09125f8$export$a316dc07ff5182a2 = (0, $6bXvD.unsupportedNodeAttribute)({
    toDOM () {
        return [
            'span'
        ];
    }
});
module.exports["unsupportedNodeAttribute"] = $eb340f39f09125f8$export$a316dc07ff5182a2;

});

parcelRegister("aGTRk", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $2a3b1a535f85754c$var$getCommonAttributesFromDom = (dom)=>{
    const anchor = dom;
    const data = anchor.getAttribute('data-card-data');
    const datasource = anchor.getAttribute('data-datasource');
    return {
        data: data ? JSON.parse(data) : undefined,
        layout: datasource ? dom.getAttribute('data-layout') || undefined : undefined,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting
        width: Number(dom.getAttribute('data-width')) || undefined,
        datasource: datasource ? JSON.parse(datasource) : undefined
    };
};
const $2a3b1a535f85754c$export$c4c2f833baaebdb8 = (0, $17CG5.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$2a3b1a535f85754c$var$getCommonAttributesFromDom(dom)
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$2a3b1a535f85754c$var$getCommonAttributesFromDom(dom)
                };
            }
        }
    ],
    toDOM (node) {
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`
        };
        return [
            'a',
            attrs,
            node?.attrs?.url || ' '
        ];
    }
});
const $2a3b1a535f85754c$export$9894f24949f094e5 = (0, $17CG5.blockCard)({
    parseDOM: [
        {
            tag: 'a[data-block-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('href') || undefined,
                    ...$2a3b1a535f85754c$var$getCommonAttributesFromDom(dom),
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        },
        {
            tag: 'div[data-block-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                return {
                    url: anchor.getAttribute('data-card-url') || undefined,
                    ...$2a3b1a535f85754c$var$getCommonAttributesFromDom(dom),
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const { url: url } = node.attrs;
        const { data: data } = node.attrs;
        const { layout: layout, width: width, datasource: datasource } = node.attrs;
        const attrs = {
            'data-block-card': '',
            href: url || '',
            'data-card-data': data ? JSON.stringify(data) : '',
            'data-datasource': datasource ? JSON.stringify(datasource) : '',
            'data-layout': layout,
            'data-width': `${width}`,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'a',
            attrs,
            node?.attrs?.url || ' '
        ];
    }
});
module.exports["blockCard"] = $2a3b1a535f85754c$export$c4c2f833baaebdb8;
module.exports["blockCardWithLocalId"] = $2a3b1a535f85754c$export$9894f24949f094e5;

});

parcelRegister("5elS6", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $17CG5 = parcelRequire("17CG5");

const $6acaa25df6880d71$export$6d8b0ef52e2e6390 = (0, $17CG5.taskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $fO7hX.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
const $6acaa25df6880d71$export$16018c61064a18df = (0, $17CG5.blockTaskItem)({
    parseDOM: [
        {
            tag: 'div[data-task-is-block]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $fO7hX.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    state: dom.getAttribute('data-task-state') || 'TODO'
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-task-local-id': localId || 'local-task',
            'data-task-state': state || 'TODO',
            'data-task-is-block': 'true'
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["taskItem"] = $6acaa25df6880d71$export$6d8b0ef52e2e6390;
module.exports["blockTaskItem"] = $6acaa25df6880d71$export$16018c61064a18df;

});

parcelRegister("4sfnB", function(module, exports) {

var $jBO3b = parcelRequire("jBO3b");


var $17CG5 = parcelRequire("17CG5");

const $80587b5f5ab2cd6d$export$27903d543b563e39 = (0, $17CG5.bodiedExtension)({
    parseDOM: [
        {
            context: 'bodiedExtension//',
            tag: '[data-node-type="bodied-extension"]',
            skip: true
        },
        {
            tag: '[data-node-type="bodied-extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $jBO3b.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'bodied-extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs,
            0
        ];
    }
});
module.exports["bodiedExtension"] = $80587b5f5ab2cd6d$export$27903d543b563e39;

});

parcelRegister("3EiOU", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $fbad6598eda8bda2$export$e92c7e4302dd4371 = (0, $17CG5.bodiedSyncBlock)({
    parseDOM: [
        {
            tag: 'div[data-bodied-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $fO7hX.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-bodied-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs,
            0
        ];
    }
});
module.exports["bodiedSyncBlock"] = $fbad6598eda8bda2$export$e92c7e4302dd4371;

});

parcelRegister("ghpxT", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $17CG5 = parcelRequire("17CG5");

const $74aa963f1e2799b5$export$5f25a39efab3b58b = '.ak-ul';
const $74aa963f1e2799b5$export$a140c94e5ea26bee = (0, $17CG5.bulletList)({
    parseDOM: [
        {
            tag: 'ul'
        }
    ],
    toDOM () {
        const attrs = {
            class: $74aa963f1e2799b5$export$5f25a39efab3b58b.substr(1)
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
const $74aa963f1e2799b5$export$dfd406053b2bab40 = (0, $17CG5.bulletList)({
    parseDOM: [
        {
            tag: 'ul',
            getAttrs: ()=>{
                return {
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            class: $74aa963f1e2799b5$export$5f25a39efab3b58b.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ul',
            attrs,
            0
        ];
    }
});
module.exports["bulletListSelector"] = $74aa963f1e2799b5$export$5f25a39efab3b58b;
module.exports["bulletList"] = $74aa963f1e2799b5$export$a140c94e5ea26bee;
module.exports["bulletListWithLocalId"] = $74aa963f1e2799b5$export$dfd406053b2bab40;

});

parcelRegister("kRG5M", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $fb3e28fb71fcfb36$export$8e3c2dfdc4f0453d = (0, $17CG5.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]'
        }
    ],
    toDOM () {
        const attrs = {
            'data-caption': 'true'
        };
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
const $fb3e28fb71fcfb36$export$b5d01ee303c467aa = (0, $17CG5.caption)({
    parseDOM: [
        {
            tag: 'figcaption[data-caption]',
            getAttrs: ()=>{
                return {
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-caption': 'true'
        };
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        return [
            'figcaption',
            attrs,
            0
        ];
    }
});
module.exports["caption"] = $fb3e28fb71fcfb36$export$8e3c2dfdc4f0453d;
module.exports["captionWithLocalId"] = $fb3e28fb71fcfb36$export$b5d01ee303c467aa;

});

parcelRegister("fsHCc", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $6b33e394067ba0ca$var$name = 'confluenceJiraIssue';
const $6b33e394067ba0ca$export$daf889beb5092f95 = (0, $17CG5.confluenceJiraIssue)({
    parseDOM: [
        {
            tag: `span[data-node-type="${$6b33e394067ba0ca$var$name}"]`,
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    issueKey: dom.textContent,
                    macroId: dom.dataset && dom.dataset.macroId,
                    schemaVersion: dom.dataset && dom.dataset.schemaVersion,
                    server: dom.dataset && dom.dataset.server,
                    serverId: dom.dataset && dom.dataset.serverId
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': $6b33e394067ba0ca$var$name,
            'data-macro-id': node.attrs.macroId,
            'data-schema-version': node.attrs.schemaVersion,
            'data-server': node.attrs.server,
            'data-server-id': node.attrs.serverId,
            'data-jira-issue': node.attrs.issueKey
        };
        return [
            'span',
            attrs,
            node.attrs.issueKey
        ];
    }
});
module.exports["confluenceJiraIssue"] = $6b33e394067ba0ca$export$daf889beb5092f95;

});

parcelRegister("aZa28", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $1f7582ef8f061459$var$name = 'confluenceUnsupportedBlock';
const $1f7582ef8f061459$export$e6e4878f43c27cab = (0, $17CG5.confluenceUnsupportedBlock)({
    toDOM (node) {
        // NOTE: This node cannot be "contenteditable: false". If it's the only node in a document, PM throws an error because there's nowhere to put the cursor.
        const attrs = {
            'data-node-type': $1f7582ef8f061459$var$name,
            'data-confluence-unsupported': 'block',
            'data-confluence-unsupported-block-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$1f7582ef8f061459$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-block-cxhtml')
                };
            }
        }
    ]
});
module.exports["confluenceUnsupportedBlock"] = $1f7582ef8f061459$export$e6e4878f43c27cab;

});

parcelRegister("fnSCn", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $9bec0026cd396115$var$name = 'confluenceUnsupportedInline';
const $9bec0026cd396115$export$3e6d667072febc87 = (0, $17CG5.confluenceUnsupportedInline)({
    toDOM (node) {
        const attrs = {
            'data-node-type': $9bec0026cd396115$var$name,
            'data-confluence-unsupported': 'inline',
            'data-confluence-unsupported-inline-cxhtml': node.attrs['cxhtml']
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$9bec0026cd396115$var$name}"]`,
            getAttrs (dom) {
                return {
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    cxhtml: dom.getAttribute('data-confluence-unsupported-inline-cxhtml')
                };
            }
        }
    ]
});
module.exports["confluenceUnsupportedInline"] = $9bec0026cd396115$export$3e6d667072febc87;

});

parcelRegister("cAWza", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $ed74db0afb101e5d$export$324d90190a8b822a = (0, $17CG5.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp
        };
        return [
            'span',
            attrs
        ];
    }
});
const $ed74db0afb101e5d$export$a6a035390e3921b2 = (0, $17CG5.date)({
    parseDOM: [
        {
            tag: 'span[data-node-type="date"]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    timestamp: dom.getAttribute('data-timestamp'),
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'date',
            'data-timestamp': node.attrs.timestamp,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs
        ];
    }
});
module.exports["date"] = $ed74db0afb101e5d$export$324d90190a8b822a;
module.exports["dateWithLocalId"] = $ed74db0afb101e5d$export$a6a035390e3921b2;

});

parcelRegister("bpTLT", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $17CG5 = parcelRequire("17CG5");

const $bd3ac7b762a8c2d1$export$6959e16eeff859b4 = (0, $17CG5.decisionItem)({
    parseDOM: [
        {
            tag: 'li[data-decision-local-id]',
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by list-item we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: (dom)=>({
                    localId: (0, $fO7hX.uuid).generate(),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    state: dom.getAttribute('data-decision-state')
                })
        }
    ],
    toDOM (node) {
        const { localId: localId, state: state } = node.attrs;
        const attrs = {
            'data-decision-local-id': localId || 'local-decision',
            'data-decision-state': state
        };
        return [
            'li',
            attrs,
            0
        ];
    }
});
module.exports["decisionItem"] = $bd3ac7b762a8c2d1$export$6959e16eeff859b4;

});

parcelRegister("gClzS", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $17CG5 = parcelRequire("17CG5");

const $f5933e85f3817a59$var$name = 'decisionList';
const $f5933e85f3817a59$export$a5393ce68c2ff601 = `[data-node-type="${$f5933e85f3817a59$var$name}"]`;
const $f5933e85f3817a59$export$62d45a65fb43d95e = (0, $17CG5.decisionList)({
    parseDOM: [
        {
            tag: `ol${$f5933e85f3817a59$export$a5393ce68c2ff601}`,
            // Default priority is 50. We normally don't change this but since this node type is
            // also used by ordered-list we need to make sure that we run this parser first.
            priority: 100,
            getAttrs: ()=>({
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const attrs = {
            'data-node-type': $f5933e85f3817a59$var$name,
            'data-decision-list-local-id': localId || 'local-decision-list',
            style: 'list-style: none; padding-left: 0'
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
module.exports["decisionListSelector"] = $f5933e85f3817a59$export$a5393ce68c2ff601;
module.exports["decisionList"] = $f5933e85f3817a59$export$62d45a65fb43d95e;

});

parcelRegister("jRrsu", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $3a056466ee6273d1$export$2a111da947c407d2 = (0, $17CG5.doc)({});
module.exports["doc"] = $3a056466ee6273d1$export$2a111da947c407d2;

});

parcelRegister("cfHGv", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $cd279c01d51b9978$export$be4283d9a1cb1ff6 = (0, $17CG5.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight
        };
        return [
            'div',
            attrs
        ];
    }
});
const $cd279c01d51b9978$export$36734475a7f6fd3e = (0, $17CG5.embedCard)({
    parseDOM: [
        {
            tag: 'div[data-embed-card]',
            getAttrs: (dom)=>({
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    url: dom.getAttribute('data-card-url'),
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    layout: dom.getAttribute('data-layout') || 'center',
                    // eslint-disable-next-line @atlaskit/editor/no-as-casting
                    width: Number(dom.getAttribute('data-width')) || null,
                    originalWidth: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-width')) || null,
                    originalHeight: Number(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-card-original-height')) || null,
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { url: url, layout: layout, width: width, originalWidth: originalWidth, originalHeight: originalHeight } = node.attrs;
        const attrs = {
            'data-embed-card': '',
            'data-card-url': url,
            'data-layout': layout,
            'data-width': width,
            'data-original-width': originalWidth,
            'data-original-height': originalHeight,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs
        ];
    }
});
module.exports["embedCard"] = $cd279c01d51b9978$export$be4283d9a1cb1ff6;
module.exports["embedCardWithLocalId"] = $cd279c01d51b9978$export$36734475a7f6fd3e;

});

parcelRegister("bIZRt", function(module, exports) {

var $22kLH = parcelRequire("22kLH");


var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $196c7af9ca102c99$export$a19185d1233fc4b2 = (0, $17CG5.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            getAttrs: (dom)=>(0, $22kLH.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'))
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            getAttrs: (dom)=>(0, $22kLH.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'))
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.text.default
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $196c7af9ca102c99$export$ebb3b3c7a0ac9936 = (0, $17CG5.emoji)({
    parseDOM: [
        // Handle copy/paste beautiful panel from renderer />
        {
            tag: 'div.ak-editor-panel__icon span',
            ignore: true
        },
        {
            tag: 'span[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:emoticon />
        {
            tag: 'img[data-emoticon-name]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                const attrs = (0, $22kLH.acNameToEmoji)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                dom.getAttribute('data-emoticon-name'));
                return {
                    ...attrs,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        },
        // Handle copy/paste from old <ac:hipchat-emoticons />
        {
            tag: 'img[data-hipchat-emoticon]',
            getAttrs: (dom)=>{
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const attrs = (0, $22kLH.acShortcutToEmoji)(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                dom.getAttribute('data-hipchat-emoticon'));
                return {
                    ...attrs,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        },
        // Handle copy/paste from bitbucket's <img class="emoji" />
        {
            tag: 'img.emoji[data-emoji-short-name]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    shortName: dom.getAttribute('data-emoji-short-name') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.shortName.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    id: dom.getAttribute('data-emoji-id') || $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.id.default,
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    text: // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-emoji-text') || $196c7af9ca102c99$export$a19185d1233fc4b2.attrs.text.default,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const { shortName: shortName, id: id, text: text } = node.attrs;
        const attrs = {
            'data-emoji-short-name': shortName,
            'data-emoji-id': id,
            'data-emoji-text': text,
            contenteditable: 'false',
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
module.exports["emoji"] = $196c7af9ca102c99$export$a19185d1233fc4b2;
module.exports["emojiWithLocalId"] = $196c7af9ca102c99$export$ebb3b3c7a0ac9936;

});

parcelRegister("22kLH", function(module, exports) {
// Default emoji id for Confluence glyphs that has no match to Fabric Emoji
const $685945defd0e3794$var$DEFAULT_EMOJI_ID = '2b50';
// Default ac:name for emoticons as a fallback is `blue-star`
const $685945defd0e3794$var$DEFAULT_EMOJI_ACNAME = 'blue-star';
// ac:hipchat-emoticon prefix when converting to Emoji ID
const $685945defd0e3794$var$HC_EMOTICON_PREFIX = 'atlassian-';
/**
 * Confluence glyphs ac:name of <ac:emoticon /> map to new emojis
 * {
 *   [ac:name] : ['emoji-id', 'emoji-shortName', 'emoji-fallback']
 *   ...
 * }
 * Glyphs that do not map to Fabric Emoji
 * will be mapped to Emoji Id '2b50' (:star:) with preserving ac:name as shortName attribute;
 */ const $685945defd0e3794$var$acNameToEmojiMap = {
    smile: [
        '1f642',
        ':slight_smile:',
        '\uD83D\uDE42'
    ],
    sad: [
        '1f641',
        ':slight_frown:',
        '\uD83D\uDE41'
    ],
    cheeky: [
        '1f61b',
        ':stuck_out_tongue:',
        '\uD83D\uDE1B'
    ],
    laugh: [
        '1f600',
        ':grinning:',
        '\uD83D\uDE00'
    ],
    wink: [
        '1f609',
        ':wink:',
        '\uD83D\uDE09'
    ],
    information: [
        '2139',
        ':information_source:',
        '\u2139'
    ],
    tick: [
        '2705',
        ':white_check_mark:',
        '\u2705'
    ],
    cross: [
        '274c',
        ':x:',
        '\u274C'
    ],
    warning: [
        '26a0',
        ':warning:',
        '\u26A0'
    ],
    plus: [
        '2795',
        ':heavy_plus_sign:',
        '\u2795'
    ],
    minus: [
        '2796',
        ':heavy_minus_sign:',
        '\u2796'
    ],
    question: [
        '2753',
        ':question:',
        '\u003F'
    ],
    'thumbs-up': [
        '1f44d',
        ':thumbsup:',
        '\uD83D\uDC4D'
    ],
    'thumbs-down': [
        '1f44e',
        ':thumbsdown:',
        '\uD83D\uDC4E'
    ],
    'light-on': [
        '1f4a1',
        ':bulb:',
        '\uD83D\uDCA1'
    ],
    'yellow-star': [
        '2b50',
        ':star:',
        '\uD83D\uDC9B'
    ],
    'light-off': [
        '1f6ab',
        ':no_entry_sign:',
        '\uD83D\uDEAB'
    ],
    'red-star': [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'green-star': [
        '1f49a',
        ':green_heart:',
        '\uD83D\uDC9A'
    ],
    'blue-star': [
        '1f499',
        ':blue_heart:',
        '\uD83D\uDC99'
    ],
    heart: [
        '2764',
        ':heart:',
        '\u2764\uFE0F'
    ],
    'broken-heart': [
        '1f494',
        ':broken_heart:',
        '\uD83D\uDC94'
    ]
};
function $685945defd0e3794$export$f61e93bda2a8b420(acName) {
    const emojiData = $685945defd0e3794$var$acNameToEmojiMap[acName];
    return emojiData ? {
        id: emojiData[0],
        shortName: emojiData[1],
        text: emojiData[2]
    } : {
        id: $685945defd0e3794$var$DEFAULT_EMOJI_ID,
        shortName: `:${acName}:`,
        text: ''
    };
}
function $685945defd0e3794$export$bc94e44ec0e7bd82(emojiId) {
    const filterEmojis = (acName)=>$685945defd0e3794$var$acNameToEmojiMap[acName] ? $685945defd0e3794$var$acNameToEmojiMap[acName][0] === emojiId : false;
    return Object.keys($685945defd0e3794$var$acNameToEmojiMap).filter(filterEmojis)[0];
}
function $685945defd0e3794$export$441f8b58f5790a68(hipchatEmoticonShortName) {
    return {
        id: `${$685945defd0e3794$var$HC_EMOTICON_PREFIX}${hipchatEmoticonShortName}`,
        shortName: `:${hipchatEmoticonShortName}:`,
        text: ''
    };
}
function $685945defd0e3794$var$getAcNameFromShortName(shortName) {
    return shortName.slice(shortName[0] === ':' ? 1 : 0, shortName[shortName.length - 1] === ':' ? -1 : shortName.length);
}
function $685945defd0e3794$export$880a2465992fbbe({ id: id, shortName: shortName }) {
    if ($685945defd0e3794$var$DEFAULT_EMOJI_ID === id) {
        const possibleName = $685945defd0e3794$var$getAcNameFromShortName(shortName);
        if (possibleName in $685945defd0e3794$var$acNameToEmojiMap) return possibleName;
    }
    return $685945defd0e3794$export$bc94e44ec0e7bd82(id) || $685945defd0e3794$var$DEFAULT_EMOJI_ACNAME;
}
module.exports["acNameToEmoji"] = $685945defd0e3794$export$f61e93bda2a8b420;
module.exports["acShortcutToEmoji"] = $685945defd0e3794$export$441f8b58f5790a68;
module.exports["getEmojiAcName"] = $685945defd0e3794$export$880a2465992fbbe;

});

parcelRegister("iIGXo", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $20e9983ce6d2d83c$var$nodeSpecOptions = {
    parseDOM: [
        {
            tag: 'blockquote'
        }
    ],
    toDOM () {
        return [
            'blockquote',
            0
        ];
    }
};
const $20e9983ce6d2d83c$export$67dc04e652a298ca = (0, $17CG5.blockquoteLegacy)($20e9983ce6d2d83c$var$nodeSpecOptions);
const $20e9983ce6d2d83c$export$70a64939da3e8455 = (0, $17CG5.blockquote)($20e9983ce6d2d83c$var$nodeSpecOptions);
const $20e9983ce6d2d83c$var$nodeSpecOptionsWithLocalId = {
    parseDOM: [
        {
            tag: 'blockquote',
            getAttrs: ()=>{
                return {
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'blockquote',
            {
                'data-local-id': node?.attrs?.localId || undefined
            },
            0
        ];
    }
};
const $20e9983ce6d2d83c$export$950ebf43f3364a0f = (0, $17CG5.blockquote)($20e9983ce6d2d83c$var$nodeSpecOptionsWithLocalId);
module.exports["blockquote"] = $20e9983ce6d2d83c$export$67dc04e652a298ca;
module.exports["extendedBlockquote"] = $20e9983ce6d2d83c$export$70a64939da3e8455;
module.exports["extendedBlockquoteWithLocalId"] = $20e9983ce6d2d83c$export$950ebf43f3364a0f;

});

parcelRegister("dGKc1", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

var $1126a8242393e8d2$export$969277cf61e5a7aa = /*#__PURE__*/ function(PanelType) {
    PanelType["INFO"] = "info";
    PanelType["NOTE"] = "note";
    PanelType["TIP"] = "tip";
    PanelType["WARNING"] = "warning";
    PanelType["ERROR"] = "error";
    PanelType["SUCCESS"] = "success";
    PanelType["CUSTOM"] = "custom";
    return PanelType;
}({});
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $1126a8242393e8d2$var$getDomAttrs = (nodeAttrs)=>{
    const attrs = {
        'data-panel-type': nodeAttrs.panelType,
        'data-panel-icon': nodeAttrs.panelIcon,
        'data-panel-icon-id': nodeAttrs.panelIconId,
        'data-panel-icon-text': nodeAttrs.panelIconText,
        'data-panel-color': nodeAttrs.panelColor,
        'data-local-id': nodeAttrs?.localId || undefined
    };
    return attrs;
};
const $1126a8242393e8d2$var$getParseDOMAttrs = (allowCustomPanel, dom, generateLocalId)=>{
    let parseDOMAttrs = {
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelType: dom.getAttribute('data-panel-type')
    };
    if (generateLocalId) parseDOMAttrs.localId = (0, $fO7hX.uuid).generate();
    if (allowCustomPanel) parseDOMAttrs = {
        ...parseDOMAttrs,
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIcon: dom.getAttribute('data-panel-icon'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconId: dom.getAttribute('data-panel-icon-id'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelIconText: dom.getAttribute('data-panel-icon-text'),
        // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
        panelColor: dom.getAttribute('data-panel-color')
    };
    else parseDOMAttrs.panelType = parseDOMAttrs.panelType === "custom" ? "info" : parseDOMAttrs.panelType;
    return parseDOMAttrs;
};
const $1126a8242393e8d2$var$createPanelNodeSpecOptions = (allowCustomPanel, generateLocalId)=>({
        parseDOM: [
            {
                tag: 'div[data-panel-type]',
                getAttrs: (dom)=>$1126a8242393e8d2$var$getParseDOMAttrs(allowCustomPanel, dom, generateLocalId)
            }
        ],
        toDOM (node) {
            const attrs = $1126a8242393e8d2$var$getDomAttrs(node.attrs);
            const contentAttrs = {
                'data-panel-content': 'true'
            };
            return [
                'div',
                attrs,
                [
                    'div',
                    contentAttrs,
                    0
                ]
            ];
        }
    });
const $1126a8242393e8d2$export$ce20b13564211141 = (allowCustomPanel)=>(0, $17CG5.panel)($1126a8242393e8d2$var$createPanelNodeSpecOptions(allowCustomPanel));
const $1126a8242393e8d2$export$855c3c67c9c9ebaf = (allowCustomPanel)=>(0, $17CG5.panel)($1126a8242393e8d2$var$createPanelNodeSpecOptions(allowCustomPanel, true));
module.exports["PanelType"] = $1126a8242393e8d2$export$969277cf61e5a7aa;
module.exports["extendedPanel"] = $1126a8242393e8d2$export$ce20b13564211141;
module.exports["extendedPanelWithLocalId"] = $1126a8242393e8d2$export$855c3c67c9c9ebaf;

});

parcelRegister("2xxP6", function(module, exports) {

var $jBO3b = parcelRequire("jBO3b");


var $17CG5 = parcelRequire("17CG5");

const $b705286cfb34fe7d$export$1b45514b112dd749 = (0, $17CG5.extension)({
    parseDOM: [
        {
            tag: '[data-node-type="extension"]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $jBO3b.getExtensionAttrs)(domNode)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'extension',
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-layout': node.attrs.layout,
            'data-local-id:': node.attrs.localId
        };
        return [
            'div',
            attrs
        ];
    }
});
module.exports["extension"] = $b705286cfb34fe7d$export$1b45514b112dd749;

});

parcelRegister("aFNbc", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $49611fc81cf90007$export$371da9dd35aba193 = (0, $17CG5.hardBreak)({
    parseDOM: [
        {
            tag: 'br'
        }
    ],
    toDOM () {
        return [
            'br'
        ];
    }
});
module.exports["hardBreak"] = $49611fc81cf90007$export$371da9dd35aba193;

});

parcelRegister("j0UBv", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $1f52fbaac72bad98$var$getAttrs = (level)=>(domNode)=>({
            level: level,
            localId: // eslint-disable-next-line @atlaskit/editor/no-as-casting
            domNode.getAttribute('data-local-id') || null
        });
const $1f52fbaac72bad98$export$46e4a324ac90507f = (0, $17CG5.heading)({
    parseDOM: [
        {
            tag: 'h1',
            getAttrs: $1f52fbaac72bad98$var$getAttrs(1)
        },
        {
            tag: 'h2',
            getAttrs: $1f52fbaac72bad98$var$getAttrs(2)
        },
        {
            tag: 'h3',
            getAttrs: $1f52fbaac72bad98$var$getAttrs(3)
        },
        {
            tag: 'h4',
            getAttrs: $1f52fbaac72bad98$var$getAttrs(4)
        },
        {
            tag: 'h5',
            getAttrs: $1f52fbaac72bad98$var$getAttrs(5)
        },
        {
            tag: 'h6',
            getAttrs: $1f52fbaac72bad98$var$getAttrs(6)
        }
    ],
    toDOM (node) {
        const { level: level, localId: localId } = node.attrs;
        const name = 'h' + level;
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});
module.exports["heading"] = $1f52fbaac72bad98$export$46e4a324ac90507f;

});

parcelRegister("dupND", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $67fdf088b22eb4f2$export$5c452ff88e35e47d = (0, $17CG5.image)({
    parseDOM: [
        {
            tag: 'img[src^="data:image/"]',
            ignore: true
        },
        {
            tag: 'img[src]',
            getAttrs (domNode) {
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    src: dom.getAttribute('src'),
                    alt: dom.getAttribute('alt'),
                    title: dom.getAttribute('title')
                };
            }
        }
    ],
    toDOM (node) {
        return [
            'img',
            node.attrs
        ];
    }
});
module.exports["image"] = $67fdf088b22eb4f2$export$5c452ff88e35e47d;

});

parcelRegister("aqHdD", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $6403f3d90e517327$export$cbf8224b64e0d942 = (0, $17CG5.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : ''
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
const $6403f3d90e517327$export$7ed775fc743eadd1 = (0, $17CG5.inlineCard)({
    parseDOM: [
        {
            tag: 'a[data-inline-card], span[data-inline-card]',
            // bump priority higher than hyperlink
            priority: 100,
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                /* Support attrs from Editor and Renderer */ return {
                    url: anchor.getAttribute('href') || anchor.getAttribute('data-card-url') || null,
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        },
        // for renderer
        {
            tag: 'div[data-inline-card]',
            getAttrs: (dom)=>{
                const anchor = dom;
                const data = anchor.getAttribute('data-card-data');
                return {
                    url: anchor.getAttribute('data-card-url'),
                    data: data ? JSON.parse(data) : null,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-inline-card': '',
            href: node.attrs.url || '',
            'data-card-data': node.attrs.data ? JSON.stringify(node.attrs.data) : '',
            'data-local-id': node?.attrs?.localId || undefined
        };
        if (node.attrs.url) return [
            'a',
            attrs,
            node.attrs.url
        ];
        else return [
            'a',
            attrs
        ];
    }
});
module.exports["inlineCard"] = $6403f3d90e517327$export$cbf8224b64e0d942;
module.exports["inlineCardWithLocalId"] = $6403f3d90e517327$export$7ed775fc743eadd1;

});

parcelRegister("u6ZFj", function(module, exports) {

var $jBO3b = parcelRequire("jBO3b");


var $17CG5 = parcelRequire("17CG5");

const $f72dea6b70899c68$export$16b353b2649bd8d9 = (0, $17CG5.inlineExtensionWithMarks)({
    parseDOM: [
        {
            tag: 'span[data-extension-type]',
            // eslint-disable-next-line @atlaskit/editor/no-as-casting
            getAttrs: (domNode)=>(0, $jBO3b.getExtensionAttrs)(domNode, true)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-extension-type': node.attrs.extensionType,
            'data-extension-key': node.attrs.extensionKey,
            'data-text': node.attrs.text,
            'data-parameters': JSON.stringify(node.attrs.parameters),
            'data-local-id:': node.attrs.localId,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs
        ];
    }
});
module.exports["inlineExtension"] = $f72dea6b70899c68$export$16b353b2649bd8d9;

});

parcelRegister("lifsC", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $ddc064bb105a3ad2$export$ab76e7c03cd6f650 = (0, $17CG5.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
const $ddc064bb105a3ad2$export$b2e27d292505bac2 = (0, $17CG5.layoutColumn)({
    parseDOM: [
        {
            context: 'layoutColumn//',
            tag: 'div[data-layout-column]',
            skip: true
        },
        {
            tag: 'div[data-layout-column]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                return {
                    width: Number(dom.getAttribute('data-column-width')) || undefined,
                    localId: (0, $fO7hX.uuid).generate()
                };
            }
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-layout-column': 'true'
        };
        if (node?.attrs?.localId !== undefined) attrs['data-local-id'] = node.attrs.localId;
        const { width: width } = node.attrs;
        if (width) {
            attrs['style'] = `flex-basis: ${width}%`;
            attrs['data-column-width'] = `${width}`;
        }
        // We need to apply a attribute to the inner most child to help
        // ProseMirror identify its boundaries better.
        const contentAttrs = {
            'data-layout-content': 'true'
        };
        return [
            'div',
            attrs,
            [
                'div',
                contentAttrs,
                0
            ]
        ];
    }
});
module.exports["layoutColumn"] = $ddc064bb105a3ad2$export$ab76e7c03cd6f650;
module.exports["layoutColumnWithLocalId"] = $ddc064bb105a3ad2$export$b2e27d292505bac2;

});

parcelRegister("6xrFZ", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $696718d4405613f6$export$2855e964765eac9 = (0, $17CG5.mediaGroup)({
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]'
        },
        {
            tag: 'div[class="MediaGroup"]'
        }
    ],
    toDOM () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup'
            },
            0
        ];
    }
});
module.exports["mediaGroup"] = $696718d4405613f6$export$2855e964765eac9;

});

parcelRegister("bTc4a", function(module, exports) {

var $kZ3vg = parcelRequire("kZ3vg");


var $fO7hX = parcelRequire("fO7hX");


var $17CG5 = parcelRequire("17CG5");

const $6c95f5cd21321c9f$export$38bab695e3f720f1 = (0, $kZ3vg.createMediaSpec)((0, $17CG5.mediaInline)({}).attrs, true);
const $6c95f5cd21321c9f$export$aea8e9c496505c61 = (0, $kZ3vg.createMediaSpec)({
    ...(0, $17CG5.mediaInline)({}).attrs,
    localId: {
        default: (0, $fO7hX.uuid).generate()
    }
}, true, true);
module.exports["mediaInline"] = $6c95f5cd21321c9f$export$38bab695e3f720f1;

});

parcelRegister("iw2ID", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

function $c6d61f0b18df09da$var$getExpandAttrs(domNode, generateLocalId) {
    // eslint-disable-next-line @atlaskit/editor/no-as-casting
    const dom = domNode;
    return {
        title: dom.getAttribute('data-title'),
        __expanded: true,
        localId: generateLocalId ? (0, $fO7hX.uuid).generate() : undefined
    };
}
const $c6d61f0b18df09da$var$nestedExpandFactoryOptions = {
    parseDOM: [
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$c6d61f0b18df09da$var$getExpandAttrs(domNode, false)
        },
        {
            tag: '[data-node-type="nestedExpand"] button',
            ignore: true
        },
        {
            tag: '[data-node-type="expand"] button',
            ignore: true
        },
        {
            tag: 'div[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$c6d61f0b18df09da$var$getExpandAttrs(domNode, false)
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'nestedExpand',
            'data-title': node.attrs.title,
            'data-expanded': node.attrs.__expanded,
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'div',
            attrs,
            0
        ];
    }
};
const $c6d61f0b18df09da$export$63cadbf5f4296627 = (0, $17CG5.nestedExpand)($c6d61f0b18df09da$var$nestedExpandFactoryOptions);
const $c6d61f0b18df09da$export$b854197485aa1fa0 = (0, $17CG5.nestedExpand)({
    ...$c6d61f0b18df09da$var$nestedExpandFactoryOptions,
    parseDOM: [
        ...$c6d61f0b18df09da$var$nestedExpandFactoryOptions.parseDOM || [],
        {
            context: 'nestedExpand//',
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$c6d61f0b18df09da$var$getExpandAttrs(domNode, true)
        },
        {
            tag: '[data-node-type="nestedExpand"]',
            getAttrs: (domNode)=>$c6d61f0b18df09da$var$getExpandAttrs(domNode, true)
        }
    ]
});
module.exports["nestedExpand"] = $c6d61f0b18df09da$export$63cadbf5f4296627;
module.exports["nestedExpandWithLocalId"] = $c6d61f0b18df09da$export$b854197485aa1fa0;

});

parcelRegister("fGuiW", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $17CG5 = parcelRequire("17CG5");

const $73173576a5a17f08$export$4e7125c7ff595be5 = '.ak-ol';
const $73173576a5a17f08$export$a5dc81035676e7a = (0, $17CG5.orderedList)({
    parseDOM: [
        {
            tag: 'ol'
        }
    ],
    toDOM () {
        const attrs = {
            class: $73173576a5a17f08$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $73173576a5a17f08$export$8157adc5747ec436 = (0, $17CG5.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: ()=>({
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            class: $73173576a5a17f08$export$4e7125c7ff595be5.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
// resolve "start" to a safe, 0+ integer, otherwise return undefined
// Note: Any changes to this function should also be made to "resolveOrder"
// in packages/editor/editor-common/src/utils/list.ts
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $73173576a5a17f08$var$resolveStart = (start)=>{
    const num = Number(start);
    if (Number.isNaN(num)) return;
    if (num < 0) return;
    return Math.floor(Math.max(num, 0));
};
const $73173576a5a17f08$export$b9ab759e8298198f = (0, $17CG5.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                if (startDOMAttr) {
                    const start = $73173576a5a17f08$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start
                    };
                }
                return null;
            }
        }
    ],
    toDOM (node) {
        const start = $73173576a5a17f08$var$resolveStart(node?.attrs?.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $73173576a5a17f08$export$4e7125c7ff595be5.substr(1)
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
const $73173576a5a17f08$export$2ea3505d41d7525d = (0, $17CG5.orderedList)({
    parseDOM: [
        {
            tag: 'ol',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const startDOMAttr = dom.getAttribute('start');
                const localId = (0, $fO7hX.uuid).generate();
                if (startDOMAttr) {
                    const start = $73173576a5a17f08$var$resolveStart(startDOMAttr);
                    if (typeof start === 'number') return {
                        order: start,
                        localId: localId
                    };
                }
                return {
                    localId: localId
                };
            }
        }
    ],
    toDOM (node) {
        const start = $73173576a5a17f08$var$resolveStart(node?.attrs?.order);
        const attrs = {
            start: typeof start === 'number' ? String(start) : undefined,
            class: $73173576a5a17f08$export$4e7125c7ff595be5.substr(1),
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'ol',
            attrs,
            0
        ];
    }
});
module.exports["orderedListSelector"] = $73173576a5a17f08$export$4e7125c7ff595be5;
module.exports["orderedList"] = $73173576a5a17f08$export$a5dc81035676e7a;
module.exports["orderedListWithLocalId"] = $73173576a5a17f08$export$8157adc5747ec436;
module.exports["orderedListWithOrder"] = $73173576a5a17f08$export$b9ab759e8298198f;
module.exports["orderedListWithOrderAndLocalId"] = $73173576a5a17f08$export$2ea3505d41d7525d;

});

parcelRegister("eK2Ov", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $e2de7763a5c47a27$export$9c206ddddb32a9b = (0, $17CG5.paragraph)({
    parseDOM: [
        {
            tag: 'p',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || $e2de7763a5c47a27$export$9c206ddddb32a9b.attrs?.localId?.default
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId } = node.attrs;
        const name = 'p';
        const attrs = localId !== undefined && localId !== null ? [
            {
                'data-local-id': localId
            }
        ] : [];
        return [
            name,
            ...attrs,
            0
        ];
    }
});
module.exports["paragraph"] = $e2de7763a5c47a27$export$9c206ddddb32a9b;

});

parcelRegister("jEypY", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $4a9910d6a5046cce$export$c7187bbd1a7a9244 = (0, $17CG5.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $4a9910d6a5046cce$export$c7187bbd1a7a9244.attrs.text.default
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
const $4a9910d6a5046cce$export$6205248609a8f7a0 = (0, $17CG5.placeholder)({
    parseDOM: [
        {
            tag: 'span[data-placeholder]',
            getAttrs: (dom)=>({
                    text: // eslint-disable-next-line @atlaskit/editor/no-as-casting, @typescript-eslint/no-non-null-assertion
                    dom.getAttribute('data-placeholder') || // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    $4a9910d6a5046cce$export$c7187bbd1a7a9244.attrs.text.default,
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        const { text: text } = node.attrs;
        const attrs = {
            'data-placeholder': text,
            // Needs to be edtiable for mobile to not close keyboard
            contenteditable: 'true',
            'data-local-id': node?.attrs?.localId || undefined
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
module.exports["placeholder"] = $4a9910d6a5046cce$export$c7187bbd1a7a9244;
module.exports["placeholderWithLocalId"] = $4a9910d6a5046cce$export$6205248609a8f7a0;

});

parcelRegister("bLhD4", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $019006392eb14fb0$var$hrDOM = [
    'hr'
];
const $019006392eb14fb0$export$fbeb3a3956e8a3c7 = (0, $17CG5.rule)({
    parseDOM: [
        {
            tag: 'hr'
        }
    ],
    toDOM () {
        return $019006392eb14fb0$var$hrDOM;
    }
});
const $019006392eb14fb0$export$bf3ef6fb6ad90e7 = (0, $17CG5.rule)({
    parseDOM: [
        {
            tag: 'hr',
            getAttrs: ()=>({
                    localId: (0, $fO7hX.uuid).generate()
                })
        }
    ],
    toDOM (node) {
        return [
            'hr',
            {
                'data-local-id': node?.attrs?.localId || undefined
            }
        ];
    }
});
module.exports["rule"] = $019006392eb14fb0$export$fbeb3a3956e8a3c7;
module.exports["ruleWithLocalId"] = $019006392eb14fb0$export$bf3ef6fb6ad90e7;

});

parcelRegister("f4dR3", function(module, exports) {

var $fO7hX = parcelRequire("fO7hX");


var $17CG5 = parcelRequire("17CG5");


var $1oCLl = parcelRequire("1oCLl");

const $0c9ba9ee8dd9814c$export$471f7ae5c4103ae1 = (0, $17CG5.status)({
    parseDOM: [
        {
            tag: 'span[data-node-type="status"]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                // @ts-ignore TS1501: This regular expression flag is only available when targeting 'es6' or later.
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                const textContent = dom.textContent.replace(/\n/u, '').trim();
                // Prefer data-text attribute over textContent
                // When NodeView DOM is copied, inner text content may not be preserved
                const text = (0, $1oCLl.expValEquals)('platform_editor_copy_paste_issue_fix', 'isEnabled', true) ? dom.getAttribute('data-text') || textContent : textContent;
                return {
                    text: text,
                    color: dom.getAttribute('data-color'),
                    localId: (0, $fO7hX.uuid).generate(),
                    style: dom.getAttribute('data-style')
                };
            }
        }
    ],
    toDOM (node) {
        const { text: text, color: color, localId: localId, style: style } = node.attrs;
        const attrs = {
            'data-node-type': 'status',
            'data-color': color,
            'data-local-id': localId,
            'data-style': style,
            contenteditable: 'false'
        };
        return [
            'span',
            attrs,
            text
        ];
    }
});
module.exports["status"] = $0c9ba9ee8dd9814c$export$471f7ae5c4103ae1;

});

parcelRegister("8WAFY", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");


var $fO7hX = parcelRequire("fO7hX");

const $b37e2e1d23246f60$export$faab0ca9701d7048 = (0, $17CG5.syncBlock)({
    parseDOM: [
        {
            tag: 'div[data-sync-block]',
            getAttrs: (domNode)=>{
                // eslint-disable-next-line @atlaskit/editor/no-as-casting
                const dom = domNode;
                const attrs = {
                    localId: dom.getAttribute('data-local-id') || (0, $fO7hX.uuid).generate(),
                    resourceId: dom.getAttribute('data-resource-id') || ''
                };
                return attrs;
            }
        }
    ],
    toDOM (node) {
        const { localId: localId, resourceId: resourceId } = node.attrs;
        const name = 'div';
        const attrs = {
            'data-sync-block': '',
            'data-local-id': localId,
            'data-resource-id': resourceId
        };
        return [
            name,
            attrs
        ];
    }
});
module.exports["syncBlock"] = $b37e2e1d23246f60$export$faab0ca9701d7048;

});

parcelRegister("bSuKu", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $98f333b022879203$export$6f093cfa640b7166 = (0, $17CG5.text)({
    toDebugString: ()=>'text_node'
});
module.exports["text"] = $98f333b022879203$export$6f093cfa640b7166;

});

parcelRegister("h3652", function(module, exports) {
$parcel$export(module.exports, "default", () => $75a8bf7104e5241c$export$2e2bcd8739ae039);
const $75a8bf7104e5241c$var$name = 'unknownBlock';
var $75a8bf7104e5241c$export$2e2bcd8739ae039 = {
    group: 'block',
    content: 'inline+',
    marks: '_',
    toDOM () {
        return [
            'div',
            {
                'data-node-type': $75a8bf7104e5241c$var$name
            },
            0
        ];
    },
    parseDOM: [
        {
            tag: `div[data-node-type="${$75a8bf7104e5241c$var$name}"]`
        }
    ]
};

});

parcelRegister("iSXnW", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $54e09dc740ba146f$export$44b79b0979d0f0f7 = (0, $17CG5.unsupportedBlock)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedBlock"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedBlock',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'div',
            attrs,
            'Unsupported content'
        ];
    }
});
module.exports["unsupportedBlock"] = $54e09dc740ba146f$export$44b79b0979d0f0f7;

});

parcelRegister("cre7m", function(module, exports) {

var $17CG5 = parcelRequire("17CG5");

const $eb7c3a9e9fc769a1$export$310ebe0d80122e9b = (0, $17CG5.unsupportedInline)({
    parseDOM: [
        {
            tag: '[data-node-type="unsupportedInline"]',
            getAttrs: (dom)=>({
                    originalValue: JSON.parse(// eslint-disable-next-line @atlaskit/editor/no-as-casting
                    dom.getAttribute('data-original-value') || '{}')
                })
        }
    ],
    toDOM (node) {
        const attrs = {
            'data-node-type': 'unsupportedInline',
            'data-original-value': JSON.stringify(node.attrs.originalValue)
        };
        return [
            'span',
            attrs,
            'Unsupported content'
        ];
    }
});
module.exports["unsupportedInline"] = $eb7c3a9e9fc769a1$export$310ebe0d80122e9b;

});

parcelRegister("dDZcC", function(module, exports) {

var $6jPem = parcelRequire("6jPem");


var $9gh1o = parcelRequire("9gh1o");

/** NodeNestingTransformError  */ class $efc09fde1d3b7fcb$export$3d8e8d2182f13924 extends Error {
    /**
   * @param message - Error message - Do not use any UGC in this message
   */ constructor(message){
        super(message);
        this.name = 'NodeNestingTransformError';
    }
}


const $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_TYPE = 'com.atlassian.confluence.migration', $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_KEY = 'nested-table';
const $af3cc9663dee118d$export$f45e7335ec874bfe = (extensionNode)=>extensionNode.attrs?.extensionType === $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_TYPE && extensionNode.attrs?.extensionKey === $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_KEY;
const $af3cc9663dee118d$var$transformNestedTableExtension = (nestedTableExtension)=>{
    // No content - drop the extension node
    if (!nestedTableExtension.attrs?.parameters?.adf) return false;
    try {
        const adf = JSON.parse(nestedTableExtension.attrs?.parameters?.adf);
        if (!adf.content || adf.content.length === 0) return false;
        return adf.content[0];
    } catch (e) {
        throw new (0, $efc09fde1d3b7fcb$export$3d8e8d2182f13924)('Failed to parse nested table content');
    }
};
const $af3cc9663dee118d$export$18544d0b5f43e4a1 = (adf)=>{
    let isTransformed = false;
    const transformedAdf = (0, $6jPem.traverse)(adf, {
        extension: (node)=>{
            if ($af3cc9663dee118d$export$f45e7335ec874bfe(node)) {
                isTransformed = true;
                return $af3cc9663dee118d$var$transformNestedTableExtension(node);
            }
            return;
        }
    });
    return {
        transformedAdf: transformedAdf,
        isTransformed: isTransformed
    };
};
const $af3cc9663dee118d$export$8a334a7d9fe120ec = (tableCellNode)=>{
    try {
        return {
            ...tableCellNode,
            content: tableCellNode.content?.map((childNode)=>{
                // wrap nested table in an extension node
                if (childNode?.type === 'table') return (0, $9gh1o.extension)({
                    extensionType: $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_TYPE,
                    extensionKey: $af3cc9663dee118d$var$NESTED_TABLE_EXTENSION_KEY,
                    parameters: {
                        adf: JSON.stringify({
                            type: 'doc',
                            version: 1,
                            content: [
                                childNode
                            ]
                        })
                    }
                });
                return childNode;
            })
        };
    } catch (e) {
        throw new (0, $efc09fde1d3b7fcb$export$3d8e8d2182f13924)('Failed to encode nested table node');
    }
};
module.exports["isNestedTableExtension"] = $af3cc9663dee118d$export$f45e7335ec874bfe;
module.exports["transformNestedTablesIncomingDocument"] = $af3cc9663dee118d$export$18544d0b5f43e4a1;
module.exports["transformNestedTableNodeOutgoingDocument"] = $af3cc9663dee118d$export$8a334a7d9fe120ec;

});

parcelRegister("6jPem", function(module, exports) {
function $a49fd3f268c80639$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $a49fd3f268c80639$export$df3f009e3d155b20(adf, visitors) {
    if (!$a49fd3f268c80639$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $a49fd3f268c80639$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $a49fd3f268c80639$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $a49fd3f268c80639$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}
module.exports["traverse"] = $a49fd3f268c80639$export$df3f009e3d155b20;

});

parcelRegister("9gh1o", function(module, exports) {
const $0b52ddd0ebfb8ca2$export$1b45514b112dd749 = (attrs)=>({
        type: 'extension',
        attrs: attrs
    });
module.exports["extension"] = $0b52ddd0ebfb8ca2$export$1b45514b112dd749;

});

parcelRegister("dZ8uq", function(module, exports) {

var $8Qxmq = parcelRequire("8Qxmq");

function $9f9b36b6d620d73c$export$63eebf86443a0a61(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue = null) {
    return (0, $8Qxmq.expValEqualsInternal)(experimentName, experimentParam, experimentExpectedValue, experimentDefaultValue, false);
}
module.exports["expValEqualsNoExposure"] = $9f9b36b6d620d73c$export$63eebf86443a0a61;

});

parcelRegister("5nZsM", function(module, exports) {

var $iKCFj = parcelRequire("iKCFj");


var $2Ed9T = parcelRequire("2Ed9T");

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $3ebec708b133657c$var$camelCase = $2Ed9T(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $iKCFj(word) : word);
});
module.exports = $3ebec708b133657c$var$camelCase;

});

parcelRegister("iKCFj", function(module, exports) {

var $fPVB6 = parcelRequire("fPVB6");


var $12IaO = parcelRequire("12IaO");

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $da6a84003d7bc8a2$var$capitalize(string) {
    return $12IaO($fPVB6(string).toLowerCase());
}
module.exports = $da6a84003d7bc8a2$var$capitalize;

});

parcelRegister("2Ed9T", function(module, exports) {

var $52wl7 = parcelRequire("52wl7");


var $iOvMY = parcelRequire("iOvMY");

var $8a780d7d3205113e$exports = {};
var $003133aba52e1295$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $003133aba52e1295$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $003133aba52e1295$var$asciiWords(string) {
    return string.match($003133aba52e1295$var$reAsciiWord) || [];
}
$003133aba52e1295$exports = $003133aba52e1295$var$asciiWords;


var $16c8eb795c50bf79$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $16c8eb795c50bf79$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $16c8eb795c50bf79$var$hasUnicodeWord(string) {
    return $16c8eb795c50bf79$var$reHasUnicodeWord.test(string);
}
$16c8eb795c50bf79$exports = $16c8eb795c50bf79$var$hasUnicodeWord;



var $fPVB6 = parcelRequire("fPVB6");

var $c8cd609b21904ab0$exports = {};
/** Used to compose unicode character classes. */ var $c8cd609b21904ab0$var$rsAstralRange = '\\ud800-\\udfff', $c8cd609b21904ab0$var$rsComboMarksRange = '\\u0300-\\u036f', $c8cd609b21904ab0$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $c8cd609b21904ab0$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $c8cd609b21904ab0$var$rsComboRange = $c8cd609b21904ab0$var$rsComboMarksRange + $c8cd609b21904ab0$var$reComboHalfMarksRange + $c8cd609b21904ab0$var$rsComboSymbolsRange, $c8cd609b21904ab0$var$rsDingbatRange = '\\u2700-\\u27bf', $c8cd609b21904ab0$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $c8cd609b21904ab0$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $c8cd609b21904ab0$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $c8cd609b21904ab0$var$rsPunctuationRange = '\\u2000-\\u206f', $c8cd609b21904ab0$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $c8cd609b21904ab0$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $c8cd609b21904ab0$var$rsVarRange = '\\ufe0e\\ufe0f', $c8cd609b21904ab0$var$rsBreakRange = $c8cd609b21904ab0$var$rsMathOpRange + $c8cd609b21904ab0$var$rsNonCharRange + $c8cd609b21904ab0$var$rsPunctuationRange + $c8cd609b21904ab0$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $c8cd609b21904ab0$var$rsApos = "['\u2019]", $c8cd609b21904ab0$var$rsBreak = '[' + $c8cd609b21904ab0$var$rsBreakRange + ']', $c8cd609b21904ab0$var$rsCombo = '[' + $c8cd609b21904ab0$var$rsComboRange + ']', $c8cd609b21904ab0$var$rsDigits = '\\d+', $c8cd609b21904ab0$var$rsDingbat = '[' + $c8cd609b21904ab0$var$rsDingbatRange + ']', $c8cd609b21904ab0$var$rsLower = '[' + $c8cd609b21904ab0$var$rsLowerRange + ']', $c8cd609b21904ab0$var$rsMisc = '[^' + $c8cd609b21904ab0$var$rsAstralRange + $c8cd609b21904ab0$var$rsBreakRange + $c8cd609b21904ab0$var$rsDigits + $c8cd609b21904ab0$var$rsDingbatRange + $c8cd609b21904ab0$var$rsLowerRange + $c8cd609b21904ab0$var$rsUpperRange + ']', $c8cd609b21904ab0$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $c8cd609b21904ab0$var$rsModifier = '(?:' + $c8cd609b21904ab0$var$rsCombo + '|' + $c8cd609b21904ab0$var$rsFitz + ')', $c8cd609b21904ab0$var$rsNonAstral = '[^' + $c8cd609b21904ab0$var$rsAstralRange + ']', $c8cd609b21904ab0$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $c8cd609b21904ab0$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $c8cd609b21904ab0$var$rsUpper = '[' + $c8cd609b21904ab0$var$rsUpperRange + ']', $c8cd609b21904ab0$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $c8cd609b21904ab0$var$rsMiscLower = '(?:' + $c8cd609b21904ab0$var$rsLower + '|' + $c8cd609b21904ab0$var$rsMisc + ')', $c8cd609b21904ab0$var$rsMiscUpper = '(?:' + $c8cd609b21904ab0$var$rsUpper + '|' + $c8cd609b21904ab0$var$rsMisc + ')', $c8cd609b21904ab0$var$rsOptContrLower = '(?:' + $c8cd609b21904ab0$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $c8cd609b21904ab0$var$rsOptContrUpper = '(?:' + $c8cd609b21904ab0$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $c8cd609b21904ab0$var$reOptMod = $c8cd609b21904ab0$var$rsModifier + '?', $c8cd609b21904ab0$var$rsOptVar = '[' + $c8cd609b21904ab0$var$rsVarRange + ']?', $c8cd609b21904ab0$var$rsOptJoin = '(?:' + $c8cd609b21904ab0$var$rsZWJ + '(?:' + [
    $c8cd609b21904ab0$var$rsNonAstral,
    $c8cd609b21904ab0$var$rsRegional,
    $c8cd609b21904ab0$var$rsSurrPair
].join('|') + ')' + $c8cd609b21904ab0$var$rsOptVar + $c8cd609b21904ab0$var$reOptMod + ')*', $c8cd609b21904ab0$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $c8cd609b21904ab0$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $c8cd609b21904ab0$var$rsSeq = $c8cd609b21904ab0$var$rsOptVar + $c8cd609b21904ab0$var$reOptMod + $c8cd609b21904ab0$var$rsOptJoin, $c8cd609b21904ab0$var$rsEmoji = '(?:' + [
    $c8cd609b21904ab0$var$rsDingbat,
    $c8cd609b21904ab0$var$rsRegional,
    $c8cd609b21904ab0$var$rsSurrPair
].join('|') + ')' + $c8cd609b21904ab0$var$rsSeq;
/** Used to match complex or compound words. */ var $c8cd609b21904ab0$var$reUnicodeWord = RegExp([
    $c8cd609b21904ab0$var$rsUpper + '?' + $c8cd609b21904ab0$var$rsLower + '+' + $c8cd609b21904ab0$var$rsOptContrLower + '(?=' + [
        $c8cd609b21904ab0$var$rsBreak,
        $c8cd609b21904ab0$var$rsUpper,
        '$'
    ].join('|') + ')',
    $c8cd609b21904ab0$var$rsMiscUpper + '+' + $c8cd609b21904ab0$var$rsOptContrUpper + '(?=' + [
        $c8cd609b21904ab0$var$rsBreak,
        $c8cd609b21904ab0$var$rsUpper + $c8cd609b21904ab0$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $c8cd609b21904ab0$var$rsUpper + '?' + $c8cd609b21904ab0$var$rsMiscLower + '+' + $c8cd609b21904ab0$var$rsOptContrLower,
    $c8cd609b21904ab0$var$rsUpper + '+' + $c8cd609b21904ab0$var$rsOptContrUpper,
    $c8cd609b21904ab0$var$rsOrdUpper,
    $c8cd609b21904ab0$var$rsOrdLower,
    $c8cd609b21904ab0$var$rsDigits,
    $c8cd609b21904ab0$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $c8cd609b21904ab0$var$unicodeWords(string) {
    return string.match($c8cd609b21904ab0$var$reUnicodeWord) || [];
}
$c8cd609b21904ab0$exports = $c8cd609b21904ab0$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $8a780d7d3205113e$var$words(string, pattern, guard) {
    string = $fPVB6(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $16c8eb795c50bf79$exports(string) ? $c8cd609b21904ab0$exports(string) : $003133aba52e1295$exports(string);
    return string.match(pattern) || [];
}
$8a780d7d3205113e$exports = $8a780d7d3205113e$var$words;


/** Used to compose unicode capture groups. */ var $1ed9863c2ebfed04$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $1ed9863c2ebfed04$var$reApos = RegExp($1ed9863c2ebfed04$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $1ed9863c2ebfed04$var$createCompounder(callback) {
    return function(string) {
        return $52wl7($8a780d7d3205113e$exports($iOvMY(string).replace($1ed9863c2ebfed04$var$reApos, '')), callback, '');
    };
}
module.exports = $1ed9863c2ebfed04$var$createCompounder;

});

parcelRegister("52wl7", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3ab639a44a152d0d$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $3ab639a44a152d0d$var$arrayReduce;

});

parcelRegister("iOvMY", function(module, exports) {
var $d2258c0d042ca0c6$exports = {};

var $jghHU = parcelRequire("jghHU");

/** Used to map Latin Unicode letters to basic Latin letters. */ var $d2258c0d042ca0c6$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $d2258c0d042ca0c6$var$deburrLetter = $jghHU($d2258c0d042ca0c6$var$deburredLetters);
$d2258c0d042ca0c6$exports = $d2258c0d042ca0c6$var$deburrLetter;



var $fPVB6 = parcelRequire("fPVB6");

/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $db258e1bec5616a7$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $db258e1bec5616a7$var$rsComboMarksRange = '\\u0300-\\u036f', $db258e1bec5616a7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $db258e1bec5616a7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $db258e1bec5616a7$var$rsComboRange = $db258e1bec5616a7$var$rsComboMarksRange + $db258e1bec5616a7$var$reComboHalfMarksRange + $db258e1bec5616a7$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $db258e1bec5616a7$var$rsCombo = '[' + $db258e1bec5616a7$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $db258e1bec5616a7$var$reComboMark = RegExp($db258e1bec5616a7$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $db258e1bec5616a7$var$deburr(string) {
    string = $fPVB6(string);
    return string && string.replace($db258e1bec5616a7$var$reLatin, $d2258c0d042ca0c6$exports).replace($db258e1bec5616a7$var$reComboMark, '');
}
module.exports = $db258e1bec5616a7$var$deburr;

});

parcelRegister("jghHU", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $e05d3f3448b226c6$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $e05d3f3448b226c6$var$basePropertyOf;

});

parcelRegister("3uVVG", function(module, exports) {
$parcel$export(module.exports, "AuthError", () => (parcelRequire("uvNb9")).AuthError);

var $uvNb9 = parcelRequire("uvNb9");


var $9P47v = parcelRequire("9P47v");

function $81514351a4f15f99$export$73693bad9f5880b0(startUrl, windowFeatures) {
    return new Promise((resolve, reject)=>{
        let authWindow = null;
        let authWindowInterval;
        const handleAuthWindowMessage = (event)=>{
            if (event.source !== authWindow) return;
            const { data: data } = event;
            if (typeof data !== 'object') return;
            switch(data.type){
                case 'outbound-auth:success':
                    finish();
                    resolve();
                    break;
                case 'outbound-auth:failure':
                    finish();
                    const errorType = data.errorType.toLowerCase();
                    if ((0, $9P47v.isOfTypeAuthError)(errorType)) reject(new (0, $uvNb9.AuthError)(data.message, errorType));
                    else reject(new (0, $uvNb9.AuthError)(data.message));
                    break;
            }
        };
        const handleAuthWindowInterval = ()=>{
            if (authWindow && authWindow.closed) {
                finish();
                reject(new (0, $uvNb9.AuthError)('The auth window was closed', 'auth_window_closed'));
            }
        };
        const start = ()=>{
            window.addEventListener('message', handleAuthWindowMessage);
            authWindow = window.open(startUrl, startUrl, windowFeatures);
            authWindowInterval = window.setInterval(handleAuthWindowInterval, 500);
        };
        const finish = ()=>{
            clearInterval(authWindowInterval);
            window.removeEventListener('message', handleAuthWindowMessage);
            if (authWindow) {
                authWindow.close();
                authWindow = null;
            }
        };
        start();
    });
}
module.exports["auth"] = $81514351a4f15f99$export$73693bad9f5880b0;

});

parcelRegister("9P47v", function(module, exports) {
// See https://tools.ietf.org/html/rfc6749#section-4.1.2.1
// 'auth_window_closed' is returned in addition to types from this RFC,
// representing when the authentication window is closed by the user
// 'authclientoauth2.autherror' is added to represent errors from
// outbound-auth
const $cd3cb472abe3f4ba$export$400e64c8451aa84f = (inputString)=>{
    return [
        'auth_window_closed',
        'invalid_request',
        'unauthorized_client',
        'access_denied',
        'unsupported_response_type',
        'invalid_scope',
        'server_error',
        'temporarily_unavailable',
        'authclientoauth2.autherror'
    ].includes(inputString);
};
module.exports["isOfTypeAuthError"] = $cd3cb472abe3f4ba$export$400e64c8451aa84f;

});

parcelRegister("aFUXX", function(module, exports) {

var $dh538 = parcelRequire("dh538");


var $iu6m9 = parcelRequire("iu6m9");

const $cf06caec6e967ae4$export$fe6b0b821a0e9067 = 16;
const $cf06caec6e967ae4$export$24495b314f307191 = 13;
const $cf06caec6e967ae4$export$9a7c520c39e1f0aa = "var(--ds-font-family-code, \"Atlassian Mono\", ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $cf06caec6e967ae4$export$1d762aef048d30f9 = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $cf06caec6e967ae4$export$a7a75e50ae62d0a8 = "var(--ds-border, #0B120E24)";
const $cf06caec6e967ae4$export$b9864494c2608629 = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $cf06caec6e967ae4$export$f0e953d95429ca1 = '12px';
const $cf06caec6e967ae4$export$a309dbdeca0adb1a = '2px 4px';
const $cf06caec6e967ae4$export$ef95eb6ef0fd0a4a = "var(--ds-background-danger, #FFECEB)";
const $cf06caec6e967ae4$export$8f7d2d784079e274 = 'rgba(255, 189, 173, 0.5)'; // R75 with 50% opacity
const $cf06caec6e967ae4$export$3c108a6bc41bb5f2 = "var(--ds-border-danger, #E2483D)";
const $cf06caec6e967ae4$export$bf3aaa2106c119fd = "var(--ds-icon-danger, #C9372C)";
const $cf06caec6e967ae4$export$d2715266dd4a1fd1 = 20;
const $cf06caec6e967ae4$export$cf524c1b49838a49 = "var(--ds-border-selected, #1868DB)";
const $cf06caec6e967ae4$export$8dac549e32469ac4 = 1;
const $cf06caec6e967ae4$export$befaaae517e3d864 = 2;
const $cf06caec6e967ae4$export$6e1e1996c4e8cc51 = `${$cf06caec6e967ae4$export$8dac549e32469ac4}px solid ${"var(--ds-border-selected, #1868DB)"}`;
const $cf06caec6e967ae4$export$b6a59ac3a19b6343 = `0 0 0 ${$cf06caec6e967ae4$export$8dac549e32469ac4}px ${"var(--ds-border-selected, #1868DB)"}`;
const $cf06caec6e967ae4$export$37e178ca41c198ca = `0 0 0 ${$cf06caec6e967ae4$export$befaaae517e3d864}px ${"var(--ds-border-selected, #1868DB)"}`;
const $cf06caec6e967ae4$export$4a007c22e25e31f6 = 0.3;
const $cf06caec6e967ae4$export$f35cc48f3398ab79 = 1;
const $cf06caec6e967ae4$export$b46cda584c619451 = 2;
const $cf06caec6e967ae4$export$6bed85de54b5de42 = 11; // filmstrip uses 10 for its shadow
const $cf06caec6e967ae4$export$321ddd2f049dd12 = $cf06caec6e967ae4$export$6bed85de54b5de42 + 1;
const $cf06caec6e967ae4$export$daeac9b8422ac3c2 = 2;
const $cf06caec6e967ae4$export$501d46e11ed5bf73 = 500;
const $cf06caec6e967ae4$export$6817b4b6a5ef78f1 = 400;
const $cf06caec6e967ae4$export$93768eb72dec48ce = $cf06caec6e967ae4$export$501d46e11ed5bf73 + 10;
const $cf06caec6e967ae4$export$c0aec4e0896849a0 = $cf06caec6e967ae4$export$93768eb72dec48ce - 5;
const $cf06caec6e967ae4$export$5886f057e4f21fe4 = $cf06caec6e967ae4$export$6817b4b6a5ef78f1 + 5;
const $cf06caec6e967ae4$export$6e85faa46d537a3f = 11;
const $cf06caec6e967ae4$export$36ba77fba4a62d5f = "var(--ds-background-accent-gray-subtler, #DDDEE1)";
const $cf06caec6e967ae4$export$640eef769748f78f = "var(--ds-background-accent-gray-subtlest, #F0F1F2)";
const $cf06caec6e967ae4$export$4c6f61fb4b9ae93 = '#F1F2F4';
const $cf06caec6e967ae4$export$95e9a0285b97474d = '#2C333A';
const $cf06caec6e967ae4$export$f7bbcec54ff5bc47 = "var(--ds-border-focused, #4688EC)";
const $cf06caec6e967ae4$export$76b5e653883e5290 = '3px';
const $cf06caec6e967ae4$export$6d85fe8177a50c0c = 0.5;
const $cf06caec6e967ae4$export$fad19f16d3f953a3 = 680;
const $cf06caec6e967ae4$export$9db045950eedb49f = 760;
const $cf06caec6e967ae4$export$74c442132af16a = 960; // This value is used for tables with breakouts and is used to calculate `breakoutWidthPx`
const $cf06caec6e967ae4$export$f580e3d28d0986de = 1800;
const $cf06caec6e967ae4$export$c0f7d71e10d277e9 = 4000;
const $cf06caec6e967ae4$export$9d5488b5afad62bf = 1792;
const $cf06caec6e967ae4$export$45eb0f5135abf6f1 = 4000;
const $cf06caec6e967ae4$export$37df10057d36a0e5 = 42;
const $cf06caec6e967ae4$export$437293c5e9fc2703 = 96;
const $cf06caec6e967ae4$export$6e0f4d52efd3d2d = 32;
const $cf06caec6e967ae4$export$f222e0c7a2dc5324 = ()=>// eslint-disable-next-line @atlaskit/platform/no-preconditioning
    (0, $dh538.fg)('platform_editor_controls_increase_full_page_gutter') && (0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1') ? 72 : 52;
const $cf06caec6e967ae4$export$aae87d25ced827bb = 24;
const $cf06caec6e967ae4$export$cccda66937c91e4c = 600;
const $cf06caec6e967ae4$export$efe8561bbd3f74d2 = 720;
const $cf06caec6e967ae4$export$e4d39a9e8607c1d3 = 48;
const $cf06caec6e967ae4$export$43946f2400ab6f1f = 128;
const $cf06caec6e967ae4$export$558438ae7fd4b8ce = 12;
const $cf06caec6e967ae4$export$6beb98d32d4ca149 = 4;
const $cf06caec6e967ae4$export$3b24948cd5dbb087 = `cubic-bezier(0.15, 1, 0.3, 1)`;
const $cf06caec6e967ae4$export$5edb4f38c3eacb1a = 1024;
const $cf06caec6e967ae4$export$e60820063058ed59 = 1.33;
const $cf06caec6e967ae4$export$60da500206e2ceec = 905; // from breakoutConsts.calcWideWidth, layoutMaxWidth * breakoutConsts.wideScaleRatio = 904.8 ~ 905 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is <= 1266px.
const $cf06caec6e967ae4$export$c0e6648ae1bb2fac = 1011; // = akEditorDefaultLayoutWidth * breakoutWideScaleRatio = 1010.8 ~ 1011 This is a resulting width value that is applied to nodes that currently use breakouts (except table) and are set to `wide` when the viewport's width is > 1329px.
const $cf06caec6e967ae4$export$fb15fade89f67217 = $cf06caec6e967ae4$export$f35cc48f3398ab79 * 99;
const $cf06caec6e967ae4$export$847030921e9d5a40 = 12;
const $cf06caec6e967ae4$export$40eb41ab799f0329 = 1.714;
const $cf06caec6e967ae4$export$e271312fc7124aec = '1px';
const $cf06caec6e967ae4$export$d29cb2c31fcbb7c5 = 2;
const $cf06caec6e967ae4$export$688a6dc01e760755 = 320;
const $cf06caec6e967ae4$export$e736f2caf3b39eb3 = 'rgba(179, 212, 255, 0.3)';
const $cf06caec6e967ae4$export$de3cef07cda55645 = 'rgba(255, 235, 230, 0.3)';
const $cf06caec6e967ae4$export$e88f6c898960b391 = $cf06caec6e967ae4$export$f35cc48f3398ab79 * 2; //prevent paragraph nodes from rendering above wrapped nodes
const $cf06caec6e967ae4$export$e5c605f2b2a12b00 = {
    SMALL: 550,
    MEDIUM: 760
};
const $cf06caec6e967ae4$export$1d0d506416d457f1 = '0.75rem';
const $cf06caec6e967ae4$export$53030af820b542f5 = '0.75em';
const $cf06caec6e967ae4$export$e683ef42725d1713 = 680;
const $cf06caec6e967ae4$export$226c784ba04bd04b = 480;
const $cf06caec6e967ae4$export$214ff00e5618d86c = 20;
const $cf06caec6e967ae4$export$c82675fa56f2eefd = '56px';
const $cf06caec6e967ae4$var$DEFAULT_FONT_SIZE = 14;
const $cf06caec6e967ae4$export$d7726a000ae2d7c = (isToolbarAIFCEnabled)=>{
    if (// if value is undefined assume this is being called outside of editor where the experiment can be checked
    isToolbarAIFCEnabled === undefined ? (0, $iu6m9.editorExperiment)('platform_editor_toolbar_aifc', true) || (0, $dh538.fg)('platform_editor_ai_aifc_streaming') : isToolbarAIFCEnabled) return '44px';
    if ((0, $iu6m9.editorExperiment)('platform_editor_controls', 'variant1', {
        exposure: true
    })) return "var(--ds-space-500, 40px)";
    return "var(--ds-space-500, 40px)";
};
const $cf06caec6e967ae4$export$d1343597f3b52d83 = 40;
const $cf06caec6e967ae4$export$a02a3f1515c2e21a = 'ak-editor-selected-node';
const $cf06caec6e967ae4$export$58a725ff69bda73a = ({ theme: theme })=>theme && theme.baseFontSize ? theme.baseFontSize : $cf06caec6e967ae4$var$DEFAULT_FONT_SIZE;
const $cf06caec6e967ae4$export$945a9e125632354d = (multiplier)=>({ theme: theme })=>$cf06caec6e967ae4$export$58a725ff69bda73a({
            theme: theme
        }) * multiplier;
const $cf06caec6e967ae4$export$59733a9f61449b25 = (px)=>{
    if (typeof px === 'string') px = parseInt(px);
    if (isNaN(px)) throw new Error(`Invalid font size: '${px}'`);
    return `${px / 16}rem`;
};
const $cf06caec6e967ae4$export$46715ac1fbd9e64e = (value)=>{
    return `calc(${value} * var(--ak-editor-base-font-size) / ${$cf06caec6e967ae4$export$fe6b0b821a0e9067})`;
};
const $cf06caec6e967ae4$export$96b72b7f243fa693 = {
    a4KMonitor: {
        width: 3440,
        height: 1440
    },
    laptopHiDPI: {
        width: 1440,
        height: 900
    },
    laptopMDPI: {
        width: 1280,
        height: 800
    },
    tabletL: {
        width: 1024,
        height: 1366
    },
    tabletS: {
        width: 768,
        height: 1024
    },
    mobileM: {
        width: 414,
        height: 736
    },
    mobileS: {
        width: 375,
        height: 667
    },
    mobileXS: {
        width: 320,
        height: 568
    }
};
const $cf06caec6e967ae4$export$9369fd010fa0ddd6 = 0;
const $cf06caec6e967ae4$export$846a716e9e69a8df = [
    [
        'White',
        '#000000'
    ],
    [
        'Light blue',
        '#0C294F'
    ],
    [
        'Light teal',
        '#0C343B'
    ],
    [
        'Light green',
        '#052E21'
    ],
    [
        'Light yellow',
        '#484123'
    ],
    [
        'Light red',
        '#441C13'
    ],
    [
        'Light purple',
        '#282249'
    ],
    [
        'Light gray',
        '#202328'
    ],
    [
        'Blue',
        '#0B3165'
    ],
    [
        'Teal',
        '#044853'
    ],
    [
        'Green',
        '#053927'
    ],
    [
        'Yellow',
        '#6F5C25'
    ],
    [
        'Red',
        '#582013'
    ],
    [
        'Purple',
        '#3E327B'
    ],
    [
        'Gray',
        '#475262'
    ],
    [
        'Dark blue',
        '#003884'
    ],
    [
        'Dark teal',
        '#055866'
    ],
    [
        'Dark green',
        '#044932'
    ],
    [
        'Dark yellow',
        '#82641C'
    ],
    [
        'Dark red',
        '#6B2A19'
    ],
    [
        'Dark purple',
        '#4D38B2'
    ]
].map(([colorName, colorValue])=>$cf06caec6e967ae4$export$5f2dade43b841301(colorName, colorValue)).join('\n');
function $cf06caec6e967ae4$export$5f2dade43b841301(colorName, colorValue) {
    return `
  &[colorname="${colorName}"] {
    background-color: ${colorValue} !important; // !important to override default style color
  }
  `;
}
const $cf06caec6e967ae4$export$312e1e71424c4aa1 = [
    "var(--ds-icon-accent-red, #C9372C)",
    "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    "var(--ds-icon-accent-magenta, #CD519D)",
    "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    "var(--ds-icon-accent-orange, #E06C00)",
    "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    "var(--ds-icon-accent-green, #22A06B)",
    "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    "var(--ds-icon-accent-blue, #357DE8)",
    "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    "var(--ds-icon-accent-teal, #2898BD)",
    "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    "var(--ds-icon-accent-lime, #6A9A23)",
    "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    "var(--ds-icon-accent-purple, #AF59E1)",
    "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    "var(--ds-icon-accent-gray, #7D818A)",
    "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    "var(--ds-icon-accent-yellow, #B38600)",
    "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    "var(--ds-background-accent-yellow-bolder-pressed, #614A05)"
];
const $cf06caec6e967ae4$export$42608c013398a830 = [
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-blue-bolder, #1868DB)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-yellow-bolder, #946F00)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-purple-bolder, #964AC0)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-magenta-bolder, #AE4787)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-teal-bolder, #227D9B)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-orange-bolder, #BD5B00)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-lime-bolder, #5B7F24)",
        svgBackgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)"
    },
    {
        textColor: "var(--ds-text-inverse, #FFFFFF)",
        backgroundColor: "var(--ds-background-accent-gray-bolder, #6B6E76)",
        svgBackgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-blue-subtle, #669DF1)",
        svgBackgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
        svgBackgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-orange-subtle, #FCA700)",
        svgBackgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF5DB)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-yellow-subtle, #EED12B)",
        svgBackgroundColor: "var(--ds-background-accent-yellow-subtlest, #FEF7C8)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
        svgBackgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        svgBackgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-purple-subtle, #C97CF4)",
        svgBackgroundColor: "var(--ds-background-accent-purple-subtlest, #F8EEFE)"
    },
    {
        textColor: "var(--ds-text-accent-gray-bolder, #1E1F21)",
        backgroundColor: "var(--ds-background-accent-magenta-subtle, #E774BB)",
        svgBackgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)"
    }
];
module.exports["akEditorFullPageDefaultFontSize"] = $cf06caec6e967ae4$export$fe6b0b821a0e9067;
module.exports["akEditorFullPageDenseFontSize"] = $cf06caec6e967ae4$export$24495b314f307191;
module.exports["akEditorSubtleAccent"] = $cf06caec6e967ae4$export$1d762aef048d30f9;
module.exports["akEditorBlockquoteBorderColor"] = $cf06caec6e967ae4$export$a7a75e50ae62d0a8;
module.exports["akEditorDeleteBorder"] = $cf06caec6e967ae4$export$3c108a6bc41bb5f2;
module.exports["akEditorCustomIconSize"] = $cf06caec6e967ae4$export$d2715266dd4a1fd1;
module.exports["akEditorSelectedBorderColor"] = $cf06caec6e967ae4$export$cf524c1b49838a49;
module.exports["akEditorSelectedBorderSize"] = $cf06caec6e967ae4$export$8dac549e32469ac4;
module.exports["akEditorSelectedBorderBoldSize"] = $cf06caec6e967ae4$export$befaaae517e3d864;
module.exports["akEditorSelectedBorder"] = $cf06caec6e967ae4$export$6e1e1996c4e8cc51;
module.exports["akEditorSelectedBoxShadow"] = $cf06caec6e967ae4$export$b6a59ac3a19b6343;
module.exports["akEditorUnitZIndex"] = $cf06caec6e967ae4$export$f35cc48f3398ab79;
module.exports["akEditorShadowZIndex"] = $cf06caec6e967ae4$export$b46cda584c619451;
module.exports["akEditorStickyHeaderZIndex"] = $cf06caec6e967ae4$export$6bed85de54b5de42;
module.exports["akEditorSmallZIndex"] = $cf06caec6e967ae4$export$321ddd2f049dd12;
module.exports["akEditorGridLineZIndex"] = $cf06caec6e967ae4$export$daeac9b8422ac3c2;
module.exports["akEditorMenuZIndex"] = $cf06caec6e967ae4$export$501d46e11ed5bf73;
module.exports["akEditorFloatingPanelZIndex"] = $cf06caec6e967ae4$export$6817b4b6a5ef78f1;
module.exports["akEditorFloatingDialogZIndex"] = $cf06caec6e967ae4$export$93768eb72dec48ce;
module.exports["akEditorTableCellOnStickyHeaderZIndex"] = $cf06caec6e967ae4$export$c0aec4e0896849a0;
module.exports["akEditorFloatingOverlapPanelZIndex"] = $cf06caec6e967ae4$export$5886f057e4f21fe4;
module.exports["akEditorTableToolbarSize"] = $cf06caec6e967ae4$export$6e85faa46d537a3f;
module.exports["akEditorTableBorder"] = $cf06caec6e967ae4$export$36ba77fba4a62d5f;
module.exports["akEditorTableToolbar"] = $cf06caec6e967ae4$export$640eef769748f78f;
module.exports["akEditorTableHeaderCellBackground"] = $cf06caec6e967ae4$export$4c6f61fb4b9ae93;
module.exports["akEditorTableBorderSelected"] = $cf06caec6e967ae4$export$f7bbcec54ff5bc47;
module.exports["akEditorFullPageMaxWidth"] = $cf06caec6e967ae4$export$fad19f16d3f953a3;
module.exports["akEditorDefaultLayoutWidth"] = $cf06caec6e967ae4$export$9db045950eedb49f;
module.exports["akEditorWideLayoutWidth"] = $cf06caec6e967ae4$export$74c442132af16a;
module.exports["akEditorFullWidthLayoutWidth"] = $cf06caec6e967ae4$export$f580e3d28d0986de;
module.exports["akEditorMaxWidthLayoutWidth"] = $cf06caec6e967ae4$export$c0f7d71e10d277e9;
module.exports["akEditorMaxLayoutWidth"] = $cf06caec6e967ae4$export$45eb0f5135abf6f1;
module.exports["akEditorTableNumberColumnWidth"] = $cf06caec6e967ae4$export$37df10057d36a0e5;
module.exports["akEditorBreakoutPadding"] = $cf06caec6e967ae4$export$437293c5e9fc2703;
module.exports["akEditorGutterPadding"] = $cf06caec6e967ae4$export$6e0f4d52efd3d2d;
module.exports["akEditorGutterPaddingDynamic"] = $cf06caec6e967ae4$export$f222e0c7a2dc5324;
module.exports["akEditorGutterPaddingReduced"] = $cf06caec6e967ae4$export$aae87d25ced827bb;
module.exports["akEditorFullPageNarrowBreakout"] = $cf06caec6e967ae4$export$cccda66937c91e4c;
module.exports["akEditorMobileBreakoutPoint"] = $cf06caec6e967ae4$export$efe8561bbd3f74d2;
module.exports["akEditorTableCellMinWidth"] = $cf06caec6e967ae4$export$e4d39a9e8607c1d3;
module.exports["akEditorTableLegacyCellMinWidth"] = $cf06caec6e967ae4$export$43946f2400ab6f1f;
module.exports["akEditorMediaResizeHandlerPaddingWide"] = $cf06caec6e967ae4$export$558438ae7fd4b8ce;
module.exports["akEditorMediaResizeHandlerPadding"] = $cf06caec6e967ae4$export$6beb98d32d4ca149;
module.exports["akEditorSwoopCubicBezier"] = $cf06caec6e967ae4$export$3b24948cd5dbb087;
module.exports["gridMediumMaxWidth"] = $cf06caec6e967ae4$export$5edb4f38c3eacb1a;
module.exports["breakoutWideScaleRatio"] = $cf06caec6e967ae4$export$e60820063058ed59;
module.exports["akEditorCalculatedWideLayoutWidthSmallViewport"] = $cf06caec6e967ae4$export$60da500206e2ceec;
module.exports["akEditorCalculatedWideLayoutWidth"] = $cf06caec6e967ae4$export$c0e6648ae1bb2fac;
module.exports["akRichMediaResizeZIndex"] = $cf06caec6e967ae4$export$fb15fade89f67217;
module.exports["akLayoutGutterOffset"] = $cf06caec6e967ae4$export$847030921e9d5a40;
module.exports["akEditorLineHeight"] = $cf06caec6e967ae4$export$40eb41ab799f0329;
module.exports["akEditorContextPanelWidth"] = $cf06caec6e967ae4$export$688a6dc01e760755;
module.exports["akEditorTableCellBlanketSelected"] = $cf06caec6e967ae4$export$e736f2caf3b39eb3;
module.exports["akEditorTableCellBlanketDeleted"] = $cf06caec6e967ae4$export$de3cef07cda55645;
module.exports["akEditorWrappedNodeZIndex"] = $cf06caec6e967ae4$export$e88f6c898960b391;
module.exports["layoutBreakpointWidth"] = $cf06caec6e967ae4$export$e5c605f2b2a12b00;
module.exports["blockNodesVerticalMargin"] = $cf06caec6e967ae4$export$1d0d506416d457f1;
module.exports["scaledBlockNodesVerticalMargin"] = $cf06caec6e967ae4$export$53030af820b542f5;
module.exports["DEFAULT_EMBED_CARD_WIDTH"] = $cf06caec6e967ae4$export$e683ef42725d1713;
module.exports["DEFAULT_EMBED_CARD_HEIGHT"] = $cf06caec6e967ae4$export$226c784ba04bd04b;
module.exports["MAX_BROWSER_SCROLLBAR_HEIGHT"] = $cf06caec6e967ae4$export$214ff00e5618d86c;
module.exports["FULL_PAGE_EDITOR_TOOLBAR_HEIGHT"] = $cf06caec6e967ae4$export$d7726a000ae2d7c;
module.exports["akEditorFullPageToolbarHeight"] = $cf06caec6e967ae4$export$d1343597f3b52d83;
module.exports["akEditorSelectedNodeClassName"] = $cf06caec6e967ae4$export$a02a3f1515c2e21a;
module.exports["editorFontSize"] = $cf06caec6e967ae4$export$58a725ff69bda73a;
module.exports["relativeFontSizeToBase16"] = $cf06caec6e967ae4$export$59733a9f61449b25;
module.exports["relativeSizeToBaseFontSize"] = $cf06caec6e967ae4$export$46715ac1fbd9e64e;
module.exports["akEditorMobileMaxWidth"] = $cf06caec6e967ae4$export$9369fd010fa0ddd6;
module.exports["participantColors"] = $cf06caec6e967ae4$export$42608c013398a830;

});

parcelRegister("ks2lK", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");


var $aXG5V = parcelRequire("aXG5V");

const $ee383ecc396bb319$var$classesById = Object.create(null);
/**
Superclass for editor selections. Every selection type should
extend this. Should not be instantiated directly.
*/ class $ee383ecc396bb319$export$52baac22726c72bf {
    /**
    The selection's anchor, as an unresolved position.
    */ get anchor() {
        return this.$anchor.pos;
    }
    /**
    The selection's head.
    */ get head() {
        return this.$head.pos;
    }
    /**
    The lower bound of the selection's main range.
    */ get from() {
        return this.$from.pos;
    }
    /**
    The upper bound of the selection's main range.
    */ get to() {
        return this.$to.pos;
    }
    /**
    The resolved lower  bound of the selection's main range.
    */ get $from() {
        return this.ranges[0].$from;
    }
    /**
    The resolved upper bound of the selection's main range.
    */ get $to() {
        return this.ranges[0].$to;
    }
    /**
    Indicates whether the selection contains any content.
    */ get empty() {
        let ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++)if (ranges[i].$from.pos != ranges[i].$to.pos) return false;
        return true;
    }
    /**
    Get the content of this selection as a slice.
    */ content() {
        return this.$from.doc.slice(this.from, this.to, true);
    }
    /**
    Replace the selection with a slice or, if no slice is given,
    delete the selection. Will append to the given transaction.
    */ replace(tr, content = (0, $5SAOw.Slice).empty) {
        // Put the new selection at the position after the inserted
        // content. When that ended in an inline node, search backwards,
        // to get the position after that node. If not, search forward.
        let lastNode = content.content.lastChild, lastParent = null;
        for(let i = 0; i < content.openEnd; i++){
            lastParent = lastNode;
            lastNode = lastNode.lastChild;
        }
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            tr.replaceRange(mapping.map($from.pos), mapping.map($to.pos), i ? (0, $5SAOw.Slice).empty : content);
            if (i == 0) $ee383ecc396bb319$var$selectionToInsertionEnd(tr, mapFrom, (lastNode ? lastNode.isInline : lastParent && lastParent.isTextblock) ? -1 : 1);
        }
    }
    /**
    Replace the selection with the given node, appending the changes
    to the given transaction.
    */ replaceWith(tr, node) {
        let mapFrom = tr.steps.length, ranges = this.ranges;
        for(let i = 0; i < ranges.length; i++){
            let { $from: $from, $to: $to } = ranges[i], mapping = tr.mapping.slice(mapFrom);
            let from = mapping.map($from.pos), to = mapping.map($to.pos);
            if (i) tr.deleteRange(from, to);
            else {
                tr.replaceRangeWith(from, to, node);
                $ee383ecc396bb319$var$selectionToInsertionEnd(tr, mapFrom, node.isInline ? -1 : 1);
            }
        }
    }
    /**
    Find a valid cursor or leaf node selection starting at the given
    position and searching back if `dir` is negative, and forward if
    positive. When `textOnly` is true, only consider cursor
    selections. Will return null when no valid selection position is
    found.
    */ static findFrom($pos, dir, textOnly = false) {
        let inner = $pos.parent.inlineContent ? new $ee383ecc396bb319$export$c2b25f346d19bcbb($pos) : $ee383ecc396bb319$var$findSelectionIn($pos.node(0), $pos.parent, $pos.pos, $pos.index(), dir, textOnly);
        if (inner) return inner;
        for(let depth = $pos.depth - 1; depth >= 0; depth--){
            let found = dir < 0 ? $ee383ecc396bb319$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.before(depth + 1), $pos.index(depth), dir, textOnly) : $ee383ecc396bb319$var$findSelectionIn($pos.node(0), $pos.node(depth), $pos.after(depth + 1), $pos.index(depth) + 1, dir, textOnly);
            if (found) return found;
        }
        return null;
    }
    /**
    Find a valid cursor or leaf node selection near the given
    position. Searches forward first by default, but if `bias` is
    negative, it will search backwards first.
    */ static near($pos, bias = 1) {
        return this.findFrom($pos, bias) || this.findFrom($pos, -bias) || new $ee383ecc396bb319$export$c15d9ba76bdbcd95($pos.node(0));
    }
    /**
    Find the cursor or leaf node selection closest to the start of
    the given document. Will return an
    [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
    exists.
    */ static atStart(doc) {
        return $ee383ecc396bb319$var$findSelectionIn(doc, doc, 0, 0, 1) || new $ee383ecc396bb319$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Find the cursor or leaf node selection closest to the end of the
    given document.
    */ static atEnd(doc) {
        return $ee383ecc396bb319$var$findSelectionIn(doc, doc, doc.content.size, doc.childCount, -1) || new $ee383ecc396bb319$export$c15d9ba76bdbcd95(doc);
    }
    /**
    Deserialize the JSON representation of a selection. Must be
    implemented for custom classes (as a static class method).
    */ static fromJSON(doc, json) {
        if (!json || !json.type) throw new RangeError("Invalid input for Selection.fromJSON");
        let cls = $ee383ecc396bb319$var$classesById[json.type];
        if (!cls) throw new RangeError(`No selection type ${json.type} defined`);
        return cls.fromJSON(doc, json);
    }
    /**
    To be able to deserialize selections from JSON, custom selection
    classes must register themselves with an ID string, so that they
    can be disambiguated. Try to pick something that's unlikely to
    clash with classes from other modules.
    */ static jsonID(id, selectionClass) {
        if (id in $ee383ecc396bb319$var$classesById) throw new RangeError("Duplicate use of selection JSON ID " + id);
        $ee383ecc396bb319$var$classesById[id] = selectionClass;
        selectionClass.prototype.jsonID = id;
        return selectionClass;
    }
    /**
    Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
    which is a value that can be mapped without having access to a
    current document, and later resolved to a real selection for a
    given document again. (This is used mostly by the history to
    track and restore old selections.) The default implementation of
    this method just converts the selection to a text selection and
    returns the bookmark for that.
    */ getBookmark() {
        return $ee383ecc396bb319$export$c2b25f346d19bcbb.between(this.$anchor, this.$head).getBookmark();
    }
    /**
    Initialize a selection with the head and anchor and ranges. If no
    ranges are given, constructs a single range across `$anchor` and
    `$head`.
    */ constructor(/**
    The resolved anchor of the selection (the side that stays in
    place when the selection is modified).
    */ $anchor, /**
    The resolved head of the selection (the side that moves when
    the selection is modified).
    */ $head, ranges){
        this.$anchor = $anchor;
        this.$head = $head;
        this.ranges = ranges || [
            new $ee383ecc396bb319$export$7bd1839c3c5d5bd4($anchor.min($head), $anchor.max($head))
        ];
    }
}
$ee383ecc396bb319$export$52baac22726c72bf.prototype.visible = true;
/**
Represents a selected range in a document.
*/ class $ee383ecc396bb319$export$7bd1839c3c5d5bd4 {
    /**
    Create a range.
    */ constructor(/**
    The lower bound of the range.
    */ $from, /**
    The upper bound of the range.
    */ $to){
        this.$from = $from;
        this.$to = $to;
    }
}
let $ee383ecc396bb319$var$warnedAboutTextSelection = false;
function $ee383ecc396bb319$var$checkTextSelection($pos) {
    if (!$ee383ecc396bb319$var$warnedAboutTextSelection && !$pos.parent.inlineContent) {
        $ee383ecc396bb319$var$warnedAboutTextSelection = true;
        console["warn"]("TextSelection endpoint not pointing into a node with inline content (" + $pos.parent.type.name + ")");
    }
}
/**
A text selection represents a classical editor selection, with a
head (the moving side) and anchor (immobile side), both of which
point into textblock nodes. It can be empty (a regular cursor
position).
*/ class $ee383ecc396bb319$export$c2b25f346d19bcbb extends $ee383ecc396bb319$export$52baac22726c72bf {
    /**
    Returns a resolved position if this is a cursor selection (an
    empty text selection), and null otherwise.
    */ get $cursor() {
        return this.$anchor.pos == this.$head.pos ? this.$head : null;
    }
    map(doc, mapping) {
        let $head = doc.resolve(mapping.map(this.head));
        if (!$head.parent.inlineContent) return $ee383ecc396bb319$export$52baac22726c72bf.near($head);
        let $anchor = doc.resolve(mapping.map(this.anchor));
        return new $ee383ecc396bb319$export$c2b25f346d19bcbb($anchor.parent.inlineContent ? $anchor : $head, $head);
    }
    replace(tr, content = (0, $5SAOw.Slice).empty) {
        super.replace(tr, content);
        if (content == (0, $5SAOw.Slice).empty) {
            let marks = this.$from.marksAcross(this.$to);
            if (marks) tr.ensureMarks(marks);
        }
    }
    eq(other) {
        return other instanceof $ee383ecc396bb319$export$c2b25f346d19bcbb && other.anchor == this.anchor && other.head == this.head;
    }
    getBookmark() {
        return new $ee383ecc396bb319$var$TextBookmark(this.anchor, this.head);
    }
    toJSON() {
        return {
            type: "text",
            anchor: this.anchor,
            head: this.head
        };
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number" || typeof json.head != "number") throw new RangeError("Invalid input for TextSelection.fromJSON");
        return new $ee383ecc396bb319$export$c2b25f346d19bcbb(doc.resolve(json.anchor), doc.resolve(json.head));
    }
    /**
    Create a text selection from non-resolved positions.
    */ static create(doc, anchor, head = anchor) {
        let $anchor = doc.resolve(anchor);
        return new this($anchor, head == anchor ? $anchor : doc.resolve(head));
    }
    /**
    Return a text selection that spans the given positions or, if
    they aren't text positions, find a text selection near them.
    `bias` determines whether the method searches forward (default)
    or backwards (negative number) first. Will fall back to calling
    [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
    doesn't contain a valid text position.
    */ static between($anchor, $head, bias) {
        let dPos = $anchor.pos - $head.pos;
        if (!bias || dPos) bias = dPos >= 0 ? 1 : -1;
        if (!$head.parent.inlineContent) {
            let found = $ee383ecc396bb319$export$52baac22726c72bf.findFrom($head, bias, true) || $ee383ecc396bb319$export$52baac22726c72bf.findFrom($head, -bias, true);
            if (found) $head = found.$head;
            else return $ee383ecc396bb319$export$52baac22726c72bf.near($head, bias);
        }
        if (!$anchor.parent.inlineContent) {
            if (dPos == 0) $anchor = $head;
            else {
                $anchor = ($ee383ecc396bb319$export$52baac22726c72bf.findFrom($anchor, -bias, true) || $ee383ecc396bb319$export$52baac22726c72bf.findFrom($anchor, bias, true)).$anchor;
                if ($anchor.pos < $head.pos != dPos < 0) $anchor = $head;
            }
        }
        return new $ee383ecc396bb319$export$c2b25f346d19bcbb($anchor, $head);
    }
    /**
    Construct a text selection between the given points.
    */ constructor($anchor, $head = $anchor){
        $ee383ecc396bb319$var$checkTextSelection($anchor);
        $ee383ecc396bb319$var$checkTextSelection($head);
        super($anchor, $head);
    }
}
$ee383ecc396bb319$export$52baac22726c72bf.jsonID("text", $ee383ecc396bb319$export$c2b25f346d19bcbb);
class $ee383ecc396bb319$var$TextBookmark {
    map(mapping) {
        return new $ee383ecc396bb319$var$TextBookmark(mapping.map(this.anchor), mapping.map(this.head));
    }
    resolve(doc) {
        return $ee383ecc396bb319$export$c2b25f346d19bcbb.between(doc.resolve(this.anchor), doc.resolve(this.head));
    }
    constructor(anchor, head){
        this.anchor = anchor;
        this.head = head;
    }
}
/**
A node selection is a selection that points at a single node. All
nodes marked [selectable](https://prosemirror.net/docs/ref/#model.NodeSpec.selectable) can be the
target of a node selection. In such a selection, `from` and `to`
point directly before and after the selected node, `anchor` equals
`from`, and `head` equals `to`..
*/ class $ee383ecc396bb319$export$e2940151ac854c0b extends $ee383ecc396bb319$export$52baac22726c72bf {
    map(doc, mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        let $pos = doc.resolve(pos);
        if (deleted) return $ee383ecc396bb319$export$52baac22726c72bf.near($pos);
        return new $ee383ecc396bb319$export$e2940151ac854c0b($pos);
    }
    content() {
        return new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(this.node), 0, 0);
    }
    eq(other) {
        return other instanceof $ee383ecc396bb319$export$e2940151ac854c0b && other.anchor == this.anchor;
    }
    toJSON() {
        return {
            type: "node",
            anchor: this.anchor
        };
    }
    getBookmark() {
        return new $ee383ecc396bb319$var$NodeBookmark(this.anchor);
    }
    /**
    @internal
    */ static fromJSON(doc, json) {
        if (typeof json.anchor != "number") throw new RangeError("Invalid input for NodeSelection.fromJSON");
        return new $ee383ecc396bb319$export$e2940151ac854c0b(doc.resolve(json.anchor));
    }
    /**
    Create a node selection from non-resolved positions.
    */ static create(doc, from) {
        return new $ee383ecc396bb319$export$e2940151ac854c0b(doc.resolve(from));
    }
    /**
    Determines whether the given node may be selected as a node
    selection.
    */ static isSelectable(node) {
        return !node.isText && node.type.spec.selectable !== false;
    }
    /**
    Create a node selection. Does not verify the validity of its
    argument.
    */ constructor($pos){
        let node = $pos.nodeAfter;
        let $end = $pos.node(0).resolve($pos.pos + node.nodeSize);
        super($pos, $end);
        this.node = node;
    }
}
$ee383ecc396bb319$export$e2940151ac854c0b.prototype.visible = false;
$ee383ecc396bb319$export$52baac22726c72bf.jsonID("node", $ee383ecc396bb319$export$e2940151ac854c0b);
class $ee383ecc396bb319$var$NodeBookmark {
    map(mapping) {
        let { deleted: deleted, pos: pos } = mapping.mapResult(this.anchor);
        return deleted ? new $ee383ecc396bb319$var$TextBookmark(pos, pos) : new $ee383ecc396bb319$var$NodeBookmark(pos);
    }
    resolve(doc) {
        let $pos = doc.resolve(this.anchor), node = $pos.nodeAfter;
        if (node && $ee383ecc396bb319$export$e2940151ac854c0b.isSelectable(node)) return new $ee383ecc396bb319$export$e2940151ac854c0b($pos);
        return $ee383ecc396bb319$export$52baac22726c72bf.near($pos);
    }
    constructor(anchor){
        this.anchor = anchor;
    }
}
/**
A selection type that represents selecting the whole document
(which can not necessarily be expressed with a text selection, when
there are for example leaf block nodes at the start or end of the
document).
*/ class $ee383ecc396bb319$export$c15d9ba76bdbcd95 extends $ee383ecc396bb319$export$52baac22726c72bf {
    replace(tr, content = (0, $5SAOw.Slice).empty) {
        if (content == (0, $5SAOw.Slice).empty) {
            tr.delete(0, tr.doc.content.size);
            let sel = $ee383ecc396bb319$export$52baac22726c72bf.atStart(tr.doc);
            if (!sel.eq(tr.selection)) tr.setSelection(sel);
        } else super.replace(tr, content);
    }
    toJSON() {
        return {
            type: "all"
        };
    }
    /**
    @internal
    */ static fromJSON(doc) {
        return new $ee383ecc396bb319$export$c15d9ba76bdbcd95(doc);
    }
    map(doc) {
        return new $ee383ecc396bb319$export$c15d9ba76bdbcd95(doc);
    }
    eq(other) {
        return other instanceof $ee383ecc396bb319$export$c15d9ba76bdbcd95;
    }
    getBookmark() {
        return $ee383ecc396bb319$var$AllBookmark;
    }
    /**
    Create an all-selection over the given document.
    */ constructor(doc){
        super(doc.resolve(0), doc.resolve(doc.content.size));
    }
}
$ee383ecc396bb319$export$52baac22726c72bf.jsonID("all", $ee383ecc396bb319$export$c15d9ba76bdbcd95);
const $ee383ecc396bb319$var$AllBookmark = {
    map () {
        return this;
    },
    resolve (doc) {
        return new $ee383ecc396bb319$export$c15d9ba76bdbcd95(doc);
    }
};
// FIXME we'll need some awareness of text direction when scanning for selections
// Try to find a selection inside the given node. `pos` points at the
// position where the search starts. When `text` is true, only return
// text selections.
function $ee383ecc396bb319$var$findSelectionIn(doc, node, pos, index, dir, text = false) {
    if (node.inlineContent) return $ee383ecc396bb319$export$c2b25f346d19bcbb.create(doc, pos);
    for(let i = index - (dir > 0 ? 0 : 1); dir > 0 ? i < node.childCount : i >= 0; i += dir){
        let child = node.child(i);
        if (!child.isAtom) {
            let inner = $ee383ecc396bb319$var$findSelectionIn(doc, child, pos + dir, dir < 0 ? child.childCount : 0, dir, text);
            if (inner) return inner;
        } else if (!text && $ee383ecc396bb319$export$e2940151ac854c0b.isSelectable(child)) return $ee383ecc396bb319$export$e2940151ac854c0b.create(doc, pos - (dir < 0 ? child.nodeSize : 0));
        pos += child.nodeSize * dir;
    }
    return null;
}
function $ee383ecc396bb319$var$selectionToInsertionEnd(tr, startLen, bias) {
    let last = tr.steps.length - 1;
    if (last < startLen) return;
    let step = tr.steps[last];
    if (!(step instanceof (0, $aXG5V.ReplaceStep) || step instanceof (0, $aXG5V.ReplaceAroundStep))) return;
    let map = tr.mapping.maps[last], end;
    map.forEach((_from, _to, _newFrom, newTo)=>{
        if (end == null) end = newTo;
    });
    tr.setSelection($ee383ecc396bb319$export$52baac22726c72bf.near(tr.doc.resolve(end), bias));
}
const $ee383ecc396bb319$var$UPDATED_SEL = 1, $ee383ecc396bb319$var$UPDATED_MARKS = 2, $ee383ecc396bb319$var$UPDATED_SCROLL = 4;
/**
An editor state transaction, which can be applied to a state to
create an updated state. Use
[`EditorState.tr`](https://prosemirror.net/docs/ref/#state.EditorState.tr) to create an instance.

Transactions track changes to the document (they are a subclass of
[`Transform`](https://prosemirror.net/docs/ref/#transform.Transform)), but also other state changes,
like selection updates and adjustments of the set of [stored
marks](https://prosemirror.net/docs/ref/#state.EditorState.storedMarks). In addition, you can store
metadata properties in a transaction, which are extra pieces of
information that client code or plugins can use to describe what a
transaction represents, so that they can update their [own
state](https://prosemirror.net/docs/ref/#state.StateField) accordingly.

The [editor view](https://prosemirror.net/docs/ref/#view.EditorView) uses a few metadata
properties: it will attach a property `"pointer"` with the value
`true` to selection transactions directly caused by mouse or touch
input, a `"composition"` property holding an ID identifying the
composition that caused it to transactions caused by composed DOM
input, and a `"uiEvent"` property of that may be `"paste"`,
`"cut"`, or `"drop"`.
*/ class $ee383ecc396bb319$export$febc5573c75cefb0 extends (0, $aXG5V.Transform) {
    /**
    The transaction's current selection. This defaults to the editor
    selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
    transaction, but can be overwritten with
    [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
    */ get selection() {
        if (this.curSelectionFor < this.steps.length) {
            this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor));
            this.curSelectionFor = this.steps.length;
        }
        return this.curSelection;
    }
    /**
    Update the transaction's current selection. Will determine the
    selection that the editor gets when the transaction is applied.
    */ setSelection(selection) {
        if (selection.$from.doc != this.doc) throw new RangeError("Selection passed to setSelection must point at the current document");
        this.curSelection = selection;
        this.curSelectionFor = this.steps.length;
        this.updated = (this.updated | $ee383ecc396bb319$var$UPDATED_SEL) & ~$ee383ecc396bb319$var$UPDATED_MARKS;
        this.storedMarks = null;
        return this;
    }
    /**
    Whether the selection was explicitly updated by this transaction.
    */ get selectionSet() {
        return (this.updated & $ee383ecc396bb319$var$UPDATED_SEL) > 0;
    }
    /**
    Set the current stored marks.
    */ setStoredMarks(marks) {
        this.storedMarks = marks;
        this.updated |= $ee383ecc396bb319$var$UPDATED_MARKS;
        return this;
    }
    /**
    Make sure the current stored marks or, if that is null, the marks
    at the selection, match the given set of marks. Does nothing if
    this is already the case.
    */ ensureMarks(marks) {
        if (!(0, $5SAOw.Mark).sameSet(this.storedMarks || this.selection.$from.marks(), marks)) this.setStoredMarks(marks);
        return this;
    }
    /**
    Add a mark to the set of stored marks.
    */ addStoredMark(mark) {
        return this.ensureMarks(mark.addToSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Remove a mark or mark type from the set of stored marks.
    */ removeStoredMark(mark) {
        return this.ensureMarks(mark.removeFromSet(this.storedMarks || this.selection.$head.marks()));
    }
    /**
    Whether the stored marks were explicitly set for this transaction.
    */ get storedMarksSet() {
        return (this.updated & $ee383ecc396bb319$var$UPDATED_MARKS) > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        super.addStep(step, doc);
        this.updated = this.updated & ~$ee383ecc396bb319$var$UPDATED_MARKS;
        this.storedMarks = null;
    }
    /**
    Update the timestamp for the transaction.
    */ setTime(time) {
        this.time = time;
        return this;
    }
    /**
    Replace the current selection with the given slice.
    */ replaceSelection(slice) {
        this.selection.replace(this, slice);
        return this;
    }
    /**
    Replace the selection with the given node. When `inheritMarks` is
    true and the content is inline, it inherits the marks from the
    place where it is inserted.
    */ replaceSelectionWith(node, inheritMarks = true) {
        let selection = this.selection;
        if (inheritMarks) node = node.mark(this.storedMarks || (selection.empty ? selection.$from.marks() : selection.$from.marksAcross(selection.$to) || (0, $5SAOw.Mark).none));
        selection.replaceWith(this, node);
        return this;
    }
    /**
    Delete the selection.
    */ deleteSelection() {
        this.selection.replace(this);
        return this;
    }
    /**
    Replace the given range, or the selection if no range is given,
    with a text node containing the given string.
    */ insertText(text, from, to) {
        let schema = this.doc.type.schema;
        if (from == null) {
            if (!text) return this.deleteSelection();
            return this.replaceSelectionWith(schema.text(text), true);
        } else {
            if (to == null) to = from;
            to = to == null ? from : to;
            if (!text) return this.deleteRange(from, to);
            let marks = this.storedMarks;
            if (!marks) {
                let $from = this.doc.resolve(from);
                marks = to == from ? $from.marks() : $from.marksAcross(this.doc.resolve(to));
            }
            this.replaceRangeWith(from, to, schema.text(text, marks));
            if (!this.selection.empty) this.setSelection($ee383ecc396bb319$export$52baac22726c72bf.near(this.selection.$to));
            return this;
        }
    }
    /**
    Store a metadata property in this transaction, keyed either by
    name or by plugin.
    */ setMeta(key, value) {
        this.meta[typeof key == "string" ? key : key.key] = value;
        return this;
    }
    /**
    Retrieve a metadata property for a given name or plugin.
    */ getMeta(key) {
        return this.meta[typeof key == "string" ? key : key.key];
    }
    /**
    Returns true if this transaction doesn't contain any metadata,
    and can thus safely be extended.
    */ get isGeneric() {
        for(let _ in this.meta)return false;
        return true;
    }
    /**
    Indicate that the editor should scroll the selection into view
    when updated to the state produced by this transaction.
    */ scrollIntoView() {
        this.updated |= $ee383ecc396bb319$var$UPDATED_SCROLL;
        return this;
    }
    /**
    True when this transaction has had `scrollIntoView` called on it.
    */ get scrolledIntoView() {
        return (this.updated & $ee383ecc396bb319$var$UPDATED_SCROLL) > 0;
    }
    /**
    @internal
    */ constructor(state){
        super(state.doc);
        // The step count for which the current selection is valid.
        this.curSelectionFor = 0;
        // Bitfield to track which aspects of the state were updated by
        // this transaction.
        this.updated = 0;
        // Object used to store metadata properties for the transaction.
        this.meta = Object.create(null);
        this.time = Date.now();
        this.curSelection = state.selection;
        this.storedMarks = state.storedMarks;
    }
}
function $ee383ecc396bb319$var$bind(f, self) {
    return !self || !f ? f : f.bind(self);
}
class $ee383ecc396bb319$var$FieldDesc {
    constructor(name, desc, self){
        this.name = name;
        this.init = $ee383ecc396bb319$var$bind(desc.init, self);
        this.apply = $ee383ecc396bb319$var$bind(desc.apply, self);
    }
}
const $ee383ecc396bb319$var$baseFields = [
    new $ee383ecc396bb319$var$FieldDesc("doc", {
        init (config) {
            return config.doc || config.schema.topNodeType.createAndFill();
        },
        apply (tr) {
            return tr.doc;
        }
    }),
    new $ee383ecc396bb319$var$FieldDesc("selection", {
        init (config, instance) {
            return config.selection || $ee383ecc396bb319$export$52baac22726c72bf.atStart(instance.doc);
        },
        apply (tr) {
            return tr.selection;
        }
    }),
    new $ee383ecc396bb319$var$FieldDesc("storedMarks", {
        init (config) {
            return config.storedMarks || null;
        },
        apply (tr, _marks, _old, state) {
            return state.selection.$cursor ? tr.storedMarks : null;
        }
    }),
    new $ee383ecc396bb319$var$FieldDesc("scrollToSelection", {
        init () {
            return 0;
        },
        apply (tr, prev) {
            return tr.scrolledIntoView ? prev + 1 : prev;
        }
    })
];
// Object wrapping the part of a state object that stays the same
// across transactions. Stored in the state's `config` property.
class $ee383ecc396bb319$var$Configuration {
    constructor(schema, plugins){
        this.schema = schema;
        this.plugins = [];
        this.pluginsByKey = Object.create(null);
        this.fields = $ee383ecc396bb319$var$baseFields.slice();
        if (plugins) plugins.forEach((plugin)=>{
            if (this.pluginsByKey[plugin.key]) throw new RangeError("Adding different instances of a keyed plugin (" + plugin.key + ")");
            this.plugins.push(plugin);
            this.pluginsByKey[plugin.key] = plugin;
            if (plugin.spec.state) this.fields.push(new $ee383ecc396bb319$var$FieldDesc(plugin.key, plugin.spec.state, plugin));
        });
    }
}
/**
The state of a ProseMirror editor is represented by an object of
this type. A state is a persistent data structure—it isn't
updated, but rather a new state value is computed from an old one
using the [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) method.

A state holds a number of built-in fields, and plugins can
[define](https://prosemirror.net/docs/ref/#state.PluginSpec.state) additional fields.
*/ class $ee383ecc396bb319$export$afa855cbfaff27f2 {
    /**
    The schema of the state's document.
    */ get schema() {
        return this.config.schema;
    }
    /**
    The plugins that are active in this state.
    */ get plugins() {
        return this.config.plugins;
    }
    /**
    Apply the given transaction to produce a new state.
    */ apply(tr) {
        return this.applyTransaction(tr).state;
    }
    /**
    @internal
    */ filterTransaction(tr, ignore = -1) {
        for(let i = 0; i < this.config.plugins.length; i++)if (i != ignore) {
            let plugin = this.config.plugins[i];
            if (plugin.spec.filterTransaction && !plugin.spec.filterTransaction.call(plugin, tr, this)) return false;
        }
        return true;
    }
    /**
    Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
    returns the precise transactions that were applied (which might
    be influenced by the [transaction
    hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
    plugins) along with the new state.
    */ applyTransaction(rootTr) {
        if (!this.filterTransaction(rootTr)) return {
            state: this,
            transactions: []
        };
        let trs = [
            rootTr
        ], newState = this.applyInner(rootTr), seen = null;
        // This loop repeatedly gives plugins a chance to respond to
        // transactions as new transactions are added, making sure to only
        // pass the transactions the plugin did not see before.
        for(;;){
            let haveNew = false;
            for(let i = 0; i < this.config.plugins.length; i++){
                let plugin = this.config.plugins[i];
                if (plugin.spec.appendTransaction) {
                    let n = seen ? seen[i].n : 0, oldState = seen ? seen[i].state : this;
                    let tr = n < trs.length && plugin.spec.appendTransaction.call(plugin, n ? trs.slice(n) : trs, oldState, newState);
                    if (tr && newState.filterTransaction(tr, i)) {
                        tr.setMeta("appendedTransaction", rootTr);
                        if (!seen) {
                            seen = [];
                            for(let j = 0; j < this.config.plugins.length; j++)seen.push(j < i ? {
                                state: newState,
                                n: trs.length
                            } : {
                                state: this,
                                n: 0
                            });
                        }
                        trs.push(tr);
                        newState = newState.applyInner(tr);
                        haveNew = true;
                    }
                    if (seen) seen[i] = {
                        state: newState,
                        n: trs.length
                    };
                }
            }
            if (!haveNew) return {
                state: newState,
                transactions: trs
            };
        }
    }
    /**
    @internal
    */ applyInner(tr) {
        if (!tr.before.eq(this.doc)) throw new RangeError("Applying a mismatched transaction");
        let newInstance = new $ee383ecc396bb319$export$afa855cbfaff27f2(this.config), fields = this.config.fields;
        for(let i = 0; i < fields.length; i++){
            let field = fields[i];
            newInstance[field.name] = field.apply(tr, this[field.name], this, newInstance);
        }
        return newInstance;
    }
    /**
    Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
    */ get tr() {
        return new $ee383ecc396bb319$export$febc5573c75cefb0(this);
    }
    /**
    Create a new state.
    */ static create(config) {
        let $config = new $ee383ecc396bb319$var$Configuration(config.doc ? config.doc.type.schema : config.schema, config.plugins);
        let instance = new $ee383ecc396bb319$export$afa855cbfaff27f2($config);
        for(let i = 0; i < $config.fields.length; i++)instance[$config.fields[i].name] = $config.fields[i].init(config, instance);
        return instance;
    }
    /**
    Create a new state based on this one, but with an adjusted set
    of active plugins. State fields that exist in both sets of
    plugins are kept unchanged. Those that no longer exist are
    dropped, and those that are new are initialized using their
    [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
    configuration object..
    */ reconfigure(config) {
        let $config = new $ee383ecc396bb319$var$Configuration(this.schema, config.plugins);
        let fields = $config.fields, instance = new $ee383ecc396bb319$export$afa855cbfaff27f2($config);
        for(let i = 0; i < fields.length; i++){
            let name = fields[i].name;
            instance[name] = this.hasOwnProperty(name) ? this[name] : fields[i].init(config, instance);
        }
        return instance;
    }
    /**
    Serialize this state to JSON. If you want to serialize the state
    of plugins, pass an object mapping property names to use in the
    resulting JSON object to plugin objects. The argument may also be
    a string or number, in which case it is ignored, to support the
    way `JSON.stringify` calls `toString` methods.
    */ toJSON(pluginFields) {
        let result = {
            doc: this.doc.toJSON(),
            selection: this.selection.toJSON()
        };
        if (this.storedMarks) result.storedMarks = this.storedMarks.map((m)=>m.toJSON());
        if (pluginFields && typeof pluginFields == 'object') for(let prop in pluginFields){
            if (prop == "doc" || prop == "selection") throw new RangeError("The JSON fields `doc` and `selection` are reserved");
            let plugin = pluginFields[prop], state = plugin.spec.state;
            if (state && state.toJSON) result[prop] = state.toJSON.call(plugin, this[plugin.key]);
        }
        return result;
    }
    /**
    Deserialize a JSON representation of a state. `config` should
    have at least a `schema` field, and should contain array of
    plugins to initialize the state with. `pluginFields` can be used
    to deserialize the state of plugins, by associating plugin
    instances with the property names they use in the JSON object.
    */ static fromJSON(config, json, pluginFields) {
        if (!json) throw new RangeError("Invalid input for EditorState.fromJSON");
        if (!config.schema) throw new RangeError("Required config field 'schema' missing");
        let $config = new $ee383ecc396bb319$var$Configuration(config.schema, config.plugins);
        let instance = new $ee383ecc396bb319$export$afa855cbfaff27f2($config);
        $config.fields.forEach((field)=>{
            if (field.name == "doc") instance.doc = (0, $5SAOw.Node).fromJSON(config.schema, json.doc);
            else if (field.name == "selection") instance.selection = $ee383ecc396bb319$export$52baac22726c72bf.fromJSON(instance.doc, json.selection);
            else if (field.name == "storedMarks") {
                if (json.storedMarks) instance.storedMarks = json.storedMarks.map(config.schema.markFromJSON);
            } else {
                if (pluginFields) for(let prop in pluginFields){
                    let plugin = pluginFields[prop], state = plugin.spec.state;
                    if (plugin.key == field.name && state && state.fromJSON && Object.prototype.hasOwnProperty.call(json, prop)) {
                        instance[field.name] = state.fromJSON.call(plugin, config, json[prop], instance);
                        return;
                    }
                }
                instance[field.name] = field.init(config, instance);
            }
        });
        return instance;
    }
    /**
    @internal
    */ constructor(/**
    @internal
    */ config){
        this.config = config;
    }
}
function $ee383ecc396bb319$var$bindProps(obj, self, target) {
    for(let prop in obj){
        let val = obj[prop];
        if (val instanceof Function) val = val.bind(self);
        else if (prop == "handleDOMEvents") val = $ee383ecc396bb319$var$bindProps(val, self, {});
        target[prop] = val;
    }
    return target;
}
/**
Plugins bundle functionality that can be added to an editor.
They are part of the [editor state](https://prosemirror.net/docs/ref/#state.EditorState) and
may influence that state and the view that contains it.
*/ class $ee383ecc396bb319$export$901cf72dabf2112a {
    /**
    Extract the plugin's state field from an editor state.
    */ getState(state) {
        return state[this.key];
    }
    /**
    Create a plugin.
    */ constructor(/**
    The plugin's [spec object](https://prosemirror.net/docs/ref/#state.PluginSpec).
    */ spec){
        this.spec = spec;
        /**
        The [props](https://prosemirror.net/docs/ref/#view.EditorProps) exported by this plugin.
        */ this.props = {};
        if (spec.props) $ee383ecc396bb319$var$bindProps(spec.props, this, this.props);
        this.key = spec.key ? spec.key.key : $ee383ecc396bb319$var$createKey("plugin");
    }
}
const $ee383ecc396bb319$var$keys = Object.create(null);
function $ee383ecc396bb319$var$createKey(name) {
    if (name in $ee383ecc396bb319$var$keys) return name + "$" + ++$ee383ecc396bb319$var$keys[name];
    $ee383ecc396bb319$var$keys[name] = 0;
    return name + "$";
}
/**
A key is used to [tag](https://prosemirror.net/docs/ref/#state.PluginSpec.key) plugins in a way
that makes it possible to find them, given an editor state.
Assigning a key does mean only one plugin of that type can be
active in a state.
*/ class $ee383ecc396bb319$export$1692d8b0e89cecc3 {
    /**
    Get the active plugin with this key, if any, from an editor
    state.
    */ get(state) {
        return state.config.pluginsByKey[this.key];
    }
    /**
    Get the plugin's state from an editor state.
    */ getState(state) {
        return state[this.key];
    }
    /**
    Create a plugin key.
    */ constructor(name = "key"){
        this.key = $ee383ecc396bb319$var$createKey(name);
    }
}
module.exports["Selection"] = $ee383ecc396bb319$export$52baac22726c72bf;
module.exports["TextSelection"] = $ee383ecc396bb319$export$c2b25f346d19bcbb;
module.exports["AllSelection"] = $ee383ecc396bb319$export$c15d9ba76bdbcd95;
module.exports["SelectionRange"] = $ee383ecc396bb319$export$7bd1839c3c5d5bd4;
module.exports["NodeSelection"] = $ee383ecc396bb319$export$e2940151ac854c0b;
module.exports["Transaction"] = $ee383ecc396bb319$export$febc5573c75cefb0;
module.exports["EditorState"] = $ee383ecc396bb319$export$afa855cbfaff27f2;
module.exports["Plugin"] = $ee383ecc396bb319$export$901cf72dabf2112a;
module.exports["PluginKey"] = $ee383ecc396bb319$export$1692d8b0e89cecc3;

});

parcelRegister("aXG5V", function(module, exports) {

var $5SAOw = parcelRequire("5SAOw");

// Recovery values encode a range index and an offset. They are
// represented as numbers, because tons of them will be created when
// mapping, for example, a large number of decorations. The number's
// lower 16 bits provide the index, the remaining bits the offset.
//
// Note: We intentionally don't use bit shift operators to en- and
// decode these, since those clip to 32 bits, which we might in rare
// cases want to overflow. A 64-bit float can represent 48-bit
// integers precisely.
const $7fb0112872b78c0a$var$lower16 = 0xffff;
const $7fb0112872b78c0a$var$factor16 = Math.pow(2, 16);
function $7fb0112872b78c0a$var$makeRecover(index, offset) {
    return index + offset * $7fb0112872b78c0a$var$factor16;
}
function $7fb0112872b78c0a$var$recoverIndex(value) {
    return value & $7fb0112872b78c0a$var$lower16;
}
function $7fb0112872b78c0a$var$recoverOffset(value) {
    return (value - (value & $7fb0112872b78c0a$var$lower16)) / $7fb0112872b78c0a$var$factor16;
}
const $7fb0112872b78c0a$var$DEL_BEFORE = 1, $7fb0112872b78c0a$var$DEL_AFTER = 2, $7fb0112872b78c0a$var$DEL_ACROSS = 4, $7fb0112872b78c0a$var$DEL_SIDE = 8;
/**
An object representing a mapped position with extra
information.
*/ class $7fb0112872b78c0a$export$c77c9be41668e9b4 {
    /**
    Tells you whether the position was deleted, that is, whether the
    step removed the token on the side queried (via the `assoc`)
    argument from the document.
    */ get deleted() {
        return (this.delInfo & $7fb0112872b78c0a$var$DEL_SIDE) > 0;
    }
    /**
    Tells you whether the token before the mapped position was deleted.
    */ get deletedBefore() {
        return (this.delInfo & ($7fb0112872b78c0a$var$DEL_BEFORE | $7fb0112872b78c0a$var$DEL_ACROSS)) > 0;
    }
    /**
    True when the token after the mapped position was deleted.
    */ get deletedAfter() {
        return (this.delInfo & ($7fb0112872b78c0a$var$DEL_AFTER | $7fb0112872b78c0a$var$DEL_ACROSS)) > 0;
    }
    /**
    Tells whether any of the steps mapped through deletes across the
    position (including both the token before and after the
    position).
    */ get deletedAcross() {
        return (this.delInfo & $7fb0112872b78c0a$var$DEL_ACROSS) > 0;
    }
    /**
    @internal
    */ constructor(/**
    The mapped version of the position.
    */ pos, /**
    @internal
    */ delInfo, /**
    @internal
    */ recover){
        this.pos = pos;
        this.delInfo = delInfo;
        this.recover = recover;
    }
}
/**
A map describing the deletions and insertions made by a step, which
can be used to find the correspondence between positions in the
pre-step version of a document and the same position in the
post-step version.
*/ class $7fb0112872b78c0a$export$c53d01c3ab9721b3 {
    /**
    @internal
    */ recover(value) {
        let diff = 0, index = $7fb0112872b78c0a$var$recoverIndex(value);
        if (!this.inverted) for(let i = 0; i < index; i++)diff += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
        return this.ranges[index * 3] + diff + $7fb0112872b78c0a$var$recoverOffset(value);
    }
    mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    map(pos, assoc = 1) {
        return this._map(pos, assoc, true);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let diff = 0, oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex], end = start + oldSize;
            if (pos <= end) {
                let side = !oldSize ? assoc : pos == start ? -1 : pos == end ? 1 : assoc;
                let result = start + diff + (side < 0 ? 0 : newSize);
                if (simple) return result;
                let recover = pos == (assoc < 0 ? start : end) ? null : $7fb0112872b78c0a$var$makeRecover(i / 3, pos - start);
                let del = pos == start ? $7fb0112872b78c0a$var$DEL_AFTER : pos == end ? $7fb0112872b78c0a$var$DEL_BEFORE : $7fb0112872b78c0a$var$DEL_ACROSS;
                if (assoc < 0 ? pos != start : pos != end) del |= $7fb0112872b78c0a$var$DEL_SIDE;
                return new $7fb0112872b78c0a$export$c77c9be41668e9b4(result, del, recover);
            }
            diff += newSize - oldSize;
        }
        return simple ? pos + diff : new $7fb0112872b78c0a$export$c77c9be41668e9b4(pos + diff, 0, null);
    }
    /**
    @internal
    */ touches(pos, recover) {
        let diff = 0, index = $7fb0112872b78c0a$var$recoverIndex(recover);
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i] - (this.inverted ? diff : 0);
            if (start > pos) break;
            let oldSize = this.ranges[i + oldIndex], end = start + oldSize;
            if (pos <= end && i == index * 3) return true;
            diff += this.ranges[i + newIndex] - oldSize;
        }
        return false;
    }
    /**
    Calls the given function on each of the changed ranges included in
    this map.
    */ forEach(f) {
        let oldIndex = this.inverted ? 2 : 1, newIndex = this.inverted ? 1 : 2;
        for(let i = 0, diff = 0; i < this.ranges.length; i += 3){
            let start = this.ranges[i], oldStart = start - (this.inverted ? diff : 0), newStart = start + (this.inverted ? 0 : diff);
            let oldSize = this.ranges[i + oldIndex], newSize = this.ranges[i + newIndex];
            f(oldStart, oldStart + oldSize, newStart, newStart + newSize);
            diff += newSize - oldSize;
        }
    }
    /**
    Create an inverted version of this map. The result can be used to
    map positions in the post-step document to the pre-step document.
    */ invert() {
        return new $7fb0112872b78c0a$export$c53d01c3ab9721b3(this.ranges, !this.inverted);
    }
    /**
    @internal
    */ toString() {
        return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
    }
    /**
    Create a map that moves all positions by offset `n` (which may be
    negative). This can be useful when applying steps meant for a
    sub-document to a larger document, or vice-versa.
    */ static offset(n) {
        return n == 0 ? $7fb0112872b78c0a$export$c53d01c3ab9721b3.empty : new $7fb0112872b78c0a$export$c53d01c3ab9721b3(n < 0 ? [
            0,
            -n,
            0
        ] : [
            0,
            0,
            n
        ]);
    }
    /**
    Create a position map. The modifications to the document are
    represented as an array of numbers, in which each group of three
    represents a modified chunk as `[start, oldSize, newSize]`.
    */ constructor(/**
    @internal
    */ ranges, /**
    @internal
    */ inverted = false){
        this.ranges = ranges;
        this.inverted = inverted;
        if (!ranges.length && $7fb0112872b78c0a$export$c53d01c3ab9721b3.empty) return $7fb0112872b78c0a$export$c53d01c3ab9721b3.empty;
    }
}
/**
A StepMap that contains no changed ranges.
*/ $7fb0112872b78c0a$export$c53d01c3ab9721b3.empty = new $7fb0112872b78c0a$export$c53d01c3ab9721b3([]);
/**
A mapping represents a pipeline of zero or more [step
maps](https://prosemirror.net/docs/ref/#transform.StepMap). It has special provisions for losslessly
handling mapping positions through a series of steps in which some
steps are inverted versions of earlier steps. (This comes up when
‘[rebasing](/docs/guide/#transform.rebasing)’ steps for
collaboration or history management.)
*/ class $7fb0112872b78c0a$export$f5f785078011b62 {
    /**
    Create a mapping that maps only through a part of this one.
    */ slice(from = 0, to = this.maps.length) {
        return new $7fb0112872b78c0a$export$f5f785078011b62(this.maps, this.mirror, from, to);
    }
    /**
    @internal
    */ copy() {
        return new $7fb0112872b78c0a$export$f5f785078011b62(this.maps.slice(), this.mirror && this.mirror.slice(), this.from, this.to);
    }
    /**
    Add a step map to the end of this mapping. If `mirrors` is
    given, it should be the index of the step map that is the mirror
    image of this one.
    */ appendMap(map, mirrors) {
        this.to = this.maps.push(map);
        if (mirrors != null) this.setMirror(this.maps.length - 1, mirrors);
    }
    /**
    Add all the step maps in a given mapping to this one (preserving
    mirroring information).
    */ appendMapping(mapping) {
        for(let i = 0, startSize = this.maps.length; i < mapping.maps.length; i++){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i], mirr != null && mirr < i ? startSize + mirr : undefined);
        }
    }
    /**
    Finds the offset of the step map that mirrors the map at the
    given offset, in this mapping (as per the second argument to
    `appendMap`).
    */ getMirror(n) {
        if (this.mirror) {
            for(let i = 0; i < this.mirror.length; i++)if (this.mirror[i] == n) return this.mirror[i + (i % 2 ? -1 : 1)];
        }
    }
    /**
    @internal
    */ setMirror(n, m) {
        if (!this.mirror) this.mirror = [];
        this.mirror.push(n, m);
    }
    /**
    Append the inverse of the given mapping to this one.
    */ appendMappingInverted(mapping) {
        for(let i = mapping.maps.length - 1, totalSize = this.maps.length + mapping.maps.length; i >= 0; i--){
            let mirr = mapping.getMirror(i);
            this.appendMap(mapping.maps[i].invert(), mirr != null && mirr > i ? totalSize - mirr - 1 : undefined);
        }
    }
    /**
    Create an inverted version of this mapping.
    */ invert() {
        let inverse = new $7fb0112872b78c0a$export$f5f785078011b62;
        inverse.appendMappingInverted(this);
        return inverse;
    }
    /**
    Map a position through this mapping.
    */ map(pos, assoc = 1) {
        if (this.mirror) return this._map(pos, assoc, true);
        for(let i = this.from; i < this.to; i++)pos = this.maps[i].map(pos, assoc);
        return pos;
    }
    /**
    Map a position through this mapping, returning a mapping
    result.
    */ mapResult(pos, assoc = 1) {
        return this._map(pos, assoc, false);
    }
    /**
    @internal
    */ _map(pos, assoc, simple) {
        let delInfo = 0;
        for(let i = this.from; i < this.to; i++){
            let map = this.maps[i], result = map.mapResult(pos, assoc);
            if (result.recover != null) {
                let corr = this.getMirror(i);
                if (corr != null && corr > i && corr < this.to) {
                    i = corr;
                    pos = this.maps[corr].recover(result.recover);
                    continue;
                }
            }
            delInfo |= result.delInfo;
            pos = result.pos;
        }
        return simple ? pos : new $7fb0112872b78c0a$export$c77c9be41668e9b4(pos, delInfo, null);
    }
    /**
    Create a new mapping with the given position maps.
    */ constructor(/**
    The step maps in this mapping.
    */ maps = [], /**
    @internal
    */ mirror, /**
    The starting position in the `maps` array, used when `map` or
    `mapResult` is called.
    */ from = 0, /**
    The end position in the `maps` array.
    */ to = maps.length){
        this.maps = maps;
        this.mirror = mirror;
        this.from = from;
        this.to = to;
    }
}
const $7fb0112872b78c0a$var$stepsByID = Object.create(null);
/**
A step object represents an atomic change. It generally applies
only to the document it was created for, since the positions
stored in it will only make sense for that document.

New steps are defined by creating classes that extend `Step`,
overriding the `apply`, `invert`, `map`, `getMap` and `fromJSON`
methods, and registering your class with a unique
JSON-serialization identifier using
[`Step.jsonID`](https://prosemirror.net/docs/ref/#transform.Step^jsonID).
*/ class $7fb0112872b78c0a$export$fd55ce593607084a {
    /**
    Get the step map that represents the changes made by this step,
    and which can be used to transform between positions in the old
    and the new document.
    */ getMap() {
        return $7fb0112872b78c0a$export$c53d01c3ab9721b3.empty;
    }
    /**
    Try to merge this step with another one, to be applied directly
    after it. Returns the merged step when possible, null if the
    steps can't be merged.
    */ merge(other) {
        return null;
    }
    /**
    Deserialize a step from its JSON representation. Will call
    through to the step class' own implementation of this method.
    */ static fromJSON(schema, json) {
        if (!json || !json.stepType) throw new RangeError("Invalid input for Step.fromJSON");
        let type = $7fb0112872b78c0a$var$stepsByID[json.stepType];
        if (!type) throw new RangeError(`No step type ${json.stepType} defined`);
        return type.fromJSON(schema, json);
    }
    /**
    To be able to serialize steps to JSON, each step needs a string
    ID to attach to its JSON representation. Use this method to
    register an ID for your step classes. Try to pick something
    that's unlikely to clash with steps from other modules.
    */ static jsonID(id, stepClass) {
        if (id in $7fb0112872b78c0a$var$stepsByID) throw new RangeError("Duplicate use of step JSON ID " + id);
        $7fb0112872b78c0a$var$stepsByID[id] = stepClass;
        stepClass.prototype.jsonID = id;
        return stepClass;
    }
}
/**
The result of [applying](https://prosemirror.net/docs/ref/#transform.Step.apply) a step. Contains either a
new document or a failure value.
*/ class $7fb0112872b78c0a$export$8ebf1578a4199c09 {
    /**
    Create a successful step result.
    */ static ok(doc) {
        return new $7fb0112872b78c0a$export$8ebf1578a4199c09(doc, null);
    }
    /**
    Create a failed step result.
    */ static fail(message) {
        return new $7fb0112872b78c0a$export$8ebf1578a4199c09(null, message);
    }
    /**
    Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
    arguments. Create a successful result if it succeeds, and a
    failed one if it throws a `ReplaceError`.
    */ static fromReplace(doc, from, to, slice) {
        try {
            return $7fb0112872b78c0a$export$8ebf1578a4199c09.ok(doc.replace(from, to, slice));
        } catch (e) {
            if (e instanceof (0, $5SAOw.ReplaceError)) return $7fb0112872b78c0a$export$8ebf1578a4199c09.fail(e.message);
            throw e;
        }
    }
    /**
    @internal
    */ constructor(/**
    The transformed document, if successful.
    */ doc, /**
    The failure message, if unsuccessful.
    */ failed){
        this.doc = doc;
        this.failed = failed;
    }
}
function $7fb0112872b78c0a$var$mapFragment(fragment, f, parent) {
    let mapped = [];
    for(let i = 0; i < fragment.childCount; i++){
        let child = fragment.child(i);
        if (child.content.size) child = child.copy($7fb0112872b78c0a$var$mapFragment(child.content, f, child));
        if (child.isInline) child = f(child, parent, i);
        mapped.push(child);
    }
    return (0, $5SAOw.Fragment).fromArray(mapped);
}
/**
Add a mark to all inline content between two positions.
*/ class $7fb0112872b78c0a$export$d24ba56b0e3464a9 extends $7fb0112872b78c0a$export$fd55ce593607084a {
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to), $from = doc.resolve(this.from);
        let parent = $from.node($from.sharedDepth(this.to));
        let slice = new (0, $5SAOw.Slice)($7fb0112872b78c0a$var$mapFragment(oldSlice.content, (node, parent)=>{
            if (!node.isAtom || !parent.type.allowsMarkType(this.mark.type)) return node;
            return node.mark(this.mark.addToSet(node.marks));
        }, parent), oldSlice.openStart, oldSlice.openEnd);
        return $7fb0112872b78c0a$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $7fb0112872b78c0a$export$94150db1311f67a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $7fb0112872b78c0a$export$d24ba56b0e3464a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $7fb0112872b78c0a$export$d24ba56b0e3464a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $7fb0112872b78c0a$export$d24ba56b0e3464a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "addMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for AddMarkStep.fromJSON");
        return new $7fb0112872b78c0a$export$d24ba56b0e3464a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
    /**
    Create a mark step.
    */ constructor(/**
    The start of the marked range.
    */ from, /**
    The end of the marked range.
    */ to, /**
    The mark to add.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
}
$7fb0112872b78c0a$export$fd55ce593607084a.jsonID("addMark", $7fb0112872b78c0a$export$d24ba56b0e3464a9);
/**
Remove a mark from all inline content between two positions.
*/ class $7fb0112872b78c0a$export$94150db1311f67a9 extends $7fb0112872b78c0a$export$fd55ce593607084a {
    apply(doc) {
        let oldSlice = doc.slice(this.from, this.to);
        let slice = new (0, $5SAOw.Slice)($7fb0112872b78c0a$var$mapFragment(oldSlice.content, (node)=>{
            return node.mark(this.mark.removeFromSet(node.marks));
        }, doc), oldSlice.openStart, oldSlice.openEnd);
        return $7fb0112872b78c0a$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, slice);
    }
    invert() {
        return new $7fb0112872b78c0a$export$d24ba56b0e3464a9(this.from, this.to, this.mark);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deleted && to.deleted || from.pos >= to.pos) return null;
        return new $7fb0112872b78c0a$export$94150db1311f67a9(from.pos, to.pos, this.mark);
    }
    merge(other) {
        if (other instanceof $7fb0112872b78c0a$export$94150db1311f67a9 && other.mark.eq(this.mark) && this.from <= other.to && this.to >= other.from) return new $7fb0112872b78c0a$export$94150db1311f67a9(Math.min(this.from, other.from), Math.max(this.to, other.to), this.mark);
        return null;
    }
    toJSON() {
        return {
            stepType: "removeMark",
            mark: this.mark.toJSON(),
            from: this.from,
            to: this.to
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
        return new $7fb0112872b78c0a$export$94150db1311f67a9(json.from, json.to, schema.markFromJSON(json.mark));
    }
    /**
    Create a mark-removing step.
    */ constructor(/**
    The start of the unmarked range.
    */ from, /**
    The end of the unmarked range.
    */ to, /**
    The mark to remove.
    */ mark){
        super();
        this.from = from;
        this.to = to;
        this.mark = mark;
    }
}
$7fb0112872b78c0a$export$fd55ce593607084a.jsonID("removeMark", $7fb0112872b78c0a$export$94150db1311f67a9);
/**
Add a mark to a specific node.
*/ class $7fb0112872b78c0a$export$adefd16c402fee4e extends $7fb0112872b78c0a$export$fd55ce593607084a {
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $7fb0112872b78c0a$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.addToSet(node.marks));
        return $7fb0112872b78c0a$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (node) {
            let newSet = this.mark.addToSet(node.marks);
            if (newSet.length == node.marks.length) {
                for(let i = 0; i < node.marks.length; i++)if (!node.marks[i].isInSet(newSet)) return new $7fb0112872b78c0a$export$adefd16c402fee4e(this.pos, node.marks[i]);
                return new $7fb0112872b78c0a$export$adefd16c402fee4e(this.pos, this.mark);
            }
        }
        return new $7fb0112872b78c0a$export$fdf7d1dc10724da2(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $7fb0112872b78c0a$export$adefd16c402fee4e(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "addNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
        return new $7fb0112872b78c0a$export$adefd16c402fee4e(json.pos, schema.markFromJSON(json.mark));
    }
    /**
    Create a node mark step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to add.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
}
$7fb0112872b78c0a$export$fd55ce593607084a.jsonID("addNodeMark", $7fb0112872b78c0a$export$adefd16c402fee4e);
/**
Remove a mark from a specific node.
*/ class $7fb0112872b78c0a$export$fdf7d1dc10724da2 extends $7fb0112872b78c0a$export$fd55ce593607084a {
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $7fb0112872b78c0a$export$8ebf1578a4199c09.fail("No node at mark step's position");
        let updated = node.type.create(node.attrs, null, this.mark.removeFromSet(node.marks));
        return $7fb0112872b78c0a$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    invert(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node || !this.mark.isInSet(node.marks)) return this;
        return new $7fb0112872b78c0a$export$adefd16c402fee4e(this.pos, this.mark);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $7fb0112872b78c0a$export$fdf7d1dc10724da2(pos.pos, this.mark);
    }
    toJSON() {
        return {
            stepType: "removeNodeMark",
            pos: this.pos,
            mark: this.mark.toJSON()
        };
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.pos != "number") throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
        return new $7fb0112872b78c0a$export$fdf7d1dc10724da2(json.pos, schema.markFromJSON(json.mark));
    }
    /**
    Create a mark-removing step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The mark to remove.
    */ mark){
        super();
        this.pos = pos;
        this.mark = mark;
    }
}
$7fb0112872b78c0a$export$fd55ce593607084a.jsonID("removeNodeMark", $7fb0112872b78c0a$export$fdf7d1dc10724da2);
/**
Replace a part of the document with a slice of new content.
*/ class $7fb0112872b78c0a$export$5c860b2e74034756 extends $7fb0112872b78c0a$export$fd55ce593607084a {
    apply(doc) {
        if (this.structure && $7fb0112872b78c0a$var$contentBetween(doc, this.from, this.to)) return $7fb0112872b78c0a$export$8ebf1578a4199c09.fail("Structure replace would overwrite content");
        return $7fb0112872b78c0a$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, this.slice);
    }
    getMap() {
        return new $7fb0112872b78c0a$export$c53d01c3ab9721b3([
            this.from,
            this.to - this.from,
            this.slice.size
        ]);
    }
    invert(doc) {
        return new $7fb0112872b78c0a$export$5c860b2e74034756(this.from, this.from + this.slice.size, doc.slice(this.from, this.to));
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        if (from.deletedAcross && to.deletedAcross) return null;
        return new $7fb0112872b78c0a$export$5c860b2e74034756(from.pos, Math.max(from.pos, to.pos), this.slice);
    }
    merge(other) {
        if (!(other instanceof $7fb0112872b78c0a$export$5c860b2e74034756) || other.structure || this.structure) return null;
        if (this.from + this.slice.size == other.from && !this.slice.openEnd && !other.slice.openStart) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $5SAOw.Slice).empty : new (0, $5SAOw.Slice)(this.slice.content.append(other.slice.content), this.slice.openStart, other.slice.openEnd);
            return new $7fb0112872b78c0a$export$5c860b2e74034756(this.from, this.to + (other.to - other.from), slice, this.structure);
        } else if (other.to == this.from && !this.slice.openStart && !other.slice.openEnd) {
            let slice = this.slice.size + other.slice.size == 0 ? (0, $5SAOw.Slice).empty : new (0, $5SAOw.Slice)(other.slice.content.append(this.slice.content), other.slice.openStart, this.slice.openEnd);
            return new $7fb0112872b78c0a$export$5c860b2e74034756(other.from, this.to, slice, this.structure);
        } else return null;
    }
    toJSON() {
        let json = {
            stepType: "replace",
            from: this.from,
            to: this.to
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number") throw new RangeError("Invalid input for ReplaceStep.fromJSON");
        return new $7fb0112872b78c0a$export$5c860b2e74034756(json.from, json.to, (0, $5SAOw.Slice).fromJSON(schema, json.slice), !!json.structure);
    }
    /**
    The given `slice` should fit the 'gap' between `from` and
    `to`—the depths must line up, and the surrounding nodes must be
    able to be joined with the open sides of the slice. When
    `structure` is true, the step will fail if the content between
    from and to is not just a sequence of closing and then opening
    tokens (this is to guard against rebased replace steps
    overwriting something they weren't supposed to).
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The slice to insert.
    */ slice, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.slice = slice;
        this.structure = structure;
    }
}
$7fb0112872b78c0a$export$fd55ce593607084a.jsonID("replace", $7fb0112872b78c0a$export$5c860b2e74034756);
/**
Replace a part of the document with a slice of content, but
preserve a range of the replaced content by moving it into the
slice.
*/ class $7fb0112872b78c0a$export$444ba800d6024a98 extends $7fb0112872b78c0a$export$fd55ce593607084a {
    apply(doc) {
        if (this.structure && ($7fb0112872b78c0a$var$contentBetween(doc, this.from, this.gapFrom) || $7fb0112872b78c0a$var$contentBetween(doc, this.gapTo, this.to))) return $7fb0112872b78c0a$export$8ebf1578a4199c09.fail("Structure gap-replace would overwrite content");
        let gap = doc.slice(this.gapFrom, this.gapTo);
        if (gap.openStart || gap.openEnd) return $7fb0112872b78c0a$export$8ebf1578a4199c09.fail("Gap is not a flat range");
        let inserted = this.slice.insertAt(this.insert, gap.content);
        if (!inserted) return $7fb0112872b78c0a$export$8ebf1578a4199c09.fail("Content does not fit in gap");
        return $7fb0112872b78c0a$export$8ebf1578a4199c09.fromReplace(doc, this.from, this.to, inserted);
    }
    getMap() {
        return new $7fb0112872b78c0a$export$c53d01c3ab9721b3([
            this.from,
            this.gapFrom - this.from,
            this.insert,
            this.gapTo,
            this.to - this.gapTo,
            this.slice.size - this.insert
        ]);
    }
    invert(doc) {
        let gap = this.gapTo - this.gapFrom;
        return new $7fb0112872b78c0a$export$444ba800d6024a98(this.from, this.from + this.slice.size + gap, this.from + this.insert, this.from + this.insert + gap, doc.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
    }
    map(mapping) {
        let from = mapping.mapResult(this.from, 1), to = mapping.mapResult(this.to, -1);
        let gapFrom = this.from == this.gapFrom ? from.pos : mapping.map(this.gapFrom, -1);
        let gapTo = this.to == this.gapTo ? to.pos : mapping.map(this.gapTo, 1);
        if (from.deletedAcross && to.deletedAcross || gapFrom < from.pos || gapTo > to.pos) return null;
        return new $7fb0112872b78c0a$export$444ba800d6024a98(from.pos, to.pos, gapFrom, gapTo, this.slice, this.insert, this.structure);
    }
    toJSON() {
        let json = {
            stepType: "replaceAround",
            from: this.from,
            to: this.to,
            gapFrom: this.gapFrom,
            gapTo: this.gapTo,
            insert: this.insert
        };
        if (this.slice.size) json.slice = this.slice.toJSON();
        if (this.structure) json.structure = true;
        return json;
    }
    /**
    @internal
    */ static fromJSON(schema, json) {
        if (typeof json.from != "number" || typeof json.to != "number" || typeof json.gapFrom != "number" || typeof json.gapTo != "number" || typeof json.insert != "number") throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
        return new $7fb0112872b78c0a$export$444ba800d6024a98(json.from, json.to, json.gapFrom, json.gapTo, (0, $5SAOw.Slice).fromJSON(schema, json.slice), json.insert, !!json.structure);
    }
    /**
    Create a replace-around step with the given range and gap.
    `insert` should be the point in the slice into which the content
    of the gap should be moved. `structure` has the same meaning as
    it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
    */ constructor(/**
    The start position of the replaced range.
    */ from, /**
    The end position of the replaced range.
    */ to, /**
    The start of preserved range.
    */ gapFrom, /**
    The end of preserved range.
    */ gapTo, /**
    The slice to insert.
    */ slice, /**
    The position in the slice where the preserved range should be
    inserted.
    */ insert, /**
    @internal
    */ structure = false){
        super();
        this.from = from;
        this.to = to;
        this.gapFrom = gapFrom;
        this.gapTo = gapTo;
        this.slice = slice;
        this.insert = insert;
        this.structure = structure;
    }
}
$7fb0112872b78c0a$export$fd55ce593607084a.jsonID("replaceAround", $7fb0112872b78c0a$export$444ba800d6024a98);
function $7fb0112872b78c0a$var$contentBetween(doc, from, to) {
    let $from = doc.resolve(from), dist = to - from, depth = $from.depth;
    while(dist > 0 && depth > 0 && $from.indexAfter(depth) == $from.node(depth).childCount){
        depth--;
        dist--;
    }
    if (dist > 0) {
        let next = $from.node(depth).maybeChild($from.indexAfter(depth));
        while(dist > 0){
            if (!next || next.isLeaf) return true;
            next = next.firstChild;
            dist--;
        }
    }
    return false;
}
function $7fb0112872b78c0a$var$addMark(tr, from, to, mark) {
    let removed = [], added = [];
    let removing, adding;
    tr.doc.nodesBetween(from, to, (node, pos, parent)=>{
        if (!node.isInline) return;
        let marks = node.marks;
        if (!mark.isInSet(marks) && parent.type.allowsMarkType(mark.type)) {
            let start = Math.max(pos, from), end = Math.min(pos + node.nodeSize, to);
            let newSet = mark.addToSet(marks);
            for(let i = 0; i < marks.length; i++)if (!marks[i].isInSet(newSet)) {
                if (removing && removing.to == start && removing.mark.eq(marks[i])) removing.to = end;
                else removed.push(removing = new $7fb0112872b78c0a$export$94150db1311f67a9(start, end, marks[i]));
            }
            if (adding && adding.to == start) adding.to = end;
            else added.push(adding = new $7fb0112872b78c0a$export$d24ba56b0e3464a9(start, end, mark));
        }
    });
    removed.forEach((s)=>tr.step(s));
    added.forEach((s)=>tr.step(s));
}
function $7fb0112872b78c0a$var$removeMark(tr, from, to, mark) {
    let matched = [], step = 0;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        if (!node.isInline) return;
        step++;
        let toRemove = null;
        if (mark instanceof (0, $5SAOw.MarkType)) {
            let set = node.marks, found;
            while(found = mark.isInSet(set)){
                (toRemove || (toRemove = [])).push(found);
                set = found.removeFromSet(set);
            }
        } else if (mark) {
            if (mark.isInSet(node.marks)) toRemove = [
                mark
            ];
        } else toRemove = node.marks;
        if (toRemove && toRemove.length) {
            let end = Math.min(pos + node.nodeSize, to);
            for(let i = 0; i < toRemove.length; i++){
                let style = toRemove[i], found;
                for(let j = 0; j < matched.length; j++){
                    let m = matched[j];
                    if (m.step == step - 1 && style.eq(matched[j].style)) found = m;
                }
                if (found) {
                    found.to = end;
                    found.step = step;
                } else matched.push({
                    style: style,
                    from: Math.max(pos, from),
                    to: end,
                    step: step
                });
            }
        }
    });
    matched.forEach((m)=>tr.step(new $7fb0112872b78c0a$export$94150db1311f67a9(m.from, m.to, m.style)));
}
function $7fb0112872b78c0a$var$clearIncompatible(tr, pos, parentType, match = parentType.contentMatch, clearNewlines = true) {
    let node = tr.doc.nodeAt(pos);
    let replSteps = [], cur = pos + 1;
    for(let i = 0; i < node.childCount; i++){
        let child = node.child(i), end = cur + child.nodeSize;
        let allowed = match.matchType(child.type);
        if (!allowed) replSteps.push(new $7fb0112872b78c0a$export$5c860b2e74034756(cur, end, (0, $5SAOw.Slice).empty));
        else {
            match = allowed;
            for(let j = 0; j < child.marks.length; j++)if (!parentType.allowsMarkType(child.marks[j].type)) tr.step(new $7fb0112872b78c0a$export$94150db1311f67a9(cur, end, child.marks[j]));
            if (clearNewlines && child.isText && parentType.whitespace != "pre") {
                let m, newline = /\r?\n|\r/g, slice;
                while(m = newline.exec(child.text)){
                    if (!slice) slice = new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(parentType.schema.text(" ", parentType.allowedMarks(child.marks))), 0, 0);
                    replSteps.push(new $7fb0112872b78c0a$export$5c860b2e74034756(cur + m.index, cur + m.index + m[0].length, slice));
                }
            }
        }
        cur = end;
    }
    if (!match.validEnd) {
        let fill = match.fillBefore((0, $5SAOw.Fragment).empty, true);
        tr.replace(cur, cur, new (0, $5SAOw.Slice)(fill, 0, 0));
    }
    for(let i = replSteps.length - 1; i >= 0; i--)tr.step(replSteps[i]);
}
function $7fb0112872b78c0a$var$canCut(node, start, end) {
    return (start == 0 || node.canReplace(start, node.childCount)) && (end == node.childCount || node.canReplace(0, end));
}
/**
Try to find a target depth to which the content in the given range
can be lifted. Will not go across
[isolating](https://prosemirror.net/docs/ref/#model.NodeSpec.isolating) parent nodes.
*/ function $7fb0112872b78c0a$export$f1508b72cc76a09e(range) {
    let parent = range.parent;
    let content = parent.content.cutByIndex(range.startIndex, range.endIndex);
    for(let depth = range.depth;; --depth){
        let node = range.$from.node(depth);
        let index = range.$from.index(depth), endIndex = range.$to.indexAfter(depth);
        if (depth < range.depth && node.canReplace(index, endIndex, content)) return depth;
        if (depth == 0 || node.type.spec.isolating || !$7fb0112872b78c0a$var$canCut(node, index, endIndex)) break;
    }
    return null;
}
function $7fb0112872b78c0a$var$lift(tr, range, target) {
    let { $from: $from, $to: $to, depth: depth } = range;
    let gapStart = $from.before(depth + 1), gapEnd = $to.after(depth + 1);
    let start = gapStart, end = gapEnd;
    let before = (0, $5SAOw.Fragment).empty, openStart = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $from.index(d) > 0) {
        splitting = true;
        before = (0, $5SAOw.Fragment).from($from.node(d).copy(before));
        openStart++;
    } else start--;
    let after = (0, $5SAOw.Fragment).empty, openEnd = 0;
    for(let d = depth, splitting = false; d > target; d--)if (splitting || $to.after(d + 1) < $to.end(d)) {
        splitting = true;
        after = (0, $5SAOw.Fragment).from($to.node(d).copy(after));
        openEnd++;
    } else end++;
    tr.step(new $7fb0112872b78c0a$export$444ba800d6024a98(start, end, gapStart, gapEnd, new (0, $5SAOw.Slice)(before.append(after), openStart, openEnd), before.size - openStart, true));
}
/**
Try to find a valid way to wrap the content in the given range in a
node of the given type. May introduce extra nodes around and inside
the wrapper node, if necessary. Returns null if no valid wrapping
could be found. When `innerRange` is given, that range's content is
used as the content to fit into the wrapping, instead of the
content of `range`.
*/ function $7fb0112872b78c0a$export$118cb9a83e81ba37(range, nodeType, attrs = null, innerRange = range) {
    let around = $7fb0112872b78c0a$var$findWrappingOutside(range, nodeType);
    let inner = around && $7fb0112872b78c0a$var$findWrappingInside(innerRange, nodeType);
    if (!inner) return null;
    return around.map($7fb0112872b78c0a$var$withAttrs).concat({
        type: nodeType,
        attrs: attrs
    }).concat(inner.map($7fb0112872b78c0a$var$withAttrs));
}
function $7fb0112872b78c0a$var$withAttrs(type) {
    return {
        type: type,
        attrs: null
    };
}
function $7fb0112872b78c0a$var$findWrappingOutside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let around = parent.contentMatchAt(startIndex).findWrapping(type);
    if (!around) return null;
    let outer = around.length ? around[0] : type;
    return parent.canReplaceWith(startIndex, endIndex, outer) ? around : null;
}
function $7fb0112872b78c0a$var$findWrappingInside(range, type) {
    let { parent: parent, startIndex: startIndex, endIndex: endIndex } = range;
    let inner = parent.child(startIndex);
    let inside = type.contentMatch.findWrapping(inner.type);
    if (!inside) return null;
    let lastType = inside.length ? inside[inside.length - 1] : type;
    let innerMatch = lastType.contentMatch;
    for(let i = startIndex; innerMatch && i < endIndex; i++)innerMatch = innerMatch.matchType(parent.child(i).type);
    if (!innerMatch || !innerMatch.validEnd) return null;
    return inside;
}
function $7fb0112872b78c0a$var$wrap(tr, range, wrappers) {
    let content = (0, $5SAOw.Fragment).empty;
    for(let i = wrappers.length - 1; i >= 0; i--){
        if (content.size) {
            let match = wrappers[i].type.contentMatch.matchFragment(content);
            if (!match || !match.validEnd) throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
        }
        content = (0, $5SAOw.Fragment).from(wrappers[i].type.create(wrappers[i].attrs, content));
    }
    let start = range.start, end = range.end;
    tr.step(new $7fb0112872b78c0a$export$444ba800d6024a98(start, end, start, end, new (0, $5SAOw.Slice)(content, 0, 0), wrappers.length, true));
}
function $7fb0112872b78c0a$var$setBlockType(tr, from, to, type, attrs) {
    if (!type.isTextblock) throw new RangeError("Type given to setBlockType should be a textblock");
    let mapFrom = tr.steps.length;
    tr.doc.nodesBetween(from, to, (node, pos)=>{
        let attrsHere = typeof attrs == "function" ? attrs(node) : attrs;
        if (node.isTextblock && !node.hasMarkup(type, attrsHere) && $7fb0112872b78c0a$var$canChangeType(tr.doc, tr.mapping.slice(mapFrom).map(pos), type)) {
            let convertNewlines = null;
            if (type.schema.linebreakReplacement) {
                let pre = type.whitespace == "pre", supportLinebreak = !!type.contentMatch.matchType(type.schema.linebreakReplacement);
                if (pre && !supportLinebreak) convertNewlines = false;
                else if (!pre && supportLinebreak) convertNewlines = true;
            }
            // Ensure all markup that isn't allowed in the new node type is cleared
            if (convertNewlines === false) $7fb0112872b78c0a$var$replaceLinebreaks(tr, node, pos, mapFrom);
            $7fb0112872b78c0a$var$clearIncompatible(tr, tr.mapping.slice(mapFrom).map(pos, 1), type, undefined, convertNewlines === null);
            let mapping = tr.mapping.slice(mapFrom);
            let startM = mapping.map(pos, 1), endM = mapping.map(pos + node.nodeSize, 1);
            tr.step(new $7fb0112872b78c0a$export$444ba800d6024a98(startM, endM, startM + 1, endM - 1, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(type.create(attrsHere, null, node.marks)), 0, 0), 1, true));
            if (convertNewlines === true) $7fb0112872b78c0a$var$replaceNewlines(tr, node, pos, mapFrom);
            return false;
        }
    });
}
function $7fb0112872b78c0a$var$replaceNewlines(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.isText) {
            let m, newline = /\r?\n|\r/g;
            while(m = newline.exec(child.text)){
                let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset + m.index);
                tr.replaceWith(start, start + 1, node.type.schema.linebreakReplacement.create());
            }
        }
    });
}
function $7fb0112872b78c0a$var$replaceLinebreaks(tr, node, pos, mapFrom) {
    node.forEach((child, offset)=>{
        if (child.type == child.type.schema.linebreakReplacement) {
            let start = tr.mapping.slice(mapFrom).map(pos + 1 + offset);
            tr.replaceWith(start, start + 1, node.type.schema.text("\n"));
        }
    });
}
function $7fb0112872b78c0a$var$canChangeType(doc, pos, type) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $pos.parent.canReplaceWith(index, index + 1, type);
}
/**
Change the type, attributes, and/or marks of the node at `pos`.
When `type` isn't given, the existing node type is preserved,
*/ function $7fb0112872b78c0a$var$setNodeMarkup(tr, pos, type, attrs, marks) {
    let node = tr.doc.nodeAt(pos);
    if (!node) throw new RangeError("No node at given position");
    if (!type) type = node.type;
    let newNode = type.create(attrs, null, marks || node.marks);
    if (node.isLeaf) return tr.replaceWith(pos, pos + node.nodeSize, newNode);
    if (!type.validContent(node.content)) throw new RangeError("Invalid content for node type " + type.name);
    tr.step(new $7fb0112872b78c0a$export$444ba800d6024a98(pos, pos + node.nodeSize, pos + 1, pos + node.nodeSize - 1, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(newNode), 0, 0), 1, true));
}
/**
Check whether splitting at the given position is allowed.
*/ function $7fb0112872b78c0a$export$5aaf008897aef029(doc, pos, depth = 1, typesAfter) {
    let $pos = doc.resolve(pos), base = $pos.depth - depth;
    let innerType = typesAfter && typesAfter[typesAfter.length - 1] || $pos.parent;
    if (base < 0 || $pos.parent.type.spec.isolating || !$pos.parent.canReplace($pos.index(), $pos.parent.childCount) || !innerType.type.validContent($pos.parent.content.cutByIndex($pos.index(), $pos.parent.childCount))) return false;
    for(let d = $pos.depth - 1, i = depth - 2; d > base; d--, i--){
        let node = $pos.node(d), index = $pos.index(d);
        if (node.type.spec.isolating) return false;
        let rest = node.content.cutByIndex(index, node.childCount);
        let overrideChild = typesAfter && typesAfter[i + 1];
        if (overrideChild) rest = rest.replaceChild(0, overrideChild.type.create(overrideChild.attrs));
        let after = typesAfter && typesAfter[i] || node;
        if (!node.canReplace(index + 1, node.childCount) || !after.type.validContent(rest)) return false;
    }
    let index = $pos.indexAfter(base);
    let baseType = typesAfter && typesAfter[0];
    return $pos.node(base).canReplaceWith(index, index, baseType ? baseType.type : $pos.node(base + 1).type);
}
function $7fb0112872b78c0a$var$split(tr, pos, depth = 1, typesAfter) {
    let $pos = tr.doc.resolve(pos), before = (0, $5SAOw.Fragment).empty, after = (0, $5SAOw.Fragment).empty;
    for(let d = $pos.depth, e = $pos.depth - depth, i = depth - 1; d > e; d--, i--){
        before = (0, $5SAOw.Fragment).from($pos.node(d).copy(before));
        let typeAfter = typesAfter && typesAfter[i];
        after = (0, $5SAOw.Fragment).from(typeAfter ? typeAfter.type.create(typeAfter.attrs, after) : $pos.node(d).copy(after));
    }
    tr.step(new $7fb0112872b78c0a$export$5c860b2e74034756(pos, pos, new (0, $5SAOw.Slice)(before.append(after), depth, depth), true));
}
/**
Test whether the blocks before and after a given position can be
joined.
*/ function $7fb0112872b78c0a$export$f15f89fd9d8cc98a(doc, pos) {
    let $pos = doc.resolve(pos), index = $pos.index();
    return $7fb0112872b78c0a$var$joinable($pos.nodeBefore, $pos.nodeAfter) && $pos.parent.canReplace(index, index + 1);
}
function $7fb0112872b78c0a$var$canAppendWithSubstitutedLinebreaks(a, b) {
    if (!b.content.size) a.type.compatibleContent(b.type);
    let match = a.contentMatchAt(a.childCount);
    let { linebreakReplacement: linebreakReplacement } = a.type.schema;
    for(let i = 0; i < b.childCount; i++){
        let child = b.child(i);
        let type = child.type == linebreakReplacement ? a.type.schema.nodes.text : child.type;
        match = match.matchType(type);
        if (!match) return false;
        if (!a.type.allowsMarks(child.marks)) return false;
    }
    return match.validEnd;
}
function $7fb0112872b78c0a$var$joinable(a, b) {
    return !!(a && b && !a.isLeaf && $7fb0112872b78c0a$var$canAppendWithSubstitutedLinebreaks(a, b));
}
/**
Find an ancestor of the given position that can be joined to the
block before (or after if `dir` is positive). Returns the joinable
point, if any.
*/ function $7fb0112872b78c0a$export$41b1d4cb5ceb3147(doc, pos, dir = -1) {
    let $pos = doc.resolve(pos);
    for(let d = $pos.depth;; d--){
        let before, after, index = $pos.index(d);
        if (d == $pos.depth) {
            before = $pos.nodeBefore;
            after = $pos.nodeAfter;
        } else if (dir > 0) {
            before = $pos.node(d + 1);
            index++;
            after = $pos.node(d).maybeChild(index);
        } else {
            before = $pos.node(d).maybeChild(index - 1);
            after = $pos.node(d + 1);
        }
        if (before && !before.isTextblock && $7fb0112872b78c0a$var$joinable(before, after) && $pos.node(d).canReplace(index, index + 1)) return pos;
        if (d == 0) break;
        pos = dir < 0 ? $pos.before(d) : $pos.after(d);
    }
}
function $7fb0112872b78c0a$var$join(tr, pos, depth) {
    let convertNewlines = null;
    let { linebreakReplacement: linebreakReplacement } = tr.doc.type.schema;
    let $before = tr.doc.resolve(pos - depth), beforeType = $before.node().type;
    if (linebreakReplacement && beforeType.inlineContent) {
        let pre = beforeType.whitespace == "pre";
        let supportLinebreak = !!beforeType.contentMatch.matchType(linebreakReplacement);
        if (pre && !supportLinebreak) convertNewlines = false;
        else if (!pre && supportLinebreak) convertNewlines = true;
    }
    let mapFrom = tr.steps.length;
    if (convertNewlines === false) {
        let $after = tr.doc.resolve(pos + depth);
        $7fb0112872b78c0a$var$replaceLinebreaks(tr, $after.node(), $after.before(), mapFrom);
    }
    if (beforeType.inlineContent) $7fb0112872b78c0a$var$clearIncompatible(tr, pos + depth - 1, beforeType, $before.node().contentMatchAt($before.index()), convertNewlines == null);
    let mapping = tr.mapping.slice(mapFrom), start = mapping.map(pos - depth);
    tr.step(new $7fb0112872b78c0a$export$5c860b2e74034756(start, mapping.map(pos + depth, -1), (0, $5SAOw.Slice).empty, true));
    if (convertNewlines === true) {
        let $full = tr.doc.resolve(start);
        $7fb0112872b78c0a$var$replaceNewlines(tr, $full.node(), $full.before(), tr.steps.length);
    }
    return tr;
}
/**
Try to find a point where a node of the given type can be inserted
near `pos`, by searching up the node hierarchy when `pos` itself
isn't a valid place but is at the start or end of a node. Return
null if no position was found.
*/ function $7fb0112872b78c0a$export$64cb316d02de1dd1(doc, pos, nodeType) {
    let $pos = doc.resolve(pos);
    if ($pos.parent.canReplaceWith($pos.index(), $pos.index(), nodeType)) return pos;
    if ($pos.parentOffset == 0) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.index(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.before(d + 1);
        if (index > 0) return null;
    }
    if ($pos.parentOffset == $pos.parent.content.size) for(let d = $pos.depth - 1; d >= 0; d--){
        let index = $pos.indexAfter(d);
        if ($pos.node(d).canReplaceWith(index, index, nodeType)) return $pos.after(d + 1);
        if (index < $pos.node(d).childCount) return null;
    }
    return null;
}
/**
Finds a position at or around the given position where the given
slice can be inserted. Will look at parent nodes' nearest boundary
and try there, even if the original position wasn't directly at the
start or end of that node. Returns null when no position was found.
*/ function $7fb0112872b78c0a$export$2819d598d048fc9c(doc, pos, slice) {
    let $pos = doc.resolve(pos);
    if (!slice.content.size) return pos;
    let content = slice.content;
    for(let i = 0; i < slice.openStart; i++)content = content.firstChild.content;
    for(let pass = 1; pass <= (slice.openStart == 0 && slice.size ? 2 : 1); pass++)for(let d = $pos.depth; d >= 0; d--){
        let bias = d == $pos.depth ? 0 : $pos.pos <= ($pos.start(d + 1) + $pos.end(d + 1)) / 2 ? -1 : 1;
        let insertPos = $pos.index(d) + (bias > 0 ? 1 : 0);
        let parent = $pos.node(d), fits = false;
        if (pass == 1) fits = parent.canReplace(insertPos, insertPos, content);
        else {
            let wrapping = parent.contentMatchAt(insertPos).findWrapping(content.firstChild.type);
            fits = wrapping && parent.canReplaceWith(insertPos, insertPos, wrapping[0]);
        }
        if (fits) return bias == 0 ? $pos.pos : bias < 0 ? $pos.before(d + 1) : $pos.after(d + 1);
    }
    return null;
}
/**
‘Fit’ a slice into a given position in the document, producing a
[step](https://prosemirror.net/docs/ref/#transform.Step) that inserts it. Will return null if
there's no meaningful way to insert the slice here, or inserting it
would be a no-op (an empty slice over an empty range).
*/ function $7fb0112872b78c0a$export$ed6ac67359824afd(doc, from, to = from, slice = (0, $5SAOw.Slice).empty) {
    if (from == to && !slice.size) return null;
    let $from = doc.resolve(from), $to = doc.resolve(to);
    // Optimization -- avoid work if it's obvious that it's not needed.
    if ($7fb0112872b78c0a$var$fitsTrivially($from, $to, slice)) return new $7fb0112872b78c0a$export$5c860b2e74034756(from, to, slice);
    return new $7fb0112872b78c0a$var$Fitter($from, $to, slice).fit();
}
function $7fb0112872b78c0a$var$fitsTrivially($from, $to, slice) {
    return !slice.openStart && !slice.openEnd && $from.start() == $to.start() && $from.parent.canReplace($from.index(), $to.index(), slice.content);
}
// Algorithm for 'placing' the elements of a slice into a gap:
//
// We consider the content of each node that is open to the left to be
// independently placeable. I.e. in <p("foo"), p("bar")>, when the
// paragraph on the left is open, "foo" can be placed (somewhere on
// the left side of the replacement gap) independently from p("bar").
//
// This class tracks the state of the placement progress in the
// following properties:
//
//  - `frontier` holds a stack of `{type, match}` objects that
//    represent the open side of the replacement. It starts at
//    `$from`, then moves forward as content is placed, and is finally
//    reconciled with `$to`.
//
//  - `unplaced` is a slice that represents the content that hasn't
//    been placed yet.
//
//  - `placed` is a fragment of placed content. Its open-start value
//    is implicit in `$from`, and its open-end value in `frontier`.
class $7fb0112872b78c0a$var$Fitter {
    get depth() {
        return this.frontier.length - 1;
    }
    fit() {
        // As long as there's unplaced content, try to place some of it.
        // If that fails, either increase the open score of the unplaced
        // slice, or drop nodes from it, and then try again.
        while(this.unplaced.size){
            let fit = this.findFittable();
            if (fit) this.placeNodes(fit);
            else this.openMore() || this.dropNode();
        }
        // When there's inline content directly after the frontier _and_
        // directly after `this.$to`, we must generate a `ReplaceAround`
        // step that pulls that content into the node after the frontier.
        // That means the fitting must be done to the end of the textblock
        // node after `this.$to`, not `this.$to` itself.
        let moveInline = this.mustMoveInline(), placedSize = this.placed.size - this.depth - this.$from.depth;
        let $from = this.$from, $to = this.close(moveInline < 0 ? this.$to : $from.doc.resolve(moveInline));
        if (!$to) return null;
        // If closing to `$to` succeeded, create a step
        let content = this.placed, openStart = $from.depth, openEnd = $to.depth;
        while(openStart && openEnd && content.childCount == 1){
            content = content.firstChild.content;
            openStart--;
            openEnd--;
        }
        let slice = new (0, $5SAOw.Slice)(content, openStart, openEnd);
        if (moveInline > -1) return new $7fb0112872b78c0a$export$444ba800d6024a98($from.pos, moveInline, this.$to.pos, this.$to.end(), slice, placedSize);
        if (slice.size || $from.pos != this.$to.pos) return new $7fb0112872b78c0a$export$5c860b2e74034756($from.pos, $to.pos, slice);
        return null;
    }
    // Find a position on the start spine of `this.unplaced` that has
    // content that can be moved somewhere on the frontier. Returns two
    // depths, one for the slice and one for the frontier.
    findFittable() {
        let startDepth = this.unplaced.openStart;
        for(let cur = this.unplaced.content, d = 0, openEnd = this.unplaced.openEnd; d < startDepth; d++){
            let node = cur.firstChild;
            if (cur.childCount > 1) openEnd = 0;
            if (node.type.spec.isolating && openEnd <= d) {
                startDepth = d;
                break;
            }
            cur = node.content;
        }
        // Only try wrapping nodes (pass 2) after finding a place without
        // wrapping failed.
        for(let pass = 1; pass <= 2; pass++)for(let sliceDepth = pass == 1 ? startDepth : this.unplaced.openStart; sliceDepth >= 0; sliceDepth--){
            let fragment, parent = null;
            if (sliceDepth) {
                parent = $7fb0112872b78c0a$var$contentAt(this.unplaced.content, sliceDepth - 1).firstChild;
                fragment = parent.content;
            } else fragment = this.unplaced.content;
            let first = fragment.firstChild;
            for(let frontierDepth = this.depth; frontierDepth >= 0; frontierDepth--){
                let { type: type, match: match } = this.frontier[frontierDepth], wrap, inject = null;
                // In pass 1, if the next node matches, or there is no next
                // node but the parents look compatible, we've found a
                // place.
                if (pass == 1 && (first ? match.matchType(first.type) || (inject = match.fillBefore((0, $5SAOw.Fragment).from(first), false)) : parent && type.compatibleContent(parent.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    inject: inject
                };
                else if (pass == 2 && first && (wrap = match.findWrapping(first.type))) return {
                    sliceDepth: sliceDepth,
                    frontierDepth: frontierDepth,
                    parent: parent,
                    wrap: wrap
                };
                // Don't continue looking further up if the parent node
                // would fit here.
                if (parent && match.matchType(parent.type)) break;
            }
        }
    }
    openMore() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $7fb0112872b78c0a$var$contentAt(content, openStart);
        if (!inner.childCount || inner.firstChild.isLeaf) return false;
        this.unplaced = new (0, $5SAOw.Slice)(content, openStart + 1, Math.max(openEnd, inner.size + openStart >= content.size - openEnd ? openStart + 1 : 0));
        return true;
    }
    dropNode() {
        let { content: content, openStart: openStart, openEnd: openEnd } = this.unplaced;
        let inner = $7fb0112872b78c0a$var$contentAt(content, openStart);
        if (inner.childCount <= 1 && openStart > 0) {
            let openAtEnd = content.size - openStart <= openStart + inner.size;
            this.unplaced = new (0, $5SAOw.Slice)($7fb0112872b78c0a$var$dropFromFragment(content, openStart - 1, 1), openStart - 1, openAtEnd ? openStart - 1 : openEnd);
        } else this.unplaced = new (0, $5SAOw.Slice)($7fb0112872b78c0a$var$dropFromFragment(content, openStart, 1), openStart, openEnd);
    }
    // Move content from the unplaced slice at `sliceDepth` to the
    // frontier node at `frontierDepth`. Close that frontier node when
    // applicable.
    placeNodes({ sliceDepth: sliceDepth, frontierDepth: frontierDepth, parent: parent, inject: inject, wrap: wrap }) {
        while(this.depth > frontierDepth)this.closeFrontierNode();
        if (wrap) for(let i = 0; i < wrap.length; i++)this.openFrontierNode(wrap[i]);
        let slice = this.unplaced, fragment = parent ? parent.content : slice.content;
        let openStart = slice.openStart - sliceDepth;
        let taken = 0, add = [];
        let { match: match, type: type } = this.frontier[frontierDepth];
        if (inject) {
            for(let i = 0; i < inject.childCount; i++)add.push(inject.child(i));
            match = match.matchFragment(inject);
        }
        // Computes the amount of (end) open nodes at the end of the
        // fragment. When 0, the parent is open, but no more. When
        // negative, nothing is open.
        let openEndCount = fragment.size + sliceDepth - (slice.content.size - slice.openEnd);
        // Scan over the fragment, fitting as many child nodes as
        // possible.
        while(taken < fragment.childCount){
            let next = fragment.child(taken), matches = match.matchType(next.type);
            if (!matches) break;
            taken++;
            if (taken > 1 || openStart == 0 || next.content.size) {
                match = matches;
                add.push($7fb0112872b78c0a$var$closeNodeStart(next.mark(type.allowedMarks(next.marks)), taken == 1 ? openStart : 0, taken == fragment.childCount ? openEndCount : -1));
            }
        }
        let toEnd = taken == fragment.childCount;
        if (!toEnd) openEndCount = -1;
        this.placed = $7fb0112872b78c0a$var$addToFragment(this.placed, frontierDepth, (0, $5SAOw.Fragment).from(add));
        this.frontier[frontierDepth].match = match;
        // If the parent types match, and the entire node was moved, and
        // it's not open, close this frontier node right away.
        if (toEnd && openEndCount < 0 && parent && parent.type == this.frontier[this.depth].type && this.frontier.length > 1) this.closeFrontierNode();
        // Add new frontier nodes for any open nodes at the end.
        for(let i = 0, cur = fragment; i < openEndCount; i++){
            let node = cur.lastChild;
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt(node.childCount)
            });
            cur = node.content;
        }
        // Update `this.unplaced`. Drop the entire node from which we
        // placed it we got to its end, otherwise just drop the placed
        // nodes.
        this.unplaced = !toEnd ? new (0, $5SAOw.Slice)($7fb0112872b78c0a$var$dropFromFragment(slice.content, sliceDepth, taken), slice.openStart, slice.openEnd) : sliceDepth == 0 ? (0, $5SAOw.Slice).empty : new (0, $5SAOw.Slice)($7fb0112872b78c0a$var$dropFromFragment(slice.content, sliceDepth - 1, 1), sliceDepth - 1, openEndCount < 0 ? slice.openEnd : sliceDepth - 1);
    }
    mustMoveInline() {
        if (!this.$to.parent.isTextblock) return -1;
        let top = this.frontier[this.depth], level;
        if (!top.type.isTextblock || !$7fb0112872b78c0a$var$contentAfterFits(this.$to, this.$to.depth, top.type, top.match, false) || this.$to.depth == this.depth && (level = this.findCloseLevel(this.$to)) && level.depth == this.depth) return -1;
        let { depth: depth } = this.$to, after = this.$to.after(depth);
        while(depth > 1 && after == this.$to.end(--depth))++after;
        return after;
    }
    findCloseLevel($to) {
        scan: for(let i = Math.min(this.depth, $to.depth); i >= 0; i--){
            let { match: match, type: type } = this.frontier[i];
            let dropInner = i < $to.depth && $to.end(i + 1) == $to.pos + ($to.depth - (i + 1));
            let fit = $7fb0112872b78c0a$var$contentAfterFits($to, i, type, match, dropInner);
            if (!fit) continue;
            for(let d = i - 1; d >= 0; d--){
                let { match: match, type: type } = this.frontier[d];
                let matches = $7fb0112872b78c0a$var$contentAfterFits($to, d, type, match, true);
                if (!matches || matches.childCount) continue scan;
            }
            return {
                depth: i,
                fit: fit,
                move: dropInner ? $to.doc.resolve($to.after(i + 1)) : $to
            };
        }
    }
    close($to) {
        let close = this.findCloseLevel($to);
        if (!close) return null;
        while(this.depth > close.depth)this.closeFrontierNode();
        if (close.fit.childCount) this.placed = $7fb0112872b78c0a$var$addToFragment(this.placed, close.depth, close.fit);
        $to = close.move;
        for(let d = close.depth + 1; d <= $to.depth; d++){
            let node = $to.node(d), add = node.type.contentMatch.fillBefore(node.content, true, $to.index(d));
            this.openFrontierNode(node.type, node.attrs, add);
        }
        return $to;
    }
    openFrontierNode(type, attrs = null, content) {
        let top = this.frontier[this.depth];
        top.match = top.match.matchType(type);
        this.placed = $7fb0112872b78c0a$var$addToFragment(this.placed, this.depth, (0, $5SAOw.Fragment).from(type.create(attrs, content)));
        this.frontier.push({
            type: type,
            match: type.contentMatch
        });
    }
    closeFrontierNode() {
        let open = this.frontier.pop();
        let add = open.match.fillBefore((0, $5SAOw.Fragment).empty, true);
        if (add.childCount) this.placed = $7fb0112872b78c0a$var$addToFragment(this.placed, this.frontier.length, add);
    }
    constructor($from, $to, unplaced){
        this.$from = $from;
        this.$to = $to;
        this.unplaced = unplaced;
        this.frontier = [];
        this.placed = (0, $5SAOw.Fragment).empty;
        for(let i = 0; i <= $from.depth; i++){
            let node = $from.node(i);
            this.frontier.push({
                type: node.type,
                match: node.contentMatchAt($from.indexAfter(i))
            });
        }
        for(let i = $from.depth; i > 0; i--)this.placed = (0, $5SAOw.Fragment).from($from.node(i).copy(this.placed));
    }
}
function $7fb0112872b78c0a$var$dropFromFragment(fragment, depth, count) {
    if (depth == 0) return fragment.cutByIndex(count, fragment.childCount);
    return fragment.replaceChild(0, fragment.firstChild.copy($7fb0112872b78c0a$var$dropFromFragment(fragment.firstChild.content, depth - 1, count)));
}
function $7fb0112872b78c0a$var$addToFragment(fragment, depth, content) {
    if (depth == 0) return fragment.append(content);
    return fragment.replaceChild(fragment.childCount - 1, fragment.lastChild.copy($7fb0112872b78c0a$var$addToFragment(fragment.lastChild.content, depth - 1, content)));
}
function $7fb0112872b78c0a$var$contentAt(fragment, depth) {
    for(let i = 0; i < depth; i++)fragment = fragment.firstChild.content;
    return fragment;
}
function $7fb0112872b78c0a$var$closeNodeStart(node, openStart, openEnd) {
    if (openStart <= 0) return node;
    let frag = node.content;
    if (openStart > 1) frag = frag.replaceChild(0, $7fb0112872b78c0a$var$closeNodeStart(frag.firstChild, openStart - 1, frag.childCount == 1 ? openEnd - 1 : 0));
    if (openStart > 0) {
        frag = node.type.contentMatch.fillBefore(frag).append(frag);
        if (openEnd <= 0) frag = frag.append(node.type.contentMatch.matchFragment(frag).fillBefore((0, $5SAOw.Fragment).empty, true));
    }
    return node.copy(frag);
}
function $7fb0112872b78c0a$var$contentAfterFits($to, depth, type, match, open) {
    let node = $to.node(depth), index = open ? $to.indexAfter(depth) : $to.index(depth);
    if (index == node.childCount && !type.compatibleContent(node.type)) return null;
    let fit = match.fillBefore(node.content, true, index);
    return fit && !$7fb0112872b78c0a$var$invalidMarks(type, node.content, index) ? fit : null;
}
function $7fb0112872b78c0a$var$invalidMarks(type, fragment, start) {
    for(let i = start; i < fragment.childCount; i++)if (!type.allowsMarks(fragment.child(i).marks)) return true;
    return false;
}
function $7fb0112872b78c0a$var$definesContent(type) {
    return type.spec.defining || type.spec.definingForContent;
}
function $7fb0112872b78c0a$var$replaceRange(tr, from, to, slice) {
    if (!slice.size) return tr.deleteRange(from, to);
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    if ($7fb0112872b78c0a$var$fitsTrivially($from, $to, slice)) return tr.step(new $7fb0112872b78c0a$export$5c860b2e74034756(from, to, slice));
    let targetDepths = $7fb0112872b78c0a$var$coveredDepths($from, tr.doc.resolve(to));
    // Can't replace the whole document, so remove 0 if it's present
    if (targetDepths[targetDepths.length - 1] == 0) targetDepths.pop();
    // Negative numbers represent not expansion over the whole node at
    // that depth, but replacing from $from.before(-D) to $to.pos.
    let preferredTarget = -($from.depth + 1);
    targetDepths.unshift(preferredTarget);
    // This loop picks a preferred target depth, if one of the covering
    // depths is not outside of a defining node, and adds negative
    // depths for any depth that has $from at its start and does not
    // cross a defining node.
    for(let d = $from.depth, pos = $from.pos - 1; d > 0; d--, pos--){
        let spec = $from.node(d).type.spec;
        if (spec.defining || spec.definingAsContext || spec.isolating) break;
        if (targetDepths.indexOf(d) > -1) preferredTarget = d;
        else if ($from.before(d) == pos) targetDepths.splice(1, 0, -d);
    }
    // Try to fit each possible depth of the slice into each possible
    // target depth, starting with the preferred depths.
    let preferredTargetIndex = targetDepths.indexOf(preferredTarget);
    let leftNodes = [], preferredDepth = slice.openStart;
    for(let content = slice.content, i = 0;; i++){
        let node = content.firstChild;
        leftNodes.push(node);
        if (i == slice.openStart) break;
        content = node.content;
    }
    // Back up preferredDepth to cover defining textblocks directly
    // above it, possibly skipping a non-defining textblock.
    for(let d = preferredDepth - 1; d >= 0; d--){
        let leftNode = leftNodes[d], def = $7fb0112872b78c0a$var$definesContent(leftNode.type);
        if (def && !leftNode.sameMarkup($from.node(Math.abs(preferredTarget) - 1))) preferredDepth = d;
        else if (def || !leftNode.type.isTextblock) break;
    }
    for(let j = slice.openStart; j >= 0; j--){
        let openDepth = (j + preferredDepth + 1) % (slice.openStart + 1);
        let insert = leftNodes[openDepth];
        if (!insert) continue;
        for(let i = 0; i < targetDepths.length; i++){
            // Loop over possible expansion levels, starting with the
            // preferred one
            let targetDepth = targetDepths[(i + preferredTargetIndex) % targetDepths.length], expand = true;
            if (targetDepth < 0) {
                expand = false;
                targetDepth = -targetDepth;
            }
            let parent = $from.node(targetDepth - 1), index = $from.index(targetDepth - 1);
            if (parent.canReplaceWith(index, index, insert.type, insert.marks)) return tr.replace($from.before(targetDepth), expand ? $to.after(targetDepth) : to, new (0, $5SAOw.Slice)($7fb0112872b78c0a$var$closeFragment(slice.content, 0, slice.openStart, openDepth), openDepth, slice.openEnd));
        }
    }
    let startSteps = tr.steps.length;
    for(let i = targetDepths.length - 1; i >= 0; i--){
        tr.replace(from, to, slice);
        if (tr.steps.length > startSteps) break;
        let depth = targetDepths[i];
        if (depth < 0) continue;
        from = $from.before(depth);
        to = $to.after(depth);
    }
}
function $7fb0112872b78c0a$var$closeFragment(fragment, depth, oldOpen, newOpen, parent) {
    if (depth < oldOpen) {
        let first = fragment.firstChild;
        fragment = fragment.replaceChild(0, first.copy($7fb0112872b78c0a$var$closeFragment(first.content, depth + 1, oldOpen, newOpen, first)));
    }
    if (depth > newOpen) {
        let match = parent.contentMatchAt(0);
        let start = match.fillBefore(fragment).append(fragment);
        fragment = start.append(match.matchFragment(start).fillBefore((0, $5SAOw.Fragment).empty, true));
    }
    return fragment;
}
function $7fb0112872b78c0a$var$replaceRangeWith(tr, from, to, node) {
    if (!node.isInline && from == to && tr.doc.resolve(from).parent.content.size) {
        let point = $7fb0112872b78c0a$export$64cb316d02de1dd1(tr.doc, from, node.type);
        if (point != null) from = to = point;
    }
    tr.replaceRange(from, to, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(node), 0, 0));
}
function $7fb0112872b78c0a$var$deleteRange(tr, from, to) {
    let $from = tr.doc.resolve(from), $to = tr.doc.resolve(to);
    let covered = $7fb0112872b78c0a$var$coveredDepths($from, $to);
    for(let i = 0; i < covered.length; i++){
        let depth = covered[i], last = i == covered.length - 1;
        if (last && depth == 0 || $from.node(depth).type.contentMatch.validEnd) return tr.delete($from.start(depth), $to.end(depth));
        if (depth > 0 && (last || $from.node(depth - 1).canReplace($from.index(depth - 1), $to.indexAfter(depth - 1)))) return tr.delete($from.before(depth), $to.after(depth));
    }
    for(let d = 1; d <= $from.depth && d <= $to.depth; d++){
        if (from - $from.start(d) == $from.depth - d && to > $from.end(d) && $to.end(d) - to != $to.depth - d && $from.start(d - 1) == $to.start(d - 1) && $from.node(d - 1).canReplace($from.index(d - 1), $to.index(d - 1))) return tr.delete($from.before(d), to);
    }
    tr.delete(from, to);
}
// Returns an array of all depths for which $from - $to spans the
// whole content of the nodes at that depth.
function $7fb0112872b78c0a$var$coveredDepths($from, $to) {
    let result = [], minDepth = Math.min($from.depth, $to.depth);
    for(let d = minDepth; d >= 0; d--){
        let start = $from.start(d);
        if (start < $from.pos - ($from.depth - d) || $to.end(d) > $to.pos + ($to.depth - d) || $from.node(d).type.spec.isolating || $to.node(d).type.spec.isolating) break;
        if (start == $to.start(d) || d == $from.depth && d == $to.depth && $from.parent.inlineContent && $to.parent.inlineContent && d && $to.start(d - 1) == start - 1) result.push(d);
    }
    return result;
}
/**
Update an attribute in a specific node.
*/ class $7fb0112872b78c0a$export$626399c38172f669 extends $7fb0112872b78c0a$export$fd55ce593607084a {
    apply(doc) {
        let node = doc.nodeAt(this.pos);
        if (!node) return $7fb0112872b78c0a$export$8ebf1578a4199c09.fail("No node at attribute step's position");
        let attrs = Object.create(null);
        for(let name in node.attrs)attrs[name] = node.attrs[name];
        attrs[this.attr] = this.value;
        let updated = node.type.create(attrs, null, node.marks);
        return $7fb0112872b78c0a$export$8ebf1578a4199c09.fromReplace(doc, this.pos, this.pos + 1, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(updated), 0, node.isLeaf ? 0 : 1));
    }
    getMap() {
        return $7fb0112872b78c0a$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $7fb0112872b78c0a$export$626399c38172f669(this.pos, this.attr, doc.nodeAt(this.pos).attrs[this.attr]);
    }
    map(mapping) {
        let pos = mapping.mapResult(this.pos, 1);
        return pos.deletedAfter ? null : new $7fb0112872b78c0a$export$626399c38172f669(pos.pos, this.attr, this.value);
    }
    toJSON() {
        return {
            stepType: "attr",
            pos: this.pos,
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.pos != "number" || typeof json.attr != "string") throw new RangeError("Invalid input for AttrStep.fromJSON");
        return new $7fb0112872b78c0a$export$626399c38172f669(json.pos, json.attr, json.value);
    }
    /**
    Construct an attribute step.
    */ constructor(/**
    The position of the target node.
    */ pos, /**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.pos = pos;
        this.attr = attr;
        this.value = value;
    }
}
$7fb0112872b78c0a$export$fd55ce593607084a.jsonID("attr", $7fb0112872b78c0a$export$626399c38172f669);
/**
Update an attribute in the doc node.
*/ class $7fb0112872b78c0a$export$f50707b396300ac9 extends $7fb0112872b78c0a$export$fd55ce593607084a {
    apply(doc) {
        let attrs = Object.create(null);
        for(let name in doc.attrs)attrs[name] = doc.attrs[name];
        attrs[this.attr] = this.value;
        let updated = doc.type.create(attrs, doc.content, doc.marks);
        return $7fb0112872b78c0a$export$8ebf1578a4199c09.ok(updated);
    }
    getMap() {
        return $7fb0112872b78c0a$export$c53d01c3ab9721b3.empty;
    }
    invert(doc) {
        return new $7fb0112872b78c0a$export$f50707b396300ac9(this.attr, doc.attrs[this.attr]);
    }
    map(mapping) {
        return this;
    }
    toJSON() {
        return {
            stepType: "docAttr",
            attr: this.attr,
            value: this.value
        };
    }
    static fromJSON(schema, json) {
        if (typeof json.attr != "string") throw new RangeError("Invalid input for DocAttrStep.fromJSON");
        return new $7fb0112872b78c0a$export$f50707b396300ac9(json.attr, json.value);
    }
    /**
    Construct an attribute step.
    */ constructor(/**
    The attribute to set.
    */ attr, // The attribute's new value.
    value){
        super();
        this.attr = attr;
        this.value = value;
    }
}
$7fb0112872b78c0a$export$fd55ce593607084a.jsonID("docAttr", $7fb0112872b78c0a$export$f50707b396300ac9);
/**
@internal
*/ let $7fb0112872b78c0a$export$88cc3a1dfce48dd3 = class extends Error {
};
$7fb0112872b78c0a$export$88cc3a1dfce48dd3 = function TransformError(message) {
    let err = Error.call(this, message);
    err.__proto__ = TransformError.prototype;
    return err;
};
$7fb0112872b78c0a$export$88cc3a1dfce48dd3.prototype = Object.create(Error.prototype);
$7fb0112872b78c0a$export$88cc3a1dfce48dd3.prototype.constructor = $7fb0112872b78c0a$export$88cc3a1dfce48dd3;
$7fb0112872b78c0a$export$88cc3a1dfce48dd3.prototype.name = "TransformError";
/**
Abstraction to build up and track an array of
[steps](https://prosemirror.net/docs/ref/#transform.Step) representing a document transformation.

Most transforming methods return the `Transform` object itself, so
that they can be chained.
*/ class $7fb0112872b78c0a$export$563a914cafbdc389 {
    /**
    The starting document.
    */ get before() {
        return this.docs.length ? this.docs[0] : this.doc;
    }
    /**
    Apply a new step in this transform, saving the result. Throws an
    error when the step fails.
    */ step(step) {
        let result = this.maybeStep(step);
        if (result.failed) throw new $7fb0112872b78c0a$export$88cc3a1dfce48dd3(result.failed);
        return this;
    }
    /**
    Try to apply a step in this transformation, ignoring it if it
    fails. Returns the step result.
    */ maybeStep(step) {
        let result = step.apply(this.doc);
        if (!result.failed) this.addStep(step, result.doc);
        return result;
    }
    /**
    True when the document has been changed (when there are any
    steps).
    */ get docChanged() {
        return this.steps.length > 0;
    }
    /**
    @internal
    */ addStep(step, doc) {
        this.docs.push(this.doc);
        this.steps.push(step);
        this.mapping.appendMap(step.getMap());
        this.doc = doc;
    }
    /**
    Replace the part of the document between `from` and `to` with the
    given `slice`.
    */ replace(from, to = from, slice = (0, $5SAOw.Slice).empty) {
        let step = $7fb0112872b78c0a$export$ed6ac67359824afd(this.doc, from, to, slice);
        if (step) this.step(step);
        return this;
    }
    /**
    Replace the given range with the given content, which may be a
    fragment, node, or array of nodes.
    */ replaceWith(from, to, content) {
        return this.replace(from, to, new (0, $5SAOw.Slice)((0, $5SAOw.Fragment).from(content), 0, 0));
    }
    /**
    Delete the content between the given positions.
    */ delete(from, to) {
        return this.replace(from, to, (0, $5SAOw.Slice).empty);
    }
    /**
    Insert the given content at the given position.
    */ insert(pos, content) {
        return this.replaceWith(pos, pos, content);
    }
    /**
    Replace a range of the document with a given slice, using
    `from`, `to`, and the slice's
    [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
    than fixed start and end points. This method may grow the
    replaced area or close open nodes in the slice in order to get a
    fit that is more in line with WYSIWYG expectations, by dropping
    fully covered parent nodes of the replaced region when they are
    marked [non-defining as
    context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
    open parent node from the slice that _is_ marked as [defining
    its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
    
    This is the method, for example, to handle paste. The similar
    [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
    primitive tool which will _not_ move the start and end of its given
    range, and is useful in situations where you need more precise
    control over what happens.
    */ replaceRange(from, to, slice) {
        $7fb0112872b78c0a$var$replaceRange(this, from, to, slice);
        return this;
    }
    /**
    Replace the given range with a node, but use `from` and `to` as
    hints, rather than precise positions. When from and to are the same
    and are at the start or end of a parent node in which the given
    node doesn't fit, this method may _move_ them out towards a parent
    that does allow the given node to be placed. When the given range
    completely covers a parent node, this method may completely replace
    that parent node.
    */ replaceRangeWith(from, to, node) {
        $7fb0112872b78c0a$var$replaceRangeWith(this, from, to, node);
        return this;
    }
    /**
    Delete the given range, expanding it to cover fully covered
    parent nodes until a valid replace is found.
    */ deleteRange(from, to) {
        $7fb0112872b78c0a$var$deleteRange(this, from, to);
        return this;
    }
    /**
    Split the content in the given range off from its parent, if there
    is sibling content before or after it, and move it up the tree to
    the depth specified by `target`. You'll probably want to use
    [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
    sure the lift is valid.
    */ lift(range, target) {
        $7fb0112872b78c0a$var$lift(this, range, target);
        return this;
    }
    /**
    Join the blocks around the given position. If depth is 2, their
    last and first siblings are also joined, and so on.
    */ join(pos, depth = 1) {
        $7fb0112872b78c0a$var$join(this, pos, depth);
        return this;
    }
    /**
    Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
    The wrappers are assumed to be valid in this position, and should
    probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
    */ wrap(range, wrappers) {
        $7fb0112872b78c0a$var$wrap(this, range, wrappers);
        return this;
    }
    /**
    Set the type of all textblocks (partly) between `from` and `to` to
    the given node type with the given attributes.
    */ setBlockType(from, to = from, type, attrs = null) {
        $7fb0112872b78c0a$var$setBlockType(this, from, to, type, attrs);
        return this;
    }
    /**
    Change the type, attributes, and/or marks of the node at `pos`.
    When `type` isn't given, the existing node type is preserved,
    */ setNodeMarkup(pos, type, attrs = null, marks) {
        $7fb0112872b78c0a$var$setNodeMarkup(this, pos, type, attrs, marks);
        return this;
    }
    /**
    Set a single attribute on a given node to a new value.
    The `pos` addresses the document content. Use `setDocAttribute`
    to set attributes on the document itself.
    */ setNodeAttribute(pos, attr, value) {
        this.step(new $7fb0112872b78c0a$export$626399c38172f669(pos, attr, value));
        return this;
    }
    /**
    Set a single attribute on the document to a new value.
    */ setDocAttribute(attr, value) {
        this.step(new $7fb0112872b78c0a$export$f50707b396300ac9(attr, value));
        return this;
    }
    /**
    Add a mark to the node at position `pos`.
    */ addNodeMark(pos, mark) {
        this.step(new $7fb0112872b78c0a$export$adefd16c402fee4e(pos, mark));
        return this;
    }
    /**
    Remove a mark (or a mark of the given type) from the node at
    position `pos`.
    */ removeNodeMark(pos, mark) {
        if (!(mark instanceof (0, $5SAOw.Mark))) {
            let node = this.doc.nodeAt(pos);
            if (!node) throw new RangeError("No node at position " + pos);
            mark = mark.isInSet(node.marks);
            if (!mark) return this;
        }
        this.step(new $7fb0112872b78c0a$export$fdf7d1dc10724da2(pos, mark));
        return this;
    }
    /**
    Split the node at the given position, and optionally, if `depth` is
    greater than one, any number of nodes above that. By default, the
    parts split off will inherit the node type of the original node.
    This can be changed by passing an array of types and attributes to
    use after the split.
    */ split(pos, depth = 1, typesAfter) {
        $7fb0112872b78c0a$var$split(this, pos, depth, typesAfter);
        return this;
    }
    /**
    Add the given mark to the inline content between `from` and `to`.
    */ addMark(from, to, mark) {
        $7fb0112872b78c0a$var$addMark(this, from, to, mark);
        return this;
    }
    /**
    Remove marks from inline nodes between `from` and `to`. When
    `mark` is a single mark, remove precisely that mark. When it is
    a mark type, remove all marks of that type. When it is null,
    remove all marks of any type.
    */ removeMark(from, to, mark) {
        $7fb0112872b78c0a$var$removeMark(this, from, to, mark);
        return this;
    }
    /**
    Removes all marks and nodes from the content of the node at
    `pos` that don't match the given new parent node type. Accepts
    an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
    third argument.
    */ clearIncompatible(pos, parentType, match) {
        $7fb0112872b78c0a$var$clearIncompatible(this, pos, parentType, match);
        return this;
    }
    /**
    Create a transform that starts with the given document.
    */ constructor(/**
    The current document (the result of applying the steps in the
    transform).
    */ doc){
        this.doc = doc;
        /**
        The steps in this transform.
        */ this.steps = [];
        /**
        The documents before each of the steps.
        */ this.docs = [];
        /**
        A mapping with the maps for each of the steps in this transform.
        */ this.mapping = new $7fb0112872b78c0a$export$f5f785078011b62;
    }
}
module.exports["StepMap"] = $7fb0112872b78c0a$export$c53d01c3ab9721b3;
module.exports["Mapping"] = $7fb0112872b78c0a$export$f5f785078011b62;
module.exports["Step"] = $7fb0112872b78c0a$export$fd55ce593607084a;
module.exports["StepResult"] = $7fb0112872b78c0a$export$8ebf1578a4199c09;
module.exports["AddMarkStep"] = $7fb0112872b78c0a$export$d24ba56b0e3464a9;
module.exports["RemoveMarkStep"] = $7fb0112872b78c0a$export$94150db1311f67a9;
module.exports["AddNodeMarkStep"] = $7fb0112872b78c0a$export$adefd16c402fee4e;
module.exports["RemoveNodeMarkStep"] = $7fb0112872b78c0a$export$fdf7d1dc10724da2;
module.exports["ReplaceStep"] = $7fb0112872b78c0a$export$5c860b2e74034756;
module.exports["ReplaceAroundStep"] = $7fb0112872b78c0a$export$444ba800d6024a98;
module.exports["liftTarget"] = $7fb0112872b78c0a$export$f1508b72cc76a09e;
module.exports["findWrapping"] = $7fb0112872b78c0a$export$118cb9a83e81ba37;
module.exports["canSplit"] = $7fb0112872b78c0a$export$5aaf008897aef029;
module.exports["canJoin"] = $7fb0112872b78c0a$export$f15f89fd9d8cc98a;
module.exports["joinPoint"] = $7fb0112872b78c0a$export$41b1d4cb5ceb3147;
module.exports["insertPoint"] = $7fb0112872b78c0a$export$64cb316d02de1dd1;
module.exports["dropPoint"] = $7fb0112872b78c0a$export$2819d598d048fc9c;
module.exports["replaceStep"] = $7fb0112872b78c0a$export$ed6ac67359824afd;
module.exports["AttrStep"] = $7fb0112872b78c0a$export$626399c38172f669;
module.exports["DocAttrStep"] = $7fb0112872b78c0a$export$f50707b396300ac9;
module.exports["Transform"] = $7fb0112872b78c0a$export$563a914cafbdc389;

});

parcelRegister("8m4tT", function(module, exports) {
// src/selection.ts

var $ks2lK = parcelRequire("ks2lK");


var $5SAOw = parcelRequire("5SAOw");

var $6153daae61560dbf$export$5dd18664fe8bcbde = (nodeType)=>(tr)=>{
        const parent = $6153daae61560dbf$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $6153daae61560dbf$var$removeNodeAtPos(parent.pos)(tr);
        return tr;
    };
var $6153daae61560dbf$export$b72cc612b642c071 = (nodeType, content)=>(tr)=>{
        if (!Array.isArray(nodeType)) nodeType = [
            nodeType
        ];
        for(let i = 0, count = nodeType.length; i < count; i++){
            const parent = $6153daae61560dbf$export$1a3a74094b9968e(nodeType[i])(tr.selection);
            if (parent) {
                const newTr = $6153daae61560dbf$var$replaceNodeAtPos(parent.pos, content)(tr);
                if (newTr !== tr) return newTr;
            }
        }
        return tr;
    };
var $6153daae61560dbf$export$7d6e4e6663186878 = (tr)=>{
    if ($6153daae61560dbf$export$a8c1d2c13abf8822(tr.selection)) {
        const from = tr.selection.$from.pos;
        const to = tr.selection.$to.pos;
        return $6153daae61560dbf$var$cloneTr(tr.delete(from, to));
    }
    return tr;
};
var $6153daae61560dbf$export$39874bca494f9ba3 = (content)=>(tr)=>{
        if ($6153daae61560dbf$export$a8c1d2c13abf8822(tr.selection)) {
            const { $from: $from, $to: $to } = tr.selection;
            if (content instanceof (0, $5SAOw.Fragment) && $from.parent.canReplace($from.index(), $from.indexAfter(), content) || content instanceof (0, $5SAOw.Node) && $from.parent.canReplaceWith($from.index(), $from.indexAfter(), content.type)) return $6153daae61560dbf$var$cloneTr(tr.replaceWith($from.pos, $to.pos, content).setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve($from.pos))));
        }
        return tr;
    };
var $6153daae61560dbf$export$1df6d14df6b0b758 = (position, dir = 1)=>(tr)=>{
        const nextSelection = (0, $ks2lK.Selection).findFrom(tr.doc.resolve(position), dir, true);
        if (nextSelection) return tr.setSelection(nextSelection);
        return tr;
    };
var $6153daae61560dbf$var$isSelectableNode = (node)=>Boolean(node instanceof (0, $5SAOw.Node) && node.type && node.type.spec.selectable);
var $6153daae61560dbf$var$shouldSelectNode = (node)=>$6153daae61560dbf$var$isSelectableNode(node) && node.type.isLeaf;
var $6153daae61560dbf$var$setSelection = (node, pos, tr)=>{
    if ($6153daae61560dbf$var$shouldSelectNode(node)) return tr.setSelection(new (0, $ks2lK.NodeSelection)(tr.doc.resolve(pos)));
    return $6153daae61560dbf$export$1df6d14df6b0b758(pos)(tr);
};
var $6153daae61560dbf$export$5fe92db78385e37c = (content, position, tryToReplace)=>(tr)=>{
        const hasPosition = typeof position === "number";
        const { $from: $from } = tr.selection;
        const $insertPos = hasPosition ? tr.doc.resolve(position) : $6153daae61560dbf$export$a8c1d2c13abf8822(tr.selection) ? tr.doc.resolve($from.pos + 1) : $from;
        const { parent: parent } = $insertPos;
        if ($6153daae61560dbf$export$a8c1d2c13abf8822(tr.selection) && tryToReplace) {
            const oldTr = tr;
            tr = $6153daae61560dbf$export$39874bca494f9ba3(content)(tr);
            if (oldTr !== tr) return tr;
        }
        if ($6153daae61560dbf$var$isEmptyParagraph(parent)) {
            const oldTr = tr;
            tr = $6153daae61560dbf$export$b72cc612b642c071(parent.type, content)(tr);
            if (oldTr !== tr) {
                const pos = $6153daae61560dbf$var$isSelectableNode(content) ? // for selectable node, selection position would be the position of the replaced parent
                $insertPos.before($insertPos.depth) : $insertPos.pos;
                return $6153daae61560dbf$var$setSelection(content, pos, tr);
            }
        }
        if ($6153daae61560dbf$export$b4d1262a40ad21d4($insertPos, content)) {
            tr.insert($insertPos.pos, content);
            const pos = hasPosition ? $insertPos.pos : $6153daae61560dbf$var$isSelectableNode(content) ? // for atom nodes selection position after insertion is the previous pos
            tr.selection.$anchor.pos - 1 : tr.selection.$anchor.pos;
            return $6153daae61560dbf$var$cloneTr($6153daae61560dbf$var$setSelection(content, pos, tr));
        }
        for(let i = $insertPos.depth; i > 0; i--){
            const pos = $insertPos.after(i);
            const $pos = tr.doc.resolve(pos);
            if ($6153daae61560dbf$export$b4d1262a40ad21d4($pos, content)) {
                tr.insert(pos, content);
                return $6153daae61560dbf$var$cloneTr($6153daae61560dbf$var$setSelection(content, pos, tr));
            }
        }
        return tr;
    };
var $6153daae61560dbf$export$36491a9ea218d882 = (nodeType, type, attrs, marks)=>(tr)=>{
        const parent = $6153daae61560dbf$export$1a3a74094b9968e(nodeType)(tr.selection);
        if (parent) return $6153daae61560dbf$var$cloneTr(tr.setNodeMarkup(parent.pos, type, Object.assign({}, parent.node.attrs, attrs), marks));
        return tr;
    };
var $6153daae61560dbf$export$7f11cc48adfe3aed = (nodeType)=>(tr)=>{
        if (!$6153daae61560dbf$export$a8c1d2c13abf8822(tr.selection)) {
            const parent = $6153daae61560dbf$export$1a3a74094b9968e(nodeType)(tr.selection);
            if (parent) return $6153daae61560dbf$var$cloneTr(tr.setSelection((0, $ks2lK.NodeSelection).create(tr.doc, parent.pos)));
        }
        return tr;
    };
var $6153daae61560dbf$export$ffb1550ab6c3d03c = (tr)=>{
    const position = $6153daae61560dbf$export$f8088819b1e2c2dc(tr.selection);
    if (typeof position === "number") return $6153daae61560dbf$var$removeNodeAtPos(position)(tr);
    return tr;
};
// src/helpers.ts
var $6153daae61560dbf$export$a8c1d2c13abf8822 = (selection)=>{
    return selection instanceof (0, $ks2lK.NodeSelection);
};
var $6153daae61560dbf$var$equalNodeType = (nodeType, node)=>{
    return Array.isArray(nodeType) && nodeType.indexOf(node.type) > -1 || node.type === nodeType;
};
var $6153daae61560dbf$var$cloneTr = (tr)=>{
    return Object.assign(Object.create(tr), tr).setTime(Date.now());
};
var $6153daae61560dbf$var$replaceNodeAtPos = (position, content)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        const $pos = tr.doc.resolve(position);
        if (!node) return tr;
        if ($6153daae61560dbf$var$canReplace($pos, content)) {
            tr = tr.replaceWith(position, position + node.nodeSize, content);
            const start = tr.selection.$from.pos - 1;
            tr = $6153daae61560dbf$export$1df6d14df6b0b758(Math.max(start, 0), -1)(tr);
            tr = $6153daae61560dbf$export$1df6d14df6b0b758(tr.selection.$from.start())(tr);
            return $6153daae61560dbf$var$cloneTr(tr);
        }
        return tr;
    };
var $6153daae61560dbf$var$canReplace = ($pos, content)=>{
    const node = $pos.node($pos.depth);
    return node && node.type.validContent(content instanceof (0, $5SAOw.Fragment) ? content : (0, $5SAOw.Fragment).from(content));
};
var $6153daae61560dbf$var$removeNodeAtPos = (position)=>(tr)=>{
        const node = tr.doc.nodeAt(position);
        if (!node) return tr;
        return $6153daae61560dbf$var$cloneTr(tr.delete(position, position + node.nodeSize));
    };
var $6153daae61560dbf$export$b4d1262a40ad21d4 = ($pos, content)=>{
    const index = $pos.index();
    if (content instanceof (0, $5SAOw.Fragment)) return $pos.parent.canReplace(index, index, content);
    else if (content instanceof (0, $5SAOw.Node)) return $pos.parent.canReplaceWith(index, index, content.type);
    return false;
};
var $6153daae61560dbf$var$isEmptyParagraph = (node)=>{
    return !node || node.type.name === "paragraph" && node.nodeSize === 2;
};
// src/selection.ts
var $6153daae61560dbf$export$dc159056ffdb4c76 = (predicate)=>({ $from: $from, $to: $to }, validateSameParent = false)=>{
        if (validateSameParent && !$from.sameParent($to)) {
            let depth = Math.min($from.depth, $to.depth);
            while(depth >= 0){
                const fromNode = $from.node(depth);
                const toNode = $to.node(depth);
                if (toNode === fromNode) {
                    if (predicate(fromNode)) return {
                        // Return the resolved pos
                        pos: depth > 0 ? $from.before(depth) : 0,
                        start: $from.start(depth),
                        depth: depth,
                        node: fromNode
                    };
                }
                depth = depth - 1;
            }
            return;
        }
        return $6153daae61560dbf$export$fe09644e3bc6166b($from, predicate);
    };
var $6153daae61560dbf$export$fe09644e3bc6166b = ($pos, predicate)=>{
    for(let i = $pos.depth; i > 0; i--){
        const node = $pos.node(i);
        if (predicate(node)) return {
            pos: i > 0 ? $pos.before(i) : 0,
            start: $pos.start(i),
            depth: i,
            node: node
        };
    }
};
var $6153daae61560dbf$export$8556d79fa8189214 = (predicate, domAtPos)=>(selection)=>{
        const parent = $6153daae61560dbf$export$dc159056ffdb4c76(predicate)(selection);
        if (parent) return $6153daae61560dbf$export$666ce65defe9ad6e(parent.pos, domAtPos);
    };
var $6153daae61560dbf$export$178ecaf80f45fdb6 = (predicate)=>(selection)=>{
        return !!$6153daae61560dbf$export$dc159056ffdb4c76(predicate)(selection);
    };
var $6153daae61560dbf$export$1a3a74094b9968e = (nodeType)=>(selection)=>{
        return $6153daae61560dbf$export$dc159056ffdb4c76((node)=>$6153daae61560dbf$var$equalNodeType(nodeType, node))(selection);
    };
var $6153daae61560dbf$export$8bf0d019bde85d18 = ($pos, nodeType)=>{
    return $6153daae61560dbf$export$fe09644e3bc6166b($pos, (node)=>$6153daae61560dbf$var$equalNodeType(nodeType, node));
};
var $6153daae61560dbf$export$14f438bb7227ce63 = (nodeType)=>(selection)=>{
        return $6153daae61560dbf$export$178ecaf80f45fdb6((node)=>$6153daae61560dbf$var$equalNodeType(nodeType, node))(selection);
    };
var $6153daae61560dbf$export$faeafc1151740116 = (nodeType, domAtPos)=>(selection)=>{
        return $6153daae61560dbf$export$8556d79fa8189214((node)=>$6153daae61560dbf$var$equalNodeType(nodeType, node), domAtPos)(selection);
    };
var $6153daae61560dbf$export$924aa2dd4d9a67fa = (nodeType)=>(selection)=>{
        if ($6153daae61560dbf$export$a8c1d2c13abf8822(selection)) {
            const { node: node, $from: $from } = selection;
            if ($6153daae61560dbf$var$equalNodeType(nodeType, node)) return {
                node: node,
                start: $from.start(),
                pos: $from.pos,
                depth: $from.depth
            };
        }
    };
var $6153daae61560dbf$export$f8088819b1e2c2dc = (selection)=>{
    const { nodeBefore: nodeBefore } = selection.$from;
    const maybeSelection = (0, $ks2lK.Selection).findFrom(selection.$from, -1);
    if (maybeSelection && nodeBefore) {
        const parent = $6153daae61560dbf$export$1a3a74094b9968e(nodeBefore.type)(maybeSelection);
        if (parent) return parent.pos;
        return maybeSelection.$from.pos;
    }
};
var $6153daae61560dbf$export$666ce65defe9ad6e = (position, domAtPos)=>{
    const dom = domAtPos(position);
    const node = dom.node.childNodes[dom.offset];
    if (dom.node.nodeType === Node.TEXT_NODE && dom.node.parentNode) return dom.node.parentNode;
    if (!node || node.nodeType === Node.TEXT_NODE) return dom.node;
    return node;
};
// src/node.ts
var $6153daae61560dbf$export$bffa455ba8c619a6 = (node, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    const result = [];
    node.descendants((child, pos)=>{
        result.push({
            node: child,
            pos: pos
        });
        if (!descend) return false;
    });
    return result;
};
var $6153daae61560dbf$export$f94ca194e830789c = (node, predicate, descend = true)=>{
    if (!node) throw new Error('Invalid "node" parameter');
    else if (!predicate) throw new Error('Invalid "predicate" parameter');
    return $6153daae61560dbf$export$bffa455ba8c619a6(node, descend).filter((child)=>predicate(child.node));
};
var $6153daae61560dbf$export$53418710fbc2d8cc = (node, descend = true)=>{
    return $6153daae61560dbf$export$f94ca194e830789c(node, (child)=>child.isText, descend);
};
var $6153daae61560dbf$export$ddc1620722e25671 = (node, descend = true)=>{
    return $6153daae61560dbf$export$f94ca194e830789c(node, (child)=>child.isInline, descend);
};
var $6153daae61560dbf$export$cae8d7f259e5bbe9 = (node, descend = true)=>{
    return $6153daae61560dbf$export$f94ca194e830789c(node, (child)=>child.isBlock, descend);
};
var $6153daae61560dbf$export$a836476a7f9de5b4 = (node, predicate, descend = true)=>{
    return $6153daae61560dbf$export$f94ca194e830789c(node, (child)=>!!predicate(child.attrs), descend);
};
var $6153daae61560dbf$export$96bb9476c7c69f39 = (node, nodeType, descend = true)=>{
    return $6153daae61560dbf$export$f94ca194e830789c(node, (child)=>child.type === nodeType, descend);
};
var $6153daae61560dbf$export$c01a9e7ec615e821 = (node, markType, descend = true)=>{
    return $6153daae61560dbf$export$f94ca194e830789c(node, (child)=>Boolean(markType.isInSet(child.marks)), descend);
};
var $6153daae61560dbf$export$2344b14b097df817 = (node, nodeType)=>{
    return !!$6153daae61560dbf$export$96bb9476c7c69f39(node, nodeType).length;
};
module.exports["removeParentNodeOfType"] = $6153daae61560dbf$export$5dd18664fe8bcbde;
module.exports["findParentNodeOfType"] = $6153daae61560dbf$export$1a3a74094b9968e;
module.exports["replaceParentNodeOfType"] = $6153daae61560dbf$export$b72cc612b642c071;
module.exports["removeSelectedNode"] = $6153daae61560dbf$export$7d6e4e6663186878;
module.exports["isNodeSelection"] = $6153daae61560dbf$export$a8c1d2c13abf8822;
module.exports["replaceSelectedNode"] = $6153daae61560dbf$export$39874bca494f9ba3;
module.exports["setTextSelection"] = $6153daae61560dbf$export$1df6d14df6b0b758;
module.exports["safeInsert"] = $6153daae61560dbf$export$5fe92db78385e37c;
module.exports["canInsert"] = $6153daae61560dbf$export$b4d1262a40ad21d4;
module.exports["removeNodeBefore"] = $6153daae61560dbf$export$ffb1550ab6c3d03c;
module.exports["findPositionOfNodeBefore"] = $6153daae61560dbf$export$f8088819b1e2c2dc;
module.exports["findParentNode"] = $6153daae61560dbf$export$dc159056ffdb4c76;
module.exports["findParentNodeClosestToPos"] = $6153daae61560dbf$export$fe09644e3bc6166b;
module.exports["findDomRefAtPos"] = $6153daae61560dbf$export$666ce65defe9ad6e;
module.exports["hasParentNode"] = $6153daae61560dbf$export$178ecaf80f45fdb6;
module.exports["findParentNodeOfTypeClosestToPos"] = $6153daae61560dbf$export$8bf0d019bde85d18;
module.exports["hasParentNodeOfType"] = $6153daae61560dbf$export$14f438bb7227ce63;
module.exports["findParentDomRefOfType"] = $6153daae61560dbf$export$faeafc1151740116;
module.exports["findSelectedNodeOfType"] = $6153daae61560dbf$export$924aa2dd4d9a67fa;
module.exports["flatten"] = $6153daae61560dbf$export$bffa455ba8c619a6;
module.exports["findChildren"] = $6153daae61560dbf$export$f94ca194e830789c;
module.exports["findChildrenByType"] = $6153daae61560dbf$export$96bb9476c7c69f39;
module.exports["findChildrenByMark"] = $6153daae61560dbf$export$c01a9e7ec615e821;
module.exports["contains"] = $6153daae61560dbf$export$2344b14b097df817;

});

parcelRegister("4wH3g", function(module, exports) {

var $jmjWc = parcelRequire("jmjWc");

var $34bb8bbd6b8f84d6$require$createLoadable = $jmjWc.createLoadable;

var $398ES = parcelRequire("398ES");

var $34bb8bbd6b8f84d6$require$LoadingPriority = $398ES.LoadingPriority;
function $34bb8bbd6b8f84d6$var$WrappedReactLoadable(opts) {
    const { overrideReactLoadablePriority: overrideReactLoadablePriority } = opts;
    const ReactLoadable = $34bb8bbd6b8f84d6$require$createLoadable(overrideReactLoadablePriority !== undefined ? overrideReactLoadablePriority : $34bb8bbd6b8f84d6$require$LoadingPriority.AFTER_PAINT);
    return ReactLoadable({
        ...opts,
        isReactLoadable: true
    });
}
module.exports = $34bb8bbd6b8f84d6$var$WrappedReactLoadable;

});

parcelRegister("21K7m", function(module, exports) {

var $5rDjV = parcelRequire("5rDjV");

var $b38ed7ab605aa654$export$c1c4b33b4e7b1c70 = /*#__PURE__*/ function(AnnotationUpdateEvent) {
    AnnotationUpdateEvent["SET_ANNOTATION_FOCUS"] = "SET_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["SET_ANNOTATION_HOVERED"] = "SET_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["SET_ANNOTATION_STATE"] = "SET_ANNOTATION_STATE";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_FOCUS"] = "REMOVE_ANNOTATION_FOCUS";
    AnnotationUpdateEvent["REMOVE_ANNOTATION_HOVERED"] = "REMOVE_ANNOTATION_HOVERED";
    AnnotationUpdateEvent["ON_ANNOTATION_CLICK"] = "ON_ANNOTATION_CLICK";
    AnnotationUpdateEvent["DESELECT_ANNOTATIONS"] = "DESELECT_ANNOTATIONS";
    return AnnotationUpdateEvent;
}({});
class $b38ed7ab605aa654$export$7cc60aa9ef845515 {
    emit(event, params) {
        if (typeof params === 'undefined') return this.emitter.emit(event);
        return this.emitter.emit(event, params);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    on(event, listener) {
        return this.emitter.on(event, listener);
    }
    // Ignored via go/ees005
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    off(event, listener) {
        return this.emitter.removeListener(event, listener);
    }
    listeners(event) {
        return this.emitter.listeners(event);
    }
    constructor(){
        this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($5rDjV)))();
    }
}
module.exports["AnnotationUpdateEvent"] = $b38ed7ab605aa654$export$c1c4b33b4e7b1c70;

});

parcelRegister("1To4a", function(module, exports) {


var $1vDIt = parcelRequire("1vDIt");


var $kyRHQ = parcelRequire("kyRHQ");

/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $cd5eb1a9b0824c7e$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $1vDIt.default)[tokenId];
    let tokenValue = fallback;
    typeof $kyRHQ;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $cd5eb1a9b0824c7e$export$2e2bcd8739ae039 = $cd5eb1a9b0824c7e$var$getTokenValue;
module.exports["default"] = $cd5eb1a9b0824c7e$export$2e2bcd8739ae039;

});

parcelRegister("g7Pc3", function(module, exports) {
$parcel$export(module.exports, "default", () => $e34dc1cd2084e09d$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3gadb = parcelRequire("3gadb");

/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 






var $gMc0m = parcelRequire("gMc0m");


var $6F6hl = parcelRequire("6F6hl");

const $994b46f1e25bb927$var$decoration = {
    root: "_kqswh2mm _szplfhey _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6rzzfg _1uakf6fq _1kt9y7el _is061xn9 _1rus1917 _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rba1xn9 _1xqc19zu"
};
function $994b46f1e25bb927$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
        children: [
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $gMc0m.default)([
                    $994b46f1e25bb927$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $l998X.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $994b46f1e25bb927$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}


function $e34dc1cd2084e09d$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, shouldSkipChildren: shouldSkipChildren, tooltipEnabled: tooltipEnabled, isTooltipEnabled: isTooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    // Use new props if provided, otherwise fall back to deprecated props
    const shouldEnableTooltip = isTooltipEnabled !== undefined ? isTooltipEnabled : tooltipEnabled;
    const shouldSkip = shouldSkipChildren !== undefined ? shouldSkipChildren : skipChildren;
    if (shouldEnableTooltip) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: label,
        tag: $e34dc1cd2084e09d$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $994b46f1e25bb927$export$a592b67c93d52467), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: shouldSkip ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $994b46f1e25bb927$export$a592b67c93d52467), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: shouldSkip ? null : bidiCharacter
    });
}
const $e34dc1cd2084e09d$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});

parcelRegister("03WRT", function(module, exports) {
$parcel$export(module.exports, "default", () => $484d2d2be4c10078$export$2e2bcd8739ae039);
const $484d2d2be4c10078$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $484d2d2be4c10078$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($484d2d2be4c10078$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("8hpYf", function(module, exports) {
const $a32401f34679a7c6$export$8633a0edef8e95dd = 'emoji-common-selected';
const $a32401f34679a7c6$export$860109dfd198259b = 'emoji-common-select-on-hover';
const $a32401f34679a7c6$export$1c10634420a08d8a = 'emoji-common-emoji-sprite';
const $a32401f34679a7c6$export$b06c4aab1d012063 = 'emoji-common-node';
const $a32401f34679a7c6$export$da61cef1c8919f7c = 'emoji-common-emoji-image';
const $a32401f34679a7c6$export$b11fa39b56a371f6 = 'emoji-common-deleteButton';
const $a32401f34679a7c6$export$11462c0756c24ab6 = 'emoji-common-main-styles';
const $a32401f34679a7c6$export$22b19c311e9caa4 = 'emoji-common-deletable';
const $a32401f34679a7c6$export$c7187bbd1a7a9244 = 'emoji-common-placeholder';
const $a32401f34679a7c6$export$b0fe756d87022806 = 'emoji-picker-add-emoji';
module.exports["commonSelectedStyles"] = $a32401f34679a7c6$export$8633a0edef8e95dd;
module.exports["selectOnHoverStyles"] = $a32401f34679a7c6$export$860109dfd198259b;
module.exports["emojiSprite"] = $a32401f34679a7c6$export$1c10634420a08d8a;
module.exports["emojiNodeStyles"] = $a32401f34679a7c6$export$b06c4aab1d012063;
module.exports["emojiImage"] = $a32401f34679a7c6$export$da61cef1c8919f7c;
module.exports["emojiDeleteButton"] = $a32401f34679a7c6$export$b11fa39b56a371f6;
module.exports["emojiMainStyle"] = $a32401f34679a7c6$export$11462c0756c24ab6;
module.exports["deletableEmoji"] = $a32401f34679a7c6$export$22b19c311e9caa4;
module.exports["placeholder"] = $a32401f34679a7c6$export$c7187bbd1a7a9244;
module.exports["emojiPickerAddEmoji"] = $a32401f34679a7c6$export$b0fe756d87022806;

});

parcelRegister("lgqac", function(module, exports) {
const $a2012143faf474ac$export$85183a312807388d = 'media';
const $a2012143faf474ac$export$a078c61943f9dbbe = {
    componentName: 'smart-cards',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
var $a2012143faf474ac$export$72af824fa910c33e = /*#__PURE__*/ function(TrackQuickActionType) {
    TrackQuickActionType["StatusUpdate"] = "StatusUpdate";
    return TrackQuickActionType;
}({});
var $a2012143faf474ac$export$c89e475f7f7174c2 = /*#__PURE__*/ function(TrackQuickActionFailureReason) {
    TrackQuickActionFailureReason["PermissionError"] = "PermissionError";
    TrackQuickActionFailureReason["ValidationError"] = "ValidationError";
    TrackQuickActionFailureReason["UnknownError"] = "UnknownError";
    return TrackQuickActionFailureReason;
}({});
class $a2012143faf474ac$export$b91e0203b928470c {
    insertSmartLink(url, type, createAnalyticsEvent) {
        $a2012143faf474ac$export$2a123f7ee48a122c({
            action: 'inserted',
            actionSubject: 'smartLink',
            eventType: 'track',
            attributes: {
                type: type
            },
            nonPrivacySafeAttributes: {
                domainName: url
            }
        }, createAnalyticsEvent);
    }
}
const $a2012143faf474ac$export$2a123f7ee48a122c = (payload, createAnalyticsEvent)=>{
    if (createAnalyticsEvent) createAnalyticsEvent(payload).fire($a2012143faf474ac$export$85183a312807388d);
};
module.exports["ANALYTICS_CHANNEL"] = $a2012143faf474ac$export$85183a312807388d;
module.exports["context"] = $a2012143faf474ac$export$a078c61943f9dbbe;
module.exports["TrackQuickActionType"] = $a2012143faf474ac$export$72af824fa910c33e;
module.exports["TrackQuickActionFailureReason"] = $a2012143faf474ac$export$c89e475f7f7174c2;
module.exports["SmartLinkEvents"] = $a2012143faf474ac$export$b91e0203b928470c;

});

parcelRegister("kKODE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::676f76a2e45920437adc8c35a9af8b37>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ 
var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");

const $6678419bc4dceb3a$export$3f072f06b90c3985 = 'media';


/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * Generates Typescript types for analytics events from analytics.spec.yaml
 *
 * @codegen <<SignedSource::f914fb83fac56e7154ef460866628f7d>>
 * @codegenCommand yarn workspace @atlassian/analytics-tooling run analytics:codegen smart-card
 */ const $4575fec4bf8df71a$var$createEventPayload = (eventKey, ...[attributes])=>{
    const [eventType, actionSubject, action, actionSubjectId] = eventKey.split('.');
    if (eventType === 'screen') return {
        eventType: eventType,
        name: actionSubject,
        action: 'viewed',
        attributes: attributes
    };
    return {
        eventType: eventType,
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
var $4575fec4bf8df71a$export$2e2bcd8739ae039 = $4575fec4bf8df71a$var$createEventPayload;


const $5b5d947ab1fa491a$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const fireEvent = (0, $42omo.useCallback)((...params)=>{
        const event = createAnalyticsEvent((0, $4575fec4bf8df71a$export$2e2bcd8739ae039)(...params));
        event.fire((0, $6678419bc4dceb3a$export$3f072f06b90c3985));
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireEvent: fireEvent
    };
};
module.exports["useAnalyticsEvents"] = $5b5d947ab1fa491a$export$5bf35293e545f20c;

});

parcelRegister("bIll3", function(module, exports) {

var $9801n = parcelRequire("9801n");

var $iqaft = parcelRequire("iqaft");

const $fe01df8db47f84d1$var$inlineExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$renderExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Load,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).PageSegmentLoad
};
const $fe01df8db47f84d1$var$aiExperience = {
    platform: {
        component: 'smart-links'
    },
    type: (0, $iqaft.ExperienceTypes).Experience,
    performanceType: (0, $iqaft.ExperiencePerformanceTypes).InlineResult
};
const $fe01df8db47f84d1$var$ufoExperiences = {
    'smart-link-rendered': new (0, $9801n.ConcurrentExperience)('smart-link-rendered', $fe01df8db47f84d1$var$renderExperience),
    'smart-link-authenticated': new (0, $9801n.ConcurrentExperience)('smart-link-authenticated', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-action-invocation': new (0, $9801n.ConcurrentExperience)('smart-link-action-invocation', $fe01df8db47f84d1$var$inlineExperience),
    'smart-link-ai-summary': new (0, $9801n.ConcurrentExperience)('smart-link-ai-summary', $fe01df8db47f84d1$var$aiExperience)
};
const $fe01df8db47f84d1$export$5e9287b6a10f8075 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.start();
    if (properties) experience.addMetadata(properties);
};
const $fe01df8db47f84d1$export$c5a5cf072c836c0e = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.success({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$8dda83bafca11b77 = (experienceName, id, properties)=>{
    const experience = $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id);
    experience.failure({
        metadata: properties
    });
};
const $fe01df8db47f84d1$export$4084c0df4a03a6af = (experienceName, id, properties)=>{
    $fe01df8db47f84d1$var$ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};
module.exports["startUfoExperience"] = $fe01df8db47f84d1$export$5e9287b6a10f8075;
module.exports["succeedUfoExperience"] = $fe01df8db47f84d1$export$c5a5cf072c836c0e;
module.exports["failUfoExperience"] = $fe01df8db47f84d1$export$8dda83bafca11b77;
module.exports["addMetadataToExperience"] = $fe01df8db47f84d1$export$4084c0df4a03a6af;

});

parcelRegister("5TXU5", function(module, exports) {
const $d747218f543c7aaa$export$5c881701926acbef = 'https://support.atlassian.com/confluence-cloud/docs/insert-links-and-anchors/#Smart-links';
const $d747218f543c7aaa$export$93d67ab022d9f8d2 = 'https://support.atlassian.com/confluence-cloud/docs/what-data-is-sent-and-received-when-pasting-a-smart-link/';
const $d747218f543c7aaa$export$70d24f0465ae60f8 = 'https://www.atlassian.com/trust/atlassian-intelligence';
const $d747218f543c7aaa$export$a3ed5c4e9d9599b7 = 'https://status.atlassian.com/';
const $d747218f543c7aaa$export$73b198e73554a323 = 'https://www.atlassian.com/legal/acceptable-use-policy';
var $d747218f543c7aaa$export$8910bf86027fe6be = /*#__PURE__*/ function(SmartLinkAlignment) {
    SmartLinkAlignment["Left"] = "left";
    SmartLinkAlignment["Right"] = "right";
    return SmartLinkAlignment;
}({});
var $d747218f543c7aaa$export$60831686b0574c86 = /*#__PURE__*/ function(SmartLinkDirection) {
    SmartLinkDirection["Horizontal"] = "horizontal";
    SmartLinkDirection["Vertical"] = "vertical";
    return SmartLinkDirection;
}({});
var $d747218f543c7aaa$export$d58e6377644d1dcf = /*#__PURE__*/ function(SmartLinkPosition) {
    SmartLinkPosition["Top"] = "top";
    SmartLinkPosition["Center"] = "center";
    return SmartLinkPosition;
}({});
var $d747218f543c7aaa$export$51f13ced115cbdae = /*#__PURE__*/ function(SmartLinkSize) {
    SmartLinkSize["XLarge"] = "xlarge";
    SmartLinkSize["Large"] = "large";
    SmartLinkSize["Medium"] = "medium";
    SmartLinkSize["Small"] = "small";
    return SmartLinkSize;
}({});
var $d747218f543c7aaa$export$61cff06be26816f = /*#__PURE__*/ function(SmartLinkStatus) {
    SmartLinkStatus["Pending"] = "pending";
    SmartLinkStatus["Resolving"] = "resolving";
    SmartLinkStatus["Resolved"] = "resolved";
    SmartLinkStatus["Forbidden"] = "forbidden";
    SmartLinkStatus["Errored"] = "errored";
    SmartLinkStatus["NotFound"] = "not_found";
    SmartLinkStatus["Unauthorized"] = "unauthorized";
    SmartLinkStatus["Fallback"] = "fallback";
    return SmartLinkStatus;
}({});
var $d747218f543c7aaa$export$aed0f1e801ad691f = /*#__PURE__*/ function(SmartLinkTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkTheme["Black"] = "black";
    SmartLinkTheme["Link"] = "link";
    return SmartLinkTheme;
}({});
var $d747218f543c7aaa$export$9aafec380d7005da = /*#__PURE__*/ function(SmartLinkInternalTheme) {
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    SmartLinkInternalTheme["Grey"] = "grey";
    return SmartLinkInternalTheme;
}({});
var $d747218f543c7aaa$export$19c60054ee783de6 = /*#__PURE__*/ function(SmartLinkWidth) {
    SmartLinkWidth["FitToContent"] = "fit-to-content";
    SmartLinkWidth["Flexible"] = "flexible";
    return SmartLinkWidth;
}({});
var $d747218f543c7aaa$export$d65b168331104a46 = /*#__PURE__*/ function(ElementName) {
    ElementName["AppliedToComponentsCount"] = "AppliedToComponentsCount";
    ElementName["AssignedTo"] = "AssignedTo";
    ElementName["AssignedToGroup"] = "AssignedToGroup";
    ElementName["AttachmentCount"] = "AttachmentCount";
    ElementName["AuthorGroup"] = "AuthorGroup";
    ElementName["ChecklistProgress"] = "ChecklistProgress";
    ElementName["CollaboratorGroup"] = "CollaboratorGroup";
    ElementName["CommentCount"] = "CommentCount";
    ElementName["CreatedBy"] = "CreatedBy";
    ElementName["CreatedOn"] = "CreatedOn";
    ElementName["DueOn"] = "DueOn";
    ElementName["LatestCommit"] = "LatestCommit";
    ElementName["LinkIcon"] = "LinkIcon";
    ElementName["Location"] = "Location";
    ElementName["ModifiedBy"] = "ModifiedBy";
    ElementName["ModifiedOn"] = "ModifiedOn";
    ElementName["OwnedBy"] = "OwnedBy";
    ElementName["OwnedByGroup"] = "OwnedByGroup";
    ElementName["Preview"] = "Preview";
    ElementName["Priority"] = "Priority";
    ElementName["ProgrammingLanguage"] = "ProgrammingLanguage";
    ElementName["Provider"] = "Provider";
    ElementName["ReactCount"] = "ReactCount";
    ElementName["ReadTime"] = "ReadTime";
    ElementName["Snippet"] = "Snippet";
    ElementName["SourceBranch"] = "SourceBranch";
    ElementName["State"] = "State";
    ElementName["SubscriberCount"] = "SubscriberCount";
    ElementName["SubTasksProgress"] = "SubTasksProgress";
    ElementName["StoryPoints"] = "StoryPoints";
    ElementName["TargetBranch"] = "TargetBranch";
    ElementName["TeamMemberCount"] = "TeamMemberCount";
    ElementName["Title"] = "Title";
    ElementName["UserAttributes"] = "UserAttributes";
    ElementName["ViewCount"] = "ViewCount";
    ElementName["VoteCount"] = "VoteCount";
    ElementName["SentOn"] = "SentOn";
    ElementName["HostName"] = "HostName";
    return ElementName;
}({});
var $d747218f543c7aaa$export$9c95d6e1614bad84 = /*#__PURE__*/ function(ActionName) {
    ActionName["CopyLinkAction"] = "CopyLinkAction";
    ActionName["DeleteAction"] = "DeleteAction";
    ActionName["EditAction"] = "EditAction";
    ActionName["FollowAction"] = "FollowAction";
    ActionName["PreviewAction"] = "PreviewAction";
    ActionName["AutomationAction"] = "AutomationAction";
    ActionName["DownloadAction"] = "DownloadAction";
    ActionName["CustomAction"] = "CustomAction";
    return ActionName;
}({});
var $d747218f543c7aaa$export$4871a84b35cf8eb9 = /*#__PURE__*/ function(InternalActionName) {
    InternalActionName["AISummaryAction"] = "AISummaryAction";
    InternalActionName["RovoChatAction"] = "RovoChatAction";
    InternalActionName["UnresolvedAction"] = "UnresolvedAction";
    InternalActionName["ViewRelatedLinksAction"] = "ViewRelatedLinksAction";
    return InternalActionName;
}({});
var $d747218f543c7aaa$export$13ff1290a9e22e77 = /*#__PURE__*/ function(IconType) {
    IconType["Archive"] = "FileType:Archive";
    IconType["Audio"] = "FileType:Audio";
    IconType["Blog"] = "FileType:Blog";
    IconType["Code"] = "FileType:Code";
    IconType["Document"] = "FileType:Document";
    IconType["Executable"] = "FileType:Executable";
    IconType["File"] = "FileType:File";
    IconType["Folder"] = "FileType:Folder";
    IconType["Generic"] = "FileType:Generic";
    IconType["GIF"] = "FileType:GIF";
    IconType["GoogleDocs"] = "FileType:GoogleDocs";
    IconType["GoogleForms"] = "FileType:GoogleForms";
    IconType["GoogleSheets"] = "FileType:GoogleSheets";
    IconType["GoogleSlides"] = "FileType:GoogleSlides";
    IconType["Image"] = "FileType.Image";
    IconType["MSExcel"] = "FileType:Excel";
    IconType["MSPowerpoint"] = "FileType:Powerpoint";
    IconType["MSWord"] = "FileType:WordDocument";
    IconType["PDF"] = "FileType:PDF";
    IconType["Presentation"] = "FileType:Presentation";
    IconType["Sketch"] = "FileType:Sketch";
    IconType["Spreadsheet"] = "FileType:Spreadsheet";
    IconType["Template"] = "FileType:Template";
    IconType["Video"] = "FileType:Video";
    // BitBucket?
    IconType["Branch"] = "BitBucket:Branch";
    IconType["Commit"] = "BitBucket:Commit";
    IconType["Project"] = "BitBucket:Project";
    IconType["PullRequest"] = "BitBucket:PullRequest";
    IconType["Repo"] = "BitBucket:Repo";
    // Jira?
    IconType["Bug"] = "Jira:Bug";
    IconType["Change"] = "Jira:Change";
    IconType["Epic"] = "Jira:Epic";
    IconType["Incident"] = "Jira:Incident";
    IconType["Problem"] = "Jira:Problem";
    IconType["ServiceRequest"] = "Jira:ServiceRequest";
    IconType["Story"] = "Jira:Story";
    IconType["SubTask"] = "Jira:SubTask";
    IconType["Task"] = "Jira:Task";
    // Confluence
    IconType["LiveDocument"] = "Confluence:LiveDocument";
    // Provider
    IconType["Confluence"] = "Provider:Confluence";
    IconType["Jira"] = "Provider:Jira";
    // Fallback
    IconType["Default"] = "Default";
    IconType["Error"] = "Default:Error";
    IconType["Forbidden"] = "Default:Forbidden";
    // Badge
    IconType["Attachment"] = "Badge:Attachment";
    IconType["CheckItem"] = "Badge:Task";
    IconType["Comment"] = "Badge:Comment";
    IconType["Component"] = "Badge:Component";
    IconType["View"] = "Badge:View";
    IconType["React"] = "Badge:React";
    IconType["Vote"] = "Badge:Vote";
    IconType["PriorityBlocker"] = "Badge:PriorityBlocker";
    IconType["PriorityCritical"] = "Badge:PriorityCritical";
    IconType["PriorityHigh"] = "Badge:PriorityHigh";
    IconType["PriorityHighest"] = "Badge:PriorityHighest";
    IconType["PriorityLow"] = "Badge:PriorityLow";
    IconType["PriorityLowest"] = "Badge:PriorityLowest";
    IconType["PriorityMajor"] = "Badge:PriorityMajor";
    IconType["PriorityMedium"] = "Badge:PriorityMedium";
    IconType["PriorityMinor"] = "Badge:PriorityMinor";
    IconType["PriorityTrivial"] = "Badge:PriorityTrivial";
    IconType["PriorityUndefined"] = "Badge:PriorityUndefined";
    IconType["ProgrammingLanguage"] = "Badge:ProgrammingLanguage";
    IconType["Subscriber"] = "Badge:Subscriber";
    IconType["SubTasksProgress"] = "Badge:SubTask";
    return IconType;
}({});
var $d747218f543c7aaa$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["Image"] = "image";
    return MediaType;
}({});
var $d747218f543c7aaa$export$f9f4737e25ab90fa = /*#__PURE__*/ function(MediaPlacement) {
    MediaPlacement["Left"] = "left";
    MediaPlacement["Right"] = "right";
    return MediaPlacement;
}({});
var $d747218f543c7aaa$export$6ca4ef8b3dc2c804 = /*#__PURE__*/ function(CardDisplay) {
    CardDisplay["Inline"] = "inline";
    CardDisplay["Block"] = "block";
    CardDisplay["Embed"] = "embed";
    CardDisplay["EmbedPreview"] = "embedPreview";
    CardDisplay["Flexible"] = "flexible";
    CardDisplay["HoverCardPreview"] = "hoverCardPreview";
    return CardDisplay;
}({});
module.exports["CONTENT_URL_SECURITY_AND_PERMISSIONS"] = $d747218f543c7aaa$export$5c881701926acbef;
module.exports["CONTENT_URL_3P_ACCOUNT_AUTH"] = $d747218f543c7aaa$export$93d67ab022d9f8d2;
module.exports["CONTENT_URL_AI"] = $d747218f543c7aaa$export$70d24f0465ae60f8;
module.exports["CONTENT_URL_AI_TROUBLESHOOTING"] = $d747218f543c7aaa$export$a3ed5c4e9d9599b7;
module.exports["CONTENT_URL_ACCEPTABLE_USE_POLICY"] = $d747218f543c7aaa$export$73b198e73554a323;
module.exports["SmartLinkAlignment"] = $d747218f543c7aaa$export$8910bf86027fe6be;
module.exports["SmartLinkDirection"] = $d747218f543c7aaa$export$60831686b0574c86;
module.exports["SmartLinkPosition"] = $d747218f543c7aaa$export$d58e6377644d1dcf;
module.exports["SmartLinkSize"] = $d747218f543c7aaa$export$51f13ced115cbdae;
module.exports["SmartLinkStatus"] = $d747218f543c7aaa$export$61cff06be26816f;
module.exports["SmartLinkTheme"] = $d747218f543c7aaa$export$aed0f1e801ad691f;
module.exports["SmartLinkInternalTheme"] = $d747218f543c7aaa$export$9aafec380d7005da;
module.exports["SmartLinkWidth"] = $d747218f543c7aaa$export$19c60054ee783de6;
module.exports["ElementName"] = $d747218f543c7aaa$export$d65b168331104a46;
module.exports["ActionName"] = $d747218f543c7aaa$export$9c95d6e1614bad84;
module.exports["InternalActionName"] = $d747218f543c7aaa$export$4871a84b35cf8eb9;
module.exports["IconType"] = $d747218f543c7aaa$export$13ff1290a9e22e77;
module.exports["MediaType"] = $d747218f543c7aaa$export$483c11740a902fcd;
module.exports["MediaPlacement"] = $d747218f543c7aaa$export$f9f4737e25ab90fa;
module.exports["CardDisplay"] = $d747218f543c7aaa$export$6ca4ef8b3dc2c804;

});

parcelRegister("5MkWK", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $bYRk6 = parcelRequire("bYRk6");


var $c6GJD = parcelRequire("c6GJD");


var $1xKpK = parcelRequire("1xKpK");


var $eIleF = parcelRequire("eIleF");


var $6q0AE = parcelRequire("6q0AE");


var $dh538 = parcelRequire("dh538");


var $lz9QA = parcelRequire("lz9QA");


var $lgqac = parcelRequire("lgqac");

const $9dd53b67e285af98$var$getExtendedResolvedAttributes = (linkDetails, details, linkStatus, error)=>({
        definitionId: details?.meta?.definitionId ?? null,
        resourceType: details?.meta?.resourceType ?? null,
        ...(0, $1xKpK.getResolvedAttributes)(linkDetails, details, linkStatus, error)
    });
const $9dd53b67e285af98$var$getSmartLinkAnalyticsContext = ({ display: display, id: id, response: response, source: source, status: status, url: url, error: error })=>{
    const isHyperlinkConnectExperimentEnabled = (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false);
    const resolvedAttributes = isHyperlinkConnectExperimentEnabled ? $9dd53b67e285af98$var$getExtendedResolvedAttributes({
        url: url,
        displayCategory: display === 'url' ? 'link' : 'smartLink'
    }, response, status, error) : $9dd53b67e285af98$var$getExtendedResolvedAttributes({
        url: url
    }, response, status, error);
    return {
        source: source,
        attributes: {
            ...(0, $lgqac.context),
            display: display,
            id: id,
            ...resolvedAttributes
        }
    };
};
const $9dd53b67e285af98$export$ac28ada90c4970b7 = ({ display: display, id: id, source: source, url: url })=>{
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const state = store ? (0, $6q0AE.getUrl)(store, url) : undefined;
    return (0, $42omo.useMemo)(()=>{
        return $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
            display: display,
            id: id,
            response: state?.details,
            source: source,
            status: state?.status,
            url: url,
            error: state?.error
        });
    }, [
        display,
        id,
        source,
        state?.details,
        state?.status,
        url,
        state?.error
    ]);
};
const $9dd53b67e285af98$export$eaff10f7ec59c455 = ({ children: children, display: display, id: id, source: source, url: url })=>{
    const { details: details, status: status, error: error } = (0, $lz9QA.useSmartCardState)(url);
    const data = $9dd53b67e285af98$var$getSmartLinkAnalyticsContext({
        display: display,
        id: id,
        response: details,
        source: source,
        status: status,
        url: url,
        error: (0, $dh538.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? error : undefined
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: data
    }, children);
};
module.exports["useSmartLinkAnalyticsContext"] = $9dd53b67e285af98$export$ac28ada90c4970b7;
module.exports["SmartLinkAnalyticsContext"] = $9dd53b67e285af98$export$eaff10f7ec59c455;

});

parcelRegister("1xKpK", function(module, exports) {

var $btw9C = parcelRequire("btw9C");

const $637663634becf001$export$28ddbae335bd80b5 = (status)=>{
    return !status || status !== 'not_found' ? 'smartLink' : 'link';
};



var $dh538 = parcelRequire("dh538");

const $6804f58a391a686f$export$7243431f5325a7b = (linkDetails, details, linkStatus, error)=>{
    const status = linkStatus ?? (details && (0, $btw9C.getStatus)(details));
    const displayCategory = linkDetails.displayCategory === 'link' ? 'link' : (0, $637663634becf001$export$28ddbae335bd80b5)(status);
    return {
        status: status ?? null,
        statusDetails: details?.meta?.requestAccess?.accessType ?? null,
        displayCategory: displayCategory,
        extensionKey: (0, $dh538.fg)('platform_bandicoots-smartlink-unresolved-error-key') ? details?.meta?.key ?? error?.extensionKey ?? null : details?.meta?.key ?? null,
        destinationTenantId: details?.meta?.tenantId ?? null,
        destinationActivationId: details?.meta?.activationId ?? null,
        destinationContainerId: details?.meta?.containerId ?? null,
        destinationCategory: details?.meta?.category ?? null,
        destinationProduct: details?.meta?.product ?? null,
        destinationSubproduct: details?.meta?.subproduct ?? null,
        destinationObjectId: details?.meta?.objectId ?? null,
        destinationObjectType: details?.meta?.resourceType ?? null,
        canBeDatasource: (details?.datasources || []).length > 0
    };
};
module.exports["getResolvedAttributes"] = $6804f58a391a686f$export$7243431f5325a7b;

});

parcelRegister("eIleF", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


const $38c931550e91452f$export$156b523e63b4f63a = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
function $38c931550e91452f$export$e1d190b530cf0ee9() {
    const context = (0, $42omo.useContext)($38c931550e91452f$export$156b523e63b4f63a);
    if (!context) throw Error('useSmartCard() must be wrapped in <SmartCardProvider>');
    return context;
}
const $38c931550e91452f$export$10e9cca30e50f657 = ()=>$38c931550e91452f$var$useContextMemoized($38c931550e91452f$export$156b523e63b4f63a);
const $38c931550e91452f$export$797e3658f090919c = ({ children: children })=>{
    const cardContext = $38c931550e91452f$export$10e9cca30e50f657();
    if (!cardContext?.value) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: children
    });
};
function $38c931550e91452f$var$useContextMemoized(reactContext) {
    const value = (0, $42omo.useContext)(reactContext);
    const context = (0, $42omo.useMemo)(()=>({
            Provider: reactContext.Provider,
            Consumer: reactContext.Consumer,
            value: value
        }), [
        value,
        reactContext
    ]);
    return context;
}
const $38c931550e91452f$export$2a29ca11e08dc129 = ({ children: children })=>{
    const cardContext = $38c931550e91452f$export$10e9cca30e50f657();
    const Provider = cardContext.Provider;
    return /*#__PURE__*/ (0, $l998X.jsx)(Provider, {
        value: cardContext.value,
        children: children
    });
};
var $38c931550e91452f$export$2e2bcd8739ae039 = $38c931550e91452f$export$156b523e63b4f63a;
module.exports["SmartCardContext"] = $38c931550e91452f$export$156b523e63b4f63a;
module.exports["useSmartLinkContext"] = $38c931550e91452f$export$e1d190b530cf0ee9;
module.exports["useSmartCardContext"] = $38c931550e91452f$export$10e9cca30e50f657;
module.exports["EditorSmartCardProviderValueGuard"] = $38c931550e91452f$export$797e3658f090919c;
module.exports["EditorSmartCardProvider"] = $38c931550e91452f$export$2a29ca11e08dc129;

});

parcelRegister("6q0AE", function(module, exports) {
const $30e97e7594f3b00b$export$94df0e59ebebf4a7 = (store, url)=>{
    return store.getState()[url] || {
        status: 'pending'
    };
};
module.exports["getUrl"] = $30e97e7594f3b00b$export$94df0e59ebebf4a7;

});

parcelRegister("lz9QA", function(module, exports) {

var $hpRUx = parcelRequire("hpRUx");


var $eIleF = parcelRequire("eIleF");

const $206782ec364200b6$var$PENDING_STATE = {
    status: 'pending'
};
function $206782ec364200b6$export$b0444d00ba7313c6(url) {
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const cardState = (0, $hpRUx.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, store.getState, (state)=>state[url]);
    return cardState ?? $206782ec364200b6$var$PENDING_STATE;
}
module.exports["useSmartCardState"] = $206782ec364200b6$export$b0444d00ba7313c6;

});

parcelRegister("4P6U3", function(module, exports) {
const $9f845e05fed92a58$var$result = {
    mac: false,
    ie: false,
    ie_version: 0,
    gecko: false,
    chrome: false,
    chrome_version: 0,
    android: false,
    ios: false,
    webkit: false,
    safari: false,
    supportsIntersectionObserver: false,
    supportsResizeObserver: false
};
if (typeof navigator !== 'undefined') {
    const ieEdge = /Edge\/(\d+)/.exec(navigator.userAgent);
    const ieUpTo10 = /MSIE \d/.test(navigator.userAgent);
    const ie11up = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
    $9f845e05fed92a58$var$result.mac = /Mac/.test(navigator.platform);
    let ie = $9f845e05fed92a58$var$result.ie = !!(ieUpTo10 || ie11up || ieEdge);
    $9f845e05fed92a58$var$result.ie_version = ieUpTo10 ? document.documentMode || 6 : ie11up ? +ie11up[1] : ieEdge ? +ieEdge[1] : null;
    $9f845e05fed92a58$var$result.gecko = !ie && /gecko\/\d/i.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.chrome = !ie && /Chrome\//.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.chrome_version = parseInt((navigator.userAgent.match(/Chrome\/(\d+)/) || [])[1], 10);
    $9f845e05fed92a58$var$result.android = /Android \d/.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.ios = !ie && /AppleWebKit/.test(navigator.userAgent) && /Mobile\/\w+/.test(navigator.userAgent);
    $9f845e05fed92a58$var$result.webkit = !ie && !!document.documentElement && 'WebkitAppearance' in document.documentElement.style;
    $9f845e05fed92a58$var$result.safari = Boolean(navigator.vendor && navigator.vendor.indexOf('Apple') > -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1);
    $9f845e05fed92a58$var$result.supportsIntersectionObserver = typeof window !== 'undefined' && 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    $9f845e05fed92a58$var$result.supportsResizeObserver = typeof window !== 'undefined' && 'ResizeObserver' in window && 'ResizeObserverEntry' in window;
}
function $9f845e05fed92a58$export$3f2684e5d7cb1006() {
    return $9f845e05fed92a58$var$result;
}
module.exports["browser"] = $9f845e05fed92a58$export$3f2684e5d7cb1006;

});

parcelRegister("afp1H", function(module, exports) {

var $cgtv4 = parcelRequire("cgtv4");

const $8ae4cb49ca93b6d8$export$defe85febe8b728c = (0, $cgtv4.defineMessages)({
    actions: {
        id: "fabric.linking.actions",
        defaultMessage: "Actions"
    },
    add_account: {
        id: "fabric.linking.add_account",
        defaultMessage: "Add account"
    },
    ai_summarize: {
        id: "fabric.linking.ai_summarize",
        defaultMessage: "Summarize"
    },
    ai_summarized: {
        id: "fabric.linking.ai_summarized",
        defaultMessage: "Summarized by Atlassian Intelligence"
    },
    ai_summarized_abbreviation: {
        id: "fabric.linking.ai_summarized_abbreviation",
        defaultMessage: "Summarized by AI"
    },
    ai_summarized_info: {
        id: "fabric.linking.ai_summarized_info",
        defaultMessage: "Information quality may vary. <a>Learn more</a>"
    },
    ai_summarized_info_short: {
        id: "fabric.linking.ai_summarized_info_short",
        defaultMessage: "Content quality may vary"
    },
    ai_summarizing: {
        id: "fabric.linking.ai_summarizing",
        defaultMessage: "Atlassian Intelligence is working..."
    },
    ai_summary_error_generic: {
        id: "fabric.linking.ai_summary_error_generic",
        defaultMessage: "Atlassian Intelligence (AI) isn\u2019t responding. Try again later or <a>check the status of AI</a>."
    },
    ai_summary_error_acceptable_use_violation: {
        id: "fabric.linking.ai_summary_error_acceptable_use_violation",
        defaultMessage: "We cannot show the results of this summary as it goes against <a>Atlassian's Acceptable Use Policy</a>."
    },
    ai_summary_error_hipaa_content_detected: {
        id: "fabric.linking.ai_summary_error_hipaa_content_detected",
        defaultMessage: "Atlassian Intelligence was unable to process your request as your content contains links to HIPAA restricted content."
    },
    ai_summary_error_exceeding_context_length_error: {
        id: "fabric.linking.ai_summary_error_exceeding_context_length_error",
        defaultMessage: "Atlassian Intelligence can't generate a summary for you right now as there is too much content to summarize."
    },
    assigned_to: {
        id: "fabric.linking.assigned_to",
        defaultMessage: "Assigned to {context}"
    },
    change_status: {
        id: "fabric.linking.change_status",
        defaultMessage: "Change status: {status}"
    },
    automation_action_title: {
        id: "fabric.linking.automation-action.title",
        defaultMessage: "View automation rules"
    },
    automation_action_icon_label: {
        id: "fabric.linking.automation-action.icon.label",
        defaultMessage: "Automation icon"
    },
    automation_action_tooltip: {
        id: "fabric.linking.automation-action.tooltip",
        defaultMessage: "Select an automation rule to run"
    },
    automation_action_confluence_page_modal_title: {
        id: "fabric.linking.automation-action.confluence.page.modal.title",
        defaultMessage: "Page automations"
    },
    automation_action_confluence_page_modal_description: {
        id: "fabric.linking.automation-action.confluence.page.modal.description",
        defaultMessage: "Apply an automation to <b>{name}</b>.{br}The available selections are controlled by Confluence and space administrators."
    },
    cancel: {
        id: "fabric.linking.cancel",
        defaultMessage: "Cancel"
    },
    beta: {
        id: "fabric.linking.beta",
        defaultMessage: "Beta"
    },
    cannot_connect: {
        id: "fabric.linking.cannot_connect",
        defaultMessage: "Can't connect, try again"
    },
    cannot_find_link: {
        id: "fabric.linking.cannot_find_link",
        defaultMessage: "Can't find link"
    },
    click_to_join: {
        id: "fabric.linking.click_to_join",
        defaultMessage: "Join {context}"
    },
    click_to_join_description: {
        id: "fabric.linking.click_to_join_description",
        defaultMessage: "You've been approved, so you can join {context} right away."
    },
    close: {
        id: "fabric.linking.close",
        defaultMessage: "Close"
    },
    check_this_link: {
        id: "fabric.linking.check_this_link",
        defaultMessage: "Check this link"
    },
    compass_applied_components_count: {
        id: "compass.applied_components_count.non-final",
        defaultMessage: "Applied to {numberOfComponents, plural, one {{numberOfComponents, number} component}  other {{numberOfComponents, number} components}}"
    },
    connect_to: {
        id: "fabric.linking.connect_to",
        defaultMessage: "Connect to {name}"
    },
    connect_account_description: {
        id: "fabric.linking.connect_account_description",
        defaultMessage: "We'll open a new page to help you connect your {name} account"
    },
    connect_link_account: {
        id: "fabric.linking.connect_link_account",
        defaultMessage: "Connect to preview"
    },
    connect_link_account_card: {
        id: "fabric.linking.connect_link_account_card_view",
        defaultMessage: "Connect"
    },
    connect_link_account_card_name: {
        id: "fabric.linking.connect_link_account_card_view_name",
        defaultMessage: "Connect your {context} account"
    },
    connect_link_account_card_description: {
        id: "fabric.linking.connect_link_account_card_view_description",
        defaultMessage: "To show a preview of this link, connect your {context} account."
    },
    connect_unauthorised_account_action: {
        id: "fabric.linking.connect_unauthorised_account_action",
        defaultMessage: "Connect to {context}"
    },
    connect_unauthorised_account_description: {
        id: "fabric.linking.connect_unauthorised_account_description",
        defaultMessage: "Connect your {context} account to collaborate on work across Atlassian products."
    },
    connect_unauthorised_account_description_no_provider: {
        id: "fabric.linking.connect_unauthorised_account_description_no_provider",
        defaultMessage: "Connect your account to collaborate on work across Atlassian products."
    },
    continue: {
        id: "fabric.linking.continue",
        defaultMessage: "Continue"
    },
    copy_url_to_clipboard: {
        id: "fabric.linking.copy_url_to_clipboard",
        defaultMessage: "Copy link"
    },
    copied_url_to_clipboard: {
        id: "fabric.linking.copied_url_to_clipboard",
        defaultMessage: "Copied!"
    },
    could_not_load_link: {
        id: "fabric.linking.couldnt_load_link",
        defaultMessage: "We couldn't load this link for an unknown reason."
    },
    created_by: {
        id: "fabric.linking.created_by",
        defaultMessage: "Created by {context}"
    },
    created_on_relative: {
        id: "fabric.linking.create_on_relative",
        defaultMessage: "Created {context}"
    },
    created_on_absolute: {
        id: "fabric.linking.create_on_absolute",
        defaultMessage: "Created on {context}"
    },
    delete: {
        id: "fabric.linking.delete",
        defaultMessage: "Delete"
    },
    download: {
        id: "fabric.linking.download",
        defaultMessage: "Download"
    },
    download_description: {
        id: "fabric.linking.download_description",
        defaultMessage: "Download this file into your local storage"
    },
    download_file: {
        id: "fabric.linking.download_file",
        defaultMessage: "Download file"
    },
    ai_summary_action: {
        id: "fabric.linking.ai_summary_action",
        defaultMessage: "Summarize with AI"
    },
    ai_summary_action_description: {
        id: "fabric.linking.ai_summary_action_description",
        defaultMessage: "Summarize the content of this link using Atlassian Intelligence."
    },
    copy_summary_action: {
        id: "fabric.linking.copy_summary_action",
        defaultMessage: "Copy summary"
    },
    copy_summary_action_description: {
        id: "fabric.linking.copy_summary_action_description",
        defaultMessage: "Copy summary"
    },
    copied_summary_action_description: {
        id: "fabric.linking.copied_summary_action_description",
        defaultMessage: "Copied summary to clipboard"
    },
    edit: {
        id: "fabric.linking.edit",
        defaultMessage: "Edit"
    },
    follow: {
        id: "fabric.linking.follow",
        defaultMessage: "Follow"
    },
    follow_project_description: {
        id: "fabric.linking.follow_project_description",
        defaultMessage: "Follow to get notifications on this project"
    },
    follow_project: {
        id: "fabric.linking.follow_project",
        defaultMessage: "Follow project"
    },
    follow_project_error: {
        id: "fabric.linking.follow_project_error",
        defaultMessage: "We encountered an error while trying to follow the project. Check your connection or refresh the page and try again."
    },
    follow_goal_description: {
        id: "fabric.linking.follow_goal_description",
        defaultMessage: "Follow this goal to get notifications on updates"
    },
    follow_goal: {
        id: "fabric.linking.follow_goal",
        defaultMessage: "Follow goal"
    },
    follow_goal_error: {
        id: "fabric.linking.follow_goal_error",
        defaultMessage: "We encountered an error while trying to follow the goal. Check your connection or refresh the page and try again."
    },
    go_back: {
        id: "fabric.linking.go_back",
        defaultMessage: "Go back"
    },
    invalid_permissions: {
        id: "fabric.linking.invalid_permissions",
        defaultMessage: "Restricted content"
    },
    invalid_permissions_description: {
        id: "fabric.linking.invalid_permissions_description",
        defaultMessage: "You'll need to request access or try a different account to view this preview."
    },
    join_to_view: {
        id: "fabric.linking.join_to_view",
        defaultMessage: "Join {context} to view this issue"
    },
    learn_more_about_smart_links: {
        id: "fabric.linking.learn_more_about_smart_links",
        defaultMessage: "Learn more about Smart Links."
    },
    learn_more_about_connecting_account: {
        id: "fabric.linking.learn_more_about_connecting_account",
        defaultMessage: "Learn more about connecting your account to Atlassian products."
    },
    loading: {
        id: "fabric.linking.loading",
        defaultMessage: "Loading..."
    },
    modified_by: {
        id: "fabric.linking.updated_by",
        defaultMessage: "Modified by {context}"
    },
    modified_on_relative: {
        id: "fabric.linking.modified_on_relative",
        defaultMessage: "Updated {context}"
    },
    modified_on_absolute: {
        id: "fabric.linking.modified_on_absolute",
        defaultMessage: "Updated on {context}"
    },
    more_actions: {
        id: "fabric.linking.more_actions",
        defaultMessage: "More actions"
    },
    open_issue_in_jira: {
        id: "fabric.linking.open_issue_in_jira",
        defaultMessage: "Open issue in Jira"
    },
    open_link_in_a_new_tab: {
        id: "fabric.linking.open_link_in_a_new_tab",
        defaultMessage: "Open link in a new tab"
    },
    owned_by: {
        id: "fabric.linking.owned_by",
        defaultMessage: "Owned by {context}"
    },
    owned_by_override: {
        id: "fabric.linking.owned_by_override",
        defaultMessage: "By {context}"
    },
    preview_description: {
        id: "fabric.linking.preview_description",
        defaultMessage: "Open a full screen preview of this link"
    },
    preview_improved: {
        id: "fabric.linking.preview_improved",
        defaultMessage: "Open preview"
    },
    preview_modal: {
        id: "fabric.linking.preview_modal",
        defaultMessage: "Open preview modal"
    },
    preview_panel: {
        id: "fabric.linking.preview_panel",
        defaultMessage: "Open preview panel"
    },
    preview_close: {
        id: "fabric.linking.preview_close",
        defaultMessage: "Close preview"
    },
    preview_max_size: {
        id: "fabric.linking.preview_max_size",
        defaultMessage: "View full screen"
    },
    preview_min_size: {
        id: "fabric.linking.preview_min_size",
        defaultMessage: "Close full screen"
    },
    priority_blocker: {
        id: "fabric.linking.priority_blocker",
        defaultMessage: "Blocker"
    },
    priority_critical: {
        id: "fabric.linking.priority_critical",
        defaultMessage: "Critical"
    },
    priority_high: {
        id: "fabric.linking.priority_high",
        defaultMessage: "High"
    },
    priority_highest: {
        id: "fabric.linking.priority_highest",
        defaultMessage: "Highest"
    },
    priority_low: {
        id: "fabric.linking.priority_low",
        defaultMessage: "Low"
    },
    priority_lowest: {
        id: "fabric.linking.priority_lowest",
        defaultMessage: "Lowest"
    },
    priority_major: {
        id: "fabric.linking.priority_major",
        defaultMessage: "Major"
    },
    priority_medium: {
        id: "fabric.linking.priority_medium",
        defaultMessage: "Medium"
    },
    priority_minor: {
        id: "fabric.linking.priority_minor",
        defaultMessage: "Minor"
    },
    priority_trivial: {
        id: "fabric.linking.priority_trivial",
        defaultMessage: "Trivial"
    },
    priority_undefined: {
        id: "fabric.linking.priority_undefined",
        defaultMessage: "Undefined"
    },
    forbidden_access: {
        id: "fabric.linking.forbidden_access",
        defaultMessage: "Your access is forbidden"
    },
    pending_request: {
        id: "fabric.linking.pending_request",
        defaultMessage: "Your access request is pending"
    },
    read_time: {
        id: "fabric.linking.read_time",
        defaultMessage: "{context} min read"
    },
    restricted_link: {
        id: "fabric.linking.restricted_link",
        defaultMessage: "Restricted link, try another account"
    },
    request_access_to_view: {
        id: "fabric.linking.request_access_to_view",
        defaultMessage: "Request access to {context} to view this issue"
    },
    request_denied: {
        id: "fabric.linking.request_denied",
        defaultMessage: "Your access request was denied"
    },
    retry: {
        id: "fabric.linking.retry",
        defaultMessage: "Retry"
    },
    save: {
        id: "fabric.linking.save",
        defaultMessage: "Save"
    },
    sent_on_relative: {
        id: "fabric.linking.sent_on_relative",
        defaultMessage: "Sent {context}"
    },
    sent_on_absolute: {
        id: "fabric.linking.sent_on_absolute",
        defaultMessage: "Sent on {context}"
    },
    status_change_load_error: {
        id: "fabric.linking.status_change_load_error",
        defaultMessage: "We couldn\u2019t load the statuses and transitions"
    },
    status_change_permission_error: {
        id: "fabric.linking.status_change_permission_error",
        defaultMessage: "You don\u2019t have permission to transition this issue. "
    },
    status_change_update_error: {
        id: "fabric.linking.status_change_update_error",
        defaultMessage: "We couldn\u2019t update the status"
    },
    try_again: {
        id: "fabric.linking.try_again",
        defaultMessage: "Try again"
    },
    try_another_account: {
        id: "fabric.linking.try_another_account",
        defaultMessage: "Try another account"
    },
    link_safety_warning_message: {
        id: "fabric.linking.link_safety_warning_message",
        defaultMessage: "The link {unsafeLinkText} is taking you to a different site, <a>actual link here</a>"
    },
    unauthorised_account_description: {
        id: "fabric.linking.unauthorised_account_description",
        defaultMessage: "You're trying to preview a link to a private {context} page. We recommend you review the URL or contact the page owner."
    },
    unauthorised_account_description_no_provider: {
        id: "fabric.linking.unauthorised_account_description_no_provider",
        defaultMessage: "You're trying to preview a link to a private page. We recommend you review the URL or contact the page owner."
    },
    unauthorised_account_name: {
        id: "fabric.linking.unauthorised_account_name",
        defaultMessage: "We can't display private pages from {context}"
    },
    unauthorised_account_name_no_provider: {
        id: "fabric.linking.unauthorised_account_name_no_provider",
        defaultMessage: "We can't display private pages"
    },
    unassigned: {
        id: "fabric.linking.unassigned",
        defaultMessage: "Unassigned"
    },
    unfollow: {
        id: "fabric.linking.unfollow",
        defaultMessage: "Unfollow"
    },
    unfollow_project_description: {
        id: "fabric.linking.unfollow_project_description",
        defaultMessage: "Unfollow to stop receiving project notifications"
    },
    unfollow_project: {
        id: "fabric.linking.unfollow_project",
        defaultMessage: "Unfollow project"
    },
    unfollow_project_error: {
        id: "fabric.linking.unfollow_project_error",
        defaultMessage: "We encountered an error while trying to unfollow the project. Check your connection or refresh the page and try again."
    },
    unfollow_goal_description: {
        id: "fabric.linking.unfollow_goal_description",
        defaultMessage: "Unfollow to stop receiving notifications for this goal"
    },
    unfollow_goal: {
        id: "fabric.linking.unfollow_goal",
        defaultMessage: "Unfollow goal"
    },
    unfollow_goal_error: {
        id: "fabric.linking.unfollow_goal_error",
        defaultMessage: "We encountered an error while trying to unfollow the goal. Check your connection or refresh the page and try again."
    },
    unlink_account: {
        id: "fabric.linking.unlink_account",
        defaultMessage: "Unlink Account"
    },
    view: {
        id: "fabric.linking.view",
        defaultMessage: "View"
    },
    viewIn: {
        id: "fabric.linking.srclink",
        defaultMessage: "View in"
    },
    viewOriginal: {
        id: "fabric.linking.srclinkunknown",
        defaultMessage: "View Original"
    },
    default_no_access_title: {
        id: "fabric.linking.no_access_title",
        defaultMessage: "Join {product} to view this content"
    },
    direct_access_title: {
        id: "fabric.linking.direct_access_title",
        defaultMessage: "Join {product} to view this content"
    },
    direct_access_description: {
        id: "fabric.linking.direct_access_description",
        defaultMessage: "Your team uses {product} to collaborate and you can start using it right away!"
    },
    direct_access: {
        id: "fabric.linking.direct_access",
        defaultMessage: "Join now"
    },
    request_access_description: {
        id: "fabric.linking.request_access_description",
        defaultMessage: "Your team uses {product} to collaborate. Send your admin a request for access."
    },
    request_access: {
        id: "fabric.linking.request_access",
        defaultMessage: "Request access"
    },
    request_access_pending_title: {
        id: "fabric.linking.request_access_pending_title",
        defaultMessage: "Access to {product} is pending"
    },
    request_access_pending_description: {
        id: "fabric.linking.request_access_pending_description",
        defaultMessage: "Your request to access {hostname} is awaiting admin approval."
    },
    request_access_pending: {
        id: "fabric.linking.request_access_pending",
        defaultMessage: "Pending approval"
    },
    request_denied_description: {
        id: "fabric.linking.request_denied_description",
        defaultMessage: "Your admin didn't approve your request to view {product} pages from {hostname}."
    },
    access_exists_description: {
        id: "fabric.linking.access_exists_description",
        defaultMessage: "Request access to view this content from {hostname}."
    },
    not_found_description: {
        id: "fabric.linking.not_found_description",
        defaultMessage: "The page doesn't exist or it may have changed after this link was added."
    },
    not_found_title: {
        id: "fabric.linking.not_found_title",
        defaultMessage: "We can't show you this {product} page"
    },
    forbidden_title: {
        id: "fabric.linking.forbidden_title",
        defaultMessage: "You don't have access to this content"
    },
    forbidden_description: {
        id: "fabric.linking.forbidden_description",
        defaultMessage: "Contact your admin to request access to {hostname}."
    },
    related: {
        id: "fabric.linking.related",
        defaultMessage: "Related"
    },
    generic_error_message: {
        id: "fabric.linking.generic_error_message",
        defaultMessage: "An error occurred"
    },
    related_links_modal_title: {
        id: "fabric.linking.related_links_modal_title",
        defaultMessage: "Related links"
    },
    related_links_view_related_urls: {
        id: "fabric.linking.related_links_view_related_urls",
        defaultMessage: "View recent links"
    },
    related_links_view_related_links: {
        id: "fabric.linking.related_links_view_related_links",
        defaultMessage: "View related links"
    },
    related_links_found_in: {
        id: "fabric.linking.related_links_found_in",
        defaultMessage: "Found in"
    },
    related_links_not_found: {
        id: "fabric.linking.related_links_not_found",
        defaultMessage: "We didn't find any links to show here."
    },
    related_links_includes_links_to: {
        id: "fabric.linking.related_links_includes_links_to",
        defaultMessage: "Includes links to"
    },
    related_links_modal_error_title: {
        id: "fabric.linking.related_links_modal_error_title",
        defaultMessage: "We're having trouble loading related links"
    },
    related_links_modal_unavailable_title: {
        id: "fabric.linking.related_links_modal_unavailable_title",
        defaultMessage: "We couldn't find any related links"
    },
    related_links_modal_error_description: {
        id: "fabric.linking.related_links_modal_error_description",
        defaultMessage: "Check your connection or refresh the page to try again"
    },
    related_links_modal_unavailable_description: {
        id: "fabric.linking.related_links_modal_unavailable_description",
        defaultMessage: "We continuously review and add related links for updated pages or other content types"
    },
    join_to_viewIssueTermRefresh: {
        id: "fabric.linking.join_to_view-issue-term-refresh",
        defaultMessage: "Join {context} to view this work item"
    },
    open_issue_in_jiraIssueTermRefresh: {
        id: "fabric.linking.open_issue_in_jira-issue-term-refresh",
        defaultMessage: "Open work item in Jira"
    },
    request_access_to_viewIssueTermRefresh: {
        id: "fabric.linking.request_access_to_view-issue-term-refresh",
        defaultMessage: "Request access to {context} to view this work item"
    },
    status_change_permission_errorIssueTermRefresh: {
        id: "fabric.linking.status_change_permission_error-issue-term-refresh",
        defaultMessage: "You don\u2019t have permission to transition this work item. "
    },
    team_members_count: {
        id: "fabric.linking.team_members_count",
        defaultMessage: "{context} members"
    },
    user_attributes: {
        id: "fabric.linking.user_attributes",
        // eslint-disable-next-line @atlassian/i18n/no-useless-message
        defaultMessage: "{context}"
    },
    follow_project_descriptionGalaxia: {
        id: "fabric.linking.follow_project_description-galaxia",
        defaultMessage: "Follow to get notifications on this space"
    },
    follow_project_errorGalaxia: {
        id: "fabric.linking.follow_project_error-galaxia",
        defaultMessage: "We encountered an error while trying to follow the space. Check your connection or refresh the page and try again."
    },
    unfollow_project_descriptionGalaxia: {
        id: "fabric.linking.unfollow_project_description-galaxia",
        defaultMessage: "Unfollow to stop receiving space notifications"
    },
    unfollow_project_errorGalaxia: {
        id: "fabric.linking.unfollow_project_error-galaxia",
        defaultMessage: "We encountered an error while trying to unfollow the space. Check your connection or refresh the page and try again."
    },
    connect_unauthorised_account_description_appify: {
        id: "fabric.linking.connect_unauthorised_account_description-appify",
        defaultMessage: "Connect your {context} account to collaborate on work across Atlassian apps."
    },
    connect_unauthorised_account_description_no_provider_appify: {
        id: "fabric.linking.connect_unauthorised_account_description_no_provider-appify",
        defaultMessage: "Connect your account to collaborate on work across Atlassian apps."
    },
    learn_more_about_connecting_account_appify: {
        id: "fabric.linking.learn_more_about_connecting_account-appify",
        defaultMessage: "Learn more about connecting your account to Atlassian apps."
    },
    learn_more_about_connecting_account_experiment_shorter: {
        id: "fabric.linking.learn_more_about_connecting_account_experiment_short",
        defaultMessage: "Turn your URLs into rich, interactive previews."
    },
    rovo_summary_loading: {
        id: "fabric.linking.rovo_summary.loading.non-final",
        defaultMessage: "Rovo is thinking"
    },
    ai_disclaimer: {
        id: "fabric.linking.rovo_summary.ai_disclaimer.non-final",
        defaultMessage: "Uses AI. Verify Results."
    },
    rovo_prompt_context_generic: {
        id: "fabric.linking.rovo_prompt_context_confluence_page.non-final",
        defaultMessage: "page"
    },
    rovo_prompt_context_generic_plural: {
        id: "fabric.linking.rovo_prompt_context_confluence_page.non-final",
        defaultMessage: "pages"
    },
    rovo_prompt_context_confluence_page: {
        id: "fabric.linking.rovo_prompt_context_confluence_page.non-final",
        defaultMessage: "Confluence page"
    },
    rovo_prompt_context_confluence_page_plural: {
        id: "fabric.linking.rovo_prompt_context_confluence_page_plural.non-final",
        defaultMessage: "Confluence pages"
    },
    rovo_prompt_context_confluence_page_short: {
        id: "fabric.linking.rovo_prompt_context_confluence_page_short.non-final",
        defaultMessage: "page"
    },
    rovo_prompt_context_jira_work_item: {
        id: "fabric.linking.rovo_prompt_context_jira_work_item.non-final",
        defaultMessage: "Jira work item"
    },
    rovo_prompt_context_jira_work_item_plural: {
        id: "fabric.linking.rovo_prompt_context_jira_work_item_plural.non-final",
        defaultMessage: "Jira work items"
    },
    rovo_prompt_context_jira_work_item_short: {
        id: "fabric.linking.rovo_prompt_context_jira_work_item_short.non-final",
        defaultMessage: "work item"
    },
    rovo_prompt_button_recommend_other_sources: {
        id: "fabric.linking.rovo_prompt_button_recommend_other_sources.non-final",
        defaultMessage: "Recommend other sources"
    },
    rovo_prompt_button_show_other_mentions: {
        id: "fabric.linking.rovo_prompt_button_show_other_mentions.non-final",
        defaultMessage: "Show other mentions"
    },
    rovo_prompt_button_suggest_improvement: {
        id: "fabric.linking.rovo_prompt_button_suggest_improvement.non-final",
        defaultMessage: "Suggest {context} improvement"
    }
});
module.exports["messages"] = $8ae4cb49ca93b6d8$export$defe85febe8b728c;

});

parcelRegister("7DSoa", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $lyclm = parcelRequire("lyclm");


var $eIleF = parcelRequire("eIleF");


var $5TXU5 = parcelRequire("5TXU5");


var $bIll3 = parcelRequire("bIll3");


var $4IQbU = parcelRequire("4IQbU");

const $8fe2ac6ef7785039$var$useResolve = ()=>{
    // Request JSON-LD data for the card from ORS, if it has extended
    // its cache lifespan OR there is no data for it currently. Once the data
    // has come back asynchronously, call the useResponse callback to
    // dispatch the resolved action for the card.
    const { store: store, connections: connections } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState } = store;
    const { handleResolvedLinkResponse: handleResolvedLinkResponse, handleResolvedLinkError: handleResolvedLinkError } = (0, $4IQbU.default)();
    return (0, $42omo.useCallback)(async (url, isReloading = false, isMetadataRequest = false, id = '')=>{
        const { details: details } = getState()[url] || {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const hasData = !!(details && details.data || (0, $lyclm.isEntityPresent)(details));
        if (isReloading || !hasData || isMetadataRequest) return connections.client.fetchData(url, isReloading).then((response)=>handleResolvedLinkResponse(url, response, isReloading, isMetadataRequest)).catch((error)=>handleResolvedLinkError(url, error, undefined, isMetadataRequest));
        else (0, $bIll3.addMetadataToExperience)('smart-link-rendered', id, {
            cached: true
        });
    }, [
        connections.client,
        getState,
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $8fe2ac6ef7785039$export$2e2bcd8739ae039 = $8fe2ac6ef7785039$var$useResolve;
module.exports["default"] = $8fe2ac6ef7785039$export$2e2bcd8739ae039;

});

parcelRegister("4IQbU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $jTxSS = parcelRequire("jTxSS");


var $eIleF = parcelRequire("eIleF");


var $9gPkz = parcelRequire("9gPkz");

var $jHnts = parcelRequire("jHnts");

var $btw9C = parcelRequire("btw9C");


var $5TXU5 = parcelRequire("5TXU5");


var $4ibS1 = parcelRequire("4ibS1");

const $96d7cda9026a4858$export$297c39c8b9bfca0 = 'resolving';
const $96d7cda9026a4858$export$b64a888338c24e0e = 'errored';
const $96d7cda9026a4858$export$677b6edfa0002c70 = 'fallback';
const $96d7cda9026a4858$export$3e81ce851ffda0ad = 'Provider.authFlow is not set to OAuth2.';
const $96d7cda9026a4858$export$45e7dda0d43d7f55 = 'Fatal error resolving URL';
const $96d7cda9026a4858$export$338f7d9ccca1975d = 'Error resolving metadata.';


const $afe444b12e732e06$var$useResponse = ()=>{
    // Takes in the JSON-LD response and dispatch the resolved action for the card.
    // It will dispatch a successful or error action
    const { store: store, config: config } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const hasAuthFlowSupported = config.authFlow !== 'disabled';
    const setMetadataStatus = (0, $42omo.useCallback)((url, metadataStatus)=>{
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch
    ]);
    const handleResolvedLinkError = (0, $42omo.useCallback)((url, error, response, isMetadataRequest)=>{
        const newState = {
            status: (0, $5TXU5.SmartLinkStatus).Pending,
            details: undefined
        };
        const { details: details } = getState()[url] || newState;
        const hasData = !!(details && details.data);
        // If metadata request then set metadata status, return and do not alter link status
        if (isMetadataRequest) {
            setMetadataStatus(url, 'errored');
            return;
        }
        if (error.kind === 'fatal') {
            // If we already have resolved data for this URL in the store, then
            // simply fallback to the previous data.
            if (hasData) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
                url: url
            }, details));
            else {
                dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
                    url: url
                }, details, error));
                throw error;
            }
        } else if (error.kind === 'auth') dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: url
        }, (0, $4ibS1.getUnauthorizedJsonLd)()));
        else if (error.kind === 'fallback') // Fallback to blue link with smart link formatting. Not part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR_FALLBACK), {
            url: url
        }, response, error));
        else // Fallback to blue link with smart link formatting. Part of reliability.
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_ERROR), {
            url: url
        }, undefined, error));
    }, [
        getState,
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkSuccess = (0, $42omo.useCallback)((resourceUrl, response, isReloading, isMetadataRequest)=>{
        //if a link resolves normally, metadata will also always be resolved
        setMetadataStatus(resourceUrl, 'resolved');
        // Dispatch Analytics and resolved card action - including unauthorized states.
        if (isReloading) dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RELOADING), {
            url: resourceUrl
        }, response));
        else dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVED), {
            url: resourceUrl
        }, response, undefined, undefined, isMetadataRequest));
    }, [
        setMetadataStatus,
        dispatch
    ]);
    const handleResolvedLinkResponse = (0, $42omo.useCallback)((resourceUrl, response, isReloading = false, isMetadataRequest)=>{
        const hostname = new URL(resourceUrl).hostname;
        const nextStatus = response ? (0, $btw9C.getStatus)(response) : 'fatal';
        // If we require authorization & do not have an authFlow available,
        // throw an error and render as a normal blue link.
        if ((nextStatus === 'unauthorized' || nextStatus === 'forbidden') && !hasAuthFlowSupported) {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fallback', hostname, (0, $96d7cda9026a4858$export$3e81ce851ffda0ad)), response, isMetadataRequest);
            return;
        }
        // Handle any other errors
        if (!response || nextStatus === 'fatal') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('fatal', hostname, (0, $96d7cda9026a4858$export$45e7dda0d43d7f55)), undefined, isMetadataRequest);
            return;
        }
        // Handle errors of any other kind in the metadata request response
        if (isMetadataRequest && nextStatus !== 'resolved') {
            handleResolvedLinkError(resourceUrl, new (0, $jHnts.APIError)('error', hostname, (0, $96d7cda9026a4858$export$338f7d9ccca1975d)), response, isMetadataRequest);
            return;
        }
        /**
			 * Using unstable_batchedUpdates because this store update happens async and triggers a rerender
			 * more info:
			 * https://github.com/facebook/react/blob/v18.2.0/packages/use-sync-external-store/src/useSyncExternalStoreShimClient.js#L113
			 * https://react-redux.js.org/api/batch
			 */ (0, $jTxSS.unstable_batchedUpdates)(()=>{
            handleResolvedLinkSuccess(resourceUrl, response, isReloading, isMetadataRequest);
        });
    }, [
        handleResolvedLinkError,
        handleResolvedLinkSuccess,
        hasAuthFlowSupported
    ]);
    return (0, $42omo.useMemo)(()=>({
            handleResolvedLinkError: handleResolvedLinkError,
            handleResolvedLinkResponse: handleResolvedLinkResponse
        }), [
        handleResolvedLinkError,
        handleResolvedLinkResponse
    ]);
};
var $afe444b12e732e06$export$2e2bcd8739ae039 = $afe444b12e732e06$var$useResponse;
module.exports["default"] = $afe444b12e732e06$export$2e2bcd8739ae039;

});

parcelRegister("9gPkz", function(module, exports) {
// TODO: eventually move this file to @atlaskit/link-actions
const $4165c6e5bfa202ae$export$6e470aad5ba8952e = 'pending';
const $4165c6e5bfa202ae$export$9a6a932a0a39498e = 'resolving';
const $4165c6e5bfa202ae$export$63ec8bc7a8a75482 = 'resolved';
const $4165c6e5bfa202ae$export$b8cfaa842c9ab487 = 'reloading';
const $4165c6e5bfa202ae$export$6d8ed3f9433dd372 = 'errored';
const $4165c6e5bfa202ae$export$cfbbb7126bc8a0c6 = 'fallback';
const $4165c6e5bfa202ae$export$76b5c1aca20759c6 = 'preload';
const $4165c6e5bfa202ae$export$2c5edb971b673330 = 'metadata';
const $4165c6e5bfa202ae$export$a884a52152489cc3 = (type, { url: url }, payload, error, metadataStatus, ignoreStatusCheck)=>({
        type: type,
        url: url,
        payload: payload,
        error: error,
        metadataStatus: metadataStatus,
        ignoreStatusCheck: ignoreStatusCheck
    });
module.exports["ACTION_PENDING"] = $4165c6e5bfa202ae$export$6e470aad5ba8952e;
module.exports["ACTION_RESOLVING"] = $4165c6e5bfa202ae$export$9a6a932a0a39498e;
module.exports["ACTION_RESOLVED"] = $4165c6e5bfa202ae$export$63ec8bc7a8a75482;
module.exports["ACTION_RELOADING"] = $4165c6e5bfa202ae$export$b8cfaa842c9ab487;
module.exports["ACTION_ERROR"] = $4165c6e5bfa202ae$export$6d8ed3f9433dd372;
module.exports["ACTION_ERROR_FALLBACK"] = $4165c6e5bfa202ae$export$cfbbb7126bc8a0c6;
module.exports["ACTION_UPDATE_METADATA_STATUS"] = $4165c6e5bfa202ae$export$2c5edb971b673330;
module.exports["cardAction"] = $4165c6e5bfa202ae$export$a884a52152489cc3;

});

parcelRegister("4ibS1", function(module, exports) {
const $edbc823e59ec01a7$var$emptyData = {
    '@context': {
        '@vocab': 'https://www.w3.org/ns/activitystreams#',
        atlassian: 'https://schema.atlassian.com/ns/vocabulary#',
        schema: 'http://schema.org/'
    },
    '@type': 'Object'
};
const $edbc823e59ec01a7$export$2796a804c6e44f63 = ()=>$edbc823e59ec01a7$var$emptyData;
const $edbc823e59ec01a7$export$b9482e0f6d365cc7 = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'unauthorized',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });
const $edbc823e59ec01a7$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...$edbc823e59ec01a7$var$emptyData
        }
    });
module.exports["getEmptyJsonLd"] = $edbc823e59ec01a7$export$2796a804c6e44f63;
module.exports["getUnauthorizedJsonLd"] = $edbc823e59ec01a7$export$b9482e0f6d365cc7;
module.exports["getForbiddenJsonLd"] = $edbc823e59ec01a7$export$e32193033a594efb;

});

parcelRegister("9oOnT", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dQl1W = parcelRequire("dQl1W");


var $kKODE = parcelRequire("kKODE");


var $l6tPN = parcelRequire("l6tPN");


var $bIll3 = parcelRequire("bIll3");

const $458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME = 'smart-link-action-invocation';
/**
 * Invoke client action such as preview, download and open link
 */ const $458a31c3ca98bc55$var$useInvokeClientAction = ({ fireEvent: fireEventProp })=>{
    const { fireEvent: defaultFireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const fireEvent = fireEventProp ?? defaultFireEvent;
    return (0, $42omo.useCallback)(async ({ actionSubjectId: actionSubjectId, actionType: actionType, actionFn: actionFn, definitionId: definitionId = null, extensionKey: extensionKey, display: display, id: id, resourceType: resourceType = null })=>{
        // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
        const experienceId = (0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))();
        // Begin performance instrumentation.
        const markName = `${experienceId}-${actionType}`;
        $l6tPN.mark(markName, 'pending');
        try {
            // Begin UFO experience
            (0, $bIll3.startUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId, {
                actionType: actionType,
                display: display,
                extensionKey: extensionKey,
                invokeType: 'client'
            });
            // Begin analytics instrumentation.
            if (actionSubjectId !== undefined) fireEvent(`ui.button.clicked.${actionSubjectId}`, {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            // Invoke action
            const result = await actionFn();
            $l6tPN.mark(markName, 'resolved');
            (0, $bIll3.succeedUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            fireEvent('operational.smartLinkAction.resolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'resolved')?.duration ?? null,
                id: id ?? experienceId,
                resourceType: resourceType
            });
            return result;
        } catch (err) {
            $l6tPN.mark(markName, 'errored');
            (0, $bIll3.failUfoExperience)($458a31c3ca98bc55$var$ACTION_EXPERIENCE_NAME, experienceId);
            const reason = typeof err === 'string' ? err : err?.message;
            fireEvent('operational.smartLinkAction.unresolved', {
                actionType: actionType ?? null,
                definitionId: definitionId,
                display: display ?? null,
                duration: $l6tPN.getMeasure(markName, 'errored')?.duration ?? null,
                id: id ?? experienceId,
                reason: reason,
                resourceType: resourceType
            });
        }
    }, [
        fireEvent
    ]);
};
var $458a31c3ca98bc55$export$2e2bcd8739ae039 = $458a31c3ca98bc55$var$useInvokeClientAction;
module.exports["default"] = $458a31c3ca98bc55$export$2e2bcd8739ae039;

});

parcelRegister("l6tPN", function(module, exports) {
const $f72103dc56ec53a8$var$isPerformanceAPIAvailable = ()=>{
    return typeof window !== 'undefined' && 'performance' in window && [
        'measure',
        'clearMeasures',
        'clearMarks',
        'getEntriesByName',
        'getEntriesByType'
    ].every((api)=>!!performance[api]);
};
const $f72103dc56ec53a8$var$hasPerformanceAPIAvailable = $f72103dc56ec53a8$var$isPerformanceAPIAvailable();
const $f72103dc56ec53a8$export$fcff3185c7ce7f2b = (id, status)=>`${status}:${id}`;
const $f72103dc56ec53a8$export$984df7f61dd7928f = (id, status)=>`time-to-${status}:${id}`;
const $f72103dc56ec53a8$export$1a717feb4df1a945 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const marks = performance.getEntriesByType('mark').filter((mark)=>mark.name.includes(id));
        marks.forEach((mark)=>performance.clearMarks(mark.name));
    }
};
const $f72103dc56ec53a8$export$de42547d395c8271 = (id)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const measures = performance.getEntriesByType('measure').filter((measure)=>measure.name.includes(id));
        measures.forEach((measure)=>performance.clearMeasures(measure.name));
    }
};
const $f72103dc56ec53a8$var$getMark = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        const marks = performance.getEntriesByName(name);
        if (marks.length > 0) return marks[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$d6e97a903ae9a3aa = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measures = performance.getEntriesByName(name);
        if (measures.length > 0) return measures[0];
        return undefined;
    }
};
const $f72103dc56ec53a8$export$bf7f2fce5c1cf636 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$fcff3185c7ce7f2b(id, status);
        performance.mark(name);
    }
};
const $f72103dc56ec53a8$export$185802fd694ee1f5 = (id, status)=>{
    if ($f72103dc56ec53a8$var$hasPerformanceAPIAvailable) {
        const name = $f72103dc56ec53a8$export$984df7f61dd7928f(id, status);
        const measure = $f72103dc56ec53a8$export$d6e97a903ae9a3aa(id, status);
        if (!measure) {
            const startMark = $f72103dc56ec53a8$var$getMark(id, 'pending');
            const endMark = $f72103dc56ec53a8$var$getMark(id, status);
            if (startMark && endMark) performance.measure(name, startMark.name, endMark.name);
        }
    }
};
module.exports["clearMarks"] = $f72103dc56ec53a8$export$1a717feb4df1a945;
module.exports["clearMeasures"] = $f72103dc56ec53a8$export$de42547d395c8271;
module.exports["getMeasure"] = $f72103dc56ec53a8$export$d6e97a903ae9a3aa;
module.exports["mark"] = $f72103dc56ec53a8$export$bf7f2fce5c1cf636;
module.exports["create"] = $f72103dc56ec53a8$export$185802fd694ee1f5;

});

parcelRegister("4gM1A", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $6wQZE = parcelRequire("6wQZE");

var $77752028a2bf334b$export$81a5b494baf0f17c = /*#__PURE__*/ function(ClickButton) {
    ClickButton[ClickButton["Left"] = 0] = "Left";
    ClickButton[ClickButton["Middle"] = 1] = "Middle";
    ClickButton[ClickButton["Right"] = 2] = "Right";
    return ClickButton;
}({});
const $77752028a2bf334b$export$5993d3ca6c85f774 = (/**
	 * Handler to
	 */ handler, /**
	 * Filter which mouse events should trigger the link clicked event
	 */ predicate)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return (0, $42omo.useCallback)((...args)=>{
        const [event] = args;
        handler?.apply(null, args);
        if (!predicate || predicate?.(event)) (0, $6wQZE.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        handler,
        predicate,
        createAnalyticsEvent
    ]);
};
const $77752028a2bf334b$var$isNotLeftClick = (event)=>event.button !== 0;
const $77752028a2bf334b$export$df67f318ded0283c = (onMouseDown)=>{
    return $77752028a2bf334b$export$5993d3ca6c85f774(onMouseDown, $77752028a2bf334b$var$isNotLeftClick);
};
module.exports["useLinkClicked"] = $77752028a2bf334b$export$5993d3ca6c85f774;
module.exports["useMouseDownEvent"] = $77752028a2bf334b$export$df67f318ded0283c;

});

parcelRegister("6wQZE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4P6U3 = parcelRequire("4P6U3");


var $1I43V = parcelRequire("1I43V");


var $1oCLl = parcelRequire("1oCLl");


var $4gM1A = parcelRequire("4gM1A");


var $lgqac = parcelRequire("lgqac");

const $8b02aa09be31a1d9$export$cfb45d54e1604f6c = new Map([
    [
        undefined,
        'none'
    ],
    [
        0,
        'left'
    ],
    [
        1,
        'middle'
    ],
    [
        2,
        'right'
    ]
]);
const $8b02aa09be31a1d9$export$74743eda5dda3ccf = (e)=>{
    return [
        'alt',
        'ctrl',
        'meta',
        'shift'
    ].filter((key)=>e[`${key}Key`] === true);
};
const $8b02aa09be31a1d9$var$isContentEditable = (el)=>{
    return el instanceof HTMLElement && el.isContentEditable;
};
function $8b02aa09be31a1d9$export$d2a83e3b34be812b(e, clickType) {
    const { mac: mac, safari: safari } = (0, $4P6U3.browser)();
    /**
	 * If the link/parent is content editable then left click won't have typical effect
	 */ if ($8b02aa09be31a1d9$var$isContentEditable(e.currentTarget) && [
        'left',
        'middle'
    ].includes(clickType)) return 'contentEditable';
    switch(clickType){
        case 'left':
        case 'keyboard':
            {
                // Meta key = Cmd for macOS, Windows key sometimes for Windows (otherwise false)
                // https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/metaKey
                if (e.metaKey) return mac ? 'clickThroughNewTabOrWindow' : 'clickThrough';
                if (e.shiftKey) {
                    // Alt/option click in safari typically adds the link to bookmarks
                    if (safari) return 'alt';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.ctrlKey) {
                    // Ctrl+Left on macOS defaults to triggering a right click instead (so won't trigger onClick)
                    // but if this behaviour is disabled, likely outcome is clickThrough
                    if (mac) return 'clickThrough';
                    return 'clickThroughNewTabOrWindow';
                }
                if (e.altKey) return 'alt';
                const target = e.currentTarget.getAttribute('target');
                if (target === '_blank') return 'clickThroughNewTabOrWindow';
                return 'clickThrough';
            }
        case 'middle':
            return 'clickThroughNewTabOrWindow';
        case 'right':
            return 'contextMenu';
    }
    return 'unknown';
}
const $8b02aa09be31a1d9$var$linkClickedEventOld = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented
        }
    });
const $8b02aa09be31a1d9$var$linkClickedEventWithShortLink = ({ clickType: clickType, clickOutcome: clickOutcome, keysHeld: keysHeld, defaultPrevented: defaultPrevented, isConfluenceShortLink: isConfluenceShortLink })=>({
        action: 'clicked',
        actionSubject: 'link',
        eventType: 'ui',
        attributes: {
            clickType: clickType,
            clickOutcome: clickOutcome,
            keysHeld: keysHeld,
            defaultPrevented: defaultPrevented,
            isConfluenceShortLink: isConfluenceShortLink
        }
    });
const $8b02aa09be31a1d9$export$880d2168464029dd = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $8b02aa09be31a1d9$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $8b02aa09be31a1d9$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $8b02aa09be31a1d9$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    const linkClickedEventResult = $8b02aa09be31a1d9$var$linkClickedEventOld({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $8b02aa09be31a1d9$export$fb40cb818618aeeb = (event)=>{
    // Through the `detail` property, we're able to determine if the event is (most likely) triggered via keyboard
    // https://developer.mozilla.org/en-US/docs/Web/API/UIEvent/detail
    const isKeyboard = event.nativeEvent.detail === 0;
    const clickType = isKeyboard ? 'keyboard' : $8b02aa09be31a1d9$export$cfb45d54e1604f6c.get(event.button);
    if (!clickType) return;
    const clickOutcome = $8b02aa09be31a1d9$export$d2a83e3b34be812b(event, clickType);
    const keysHeld = $8b02aa09be31a1d9$export$74743eda5dda3ccf(event);
    const defaultPrevented = event.defaultPrevented;
    // Check if the URL is a Confluence shortLink (contains "/l/cp/")
    let isConfluenceShortLink = false;
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        isConfluenceShortLink = url.includes('/l/cp/');
    }
    const linkClickedEventResult = $8b02aa09be31a1d9$var$linkClickedEventWithShortLink({
        clickType: clickType,
        clickOutcome: clickOutcome,
        keysHeld: keysHeld,
        defaultPrevented: defaultPrevented,
        isConfluenceShortLink: isConfluenceShortLink
    });
    // if the current target is an anchor tag, we can get the href from it and use that as the url being navigated too.
    if (event.currentTarget instanceof HTMLAnchorElement) {
        const url = event.currentTarget.href;
        return {
            ...linkClickedEventResult,
            nonPrivacySafeAttributes: {
                url: url
            }
        };
    } else // We can't get the href from the event target, so dont include the url or any non privacy safe attributes
    return linkClickedEventResult;
};
const $8b02aa09be31a1d9$export$7fedc699766c16de = (0, $1I43V.functionWithCondition)(()=>(0, $1oCLl.expValEquals)('smart_link_confluence_short_link_analytics', 'cohort', 'test'), $8b02aa09be31a1d9$export$fb40cb818618aeeb, $8b02aa09be31a1d9$export$880d2168464029dd);
const $8b02aa09be31a1d9$export$7987de3055fbdcb0 = (createAnalyticsEvent)=>(event, overrides = {})=>{
        const payload = $8b02aa09be31a1d9$export$7fedc699766c16de(event);
        if (payload) createAnalyticsEvent({
            ...payload,
            ...overrides,
            attributes: {
                ...payload.attributes,
                ...overrides?.attributes
            },
            nonPrivacySafeAttributes: {
                ...payload.nonPrivacySafeAttributes,
                ...overrides?.nonPrivacySafeAttributes
            }
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
const $8b02aa09be31a1d9$var$getDisplayName = (WrappedComponent)=>{
    if (typeof WrappedComponent === 'string') return WrappedComponent;
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};
function $8b02aa09be31a1d9$export$263352d59c0c5966(WrappedComponent) {
    const Component = (props)=>{
        const onClick = (0, $4gM1A.useLinkClicked)(props.onClick);
        const onMouseDown = (0, $4gM1A.useMouseDownEvent)(props.onMouseDown);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(WrappedComponent, {
            ...props,
            onClick: onClick,
            onMouseDown: onMouseDown
        });
    };
    Component.displayName = `withLinkClickedEvent(${$8b02aa09be31a1d9$var$getDisplayName(WrappedComponent)})`;
    return Component;
}
module.exports["fireLinkClickedEvent"] = $8b02aa09be31a1d9$export$7987de3055fbdcb0;
module.exports["withLinkClickedEvent"] = $8b02aa09be31a1d9$export$263352d59c0c5966;

});

parcelRegister("1I43V", function(module, exports) {
/**
 * Returns one of functions depending on a boolean condition.
 * Both functions should have the same signature.
 * @see {@link functionUnionWithCondition} for functions with different return types
 */ function $4bac077259c47cd6$export$af3c0e82a18fc057(condition, functionTrue, functionFalse) {
    const fnWithCondition = (...args)=>condition() ? functionTrue(...args) : functionFalse(...args);
    // Improvement: set name on a function. Requires external helper, not required for production
    return fnWithCondition;
}
function $4bac077259c47cd6$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return $4bac077259c47cd6$export$af3c0e82a18fc057(condition, functionTrue, functionFalse);
}
module.exports["functionWithCondition"] = $4bac077259c47cd6$export$af3c0e82a18fc057;

});

parcelRegister("a43ao", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $eIleF = parcelRequire("eIleF");


var $9gPkz = parcelRequire("9gPkz");


var $3uVVG = parcelRequire("3uVVG");


var $kKODE = parcelRequire("kKODE");


var $5TXU5 = parcelRequire("5TXU5");


var $bIll3 = parcelRequire("bIll3");


var $226XV = parcelRequire("226XV");


var $9oOnT = parcelRequire("9oOnT");


var $7DSoa = parcelRequire("7DSoa");

const $35a2bf75aa5e3412$export$f7c340395f31e832 = (id, url)=>{
    const resolveUrl = (0, $7DSoa.default)();
    const invokeClientAction = (0, $9oOnT.default)({});
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    const { store: store } = (0, $eIleF.useSmartLinkContext)();
    const { getState: getState, dispatch: dispatch } = store;
    const getSmartLinkState = (0, $42omo.useCallback)(()=>{
        const { details: details, status: status, metadataStatus: metadataStatus } = getState()[url] ?? {
            status: (0, $5TXU5.SmartLinkStatus).Pending
        };
        return {
            details: details,
            status: status,
            metadataStatus: metadataStatus
        };
    }, [
        getState,
        url
    ]);
    const setMetadataStatus = (0, $42omo.useCallback)((metadataStatus)=>{
        dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_UPDATE_METADATA_STATUS), {
            url: url
        }, undefined, undefined, metadataStatus));
    }, [
        dispatch,
        url
    ]);
    const resolve = (0, $42omo.useCallback)(async (resourceUrl = url, isReloading = false, isMetadataRequest = false)=>resolveUrl(resourceUrl, isReloading, isMetadataRequest, id), [
        id,
        resolveUrl,
        url
    ]);
    const register = (0, $42omo.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        if (!details) {
            dispatch((0, $9gPkz.cardAction)((0, $9gPkz.ACTION_RESOLVING), {
                url: url
            }));
            setMetadataStatus('pending');
        }
        return resolve();
    }, [
        getSmartLinkState,
        resolve,
        dispatch,
        url,
        setMetadataStatus
    ]);
    const reload = (0, $42omo.useCallback)(()=>{
        const { details: details } = getSmartLinkState();
        const definitionId = (0, $226XV.getDefinitionId)(details);
        if (definitionId) (0, $226XV.getByDefinitionId)(definitionId, getState()).map((url)=>resolve(url, true));
        else resolve(url, true);
    }, [
        getSmartLinkState,
        url,
        getState,
        resolve
    ]);
    const loadMetadata = (0, $42omo.useCallback)(()=>{
        const { metadataStatus: metadataStatus } = getSmartLinkState();
        //metadataStatus will be undefined for SSR links only
        if (metadataStatus === undefined) {
            setMetadataStatus('pending');
            return resolve(url, false, true);
        }
    }, [
        getSmartLinkState,
        resolve,
        setMetadataStatus,
        url
    ]);
    const authorize = (0, $42omo.useCallback)((appearance)=>{
        const { details: details, status: status } = getSmartLinkState();
        const definitionId = (0, $226XV.getDefinitionId)(details);
        const extensionKey = (0, $226XV.getExtensionKey)(details);
        const services = (0, $226XV.getServices)(details);
        // When authentication is triggered, let GAS know!
        if (status === 'unauthorized') fireEvent('ui.button.clicked.connectAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (status === 'forbidden') fireEvent('ui.smartLink.clicked.tryAnotherAccount', {
            display: appearance,
            definitionId: definitionId ?? null
        });
        if (services.length > 0) {
            fireEvent('screen.consentModal.viewed', {
                definitionId: definitionId ?? null
            });
            (0, $3uVVG.auth)(services[0].url).then(()=>{
                fireEvent('track.applicationAccount.connected', {
                    definitionId: definitionId ?? null
                });
                (0, $bIll3.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: 'success'
                });
                fireEvent('operational.smartLink.connectSucceeded', {
                    definitionId: definitionId ?? null
                });
                reload();
            }, (err)=>{
                (0, $bIll3.startUfoExperience)('smart-link-authenticated', id, {
                    extensionKey: extensionKey,
                    status: err.type
                });
                fireEvent('operational.smartLink.connectFailed', {
                    definitionId: definitionId ?? null,
                    reason: err.type ?? null
                });
                if (err.type === 'auth_window_closed') fireEvent('ui.consentModal.closed', {
                    display: appearance,
                    definitionId: definitionId ?? null
                });
                reload();
            });
        }
    }, [
        getSmartLinkState,
        id,
        reload,
        fireEvent
    ]);
    const invoke = (0, $42omo.useCallback)(async (opts, appearance)=>{
        const { key: key, action: action } = opts;
        const source = opts.source || appearance;
        if (opts.type === 'client') return await invokeClientAction({
            actionFn: opts.action.promise,
            actionType: action.type,
            display: source,
            extensionKey: key
        });
    }, [
        invokeClientAction
    ]);
    return (0, $42omo.useMemo)(()=>({
            register: register,
            reload: reload,
            authorize: authorize,
            invoke: invoke,
            loadMetadata: loadMetadata
        }), [
        register,
        reload,
        authorize,
        invoke,
        loadMetadata
    ]);
};
module.exports["useSmartCardActions"] = $35a2bf75aa5e3412$export$f7c340395f31e832;

});

parcelRegister("226XV", function(module, exports) {

var $dh538 = parcelRequire("dh538");

const $4a791b5829124355$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};


const $c8f51fccdd166527$export$f75b0b690ab4dfb9 = (definitionId, store)=>{
    const urls = Object.keys(store);
    return urls.filter((url)=>{
        const { details: details } = store[url];
        return details && details.meta.definitionId === definitionId;
    });
};
const $c8f51fccdd166527$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $4a791b5829124355$export$c81497d3681f24f4)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};
const $c8f51fccdd166527$export$46fa3e7718c82e41 = (details)=>details?.meta?.definitionId;
const $c8f51fccdd166527$export$218d96312e385949 = (details)=>details?.meta?.key;
const $c8f51fccdd166527$export$81164c1570bcd038 = (details)=>details?.data && 'atlassian:ari' in details.data && details.data['atlassian:ari'] || undefined;
const $c8f51fccdd166527$export$e029950864672b4 = (details)=>{
    if ((0, $dh538.fg)('platform_smartlink_3pclick_analytics')) {
        if (details?.entityData && 'thirdPartyAri' in details.entityData && details.entityData.thirdPartyAri) return details.entityData.thirdPartyAri;
        if (details?.data && 'atlassian:ari' in details.data && typeof details.data['atlassian:ari'] === 'string') {
            const ari = details.data['atlassian:ari'];
            if (ari.includes('ari:third-party')) return ari;
        }
    }
    return undefined;
};
const $c8f51fccdd166527$export$48b4e58cdb8031ba = ()=>{
    if (!(0, $dh538.fg)('platform_smartlink_3pclick_analytics')) return undefined;
    const product = $c8f51fccdd166527$var$getProductFromWindowURL();
    const currentURL = window.location.href;
    if (product === 'confluence') {
        if (currentURL.includes('content.id')) {
            const contentId = $c8f51fccdd166527$var$extractContentIdFromURL(currentURL);
            if (contentId) return `ConfluenceContentId:${contentId}`;
        }
        const pageId = $c8f51fccdd166527$var$extractPageIdFromURL(currentURL);
        if (pageId) return `ConfluencePageId:${pageId}`;
    } else if (product === 'jira') {
        const issueKey = $c8f51fccdd166527$var$extractJiraIssueIdFromURL(currentURL);
        if (issueKey) return `JiraIssueKey:${issueKey}`;
    }
    return undefined;
};
const $c8f51fccdd166527$export$5615361d76a8be5 = (details)=>details?.data && 'name' in details.data && details.data.name || undefined;
const $c8f51fccdd166527$export$bcf275804417edda = (details)=>{
    if (details?.data && 'icon' in details.data && details.data.icon) {
        if (typeof details.data.icon === 'object' && 'url' in details.data.icon && details.data.icon.url && typeof details.data.icon.url === 'string') return details.data.icon.url;
    }
    return undefined;
};
const $c8f51fccdd166527$export$16c0ebb0de9b767b = (details)=>details?.meta?.resourceType;
const $c8f51fccdd166527$export$e2005c9600188ac7 = (details)=>details?.meta?.product;
const $c8f51fccdd166527$export$f8fdefc70357968e = (details)=>details?.meta?.subproduct;
const $c8f51fccdd166527$export$a009e3a1163d46fb = (details)=>details && details.meta.auth || [];
const $c8f51fccdd166527$export$ac5d414b1ebfab5a = (details)=>details && $c8f51fccdd166527$export$cd41ae544cfc2a65(details) && $c8f51fccdd166527$export$795910f5f15a9633(details);
const $c8f51fccdd166527$export$cd41ae544cfc2a65 = ({ meta: { access: access } })=>access === 'granted';
const $c8f51fccdd166527$export$795910f5f15a9633 = ({ meta: { visibility: visibility } })=>visibility === 'restricted' || visibility === 'public';
const $c8f51fccdd166527$export$a752a116d184ffbd = (details)=>{
    return details?.meta?.requestAccess?.accessType;
};
const $c8f51fccdd166527$export$d590d08942abc17a = (status)=>{
    return [
        'unauthorized',
        'forbidden',
        'errored',
        'resolved',
        'not_found'
    ].indexOf(status) > -1;
};
const $c8f51fccdd166527$export$66805b16d2a1da7c = (details)=>details?.datasources;
const $c8f51fccdd166527$export$ba6d13ab7b87c55c = (details)=>{
    const datasources = $c8f51fccdd166527$export$66805b16d2a1da7c(details);
    return !!datasources && datasources.length > 0;
};
const $c8f51fccdd166527$export$3f9446bb21b945a0 = (details)=>!!details?.meta.hasScopeOverrides;
// Helper function to extract page ID from standard Confluence page URLs
const $c8f51fccdd166527$var$extractPageIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Following this pattern for confluence URL -> /wiki/spaces/{space}/pages/{pageId}/{title}
        const pagesMatch = urlObj.pathname.match(/\/wiki\/spaces\/[^\/]+\/pages\/(\d+)(?:\/|$)/);
        if (pagesMatch && pagesMatch[1]) return pagesMatch[1];
        // Following this pattern for confluence URL -> /wiki/pages/viewpage.action?pageId={pageId}
        const pageIdParam = urlObj.searchParams.get('pageId');
        if (pageIdParam) return pageIdParam;
        // Following this pattern for confluence URL -> /wiki/display/{space}/{pageId}
        const displayMatch = urlObj.pathname.match(/\/wiki\/display\/[^\/]+\/(\d+)/);
        if (displayMatch && displayMatch[1]) return displayMatch[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$extractContentIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Pattern: ?content.id={contentId} (for app connector URLs and plugin servlet URLs)
        const contentId = urlObj.searchParams.get('content.id');
        if (contentId) return contentId;
        // Also support URLs where content.id is in the query string but not parsed by URL (edge case)
        // e.g., /wiki/plugins/servlet/ac/com.atlassian.perspectiveretros/perspective-retros?content.id=5662725850
        const match = url.match(/[?&]content\.id=(\d+)/);
        if (match && match[1]) return match[1];
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$extractJiraIssueIdFromURL = (url)=>{
    try {
        const urlObj = new URL(url);
        // Support any case for Jira keys (e.g., AI3W-864, ai3w-864, Ai3W-864)
        const browseMatch = urlObj.pathname.match(/\/browse\/([A-Za-z0-9]+-\d+)/);
        if (browseMatch && browseMatch[1]) return browseMatch[1];
        // /jira/browse/{issueKey}
        const jiraBrowseMatch = urlObj.pathname.match(/\/jira\/browse\/([A-Za-z0-9]+-\d+)/);
        if (jiraBrowseMatch && jiraBrowseMatch[1]) return jiraBrowseMatch[1];
        // Query parameter ?selectedIssue={issueKey}
        const selectedIssue = urlObj.searchParams.get('selectedIssue');
        if (selectedIssue && /^[A-Za-z0-9]+-\d+$/.test(selectedIssue)) return selectedIssue;
        // Query parameter ?issueKey={issueKey}
        const issueKeyParam = urlObj.searchParams.get('issueKey');
        if (issueKeyParam && /^[A-Za-z0-9]+-\d+$/.test(issueKeyParam)) return issueKeyParam;
    } catch  {
        return undefined;
    }
    return undefined;
};
const $c8f51fccdd166527$var$getProductFromWindowURL = ()=>{
    try {
        const currentUrl = window.location.href;
        const urlObj = new URL(currentUrl);
        const hostname = urlObj.hostname.toLowerCase();
        const pathname = urlObj.pathname.toLowerCase();
        // Check for Confluence patterns
        if (hostname.includes('confluence') || pathname.includes('/wiki/') || pathname.includes('/display/') || pathname.includes('/spaces/')) return 'confluence';
        // Check for Jira patterns
        if (hostname.includes('jira') || pathname.includes('/browse/') || pathname.includes('/projects/') || pathname.includes('/secure/')) return 'jira';
    } catch  {
        return undefined;
    }
    return undefined;
};
module.exports["getByDefinitionId"] = $c8f51fccdd166527$export$f75b0b690ab4dfb9;
module.exports["getClickUrl"] = $c8f51fccdd166527$export$cf3c5acf9e9d0f02;
module.exports["getDefinitionId"] = $c8f51fccdd166527$export$46fa3e7718c82e41;
module.exports["getExtensionKey"] = $c8f51fccdd166527$export$218d96312e385949;
module.exports["getObjectAri"] = $c8f51fccdd166527$export$81164c1570bcd038;
module.exports["getThirdPartyARI"] = $c8f51fccdd166527$export$e029950864672b4;
module.exports["getFirstPartyIdentifier"] = $c8f51fccdd166527$export$48b4e58cdb8031ba;
module.exports["getObjectName"] = $c8f51fccdd166527$export$5615361d76a8be5;
module.exports["getObjectIconUrl"] = $c8f51fccdd166527$export$bcf275804417edda;
module.exports["getResourceType"] = $c8f51fccdd166527$export$16c0ebb0de9b767b;
module.exports["getServices"] = $c8f51fccdd166527$export$a009e3a1163d46fb;
module.exports["isFinalState"] = $c8f51fccdd166527$export$d590d08942abc17a;
module.exports["hasAuthScopeOverrides"] = $c8f51fccdd166527$export$3f9446bb21b945a0;

});

parcelRegister("7Vxvp", function(module, exports) {
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $fVUfS = parcelRequire("fVUfS");

const $fee91c6d88bcaa54$var$styles = {
    button: "_1e0c1bgi",
    innerContainer: "_1e0c1nu9 _1y1m1u8q _16d9qvcn _k48p1wq8 _19bv12x7 _ca0qv77o _n3tdv77o _u5f312x7 _y3gn18uv _o5721btx _1nmz9jpi",
    enabled: "_syazi7uo _80omtlke _bfhki8nm _irr3plhp _1di61gdz",
    disabled: "_syaz1gmx _80om13gf _bfhkby5v",
    unauthorised: "_syaz15cr _80omtlke _bfhkjmqp _qrwqlb4i _1o0zlb4i _13lilb4i _mrkblb4i _ca0qt94y _n3tdt94y _2hwxt94y _k48pi7a9 _irr31q28 _1di612kk"
};
const $fee91c6d88bcaa54$export$cfc7921d29ef7b80 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, isDisabled: isDisabled, viewType: viewType = 'default', ...props }, ref)=>{
    return /*#__PURE__*/ $42omo.createElement((0, $fVUfS.default), {
        ...props,
        isDisabled: isDisabled,
        ref: ref,
        // from parent component such as paragraph and heading
        style: {
            font: `inherit`
        },
        xcss: $fee91c6d88bcaa54$var$styles.button
    }, /*#__PURE__*/ $42omo.createElement("span", {
        tabIndex: isDisabled ? undefined : 0,
        className: (0, $gMc0m.default)([
            $fee91c6d88bcaa54$var$styles.innerContainer,
            isDisabled ? $fee91c6d88bcaa54$var$styles.disabled : viewType === 'unauthorised' ? $fee91c6d88bcaa54$var$styles.unauthorised : $fee91c6d88bcaa54$var$styles.enabled
        ])
    }, children));
});
module.exports["ActionButton"] = $fee91c6d88bcaa54$export$cfc7921d29ef7b80;

});

parcelRegister("dLAsE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $lgqac = parcelRequire("lgqac");

function $ff5fb1232cd87c62$export$ed70996d478e16d3() {
    /**
	 * this utility maybe extended in the future to include
	 * more contextual info about SLs
	 */ const events = (0, $42omo.useMemo)(()=>new (0, $lgqac.SmartLinkEvents)(), []);
    return events;
}
function $ff5fb1232cd87c62$export$e682245dc886cff2(firstPartyIdentifier, thirdPartyARI) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    return ()=>{
        const smartlinkClickAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'smartLink',
            actionSubjectId: 'smartlinkClickAnalyticsWorkflows',
            eventType: 'ui',
            attributes: {
                eventName: 'smartLinkClickAnalyticsThirdPartyWorkflows',
                firstPartyIdentifier: firstPartyIdentifier
            },
            nonPrivacySafeAttributes: {
                thirdPartyARI: thirdPartyARI
            }
        });
        smartlinkClickAnalyticsEvent.fire('media');
    };
}
module.exports["useSmartLinkEvents"] = $ff5fb1232cd87c62$export$ed70996d478e16d3;
module.exports["useFire3PWorkflowsClickEvent"] = $ff5fb1232cd87c62$export$e682245dc886cff2;

});

parcelRegister("hn4RR", function(module, exports) {
$parcel$export(module.exports, "default", () => $e81c36a83f2b3e0f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fBMbo = parcelRequire("fBMbo");


var $ggbZE = parcelRequire("ggbZE");


var $c6GJD = parcelRequire("c6GJD");


var $2Nwuj = parcelRequire("2Nwuj");


var $6wQZE = parcelRequire("6wQZE");





var $bYRk6 = parcelRequire("bYRk6");

const $13440d2ce08719fa$export$9458cdec663b9ff1 = ({ display: display, id: id, children: children, source: source })=>{
    const displayCategory = display === 'url' ? 'link' : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $bYRk6.default), {
        data: {
            source: source,
            attributes: {
                displayCategory: displayCategory,
                display: display,
                id: id
            }
        }
    }, children);
};











const $3be2cafa97b66d1a$var$Anchor = (0, $6wQZE.withLinkClickedEvent)('a');
const $3be2cafa97b66d1a$export$8c0773eab230d49e = (0, $6wQZE.withLinkClickedEvent)((0, $2Nwuj.default));
const $3be2cafa97b66d1a$var$Hyperlink = ({ href: href, children: children, testId: testId, isLinkComponent: isLinkComponent = false, ...props })=>{
    const Link = isLinkComponent ? $3be2cafa97b66d1a$export$8c0773eab230d49e : $3be2cafa97b66d1a$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        ...props
    }, children);
};
var $3be2cafa97b66d1a$export$2e2bcd8739ae039 = $3be2cafa97b66d1a$var$Hyperlink;






var $lAJUP = parcelRequire("lAJUP");


var $gmMgo = parcelRequire("gmMgo");





var $79vw2 = parcelRequire("79vw2");


var $dh538 = parcelRequire("dh538");


var $226XV = parcelRequire("226XV");





var $dQl1W = parcelRequire("dQl1W");





var $kKODE = parcelRequire("kKODE");


var $l6tPN = parcelRequire("l6tPN");


var $a43ao = parcelRequire("a43ao");





var $lz9QA = parcelRequire("lz9QA");

/**
 * This is a scheduled batched register mechanism for resolving blue hyperlinks while the page is idle.
 * i.e. SharePoint tenants with the same hostname will be grouped together before the register is made.
 */ 


const $30de6a1f90cac3ee$var$batchQueue = new Map();
const $30de6a1f90cac3ee$var$batchTimeouts = new Map();
const $30de6a1f90cac3ee$var$BATCH_DELAY = 250;
const $30de6a1f90cac3ee$var$executeBatch = (hostname)=>{
    const items = $30de6a1f90cac3ee$var$batchQueue.get(hostname) || [];
    if (items.length === 0) return;
    $30de6a1f90cac3ee$var$batchQueue.delete(hostname);
    $30de6a1f90cac3ee$var$batchTimeouts.delete(hostname);
    items.forEach(({ register: register, resolve: resolve, reject: reject })=>{
        register().then(resolve).catch(reject);
    });
};
const $30de6a1f90cac3ee$var$addToBatch = (hostname, item)=>{
    if (!$30de6a1f90cac3ee$var$batchQueue.has(hostname)) $30de6a1f90cac3ee$var$batchQueue.set(hostname, []);
    $30de6a1f90cac3ee$var$batchQueue.get(hostname).push(item);
    if ($30de6a1f90cac3ee$var$batchTimeouts.has(hostname)) clearTimeout($30de6a1f90cac3ee$var$batchTimeouts.get(hostname));
    $30de6a1f90cac3ee$var$batchTimeouts.set(hostname, setTimeout(()=>{
        $30de6a1f90cac3ee$var$executeBatch(hostname);
    }, $30de6a1f90cac3ee$var$BATCH_DELAY));
};
const $30de6a1f90cac3ee$export$db80d61271e4d5af = (href, register)=>{
    const isScheduled = (0, $42omo.useRef)(false);
    const scheduledRegister = (0, $42omo.useCallback)(()=>{
        if (!href || !register || isScheduled.current) return Promise.resolve();
        isScheduled.current = true;
        return new Promise((resolve, reject)=>{
            const scheduleRegister = ()=>{
                try {
                    const hostname = new URL(href).hostname;
                    $30de6a1f90cac3ee$var$addToBatch(hostname, {
                        href: href,
                        register: register,
                        resolve: (value)=>{
                            isScheduled.current = false;
                            resolve(value);
                        },
                        reject: (error)=>{
                            isScheduled.current = false;
                            reject(error);
                        }
                    });
                } catch (error) {
                    isScheduled.current = false;
                    register().then(resolve).catch(reject);
                }
            };
            if (typeof window !== 'undefined') {
                if ('requestIdleCallback' in window) window.requestIdleCallback(scheduleRegister);
                else setTimeout(scheduleRegister, 0);
            } else scheduleRegister();
        });
    }, [
        href,
        register
    ]);
    return scheduledRegister;
};


const $8ce3085c5c5a77bd$var$useResolveHyperlink = ({ href: href })=>{
    // eslint-disable-next-line @atlaskit/platform/prefer-crypto-random-uuid -- Use crypto.randomUUID instead
    const [id] = (0, $42omo.useState)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dQl1W)))());
    const state = (0, $lz9QA.useSmartCardState)(href);
    const definitionId = (0, $226XV.getDefinitionId)(state.details);
    const extensionKey = (0, $226XV.getExtensionKey)(state.details);
    const resourceType = (0, $226XV.getResourceType)(state.details);
    const actions = (0, $a43ao.useSmartCardActions)(id, href);
    const scheduledRegister = (0, $30de6a1f90cac3ee$export$db80d61271e4d5af)(href, actions.register);
    const { fireEvent: fireEvent } = (0, $kKODE.useAnalyticsEvents)();
    (0, $42omo.useEffect)(()=>{
        scheduledRegister().catch((error)=>{
            throw error;
        });
    }, [
        scheduledRegister
    ]);
    (0, $42omo.useEffect)(()=>{
        $l6tPN.mark(id, state.status);
        if (state.status !== 'pending' && state.status !== 'resolving') {
            $l6tPN.create(id, state.status);
            if (state.status === 'resolved') fireEvent('operational.hyperlink.resolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                duration: $l6tPN.getMeasure(id, state.status)?.duration ?? null
            });
            else if ((0, $dh538.fg)('platform_navx_lp_invalid_url_error') ? state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError' && state.error?.name !== 'InvalidUrlError' : state.error?.type !== 'ResolveUnsupportedError' && state.error?.type !== 'UnsupportedError') fireEvent('operational.hyperlink.unresolved', {
                definitionId: definitionId ?? null,
                extensionKey: extensionKey ?? null,
                resourceType: resourceType ?? null,
                reason: state.status,
                error: state.error === undefined ? null : {
                    name: state.error.name,
                    kind: state.error.kind,
                    type: state.error.type
                }
            });
        }
    }, [
        id,
        state.status,
        state.error,
        definitionId,
        extensionKey,
        resourceType,
        fireEvent
    ]);
    return {
        state: state,
        actions: actions
    };
};
var $8ce3085c5c5a77bd$export$2e2bcd8739ae039 = $8ce3085c5c5a77bd$var$useResolveHyperlink;






var $eIleF = parcelRequire("eIleF");

const $13849139a87405b6$var$allowedHostnames = [
    'sharepoint.com',
    'onedrive.live.com',
    'docs.google.com',
    'drive.google.com'
];
const $13849139a87405b6$export$aa45d36a96427452 = (href)=>{
    try {
        const hostname = new URL(href).hostname.toLowerCase();
        return $13849139a87405b6$var$allowedHostnames.some((allowedHostname)=>hostname.includes(allowedHostname));
    } catch  {
        return false;
    }
};
const $13849139a87405b6$var$useResolveHyperlinkValidator = (href = '')=>{
    const hasSmartCardProvider = !!(0, $42omo.useContext)((0, $eIleF.SmartCardContext));
    return hasSmartCardProvider && $13849139a87405b6$export$aa45d36a96427452(href);
};
var $13849139a87405b6$export$2e2bcd8739ae039 = $13849139a87405b6$var$useResolveHyperlinkValidator;



var $5MkWK = parcelRequire("5MkWK");





var $1e2E5 = parcelRequire("1e2E5");

/**
 * HOC to wrap component with IntlProvider if not available
 */ const $255ccdc0ab7e7f63$var$withIntlProvider = (Component)=>(props)=>{
        const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props);
        return props?.intl ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1e2E5.default), {
            locale: "en"
        }, content);
    };
var $255ccdc0ab7e7f63$export$2e2bcd8739ae039 = $255ccdc0ab7e7f63$var$withIntlProvider;



var $dLAsE = parcelRequire("dLAsE");






var $gtD4K = parcelRequire("gtD4K");


var $afp1H = parcelRequire("afp1H");


var $7Vxvp = parcelRequire("7Vxvp");


const $9a1c9ba5dc2a7a31$var$HyperlinkUnauthorizedView = ({ onAuthorize: onAuthorize, provider: provider, showConnectBtn: showConnectBtn, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3be2cafa97b66d1a$export$2e2bcd8739ae039), props), showConnectBtn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $7Vxvp.ActionButton), {
        onClick: onAuthorize,
        testId: "button-connect-account"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).connect_link_account_card_name,
        values: {
            context: provider?.text
        }
    }))));
};
var $9a1c9ba5dc2a7a31$export$2e2bcd8739ae039 = $9a1c9ba5dc2a7a31$var$HyperlinkUnauthorizedView;


const $05b0889a04ec2be1$var$HyperlinkFallbackComponent = ()=>null;
const $05b0889a04ec2be1$var$withValidator = (Component, DefaultComponent)=>(props)=>{
        const shouldResolveHyperlink = (0, $13849139a87405b6$export$2e2bcd8739ae039)(props?.href);
        return shouldResolveHyperlink && props.href ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $5MkWK.SmartLinkAnalyticsContext), {
            url: props.href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Component, props)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(DefaultComponent, props);
    };
const $05b0889a04ec2be1$var$HyperlinkWithSmartLinkResolverInner = ({ onClick: onClickCallback, ...props })=>{
    const { actions: actions, state: state } = (0, $8ce3085c5c5a77bd$export$2e2bcd8739ae039)({
        href: props.href || ''
    });
    const services = (0, $226XV.getServices)(state?.details);
    const thirdPartyARI = (0, $226XV.getThirdPartyARI)(state?.details);
    const firstPartyIdentifier = (0, $226XV.getFirstPartyIdentifier)();
    const fire3PClickEvent = (0, $dh538.fg)('platform_smartlink_3pclick_analytics') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $dLAsE.useFire3PWorkflowsClickEvent)(firstPartyIdentifier, thirdPartyARI) : undefined;
    const onClick = (0, $42omo.useCallback)((e)=>{
        // Only fire the event if the feature flag is on and other conditions are met
        if (state?.status === 'resolved' && e?.button === 0 && fire3PClickEvent && (0, $dh538.fg)('platform_smartlink_3pclick_analytics')) // 0 taken from button state representation -
        // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
        fire3PClickEvent();
        onClickCallback?.(e);
    }, [
        onClickCallback,
        fire3PClickEvent,
        state?.status
    ]);
    const onAuthorize = (0, $42omo.useCallback)(()=>actions.authorize('url'), [
        actions
    ]);
    const shouldRenderConnectBtn = ()=>{
        if (!props.children || !Array.isArray(props.children) || props.children.length === 0) return false;
        const firstChild = props.children[0];
        try {
            // Check if first child has a string matching href
            if (typeof firstChild === 'string') return props.href === firstChild;
            // Check if first child has another child object containing matching href. This aligns with the behavior of the TextWrapper component used by editor to render link nodes
            if (firstChild?.props?.children && typeof firstChild.props.children === 'string') return props.href === firstChild.props.children;
        } catch (_) {
            return false;
        }
    };
    if (state?.status === 'unauthorized' && shouldRenderConnectBtn() && ((0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_confluence', 'isEnabled', false) || (0, $c6GJD.default).getExperimentValue('platform_linking_bluelink_connect_jira', 'isEnabled', false))) {
        const provider = (0, $79vw2.extractSmartLinkProvider)(state?.details);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $9a1c9ba5dc2a7a31$export$2e2bcd8739ae039), {
            ...props,
            onAuthorize: services?.length ? onAuthorize : undefined,
            onClick: onClick,
            showConnectBtn: services?.length > 0,
            provider: provider
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $3be2cafa97b66d1a$export$2e2bcd8739ae039), {
        ...props,
        onClick: onClick
    });
};
const $05b0889a04ec2be1$export$1fdb4f77fe528a52 = (0, $lAJUP.withErrorBoundary)($05b0889a04ec2be1$var$withValidator((0, $gmMgo.default)((0, $255ccdc0ab7e7f63$export$2e2bcd8739ae039)($05b0889a04ec2be1$var$HyperlinkWithSmartLinkResolverInner), {
    enforceContext: false
}), (0, $3be2cafa97b66d1a$export$2e2bcd8739ae039)), {
    FallbackComponent: $05b0889a04ec2be1$var$HyperlinkFallbackComponent
});


/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $gMc0m = parcelRequire("gMc0m");









var $eEA8O = parcelRequire("eEA8O");





var $8CZUH = parcelRequire("8CZUH");

var $1DHa6 = parcelRequire("1DHa6");

var $8o1lj = parcelRequire("8o1lj");

var $9ot3w = parcelRequire("9ot3w");

var $d8eRd = parcelRequire("d8eRd");

var $6xdDU = parcelRequire("6xdDU");




const $edc36e514c97f3fa$var$breakWordsCss = null;
const $edc36e514c97f3fa$var$WarningModal = (props)=>{
    const { isOpen: isOpen, unsafeLinkText: unsafeLinkText, url: url, onClose: onClose, onContinue: onContinue, intl: intl } = props;
    const content = /*#__PURE__*/ $42omo.createElement((0, $6xdDU.default), null, isOpen && /*#__PURE__*/ $42omo.createElement((0, $8CZUH.default), {
        onClose: onClose,
        testId: "link-with-safety-warning"
    }, /*#__PURE__*/ $42omo.createElement((0, $9ot3w.default), {
        hasCloseButton: true
    }, /*#__PURE__*/ $42omo.createElement((0, $d8eRd.default), {
        appearance: "warning"
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).check_this_link))), /*#__PURE__*/ $42omo.createElement((0, $1DHa6.default), null, /*#__PURE__*/ $42omo.createElement("div", {
        className: (0, $gMc0m.default)([
            "_o5726vc6 _1nmz9jpi"
        ])
    }, url && unsafeLinkText && /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), {
        ...(0, $afp1H.messages).link_safety_warning_message,
        values: {
            unsafeLinkText: unsafeLinkText,
            a: ()=>/*#__PURE__*/ $42omo.createElement((0, $2Nwuj.default), {
                    href: url,
                    target: "_blank",
                    rel: "noopener noreferrer"
                }, url)
        }
    }))), /*#__PURE__*/ $42omo.createElement((0, $8o1lj.default), null, /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "subtle",
        onClick: onClose
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).go_back)), /*#__PURE__*/ $42omo.createElement((0, $eEA8O.default), {
        appearance: "warning",
        onClick: onContinue,
        autoFocus: true
    }, /*#__PURE__*/ $42omo.createElement((0, $gtD4K.default), (0, $afp1H.messages).continue)))));
    return intl ? content : /*#__PURE__*/ $42omo.createElement((0, $1e2E5.default), {
        locale: "en"
    }, content);
};
var $edc36e514c97f3fa$export$2e2bcd8739ae039 = (0, $gmMgo.default)($edc36e514c97f3fa$var$WarningModal, {
    enforceContext: false
});






var $inPa6 = parcelRequire("inPa6");


var $l3dur = parcelRequire("l3dur");


var $lgqac = parcelRequire("lgqac");

const $83b01bdf128d776a$var$toUrl = (url, base)=>{
    try {
        return new URL(url, base);
    } catch  {
        return undefined;
    }
};
const $83b01bdf128d776a$export$32b76c003683c2ec = ()=>{
    const [unsafeLinkText, setUnsafeLinkText] = (0, $42omo.useState)(null);
    const [url, setUrl] = (0, $42omo.useState)(null);
    const [isOpen, setIsOpen] = (0, $42omo.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const sendWarningModalViewedEvent = ()=>{
        createAnalyticsEvent({
            action: 'viewed',
            actionSubject: 'linkSafetyWarningModal',
            eventType: 'screen',
            name: 'linkSafetyWarningModal'
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
    const sendContinueClickedEvent = ()=>{
        createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'linkSafetyWarningModalContinue',
            eventType: 'ui',
            screen: 'linkSafetyWarningModal'
        }).fire((0, $lgqac.ANALYTICS_CHANNEL));
    };
    /**
	 * It checks and warns if a link text is a URL and different from an actual link destination
	 */ const isLinkSafe = (event, href)=>{
        if (!href) return true;
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        const normalisedUrlFromLinkText = (0, $l3dur.normalizeUrl)(linkText);
        if (!normalisedUrlFromLinkText) return true;
        const anchorLinkRegex = new RegExp(/^#/im);
        const isLinkTextAnchorLink = anchorLinkRegex.test(linkText);
        const isAnchorLink = anchorLinkRegex.test(href);
        if (isAnchorLink || isLinkTextAnchorLink) return true;
        const relativeLinkRegex = new RegExp(/^\//im);
        const isRelativeHrefLink = relativeLinkRegex.test(href);
        if (isRelativeHrefLink) return true;
        const hrefUrl = $83b01bdf128d776a$var$toUrl(href, window.location.origin);
        const linkTextUrl = $83b01bdf128d776a$var$toUrl(normalisedUrlFromLinkText, hrefUrl?.origin);
        if (!hrefUrl || !linkTextUrl) return true;
        const currentAtlassianProductOrigin = window.location.origin;
        const isSafeToIgnoreNonOriginDifferences = hrefUrl?.origin === currentAtlassianProductOrigin && linkTextUrl?.origin === currentAtlassianProductOrigin;
        if (isSafeToIgnoreNonOriginDifferences) return true;
        const httpProtocols = [
            'http:',
            'https:'
        ];
        let areProtocolsEquivalent;
        if (httpProtocols.includes(linkTextUrl.protocol) && httpProtocols.includes(hrefUrl.protocol)) {
            const noUserNameAndPassword = !linkTextUrl.username && !linkTextUrl.password && !hrefUrl.username && !hrefUrl.password;
            areProtocolsEquivalent = noUserNameAndPassword;
        } else areProtocolsEquivalent = linkTextUrl.protocol === hrefUrl.protocol;
        const areEquivalentLinks = linkTextUrl.hostname === hrefUrl.hostname && linkTextUrl.pathname === hrefUrl.pathname && linkTextUrl.search === hrefUrl.search && linkTextUrl.username === hrefUrl.username && linkTextUrl.password === hrefUrl.password && areProtocolsEquivalent;
        if (!areEquivalentLinks) return false;
        return true;
    };
    const showSafetyWarningModal = (event, href)=>{
        event.preventDefault();
        const anchor = event.currentTarget;
        const linkText = anchor.innerText;
        setUnsafeLinkText(linkText);
        href && setUrl(href);
        setIsOpen(true);
        sendWarningModalViewedEvent();
    };
    const onClose = ()=>{
        setIsOpen(false);
        setUnsafeLinkText(null);
        setUrl(null);
    };
    const onContinue = ()=>{
        onClose();
        sendContinueClickedEvent();
        url && window.open(url, '_blank', 'noopener noreferrer');
    };
    return {
        isLinkSafe: isLinkSafe,
        isOpen: isOpen,
        onClose: onClose,
        onContinue: onContinue,
        showSafetyWarningModal: showSafetyWarningModal,
        unsafeLinkText: unsafeLinkText,
        url: url
    };
};


const $e81c36a83f2b3e0f$var$PACKAGE_DATA = {
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local",
    componentName: 'linkUrl'
};
const $e81c36a83f2b3e0f$var$Anchor = (0, $6wQZE.withLinkClickedEvent)('a');
const $e81c36a83f2b3e0f$export$8c0773eab230d49e = (0, $6wQZE.withLinkClickedEvent)((0, $2Nwuj.default));
const $e81c36a83f2b3e0f$var$LinkUrl = ({ href: href, children: children, checkSafety: checkSafety = true, onClick: onClick, testId: testId = 'link-with-safety', isLinkComponent: isLinkComponent = false, enableResolve: enableResolve = false, ...props })=>{
    (0, $fBMbo.di)($e81c36a83f2b3e0f$export$8c0773eab230d49e, (0, $83b01bdf128d776a$export$32b76c003683c2ec));
    const { isLinkSafe: isLinkSafe, showSafetyWarningModal: showSafetyWarningModal, ...linkWarningModalProps } = (0, $83b01bdf128d776a$export$32b76c003683c2ec)();
    const resolveHyperlinkFG = (0, $c6GJD.default).checkGate('platform_editor_resolve_hyperlinks_killswitch');
    if (resolveHyperlinkFG) {
        const Link = enableResolve ? (0, $05b0889a04ec2be1$export$1fdb4f77fe528a52) : (0, $3be2cafa97b66d1a$export$2e2bcd8739ae039);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13440d2ce08719fa$export$9458cdec663b9ff1), {
            url: href,
            display: "url"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
            href: href,
            isLinkComponent: isLinkComponent,
            onClick: (e)=>{
                if (!checkSafety) {
                    onClick && onClick(e);
                    return;
                }
                // Only call the onClick if the link is safe
                if (isLinkSafe(e, href)) onClick && onClick(e);
                else showSafetyWarningModal(e, href);
            },
            ...props
        }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $edc36e514c97f3fa$export$2e2bcd8739ae039), linkWarningModalProps));
    }
    const Link = isLinkComponent ? $e81c36a83f2b3e0f$export$8c0773eab230d49e : $e81c36a83f2b3e0f$var$Anchor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $13440d2ce08719fa$export$9458cdec663b9ff1), {
        url: href,
        display: "url"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Link, {
        ...isLinkComponent ? {
            testId: testId
        } : {
            'data-testid': testId
        },
        href: href || '',
        onClick: (e)=>{
            if (!checkSafety) {
                onClick && onClick(e);
                return;
            }
            // Only call the onClick if the link is safe
            if (isLinkSafe(e, href)) onClick && onClick(e);
            else showSafetyWarningModal(e, href);
        },
        ...props
    }, children)), checkSafety && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $edc36e514c97f3fa$export$2e2bcd8739ae039), linkWarningModalProps));
};
var $e81c36a83f2b3e0f$export$2e2bcd8739ae039 = (0, $ggbZE.default)($e81c36a83f2b3e0f$var$PACKAGE_DATA)($e81c36a83f2b3e0f$var$LinkUrl);

});

parcelRegister("l3dur", function(module, exports) {
/**
 * This file has been partially duplicated in packages/editor/adf-schema/src/utils/url.ts
 * Any changes made here should be mirrored there until the duplicate behaviour is resolved
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $2Gb84 = parcelRequire("2Gb84");

const $8a7492fb362aaff8$var$linkify = (0, (/*@__PURE__*/$parcel$interopDefault($2Gb84)))();
$8a7492fb362aaff8$var$linkify.add('sourcetree:', 'http:');
$8a7492fb362aaff8$var$linkify.add('jamfselfservice:', 'http:');
$8a7492fb362aaff8$var$linkify.add('notes:', 'http:');
const $8a7492fb362aaff8$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $8a7492fb362aaff8$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$8a7492fb362aaff8$var$tlds.push($8a7492fb362aaff8$var$tlds2Char);
$8a7492fb362aaff8$var$linkify.tlds($8a7492fb362aaff8$var$tlds, false);
const $8a7492fb362aaff8$var$whitelistedURLPatterns = [
    /^https?:\/\/[^\s]*$/im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\/[^\s]*$/im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:[^\s]*$/im,
    /^facetime:[^\s]*$/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    /^sourcetree:/im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^foo:/im,
    /^#/im
];
const $8a7492fb362aaff8$var$normaliseLinkHref = (url)=>{
    const match = $8a7492fb362aaff8$var$getLinkMatch(url);
    return match && match.url || null;
};
const $8a7492fb362aaff8$var$getLinkMatch = (str)=>{
    if (!str) return null;
    let match = $8a7492fb362aaff8$var$linkifyMatch(str);
    if (!match.length) match = $8a7492fb362aaff8$var$linkify.match(str);
    return match && match.length > 0 && match[0].index === 0 && match[0].lastIndex === str.trim().length ? match[0] : null;
};
const $8a7492fb362aaff8$var$LINK_REGEXP = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $8a7492fb362aaff8$var$linkifyMatch = (text)=>{
    const matches = [];
    if (!$8a7492fb362aaff8$var$LINK_REGEXP.test(text)) return matches;
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($8a7492fb362aaff8$var$LINK_REGEXP) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($8a7492fb362aaff8$var$LINK_REGEXP);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
const $8a7492fb362aaff8$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    return $8a7492fb362aaff8$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
function $8a7492fb362aaff8$export$6535eb414fa2c8b6(url) {
    if (!url) return '';
    const urlWithoutNewlines = url.replace(/[\r\n]+/g, '');
    if ($8a7492fb362aaff8$export$c9f92f5469372e0f(urlWithoutNewlines)) return urlWithoutNewlines.trim();
    return $8a7492fb362aaff8$var$normaliseLinkHref(urlWithoutNewlines);
}
module.exports["isSafeUrl"] = $8a7492fb362aaff8$export$c9f92f5469372e0f;
module.exports["normalizeUrl"] = $8a7492fb362aaff8$export$6535eb414fa2c8b6;

});

parcelRegister("3rvSa", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");

const $1c0162128aea5b38$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $1c0162128aea5b38$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($1c0162128aea5b38$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};
module.exports["MediaClientContext"] = $1c0162128aea5b38$export$ba5d7212f2b4619f;
module.exports["MediaClientProvider"] = $1c0162128aea5b38$export$5bff351c86f56d97;

});

parcelRegister("ozLJl", function(module, exports) {
/**
 * Classname for the media viewer popup that appears adjacent to the editor div. Use this to check
 * if the media viewer has appeared.
 */ const $7c537b76f301caad$export$42c8d07e41ed1e74 = 'media-viewer-popup';
module.exports["mediaViewerPopupClass"] = $7c537b76f301caad$export$42c8d07e41ed1e74;

});

parcelRegister("jTudT", function(module, exports) {
const $6167473ae8c2b69b$export$7a6526d4be3b7eb3 = 'media-file-card-view';
const $6167473ae8c2b69b$export$1b2a6cb6a124ba37 = 'media-file-card-view-selected';
module.exports["fileCardImageViewSelector"] = $6167473ae8c2b69b$export$7a6526d4be3b7eb3;

});

parcelRegister("1A9t2", function(module, exports) {

var $6jPem = parcelRequire("6jPem");

function $6d2a4e7dc7af02b0$export$533b26079ad0b4b(adf, callback, initial) {
    let result = initial;
    (0, $6jPem.traverse)(adf, {
        any: (node)=>{
            result = callback(result, node);
        }
    });
    return result;
}
module.exports["reduce"] = $6d2a4e7dc7af02b0$export$533b26079ad0b4b;

});

parcelRegister("3fvfu", function(module, exports) {
const $443f0fc151c7533d$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $443f0fc151c7533d$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $443f0fc151c7533d$export$84a73a0383f58180 = 'JiraTask';
const $443f0fc151c7533d$export$c6c83963a9378a67 = 'JiraSubTask';
const $443f0fc151c7533d$export$58af3c426c111a6d = 'JiraStory';
const $443f0fc151c7533d$export$ac9898a63417219e = 'JiraBug';
const $443f0fc151c7533d$export$54db5e3fb12e39cd = 'JiraEpic';
const $443f0fc151c7533d$export$2f54a5a217202c85 = 'JiraIncident';
const $443f0fc151c7533d$export$d097371052bfc411 = 'JiraServiceRequest';
const $443f0fc151c7533d$export$efd9452ad16c6676 = 'JiraChange';
const $443f0fc151c7533d$export$2e7e70abb5d81f67 = 'JiraProblem';
const $443f0fc151c7533d$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
module.exports["CONFLUENCE_GENERATOR_ID"] = $443f0fc151c7533d$export$cee224b5de4d6d66;
module.exports["JIRA_GENERATOR_ID"] = $443f0fc151c7533d$export$f654d825189934a7;

});

parcelRegister("2ZyjG", function(module, exports) {
const $d67cef10d550b6fb$export$bf0a80f00e2b8ff6 = (nodeSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...nodeSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
const $d67cef10d550b6fb$export$cf5823ed4e9f4c6f = (markSpec)=>({ parseDOM: parseDOM, toDOM: toDOM, toDebugString: toDebugString })=>{
        // @ts-ignore
        return {
            ...markSpec,
            ...parseDOM && {
                parseDOM: parseDOM
            },
            ...toDOM && {
                toDOM: toDOM
            },
            ...toDebugString && {
                toDebugString: toDebugString
            }
        };
    };
module.exports["createPMNodeSpecFactory"] = $d67cef10d550b6fb$export$bf0a80f00e2b8ff6;
module.exports["createPMMarkSpecFactory"] = $d67cef10d550b6fb$export$cf5823ed4e9f4c6f;

});

parcelRegister("17CG5", function(module, exports) {
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $2ZyjG = parcelRequire("2ZyjG");

const $a34102d25b4b77cc$export$c4c2f833baaebdb8 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        },
        url: {
            default: null
        },
        datasource: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $a34102d25b4b77cc$export$67dc04e652a298ca = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | orderedList | bulletList | unsupportedBlock | codeBlock | mediaSingle | mediaGroup | extension)+',
    marks: 'unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $a34102d25b4b77cc$export$199922e5af8e9a6 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true
});
const $a34102d25b4b77cc$export$16018c61064a18df = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | extension) (paragraph | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $a34102d25b4b77cc$export$27903d543b563e39 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $a34102d25b4b77cc$export$e7320d153c538837 = (0, $2ZyjG.createPMNodeSpecFactory)({
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    defining: true,
    isolating: true
});
const $a34102d25b4b77cc$export$e92c7e4302dd4371 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | blockCard | blockquote | bulletList | codeBlock | confluenceUnsupportedBlock | decisionList | embedCard | expand | heading | layoutSection | mediaGroup | mediaSingle | orderedList | panel | rule | table | taskList | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation fontSize breakout link fragment',
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true,
    isolating: true
});
const $a34102d25b4b77cc$export$a140c94e5ea26bee = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $a34102d25b4b77cc$export$8e3c2dfdc4f0453d = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(hardBreak | mention | emoji | date | placeholder | inlineCard | status | text | unsupportedInline)*',
    marks: '_',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $a34102d25b4b77cc$export$7bb0d5c671655cc4 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $a34102d25b4b77cc$export$e4f1c66d84049f8b = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(text | unsupportedInline)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        language: {
            default: null
        },
        uniqueId: {
            default: null
        },
        localId: {
            default: null
        }
    },
    code: true,
    defining: true
});
const $a34102d25b4b77cc$export$daf889beb5092f95 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        issueKey: {
            default: ''
        },
        macroId: {
            default: null
        },
        schemaVersion: {
            default: null
        },
        server: {
            default: null
        },
        serverId: {
            default: null
        }
    }
});
const $a34102d25b4b77cc$export$e6e4878f43c27cab = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $a34102d25b4b77cc$export$3e6d667072febc87 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    atom: true,
    attrs: {
        cxhtml: {
            default: null
        }
    }
});
const $a34102d25b4b77cc$export$324d90190a8b822a = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$47988d68fe575725 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        timestamp: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$6959e16eeff859b4 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'DECIDED'
        }
    },
    defining: true
});
const $a34102d25b4b77cc$export$62d45a65fb43d95e = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(decisionItem | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $a34102d25b4b77cc$export$2a111da947c407d2 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(block | codeBlock | layoutSection | blockRootOnly | expand | syncBlock | bodiedSyncBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation fontSize dataConsumer fragment breakout'
});
const $a34102d25b4b77cc$export$be4283d9a1cb1ff6 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        url: {
            default: ''
        },
        layout: {
            default: 'center'
        },
        width: {
            default: 100
        },
        originalHeight: {
            default: null
        },
        originalWidth: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$a19185d1233fc4b2 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$f5574b5d45fc2112 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        shortName: {
            default: ''
        },
        id: {
            default: ''
        },
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$9f77e0932fb78f72 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    group: 'block',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $a34102d25b4b77cc$export$7e3788972005cc72 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | blockCard | embedCard | extension | unsupportedBlock | nestedExpand)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute fragment dataConsumer',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $a34102d25b4b77cc$export$1b45514b112dd749 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$a8baf338431a691 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$b555be60c7703afb = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaGroup | mediaSingle | decisionList | taskList | table | extension | bodiedExtension | unsupportedBlock | blockCard | embedCard)+',
    marks: 'dataConsumer fragment unsupportedMark unsupportedNodeAttribute',
    attrs: {},
    selectable: false,
    definingAsContext: false,
    definingForContent: true,
    isolating: true
});
const $a34102d25b4b77cc$export$371da9dd35aba193 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: '\n'
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    linebreakReplacement: true
});
const $a34102d25b4b77cc$export$46e4a324ac90507f = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $a34102d25b4b77cc$export$1b0c1557b234fa00 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $a34102d25b4b77cc$export$85461f751c457cc2 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $a34102d25b4b77cc$export$2b380a0f7e250af1 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        level: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $a34102d25b4b77cc$export$5c452ff88e35e47d = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        src: {
            default: ''
        },
        alt: {
            default: ''
        },
        title: {
            default: null
        }
    },
    draggable: true
});
const $a34102d25b4b77cc$export$cbf8224b64e0d942 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $a34102d25b4b77cc$export$2f4e72b9459914ad = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        url: {
            default: null
        },
        localId: {
            default: null
        },
        data: {
            default: null
        }
    },
    selectable: true,
    draggable: true
});
const $a34102d25b4b77cc$export$16b353b2649bd8d9 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$b3b1e36c2105006d = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$ab76e7c03cd6f650 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(block | unsupportedBlock)+',
    marks: 'unsupportedMark unsupportedNodeAttribute alignment indentation fontSize dataConsumer fragment',
    attrs: {
        width: {
            default: undefined
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true
});
const $a34102d25b4b77cc$export$b3b6a70a7fa4a5be = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,3} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $a34102d25b4b77cc$export$cdae19acb0a520fd = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){2,3}',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    isolating: true
});
const $a34102d25b4b77cc$export$206007566ca0aca5 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(layoutColumn | unsupportedBlock){1,5} unsupportedBlock*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        columnRuleStyle: {
            default: null
        },
        localId: {
            default: null
        }
    },
    isolating: true
});
const $a34102d25b4b77cc$export$76c7e83ecc9cdf05 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | mediaSingle | codeBlock | unsupportedBlock | extension) (paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)*',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $a34102d25b4b77cc$export$fcbecfed570fc881 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | bulletList | orderedList | taskList | mediaSingle | codeBlock | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    defining: true
});
const $a34102d25b4b77cc$export$987d49ffe1b0900f = (0, $2ZyjG.createPMNodeSpecFactory)({
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        height: {
            default: null
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        __contextId: {
            default: null
        },
        __displayType: {
            default: null
        },
        __external: {
            default: false
        },
        __fileMimeType: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        url: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$2855e964765eac9 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(media | unsupportedBlock)+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {},
    selectable: false
});
const $a34102d25b4b77cc$export$38bab695e3f720f1 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        type: {
            default: 'file'
        },
        localId: {
            default: null
        },
        url: {
            default: null
        },
        id: {
            default: ''
        },
        alt: {
            default: ''
        },
        collection: {
            default: ''
        },
        occurrenceKey: {
            default: null
        },
        width: {
            default: null
        },
        height: {
            default: null
        },
        __fileName: {
            default: null
        },
        __fileSize: {
            default: null
        },
        __fileMimeType: {
            default: null
        },
        __displayType: {
            default: null
        },
        __contextId: {
            default: null
        },
        __mediaTraceId: {
            default: null
        },
        __external: {
            default: false
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$969fe3781ca15058 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true,
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'annotation border link unsupportedMark unsupportedNodeAttribute'
});
const $a34102d25b4b77cc$export$8d067f22dc2d1254 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        layout: {
            default: 'center'
        },
        width: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$7e767666f2ce108a = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media (caption|unsupportedBlock) unsupportedBlock*',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: false,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$4bd9a38995f6bf50 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'media|unsupportedBlock+|media unsupportedBlock+',
    marks: 'link annotation border unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    atom: true,
    attrs: {
        localId: {
            default: null
        },
        width: {
            default: null
        },
        layout: {
            default: 'center'
        },
        widthType: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$db83999c14438df4 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$46f790bd65f760d0 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        id: {
            default: ''
        },
        localId: {
            default: null
        },
        text: {
            default: ''
        },
        accessLevel: {
            default: ''
        },
        userType: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$750e45819f66d9d0 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'extensionFrame+',
    marks: 'unsupportedNodeAttribute unsupportedMark',
    group: 'blockRootOnly',
    attrs: {
        extensionKey: {
            default: ''
        },
        extensionType: {
            default: ''
        },
        parameters: {
            default: null
        },
        text: {
            default: null
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    definingAsContext: true
});
const $a34102d25b4b77cc$export$63cadbf5f4296627 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | heading | mediaSingle | mediaGroup | codeBlock | bulletList | orderedList | taskList | decisionList | rule | panel | blockquote | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $a34102d25b4b77cc$export$f03786aa6312d1e4 = (0, $2ZyjG.createPMNodeSpecFactory)({
    attrs: {
        title: {
            default: ''
        },
        __expanded: {
            default: true
        },
        localId: {
            default: null
        }
    },
    selectable: true,
    isolating: true
});
const $a34102d25b4b77cc$export$a5dc81035676e7a = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'listItem+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        order: {
            default: 1
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $a34102d25b4b77cc$export$21f42ab9b6679f44 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | heading | bulletList | orderedList | blockCard | mediaGroup | mediaSingle | codeBlock | taskList | rule | decisionList | unsupportedBlock | extension)+',
    marks: 'fontSize unsupportedMark unsupportedNodeAttribute dataConsumer fragment',
    group: 'block',
    attrs: {
        panelType: {
            default: 'info'
        },
        panelIcon: {
            default: null
        },
        panelIconId: {
            default: null
        },
        panelIconText: {
            default: null
        },
        panelColor: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$9c206ddddb32a9b = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: 'link em strong strike subsup underline textColor annotation backgroundColor typeAheadQuery confluenceInlineComment unsupportedNodeAttribute unsupportedMark code dataConsumer fragment border',
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $a34102d25b4b77cc$export$4f98472e6dc14293 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $a34102d25b4b77cc$export$ab32079c0da00ac2 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $a34102d25b4b77cc$export$d1c89394b5f252a = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $a34102d25b4b77cc$export$961993701b15405a = (0, $2ZyjG.createPMNodeSpecFactory)({
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $a34102d25b4b77cc$export$ea332b61641b0588 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $a34102d25b4b77cc$export$a1f41dc4901771f8 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false
});
const $a34102d25b4b77cc$export$c7187bbd1a7a9244 = (0, $2ZyjG.createPMNodeSpecFactory)({
    marks: '',
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        localId: {
            default: null
        }
    },
    selectable: false
});
const $a34102d25b4b77cc$export$fbeb3a3956e8a3c7 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    attrs: {
        localId: {
            default: null
        }
    }
});
const $a34102d25b4b77cc$export$471f7ae5c4103ae1 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$b6ce52be8d7a261 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        text: {
            default: ''
        },
        color: {
            default: ''
        },
        localId: {
            default: ''
        },
        style: {
            default: ''
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$faab0ca9701d7048 = (0, $2ZyjG.createPMNodeSpecFactory)({
    attrs: {
        resourceId: {
            default: ''
        },
        localId: {
            default: ''
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$9852986a3ec5f6a0 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $a34102d25b4b77cc$export$ce086a560a1d05f5 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'tableRow+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        displayMode: {
            default: null
        },
        isNumberColumnEnabled: {
            default: false
        },
        layout: {
            default: 'default'
        },
        localId: {
            default: ''
        },
        width: {
            default: null
        },
        __autoSize: {
            default: false
        }
    },
    selectable: true,
    isolating: true,
    tableRole: 'table'
});
const $a34102d25b4b77cc$export$e1e720e5f4603e6a = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $a34102d25b4b77cc$export$abf39ca178940ff3 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | unsupportedBlock | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'cell'
});
const $a34102d25b4b77cc$export$48884d2a5190dc73 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $a34102d25b4b77cc$export$2a5a518232fa1a97 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(paragraph | panel | blockquote | orderedList | bulletList | rule | heading | codeBlock | mediaSingle | mediaGroup | decisionList | taskList | blockCard | embedCard | extension | nestedExpand | table)+',
    marks: 'alignment unsupportedMark unsupportedNodeAttribute fontSize dataConsumer fragment',
    attrs: {
        colspan: {
            default: 1
        },
        rowspan: {
            default: 1
        },
        colwidth: {
            default: null
        },
        background: {
            default: null
        },
        localId: {
            default: null
        }
    },
    selectable: false,
    isolating: true,
    tableRole: 'header_cell'
});
const $a34102d25b4b77cc$export$ce666bf02318c957 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $a34102d25b4b77cc$export$7d657479499397 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(tableCell | tableHeader)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: null
        }
    },
    selectable: false,
    tableRole: 'row'
});
const $a34102d25b4b77cc$export$6d8b0ef52e2e6390 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: 'inline*',
    marks: '_',
    attrs: {
        localId: {
            default: ''
        },
        state: {
            default: 'TODO'
        }
    },
    selectable: false,
    defining: true
});
const $a34102d25b4b77cc$export$375b6afcc5f4d291 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(taskItem | unsupportedBlock | blockTaskItem)+ (taskItem | taskList | unsupportedBlock | blockTaskItem)*',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    group: 'block',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $a34102d25b4b77cc$export$3c86306d85ad1f18 = (0, $2ZyjG.createPMNodeSpecFactory)({
    content: '(taskItem | taskList | unsupportedBlock | blockTaskItem)+',
    marks: 'unsupportedMark unsupportedNodeAttribute',
    attrs: {
        localId: {
            default: ''
        }
    },
    selectable: false,
    defining: true
});
const $a34102d25b4b77cc$export$6f093cfa640b7166 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline'
});
const $a34102d25b4b77cc$export$5ea06bc686c59dc2 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline'
});
const $a34102d25b4b77cc$export$93256a4c17b33a82 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline'
});
const $a34102d25b4b77cc$export$a12828d0f14a2762 = (0, $2ZyjG.createPMNodeSpecFactory)({});
const $a34102d25b4b77cc$export$44b79b0979d0f0f7 = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'block',
    atom: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
const $a34102d25b4b77cc$export$310ebe0d80122e9b = (0, $2ZyjG.createPMNodeSpecFactory)({
    group: 'inline',
    inline: true,
    attrs: {
        originalValue: {
            default: {}
        }
    },
    selectable: true
});
module.exports["blockCard"] = $a34102d25b4b77cc$export$c4c2f833baaebdb8;
module.exports["blockquote"] = $a34102d25b4b77cc$export$67dc04e652a298ca;
module.exports["blockquoteLegacy"] = $a34102d25b4b77cc$export$199922e5af8e9a6;
module.exports["blockTaskItem"] = $a34102d25b4b77cc$export$16018c61064a18df;
module.exports["bodiedExtension"] = $a34102d25b4b77cc$export$27903d543b563e39;
module.exports["bodiedSyncBlock"] = $a34102d25b4b77cc$export$e92c7e4302dd4371;
module.exports["bulletList"] = $a34102d25b4b77cc$export$a140c94e5ea26bee;
module.exports["caption"] = $a34102d25b4b77cc$export$8e3c2dfdc4f0453d;
module.exports["codeBlock"] = $a34102d25b4b77cc$export$7bb0d5c671655cc4;
module.exports["confluenceJiraIssue"] = $a34102d25b4b77cc$export$daf889beb5092f95;
module.exports["confluenceUnsupportedBlock"] = $a34102d25b4b77cc$export$e6e4878f43c27cab;
module.exports["confluenceUnsupportedInline"] = $a34102d25b4b77cc$export$3e6d667072febc87;
module.exports["date"] = $a34102d25b4b77cc$export$324d90190a8b822a;
module.exports["decisionItem"] = $a34102d25b4b77cc$export$6959e16eeff859b4;
module.exports["decisionList"] = $a34102d25b4b77cc$export$62d45a65fb43d95e;
module.exports["doc"] = $a34102d25b4b77cc$export$2a111da947c407d2;
module.exports["embedCard"] = $a34102d25b4b77cc$export$be4283d9a1cb1ff6;
module.exports["emoji"] = $a34102d25b4b77cc$export$a19185d1233fc4b2;
module.exports["expand"] = $a34102d25b4b77cc$export$9f77e0932fb78f72;
module.exports["extension"] = $a34102d25b4b77cc$export$1b45514b112dd749;
module.exports["extensionFrameStage0"] = $a34102d25b4b77cc$export$b555be60c7703afb;
module.exports["hardBreak"] = $a34102d25b4b77cc$export$371da9dd35aba193;
module.exports["heading"] = $a34102d25b4b77cc$export$46e4a324ac90507f;
module.exports["image"] = $a34102d25b4b77cc$export$5c452ff88e35e47d;
module.exports["inlineCard"] = $a34102d25b4b77cc$export$cbf8224b64e0d942;
module.exports["inlineExtensionWithMarks"] = $a34102d25b4b77cc$export$b3b1e36c2105006d;
module.exports["layoutColumn"] = $a34102d25b4b77cc$export$ab76e7c03cd6f650;
module.exports["layoutSection"] = $a34102d25b4b77cc$export$b3b6a70a7fa4a5be;
module.exports["layoutSectionFull"] = $a34102d25b4b77cc$export$cdae19acb0a520fd;
module.exports["layoutSectionWithSingleColumnStage0"] = $a34102d25b4b77cc$export$206007566ca0aca5;
module.exports["listItem"] = $a34102d25b4b77cc$export$76c7e83ecc9cdf05;
module.exports["listItemWithFlexibleFirstChildStage0"] = $a34102d25b4b77cc$export$fcbecfed570fc881;
module.exports["media"] = $a34102d25b4b77cc$export$987d49ffe1b0900f;
module.exports["mediaGroup"] = $a34102d25b4b77cc$export$2855e964765eac9;
module.exports["mediaInline"] = $a34102d25b4b77cc$export$38bab695e3f720f1;
module.exports["mediaSingle"] = $a34102d25b4b77cc$export$969fe3781ca15058;
module.exports["mediaSingleCaption"] = $a34102d25b4b77cc$export$8d067f22dc2d1254;
module.exports["mediaSingleFull"] = $a34102d25b4b77cc$export$7e767666f2ce108a;
module.exports["mediaSingleWidthType"] = $a34102d25b4b77cc$export$4bd9a38995f6bf50;
module.exports["mention"] = $a34102d25b4b77cc$export$db83999c14438df4;
module.exports["multiBodiedExtensionStage0"] = $a34102d25b4b77cc$export$750e45819f66d9d0;
module.exports["nestedExpand"] = $a34102d25b4b77cc$export$63cadbf5f4296627;
module.exports["orderedList"] = $a34102d25b4b77cc$export$a5dc81035676e7a;
module.exports["panel"] = $a34102d25b4b77cc$export$21f42ab9b6679f44;
module.exports["paragraph"] = $a34102d25b4b77cc$export$9c206ddddb32a9b;
module.exports["placeholder"] = $a34102d25b4b77cc$export$c7187bbd1a7a9244;
module.exports["rule"] = $a34102d25b4b77cc$export$fbeb3a3956e8a3c7;
module.exports["status"] = $a34102d25b4b77cc$export$471f7ae5c4103ae1;
module.exports["syncBlock"] = $a34102d25b4b77cc$export$faab0ca9701d7048;
module.exports["table"] = $a34102d25b4b77cc$export$9852986a3ec5f6a0;
module.exports["tableWithNestedTable"] = $a34102d25b4b77cc$export$ce086a560a1d05f5;
module.exports["tableCell"] = $a34102d25b4b77cc$export$e1e720e5f4603e6a;
module.exports["tableCellWithNestedTable"] = $a34102d25b4b77cc$export$abf39ca178940ff3;
module.exports["tableHeader"] = $a34102d25b4b77cc$export$48884d2a5190dc73;
module.exports["tableHeaderWithNestedTable"] = $a34102d25b4b77cc$export$2a5a518232fa1a97;
module.exports["tableRow"] = $a34102d25b4b77cc$export$ce666bf02318c957;
module.exports["tableRowWithNestedTable"] = $a34102d25b4b77cc$export$7d657479499397;
module.exports["taskItem"] = $a34102d25b4b77cc$export$6d8b0ef52e2e6390;
module.exports["taskList"] = $a34102d25b4b77cc$export$375b6afcc5f4d291;
module.exports["taskListWithFlexibleFirstChildStage0"] = $a34102d25b4b77cc$export$3c86306d85ad1f18;
module.exports["text"] = $a34102d25b4b77cc$export$6f093cfa640b7166;
module.exports["unsupportedBlock"] = $a34102d25b4b77cc$export$44b79b0979d0f0f7;
module.exports["unsupportedInline"] = $a34102d25b4b77cc$export$310ebe0d80122e9b;

});

parcelRegister("6bXvD", function(module, exports) {
/**
 * This file was automatically generated by @atlaskit/adf-schema-generator
 * DO NOT MODIFY IT BY HAND. Instead, modify the source files in "packages/adf-schema/src/next-schema" ,
 * and run "yarn workspace @atlaskit/adf-schema build:schema:all" to regenerate this file.
 */ 
var $2ZyjG = parcelRequire("2ZyjG");

const $5264f7dab81df437$export$8e53000a4ec837 = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        align: {}
    },
    excludes: 'alignment indentation',
    group: 'alignment'
});
const $5264f7dab81df437$export$8512c9afa7b24c3b = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        id: {
            default: ''
        },
        annotationType: {
            default: 'inlineComment'
        }
    },
    inclusive: true,
    excludes: '',
    group: 'annotation'
});
const $5264f7dab81df437$export$8c5a050822fd698c = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    excludes: 'color',
    group: 'color'
});
const $5264f7dab81df437$export$1edee58a52776cd9 = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        size: {},
        color: {}
    },
    inclusive: false
});
const $5264f7dab81df437$export$89015c65f1c75e3f = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        mode: {
            default: 'wide'
        },
        width: {
            default: null
        }
    },
    inclusive: false,
    spanning: false
});
const $5264f7dab81df437$export$6565f9f03506010b = (0, $2ZyjG.createPMMarkSpecFactory)({
    inclusive: true,
    excludes: 'fontStyle link searchQuery color'
});
const $5264f7dab81df437$export$f3b72f8fc4684ecd = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        reference: {
            default: ''
        }
    },
    inclusive: false,
    excludes: ''
});
const $5264f7dab81df437$export$3024f02c495408d6 = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        sources: {
            default: []
        }
    }
});
const $5264f7dab81df437$export$c63c6f932822f543 = (0, $2ZyjG.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $5264f7dab81df437$export$85e3c3ca0c6fb93 = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        fontSize: {}
    },
    inclusive: false,
    spanning: false
});
const $5264f7dab81df437$export$f00aeb236b6f05af = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        localId: {
            default: ''
        },
        name: {
            default: null
        }
    },
    inclusive: false,
    excludes: ''
});
const $5264f7dab81df437$export$480c699bd4ec0d86 = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        level: {}
    },
    excludes: 'indentation alignment',
    group: 'indentation'
});
const $5264f7dab81df437$export$9c30223ca0a664fb = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        href: {},
        __confluenceMetadata: {
            default: null
        }
    },
    inclusive: false,
    excludes: 'link',
    group: 'link'
});
const $5264f7dab81df437$export$4899a95d70ec5056 = (0, $2ZyjG.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $5264f7dab81df437$export$59ae2c325a998f89 = (0, $2ZyjG.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $5264f7dab81df437$export$b3401ee80eb31041 = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        type: {
            default: 'sub'
        }
    },
    inclusive: true,
    group: 'fontStyle'
});
const $5264f7dab81df437$export$32f78bffcd82ff28 = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        color: {}
    },
    inclusive: true,
    group: 'color'
});
const $5264f7dab81df437$export$20af3dabbb5538df = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        trigger: {
            default: ''
        }
    },
    inclusive: true,
    group: 'searchQuery'
});
const $5264f7dab81df437$export$425327af25286e5e = (0, $2ZyjG.createPMMarkSpecFactory)({
    inclusive: true,
    group: 'fontStyle'
});
const $5264f7dab81df437$export$30d78d5eb6719bb8 = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        originalValue: {}
    },
    excludes: ''
});
const $5264f7dab81df437$export$a316dc07ff5182a2 = (0, $2ZyjG.createPMMarkSpecFactory)({
    attrs: {
        unsupported: {},
        type: {}
    }
});
module.exports["alignment"] = $5264f7dab81df437$export$8e53000a4ec837;
module.exports["annotation"] = $5264f7dab81df437$export$8512c9afa7b24c3b;
module.exports["backgroundColor"] = $5264f7dab81df437$export$8c5a050822fd698c;
module.exports["border"] = $5264f7dab81df437$export$1edee58a52776cd9;
module.exports["breakout"] = $5264f7dab81df437$export$89015c65f1c75e3f;
module.exports["code"] = $5264f7dab81df437$export$6565f9f03506010b;
module.exports["confluenceInlineComment"] = $5264f7dab81df437$export$f3b72f8fc4684ecd;
module.exports["dataConsumer"] = $5264f7dab81df437$export$3024f02c495408d6;
module.exports["em"] = $5264f7dab81df437$export$c63c6f932822f543;
module.exports["fontSize"] = $5264f7dab81df437$export$85e3c3ca0c6fb93;
module.exports["fragment"] = $5264f7dab81df437$export$f00aeb236b6f05af;
module.exports["indentation"] = $5264f7dab81df437$export$480c699bd4ec0d86;
module.exports["link"] = $5264f7dab81df437$export$9c30223ca0a664fb;
module.exports["strike"] = $5264f7dab81df437$export$4899a95d70ec5056;
module.exports["strong"] = $5264f7dab81df437$export$59ae2c325a998f89;
module.exports["subsup"] = $5264f7dab81df437$export$b3401ee80eb31041;
module.exports["textColor"] = $5264f7dab81df437$export$32f78bffcd82ff28;
module.exports["typeAheadQuery"] = $5264f7dab81df437$export$20af3dabbb5538df;
module.exports["underline"] = $5264f7dab81df437$export$425327af25286e5e;
module.exports["unsupportedMark"] = $5264f7dab81df437$export$30d78d5eb6719bb8;
module.exports["unsupportedNodeAttribute"] = $5264f7dab81df437$export$a316dc07ff5182a2;

});

parcelRegister("fDgwd", function(module, exports) {
const $223bda5e66a89234$export$c296e2d4365c37a5 = (maybeNode)=>maybeNode instanceof Node && maybeNode.nodeType === Node.ELEMENT_NODE;
module.exports["isDOMElement"] = $223bda5e66a89234$export$c296e2d4365c37a5;

});

parcelRegister("dCzEh", function(module, exports) {
/**
 * This takes an adf hex color and returns a matching border palette color.
 *
 * By providing a design token, this enables ADF content to be rendered in new themes such as dark mode.
 *
 * Example usage
 * ```tsx
 * const cssValue = hexToEditorBorderPaletteColor('#091E4224');
 * //     ^? const cssValue: string
 * <div style={{borderColor: cssValue}} />
 * ```
 * The names of tokens can change over time, and the values of tokens will differ between themes.
 * The exact output of this function is an implementation detail and should only be used when rendering
 * content to the user, on a client with a matching major version of `@atlaskit/tokens`.
 * - **DO NOT**: store the output of these functions in any user-generated content or back-end.
 * - **DO**: store the ADF hex color, and use these utilities at render time to display the themed version of the color
 */ function $fe43cd1115321a37$export$bad3c41dd33cb4bc(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $fe43cd1115321a37$export$aa000893c5e2b9c2[hexColor.toUpperCase()] : undefined;
}
const $fe43cd1115321a37$export$aa000893c5e2b9c2 = {
    /** gray - subtle */ '#091E4224': 'var(--ds-border, #091E4224)',
    /** gray */ '#758195': 'var(--ds-border-bold, #758195)',
    /** gray - bold */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $fe43cd1115321a37$export$9c2f408d391feb93(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $fe43cd1115321a37$export$57fa5089caad992[hexColor.toUpperCase()] : undefined;
}
const $fe43cd1115321a37$export$57fa5089caad992 = {
    /** blue - light */ '#B3D4FF': 'var(--ds-background-accent-blue-subtler, #B3D4FF)',
    /** blue - medium */ '#4C9AFF': 'var(--ds-icon-accent-blue, #4C9AFF)',
    /** blue - strong */ '#0747A6': 'var(--ds-text-accent-blue, #0747A6)',
    /** teal - light */ '#B3F5FF': 'var(--ds-background-accent-teal-subtler, #B3F5FF)',
    /** teal - medium */ '#00B8D9': 'var(--ds-icon-accent-teal, #00B8D9)',
    /** teal - strong */ '#008DA6': 'var(--ds-text-accent-teal, #008DA6)',
    /** green - light */ '#ABF5D1': 'var(--ds-background-accent-green-subtler, #ABF5D1)',
    /** green - medium */ '#36B37E': 'var(--ds-icon-accent-green, #36B37E)',
    /** green - strong */ '#006644': 'var(--ds-text-accent-green, #006644)',
    /** yellowOrange - light */ '#FFF0B3': 'var(--ds-background-accent-yellow-subtler, #FFF0B3)',
    /** yellowOrange - medium */ '#FFC400': 'var(--ds-background-accent-orange-subtle, #FFC400)',
    /** yellowOrange - strong */ '#FF991F': 'var(--ds-icon-accent-orange, #FF991F)',
    /** red - light */ '#FFBDAD': 'var(--ds-background-accent-red-subtler, #FFBDAD)',
    /** red - medium */ '#FF5630': 'var(--ds-icon-accent-red, #FF5630)',
    /** red - strong */ '#BF2600': 'var(--ds-text-accent-red, #BF2600)',
    /** purple - light */ '#EAE6FF': 'var(--ds-background-accent-purple-subtler, #EAE6FF)',
    /** purple - medium */ '#6554C0': 'var(--ds-icon-accent-purple, #6554C0)',
    /** purple - strong */ '#403294': 'var(--ds-text-accent-purple, #403294)',
    /** whiteGray - light */ '#FFFFFF': 'var(--ds-text-inverse, #FFFFFF)',
    /** whiteGray - medium */ '#97A0AF': 'var(--ds-icon-accent-gray, #97A0AF)',
    /** whiteGray - strong */ '#172B4D': 'var(--ds-text, #172B4D)'
};
function $fe43cd1115321a37$export$8b58ff1b36bb75e0(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferring better type on consumption over safety in implementation)
    // @ts-expect-error
    return hexColor ? $fe43cd1115321a37$export$12a518ff137dd389[hexColor.toUpperCase()] : undefined;
}
const $fe43cd1115321a37$export$12a518ff137dd389 = {
    /** Gray - light */ '#DCDFE4': 'var(--ds-background-accent-gray-subtler, #DCDFE4)',
    /** Teal - light */ '#C6EDFB': 'var(--ds-background-accent-teal-subtler, #C6EDFB)',
    /** Lime - light */ '#D3F1A7': 'var(--ds-background-accent-lime-subtler, #D3F1A7)',
    /** Yellow - light */ '#F8E6A0': 'var(--ds-background-accent-yellow-subtler, #F8E6A0)',
    /** Orange - light */ '#FEDEC8': 'var(--ds-background-accent-orange-subtler, #FEDEC8)',
    /** Magenta - light */ '#FDD0EC': 'var(--ds-background-accent-magenta-subtler, #FDD0EC)',
    /** Purple - light */ '#DFD8FD': 'var(--ds-background-accent-purple-subtler, #DFD8FD)'
};
function $fe43cd1115321a37$export$a270511a0e7fd61a(hexColor) {
    // Ts ignore was used to allow use of conditional return type
    // (preferencing better type on consumption over safety in implementation)
    // @ts-ignore
    const tokenData = hexColor ? $fe43cd1115321a37$export$2462741d70e6a62f[hexColor.toUpperCase()] : undefined;
    // @ts-expect-error
    return tokenData ? tokenData.getValue(hexColor) : undefined;
}
const $fe43cd1115321a37$export$2462741d70e6a62f = {
    /** blue - light */ '#DEEBFF': {
        getValue: ()=>'#DEEBFF',
        token: 'var(--ds-background-accent-blue-subtlest, #DEEBFF)'
    },
    /** blue - medium */ '#B3D4FF': {
        getValue: ()=>'#B3D4FF',
        token: 'var(--ds-background-accent-blue-subtler, #B3D4FF)'
    },
    /** blue - strong */ '#4C9AFF': {
        getValue: ()=>'#4C9AFF',
        token: 'var(--ds-background-accent-blue-subtle, #4C9AFF)'
    },
    /** teal - light */ '#E6FCFF': {
        getValue: ()=>'#E6FCFF',
        token: 'var(--ds-background-accent-teal-subtlest, #E6FCFF)'
    },
    /** teal - medium */ '#B3F5FF': {
        getValue: ()=>'#B3F5FF',
        token: 'var(--ds-background-accent-teal-subtler, #B3F5FF)'
    },
    /** teal - strong */ '#79E2F2': {
        getValue: ()=>'#79E2F2',
        token: 'var(--ds-background-accent-teal-subtle, #79E2F2)'
    },
    /** green - light */ '#E3FCEF': {
        getValue: ()=>'#E3FCEF',
        token: 'var(--ds-background-accent-green-subtlest, #E3FCEF)'
    },
    /** green - medium */ '#ABF5D1': {
        getValue: ()=>'#ABF5D1',
        token: 'var(--ds-background-accent-green-subtler, #ABF5D1)'
    },
    /** green - strong */ '#57D9A3': {
        getValue: ()=>'#57D9A3',
        token: 'var(--ds-background-accent-green-subtle, #57D9A3)'
    },
    /** yellowOrange - light */ '#FFFAE6': {
        getValue: ()=>'#FFFAE6',
        token: 'var(--ds-background-accent-yellow-subtlest, #FFFAE6)'
    },
    /** yellowOrange - medium */ '#FFF0B3': {
        getValue: ()=>'#FFF0B3',
        token: 'var(--ds-background-accent-yellow-subtler, #FFF0B3)'
    },
    /** yellowOrange - strong */ '#FFC400': {
        getValue: ()=>'#FFC400',
        token: 'var(--ds-background-accent-orange-subtle, #FFC400)'
    },
    /** red - light */ '#FFEBE6': {
        getValue: ()=>'#FFEBE6',
        token: 'var(--ds-background-accent-red-subtlest, #FFEBE6)'
    },
    /** red - medium */ '#FFBDAD': {
        getValue: ()=>'#FFBDAD',
        token: 'var(--ds-background-accent-red-subtler, #FFBDAD)'
    },
    /** red - strong */ '#FF8F73': {
        getValue: ()=>'#FF8F73',
        token: 'var(--ds-background-accent-red-subtle, #FF8F73)'
    },
    /** purple - light */ '#EAE6FF': {
        getValue: ()=>'#EAE6FF',
        token: 'var(--ds-background-accent-purple-subtlest, #EAE6FF)'
    },
    /** purple - medium */ '#C0B6F2': {
        getValue: ()=>'#C0B6F2',
        token: 'var(--ds-background-accent-purple-subtler, #C0B6F2)'
    },
    /** purple - strong */ '#998DD9': {
        getValue: ()=>'#998DD9',
        token: 'var(--ds-background-accent-purple-subtle, #998DD9)'
    },
    /** whiteGray - light */ '#FFFFFF': {
        getValue: ()=>'#FFFFFF',
        token: 'var(--ds-surface, #FFFFFF)'
    },
    /** whiteGray - medium */ '#F4F5F7': {
        getValue: ()=>'#F4F5F7',
        token: 'var(--ds-background-accent-gray-subtlest, #F4F5F7)'
    },
    /** whiteGray - strong */ '#B3BAC5': {
        getValue: ()=>'#B3BAC5',
        token: 'var(--ds-background-accent-gray-subtle, #B3BAC5)'
    }
};
module.exports["hexToEditorBorderPaletteColor"] = $fe43cd1115321a37$export$bad3c41dd33cb4bc;
module.exports["hexToEditorTextPaletteColor"] = $fe43cd1115321a37$export$9c2f408d391feb93;
module.exports["hexToEditorTextBackgroundPaletteColor"] = $fe43cd1115321a37$export$8b58ff1b36bb75e0;
module.exports["hexToEditorBackgroundPaletteRawValue"] = $fe43cd1115321a37$export$a270511a0e7fd61a;

});

parcelRegister("jBO3b", function(module, exports) {
const $23b09ebbfdca63ce$export$d5f21755dc782a4a = (name)=>{
    return !!name && [
        'default',
        'wide',
        'full-width'
    ].includes(name);
};
const $23b09ebbfdca63ce$export$1765e2758fc47004 = (dom, isInline = false)=>{
    const extensionType = dom.getAttribute('data-extension-type');
    const extensionKey = dom.getAttribute('data-extension-key');
    if (!extensionType || !extensionKey) return false;
    const attrs = {
        extensionType: extensionType,
        extensionKey: extensionKey,
        text: dom.getAttribute('data-text') || undefined,
        parameters: JSON.parse(dom.getAttribute('data-parameters') || '{}'),
        localId: dom.getAttribute('data-local-id') || undefined
    };
    if (!isInline) {
        const rawLayout = dom.getAttribute('data-layout');
        attrs.layout = $23b09ebbfdca63ce$export$d5f21755dc782a4a(rawLayout) ? rawLayout : 'default';
    }
    return attrs;
};
module.exports["getExtensionAttrs"] = $23b09ebbfdca63ce$export$1765e2758fc47004;

});

parcelRegister("uvNb9", function(module, exports) {
class $2c5766e42a4da15d$export$145273558d58e0ac extends Error {
    constructor(message, type){
        super(message), this.message = message, this.type = type;
        this.name = 'AuthError';
        this.type = type;
        this.message = message;
    }
}
module.exports["AuthError"] = $2c5766e42a4da15d$export$145273558d58e0ac;

});


$parcel$global.rlb("dAdaw")
//# sourceMappingURL=component-lazy.d3517ad0.js.map
